<template>
  <div class="flex items-center relative">
    <!-- Click to pain -->
    <div
      class="text-black flex flex-col items-center z-30 absolute w-full pointer-events-none"
      :class="selected ? 'hidden':'block'"
    >
      <div class="bg-white rounded opacity-75 p-2 flex flex-col items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="42" viewBox="0 0 33 42">
          <path
            fill="#291F1E"
            fill-rule="evenodd"
            d="M17.188.297C17.008.099 16.785 0 16.517 0s-.504.099-.705.297c-.179.176-.269.395-.269.659v3.822c0 .264.09.484.269.659.201.176.437.264.705.264.268 0 .492-.088.671-.264.202-.175.302-.395.302-.66V.957c0-.264-.1-.483-.302-.66m10.978 14.96c-.269 0-.503.088-.705.264-.18.198-.269.428-.269.692 0 .264.09.483.269.659.202.176.436.264.705.264h3.894c.246 0 .47-.088.671-.264.18-.176.269-.395.269-.659s-.09-.494-.269-.692c-.2-.176-.425-.264-.671-.264h-3.894M.302 16.871c.18.176.403.264.672.264h3.894c.268 0 .492-.088.671-.264.202-.176.302-.395.302-.659s-.1-.494-.302-.692c-.18-.176-.403-.264-.671-.264H.974c-.269 0-.493.088-.672.264-.201.198-.302.428-.302.692 0 .264.1.483.302.659m23.466-8.765c0 .264.1.494.302.692.18.176.404.264.672.264s.503-.088.705-.264l2.72-2.702c.2-.198.301-.417.301-.66 0-.284-.1-.515-.302-.691-.179-.176-.403-.264-.67-.264-.27 0-.494.088-.672.264L24.07 7.447c-.201.176-.302.395-.302.659m-16.181.692c.201.176.425.264.671.264.269 0 .504-.088.705-.264.18-.198.269-.428.269-.692 0-.264-.09-.483-.269-.659L6.211 4.745c-.18-.176-.403-.264-.672-.264-.268 0-.503.088-.705.264-.18.176-.268.395-.268.659s.089.494.268.692l2.753 2.702m13.73 2.702c-.626-.615-1.342-1.099-2.148-1.45-.85-.351-1.734-.527-2.652-.527-.918 0-1.802.176-2.652.527-.806.351-1.522.835-2.149 1.45-.626.615-1.118 1.318-1.477 2.109-.358.835-.537 1.703-.537 2.603 0 .264.1.483.302.659.18.176.403.264.671.264.269 0 .504-.088.705-.264.18-.176.269-.395.269-.659 0-1.318.481-2.449 1.444-3.394.94-.923 2.081-1.384 3.424-1.384s2.484.461 3.425 1.384c.939.945 1.409 2.076 1.409 3.394 0 .264.101.483.302.659.18.176.403.264.672.264.268 0 .503-.088.705-.264.179-.176.269-.395.269-.659 0-.9-.18-1.768-.538-2.603-.336-.791-.817-1.494-1.444-2.11m-5.774 4.713c0-.264.09-.494.269-.692.201-.176.437-.264.705-.264.268 0 .492.088.671.264.202.198.302.428.302.692v13.312c0 .176.045.34.135.495.089.154.212.274.369.362.157.088.325.121.503.099.18 0 .348-.055.504-.165l3.123-2.043c.536-.351 1.13-.472 1.778-.362.65.11 1.164.417 1.545.922.134.198.202.407.202.626-.024.242-.112.44-.27.593l-7.855 8.436c-.447.484-.985.857-1.611 1.12-.588.247-1.203.38-1.847.396h-3.558c-.858-.02-1.674-.186-2.451-.495-.828-.35-1.556-.835-2.182-1.45-.627-.614-1.108-1.317-1.444-2.108-.358-.835-.537-1.703-.537-2.603v-7.612c0-.264.09-.494.269-.692.201-.175.436-.264.705-.264.268 0 .492.089.671.264.202.198.302.428.302.692v.955c0 .264.09.484.269.66.201.197.436.296.705.296.268 0 .493-.099.671-.297.202-.175.302-.395.302-.659v-2.866c0-.264.09-.483.269-.66.201-.197.436-.296.705-.296.246 0 .47.099.671.297.18.176.269.395.269.659v2.866c0 .264.1.484.302.66.18.197.403.296.671.296.269 0 .504-.099.705-.297.18-.175.269-.395.269-.659v-4.778c0-.263.1-.483.302-.659.18-.197.403-.296.672-.296.268 0 .503.099.705.296.179.176.268.396.268.66v4.777c0 .264.1.484.302.66.18.197.403.296.672.296.268 0 .492-.099.671-.297.202-.175.302-.395.302-.659V16.212m-1.074-2.043c-.582.571-.873 1.252-.873 2.043v2.999c-.313-.11-.638-.165-.973-.165-.672 0-1.265.209-1.78.626-.514.373-.861.868-1.04 1.483-.336-.132-.683-.198-1.041-.198-.671 0-1.276.198-1.813.593-.515.395-.85.9-1.007 1.516-.358-.132-.716-.198-1.074-.198-.806 0-1.488.275-2.048.824-.582.571-.873 1.252-.873 2.043v7.612c0 1.164.235 2.274.705 3.328.425 1.032 1.04 1.944 1.846 2.735 1.12 1.146 2.239 1.86 3.358 2.142 2.444.473 4.626.571 6.546.296 1.942-.273 3.464-.966 4.565-2.076l7.857-8.435c.469-.505.715-1.098.738-1.78.045-.68-.146-1.295-.57-1.845-.695-.923-1.613-1.483-2.754-1.68-1.164-.198-2.226.021-3.19.658l-1.61 1.055V16.212c0-.79-.291-1.472-.873-2.043-.56-.549-1.243-.824-2.048-.824-.806 0-1.488.275-2.048.824"
          />
        </svg>
        <div>Click pain site</div>
      </div>
    </div>
    <!-- red target dot -->
    <div
      class="absolute h-4 w-4 lg:h-6 lg:w-6 rounded-full bg-white pointer-events-none"
      :style="target"
      :class="selected ? 'block':'hidden'"
    >
      <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
      </div>

      <svg class="absolute" style="top:-28px;left:-28px;">
        <circle cx="40" cy="40" r="30" fill="red" class="marker" />
      </svg>
      <div class="bg-white w-1 h-16" style="margin-left:10px"></div>

      <red-button class="-ml-10" @click="results">Result</red-button>
      <!-- <button
        @click="results"
        class="w-30 btn btn-primary -ml-10 flex absolute pointer-events-auto nowrap"
      >
        Result
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          width="16"
          height="16"
          class="ml-2 mt-1"
        >
          <polygon fill="#fff" points="16,8 0,16 0,0" />
        </svg>
      </button> -->



    </div>

    <div class="flex-initial z-30" id="left-arrow">
      <svg
        width="34px"
        height="31px"
        viewBox="0 0 34 31"
        version="1.1"
        class="cursor-pointer arrow-left"
        @click="turnLeft"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Website" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            id="Desktop---1.1---Homepage-Callout"
            transform="translate(-719.000000, -453.000000)"
            fill="#FF0000"
          >
            <g id="Group-2" transform="translate(719.000000, 453.000000)">
              <polygon
                fill-opacity="0.5"
                transform="translate(11.500000, 15.500000) scale(-1, 1) rotate(-270.000000) translate(-11.500000, -15.500000) "
                points="11.5 4 27 27 -4 27"
              />
              <polygon
                transform="translate(22.500000, 15.500000) scale(-1, 1) rotate(-270.000000) translate(-22.500000, -15.500000) "
                points="22.5 4 38 27 7 27"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>

    <div class="flex-1 z-20" v-if="face==0" id="front-hand">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        inkscape:version="1.0beta2 (2b71d25, 2019-12-03)"
        sodipodi:docname="front.svg"
        version="1.1"
        :style="trans"
        viewBox="0 50 384 555"
        id="front-hand-svg"
        ref="hand"
      >
        <metadata id="metadata378">
          <rdf:RDF>
            <cc:Work rdf:about>
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <sodipodi:namedview
          inkscape:current-layer="hand-front"
          inkscape:window-maximized="0"
          inkscape:window-y="23"
          inkscape:window-x="0"
          inkscape:cy="277.5"
          inkscape:cx="192"
          inkscape:zoom="1.2108108"
          showgrid="false"
          id="namedview376"
          inkscape:window-height="892"
          inkscape:window-width="1002"
          inkscape:pageshadow="2"
          inkscape:pageopacity="0"
          guidetolerance="10"
          gridtolerance="10"
          objecttolerance="10"
          borderopacity="1"
          inkscape:document-rotation="0"
          borderColor="#666666"
          pagecolor="#ffffff"
        />
        <defs id="defs11">
          <mask
            maskUnits="userSpaceOnUse"
            height="359.04"
            width="781.92"
            y="-377.2556"
            x="-2625.32449"
            id="mask"
          />
        </defs>
        <filter id="f1" x="-40%" y="-40%" height="180%" width="180%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
        <filter id="f2" height="180%" width="180%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="15" />
        </filter>
        <polygon
          id="polygon13"
          points="76.136 103.819 81.397 98.27 100.277 105.905 80.322 117.371 74.05 109.224 76.136 103.819"
          class="cls-1"
        />
        <polygon
          id="polygon15"
          points="146.403 59.084 141.183 74.094 144.064 91.702 168.379 76.967 160.926 63.132 146.403 59.084"
          class="cls-1"
        />
        <path
          id="path17"
          d="M198.53915,611.17134c-17.71937.99325-35.43,2.21787-53.16171,2.88147-8.792.329-17.62256-.37374-26.43564-.60973a1.11747,1.11747,0,0,1,.00553-1.219c2.512-2.09594,5.44959-1.382,8.22517-1.04992,9.14287,1.09415,10.16937.24125,10.17175-9.0514.00279-11.1039-.01766-22.2078.00732-33.31166.01542-6.85905-1.07628-13.66519-.79587-20.54537.23083-5.665-.23411-11.35759.66634-15.78437-.33147,5.70761-2.40438,12.30374-3.84,19.01607-3.13,14.63407-6.56622,29.20008-10.04291,43.755-.51023,2.136-.45126,4.99128-3.81649,5.15715-2.491-.98223-2.17705-3.00536-1.87467-5.02941,2.02917-13.583,3.0097-27.304,5.3573-40.8474a3.9087,3.9087,0,0,0-.153-1.81769c-1.03351-5.88012.53567-11.62189,1.07463-17.39622.96735-10.36539,1.4117-20.79815,3.4174-31.04591,2.73637-2.244,3.80867-2.06315,5.2997.95305,1.36123,2.75383,2.3385,5.69549,4.106,8.36046A95.60088,95.60088,0,0,0,138.0051,501.391c.11745-4.86921.9113-9.67087,1.02435-14.54022.05459-2.35127.05294-5.082,2.40439-6.78542a6.56733,6.56733,0,0,1,5.23977,1.3048c8.00221,5.46114,16.17837,10.66083,24.18932,16.10871,1.24259.845,2.03132,2.17868,3.33111,2.946a5.195,5.195,0,0,1,.64662.9274c4.674,7.277,7.61061,15.39156,11.17131,23.20265,4.81394,10.56013,9.54947,21.15588,14.345,31.72451a51.50911,51.50911,0,0,1,2.79709,9.02876c-1.11627,2.74716-2.98554,1.72692-4.54973.70563-3.54372-2.31373-7.00673-4.75432-10.51059-7.13052-10.82158-7.33881-21.5048-14.87994-32.39624-22.11607a2.6228,2.6228,0,0,0-2.30991-.68806c-.703,1.95805.54089,3.39849,1.60917,4.83916q13.46778,18.16329,27.18062,36.14255c6.69914,8.82493,13.5778,17.51659,20.03033,26.53a25.07848,25.07848,0,0,1,2.68686,5.35051c-.11154,1.46637-1.25691,1.50511-2.15114,1.85552C201.35229,611.04365,199.88844,610.46452,198.53915,611.17134Z"
          class="cls-2"
        />
        <path
          id="path19"
          d="M201.33738,247.08019q2.34182-1.55766,4.68373-3.11531c2.00831.1157,2.1953-2.18351,3.6759-2.77254,1.69728-.18586,2.39038,1.76632,3.968,1.84208,5.95355,1.0793,11.98827,1.43259,17.9786,2.14943a26.40553,26.40553,0,0,1,7.89666,1.7573,2.28881,2.28881,0,0,1,.8306.89662,2.3837,2.3837,0,0,1,.15867,1.15876,36.11282,36.11282,0,0,1-7.2371,6.69855c-5.15869,3.841-10.07388,8.05461-15.77136,11.14262-.99269.538-1.96049,1.11973-2.00062,2.43922-.13552,1.79019,1.17552,2.58617,2.35576,3.49426a174.96724,174.96724,0,0,0,14.76521,10.55352c2.93946,1.81043,4.93231,4.84868,8.25623,6.11581a2.78348,2.78348,0,0,1,1.04041,2.61886c-5.36842,11.24968-12.543,21.48116-18.39943,32.45959a5.97228,5.97228,0,0,1-2.51328,2.66963c-11.834,6.11954-23.54472,12.474-35.39316,18.56473-1.90569.97957-4.10391,2.45-5.8335-.45533a24.90861,24.90861,0,0,1-.46617-6.33375c-.02242-12.10292.05069-24.20629-.04031-36.30843-.03385-4.50574,1.20028-8.89735.9302-13.39673-1.63634-6.8615-5.49443-12.802-8.05712-19.28407-2.1872-5.53211-4.70871-10.89131-5.27225-16.994a52.139,52.139,0,0,1,.5736-12.25546,2.47966,2.47966,0,0,1,.66049-1.08344,48.00247,48.00247,0,0,1,18.47062-2.76581c2.28077.759,3.23407,3.01922,4.9679,4.396,2.94107,6.43139,7.73141,11.6585,11.12309,16.947-.92013-2.61-4.5953-4.52115-4.58262-8.46116C198.25205,247.73848,199.79286,247.40709,201.33738,247.08019Z"
          class="cls-3"
        />
        <path
          id="path21"
          d="M198.53915,611.17134q2.19186-.36771,4.38378-.73531c1.1181-.41033,1.6825-.807,1.37162-2.37538-2.05027-10.3423-2.042-20.87187-2.43253-31.352-.11786-3.16159-1.43777-6.36522.00288-9.52722,6.93389-13.77225,16.74731-25.673,25.17781-38.476,1.25362-1.90377,2.65333-4.31546,5.48244-1.75536a11.2567,11.2567,0,0,1,.53636,6.24311c-2.16433,18.27559-3.54221,36.634-5.81163,54.89848-.42431,3.41492-1.3643,6.75318-1.47827,10.20336-.10417,2.29877-.84857,4.54628-.22,6.92884.53818,2.03987-1.61173,3.01918-2.32181,4.59641Q210.88447,610.4958,198.53915,611.17134Z"
          class="cls-4"
        />
        <path
          id="path23"
          d="M291.36018,294.25214q2.17552-5.22741,4.351-10.45485c2.422-5.56132,5.32652-10.9021,7.36543-16.64563.68377-1.92616,1.25339-4.58808,4.46824-3.86059,1.45868,1.07576,1.19259,2.6126,1.063,4.09834-.67087,7.69034-1.34865,15.3799-1.96553,23.075-.2424,3.02389-1.34531,5.91168-1.46875,7.467,1.30642-8.23747,5.40612-17.12753,8.70191-26.24474,3.85492-10.66378,7.35481-21.45278,11.39764-32.04584.81563-2.137.90746-5.235,4.52493-4.94014,1.62449.95239,1.46646,2.49138,1.18536,3.97081-2.71555,14.2923-4.48563,28.74528-7.69457,42.96444-1.33561,5.91826-3.00686,11.8512-3.15629,18.036a20.71437,20.71437,0,0,1-1.74326,7.519c1.8516-2.39417,2.45544-5.31246,3.84454-7.83533.93285-1.6942,1.989-3.67526,4.52053-1.94811,1.10131,1.597.69119,3.33513.50113,5.05932-.45,4.08245-1.71467,8.04229-1.82338,12.17586.22479,6.47645-3.21883,12.17431-3.87844,18.49914-.55868,5.35729-1.96942,10.60737-2.87445,15.93429a2.68111,2.68111,0,0,1-2.21314,2.28931c-2.19562-.649-2.098-2.57794-2.10622-4.24165-.041-8.29268-.57717-16.60072.43373-24.86788a10.47766,10.47766,0,0,0-.27927-3.98773,6.31345,6.31345,0,0,0-3.69928-4.36511,90.169,90.169,0,0,1-8.27375-4.2735c-3.97914-2.86462-6.9171-6.78151-10.23942-10.2932C291.12062,298.088,290.11351,296.22931,291.36018,294.25214Z"
          class="cls-5"
        />
        <path
          id="path25"
          d="M223.22983,609.82036c-.97563-.09641-1.95125-.19286-3.45212-.34123,1.33794-.50266,2.19443-.8244,3.321-1.24767q.75759-4.53315,1.516-9.07116a1.67484,1.67484,0,0,0,1.07852-1.4054c4.74061-22.63926,12.71688-44.36581,18.8059-66.62424a44.0168,44.0168,0,0,1,1.158-4.31971c.62516-1.61405,1.59369-2.945,3.63284-1.59214a2.61442,2.61442,0,0,1,.5181,1.87523c.57383,20.09178.66749,40.18173.84052,60.27233.05564,6.46112.91528,12.92059.28092,19.40334Q237.07968,608.29506,223.22983,609.82036Z"
          class="cls-6"
        />
        <path
          id="path27"
          d="M107.89334,268.14q-.10343-2.2767-.2069-4.55339a218.68687,218.68687,0,0,0-6.06592-27.68674c-3.20826-13.81708-6.53584-27.60787-9.58881-41.45916-2.67818-12.15043-5.04843-24.36869-7.55462-36.557,2.5799-.57778,2.75911,1.61611,3.32507,3.07781,2.59568,6.70376,4.38048,13.67694,6.62776,20.49925,1.24007,3.76471,3.07452,7.3104,3.992,11.18007.24029,1.01351,1.06045,1.28785,1.8366,1.65793a6.26942,6.26942,0,0,1,2.07319,1.96743c-.36763,7.086,5.0891,11.58219,7.75167,17.67309,1.27576-.80668,2.31091-2.85195,3.97164-.96668a4.23458,4.23458,0,0,1,.6333,2.51471c-.39155,11.63865,3.35344,22.66748,4.98616,34.006.42495,2.95138,1.28615,5.87573.46133,8.88377-.03688.39594-.08163.7974-.13168,1.19274a30.58414,30.58414,0,0,1-9.54773,8.38367C109.61628,268.1636,108.78592,268.60449,107.89334,268.14Z"
          class="cls-7"
        />
        <path
          id="path29"
          d="M98.69712,196.86171q-5.5328-15.29347-11.07042-30.5852c-1.01987-2.80853-2.09812-5.59581-3.14961-8.39284l-8.30587-29.19941c-.21211-1.09067.58138-1.36043,1.305-1.24607,5.33392.843,10.6182,1.42015,14.74261,5.8481,2.71908,2.91911,5.48331,6.04983,9.25844,7.85047a5.6337,5.6337,0,0,1,.99453,2.297,17.27337,17.27337,0,0,1,1.48837,5.02377c-2.32281,9.7884,1.41746,19.26792,1.49918,28.94556.05458,6.4668-2.44456,12.12627-4.696,17.90723C100.44816,196.11961,99.4061,196.3617,98.69712,196.86171Z"
          class="cls-8"
        />
        <path
          id="path31"
          d="M263.71873,121.23953c-2.7629,24.51852-5.81263,49.00934-8.18559,73.56552-1.52168,15.747-2.04866,31.59-3.01559,47.3904q-.491,8.02334-.95371,16.04834c-2.12333-.07413-2.182-1.72847-2.36171-3.19527a42.85745,42.85745,0,0,1-.15912-5.98519c.24006-13.37876-.67925-26.78082.68985-40.13342.30966-3.01979-.96688-5.77232-.96391-8.70291.44284-9.55226.98235-19.10381,1.79034-28.63611.65966-7.7821.8041-15.63418,2.64262-23.27222.50383-2.0931-.47651-3.81236-.75725-5.70447.05468-.91832.4174-1.79383.38748-2.72456q-.97486-8.79068-1.24264-17.63033a7.52568,7.52568,0,0,1-.1971-1.92472c-.45675-4.19049,3.25658-7.05148,3.48776-11.06509.32636-5.66668,2.1323-11.047,3.48452-16.51044,1.69257-2.53094,2.18445-5.80393,4.78548-7.77662a1.05482,1.05482,0,0,1,1.07771.31453q.01584,2.92864.03175,5.85728c-.56948,8.54983-.08,17.11007-.26139,25.66338C263.967,118.292,264.28359,119.79647,263.71873,121.23953Z"
          class="cls-9"
        />
        <path
          id="path33"
          d="M128.73083,504.0649q-2.169,21.70619-4.32558,43.41366c-.17029,1.73049-.17144,3.47771-.251,5.21716-1.50256,1.66115-1.53705,3.79538-1.80526,5.82432-2.219,16.78544-5.46308,33.38822-8.87622,49.96072-.32416,1.574-.62452,3.27927-2.76473,3.45173-2.48524-1.33091-4.97047-2.66186-7.72958-4.13943,1.248-6.03488,2.35223-11.63318,3.56756-17.20729,5.821-26.69706,11.70913-53.37966,17.46311-80.09112a66.493,66.493,0,0,0,.96588-9.64581c.25973-3.97328.36753-7.95644.541-11.93535,1.32833,2.81639.01844,5.80488.56024,7.90334.36643-4.61776-.68784-10.07863.63816-15.22069,1.18828-1.04384,2.197-1.11216,3.26119-.32238a3.43944,3.43944,0,0,1,.67563,1.12739c1.21514,5.81439.6032,11.66391.42477,17.5036C131.02093,501.7064,129.3381,502.58033,128.73083,504.0649Z"
          class="cls-10"
        />
        <path
          id="path35"
          d="M179.83816,98.49489l2.82957,20.43328c-.899,5.7185.54386,11.28872,1.19972,16.888,1.147,9.79241,2.24142,19.58743,3.1421,29.40529a5.33643,5.33643,0,0,1-.45848,3.48623c-1.63286,1.37049-2.08275.2865-2.21209-.31026a86.60749,86.60749,0,0,1-3.18744,23.46554,3.45628,3.45628,0,0,1-3.50483-1.098c-2.71807-7.04306-3.39168-14.56267-5.0601-21.847-2.11349-9.22732-3.63252-18.58988-6.28937-27.69029a2.89,2.89,0,0,1,.09965-1.15851c4.20283-10.63762,5.75347-22.08213,9.89938-32.79011-.73291-.053-1.445.37332-2.09866-.11536-1.18211-1.166-.82442-2.36987-.07824-3.5717a6.51283,6.51283,0,0,0,1.46033-3.21114,3.09663,3.09663,0,0,1,1.087-1.97171C177.7464,97.52234,178.78508,98.26274,179.83816,98.49489Z"
          class="cls-11"
        />
        <path
          id="path37"
          d="M325.87713,297.25169l-7.58485,13.14719c-1.18458-1.26565-1.20426-1.27068-.85379-2.644,3.94455-15.45833,6.44415-31.26755,11.11229-46.54338,2.83848-9.28874,4.819-18.83209,8.31854-27.91925,3.482-6.40473,8.50124-11.63216,13.219-17.08274,2.04093-2.35795,4.27333-4.55175,6.07923-7.10912.67192-.9515,1.369-1.8014,2.71093-1.57154.56258.2578.97279.598.70212,1.30427q-4.54467,13.91465-9.08938,27.82931a17.00339,17.00339,0,0,0-1.04444,5.91378c-6.96761,15.33-11.00212,31.83555-19.18816,46.64185a12.56106,12.56106,0,0,0-1.16358,5.62679C328.2516,295.95152,327.89743,297.71953,325.87713,297.25169Z"
          class="cls-12"
        />
        <path
          id="path39"
          d="M325.87713,297.25169q.69775-1.52915,1.39541-3.05832c2.88548-4.51548,5.48925-9.22316,9.15875-13.20005a11.30822,11.30822,0,0,1,2.70347-2.55859c1.0987-.59327,2.33164-1.08054,2.541.94029-7.6141,14.13954-8.10745,29.82487-9.80125,45.24337-1.03456,9.41737-1.4698,18.936-3.14732,28.23376-.96927,5.3722-3.87263,10.39576-5.90555,15.57619a13.06276,13.06276,0,0,0-3.238,5.07167c-.6549,1.80458-1.7009,3.071-3.74435,1.386-.928-1.63645-.71282-3.43787-.76187-5.20325-.32813-3.96582,2.142-7.26288,2.56178-11.1125.8203-7.52265,1.90074-15.02253,2.97822-22.51719,1.03437-7.19515,2.12969-14.38162,2.967-21.60366Q324.73081,305.85056,325.87713,297.25169Z"
          class="cls-13"
        />
        <path
          id="path41"
          d="M291.36013,294.25214q6.015,7.10778,12.03,14.2156a3.60969,3.60969,0,0,1-.531,2.84154c-7.10043,11.84777-13.36588,24.21407-21.87032,35.18932-.94035,1.21355-1.61625,3.09-3.75322,1.68809-1.30742-2.43282-.31207-4.82741.20607-7.19456,1.40433-6.41552,2.58946-12.88167,4.41009-19.20436a3.83719,3.83719,0,0,0-.13424-3.44519c-3.00278-.33221-5.93849.692-8.93968,1.19732-2.27779.38352-4.72129,1.17943-6.3478-1.45137-.01368-3.58173-1.99371-6.86322-1.58821-10.61087a5.05846,5.05846,0,0,1,2.69854-2.78586c3.16648-.66484,6.33549-1.34076,9.59563-.71638,1.95766.38259,3.86138-.85175,5.50481-.37513,1.52928.79273,1.27833,2.36813,2.31494,3.24142.90069-3.71386,2.70384-6.97714,4.15076-10.38579Q290.23337,295.35405,291.36013,294.25214Z"
          class="cls-14"
        />
        <path
          id="path43"
          d="M107.89338,268.14q.68539-.80272,1.37084-1.60544c2.15256,1.42628.86472,3.17741.51915,4.88793-.29592,1.46519-1.26862,2.5939-1.72592,3.96107-.77729,2.18625-2.25478,2.3551-4.072,1.3567-1.28468-.70581-2.47763-1.60858-4.03176-1.61777-1.32806-.11984-1.9346.84146-2.70745,1.67769-2.9671,3.21025-6.10371,6.25765-9.22527,9.31675-1.14221,1.11932-2.2184,2.43513-4.06616,2.41473-3.16713-1.21007-3.77866-4.43926-4.88972-6.93664-3.79512-8.53017-6.89655-17.35633-10.31029-26.051-.72778-1.8536-.78209-3.86967-1.379-5.75926a1.98132,1.98132,0,0,1,.57365-1.08221c1.58852-1.06359,3.30242-.66067,4.99558-.41279A97.1,97.1,0,0,1,86.186,251.09614c2.27025.29288,2.74447,2.34876,3.68835,3.88085,2.53926,4.12176,5.23683,8.1434,7.732,12.29228.45629.75868.92745,1.513,2.00391,1.37961,1.64925,1.40072,3.29853,2.80144,5.30213,4.50306C105.97031,271.37326,106.93185,269.7566,107.89338,268.14Z"
          class="cls-12"
        />
        <path
          id="path45"
          d="M25.96393,215.59606q-1.94679-3.3546-3.89359-6.70916c.56317-2.80357,2.35763-1.98607,3.9134-1.19229,1.99632,1.01857,3.89135,2.23921,5.82306,3.38482,1.15732.68638,2.29514,1.52471,3.68276,1.42981,1.76139-1.01424,1.37514-2.6469,1.39335-4.07634.0587-4.61546.17844-9.23919-.02608-13.84566a12.717,12.717,0,0,1,3.2068-9.26548,39.24325,39.24325,0,0,0,3.83951-5.49771,3.96859,3.96859,0,0,1,.89391-.623q2.93663,3.98277,5.87321,7.96557c1.846,5.00895,4.653,9.52818,7.17446,14.197.79623,1.47437,1.78718,3.06571.50295,5.34612-4.19381,3.53941-9.58525,6.17311-14.41118,9.629-.97489.69816-2.33823,1.03947-2.30382,2.61915a6.772,6.772,0,0,0,1.00944,4.54088c2.08979,3.79311,3.21841,7.97707,4.70112,12.01733a3.23444,3.23444,0,0,1-.36415,3.47791c-2.89883,1.90832-4.22726-.32039-5.74679-2.15764C35.66159,230.10088,30.94007,222.75741,25.96393,215.59606Z"
          class="cls-15"
        />
        <path
          id="path47"
          d="M39.55852,218.50305c.88916-1.08543,1.58949-2.4449,2.6999-3.20913,4.97957-3.4274,10.07581-6.68545,15.59151-10.3077-2.05415-4.61831-4.04324-8.95689-5.90354-13.35a36.36692,36.36692,0,0,1-1.27613-4.46954q23.59055,39.30784,47.1824,78.61494c.5769.96114,1.17136,1.91175,1.75763,2.86727-.0991.47211-.1982.94422-.534,2.54375-4.45049-6.777-8.41527-12.81426-12.38-18.85157a12.3691,12.3691,0,0,1-5.507-4.83763c-3.11108-4.86939-7.34544-8.98452-9.68865-14.36675-.453-1.04036-1.377-1.28332-2.27784-1.62911-4.46659-3.13791-9.774-4.32836-14.767-6.17149a129.2327,129.2327,0,0,1-14.09018-6.07124A4.91577,4.91577,0,0,1,39.55852,218.50305Z"
          class="cls-16"
        />
        <path
          id="path49"
          d="M250.92952,606.76971c-.56875-1.08892-1.62431-2.1731-1.635-3.26746-.25035-25.6128-.38775-51.22669-.54591-76.84035,2.19108-.16684,2.193,1.62708,2.59,2.97692,1.93922,6.5948,2.5976,13.44022,3.58567,20.19409,1.67715,11.46437,4.39037,22.76832,5.29169,34.35009.39228,5.04076,1.32719,10.01886,1.82873,15.04819.10441,1.20514.20886,2.41027.34667,4.00063C258.508,604.43051,254.71875,605.60011,250.92952,606.76971Z"
          class="cls-17"
        />
        <path
          id="path51"
          d="M101.03421,143.71694l-.757-1.56278c-3.36217-3.84916-4.5645-8.68775-6.14667-13.3577-1.6266-4.8012-3.16649-9.63088-4.902-14.39707-.78154-2.14631-1.74344-4.41144-.21311-6.68708l-.0717-.05041c1.178-4.44218,4.30239-7.06587,8.29856-8.87505,2.709,1.35039,4.19322,3.93945,6.1372,6.06355,2.06874,2.70738,5.376,4.6894,5.13,8.75241,1.23074,7.10582,3.29459,14.03663,4.45016,21.159C113.15543,141.43794,107.52228,145.66729,101.03421,143.71694Z"
          class="cls-6"
        />
        <path
          id="path53"
          d="M211.91619,244.79872q-1.12532-1.49526-2.25062-2.9905c-.58563-5.04623.65944-9.95692,1.09271-14.92864.62983-7.22783,2.16373-14.37315,1.98356-21.67457q1.03512-7.61038,2.07035-15.22078c2.14634.10139,2.30016,3.44171,4.92993,2.92672,1.55975-.868.55-4.26346,3.55858-3.93651,1.43174.43473,1.2188,2.00512,2.07973,3.04333,2.89472-1.45547,4.96882-3.89446,7.27749-6.03379,1.55234-1.4384,3.12092-2.50844,5.15192-.79643,1.32591,2.09789-.15565,3.74319-.9355,5.468-1.41385,3.12695-3.92365,5.61924-5.187,8.83954-5.46912,13.30057-10.80981,26.6531-15.87242,40.11368A9.2539,9.2539,0,0,1,211.91619,244.79872Z"
          class="cls-4"
        />
        <path
          id="path55"
          d="M44.77,180.32378c-.15684,1.08012.07677,2.73974-.53183,3.1495-5.24915,3.53405-5.98549,8.53687-5.62921,14.33832.37682,6.13628.08455,12.31357.08455,19.4648-4.77469-2.80389-8.6422-5.17707-12.62006-7.34807a16.73182,16.73182,0,0,0-4.003-1.04141q-.67943-1.13751-1.35871-2.275c-1.07125-7.74355,2.12608-14.53354,4.54771-21.30076,2.75728-1.79478,5.51858-.6676,8.12959-.67629.97393-1.739-.28193-2.989-.57365-4.37377-.39429-1.87119-1.7347-3.67622-.36071-5.66723a1.71842,1.71842,0,0,1,1.74066-.4009C37.87437,175.96638,41.82227,177.28853,44.77,180.32378Z"
          class="cls-18"
        />
        <path
          id="path57"
          d="M316.81653,375.19112a34.33674,34.33674,0,0,1,2.74552-4.25688,19.29922,19.29922,0,0,1,3.25955-2.5059c-3.37695,7.7462-6.60521,15.56283-10.22153,23.19566-1.0821,2.28391-3.20108,4.0963-4.92595,6.05344-14.57384,16.53629-29.565,32.72837-43.56077,49.7391-5.75261,6.99182-9.37292,15.73657-13.96313,23.684-2.58726-.12106-2.03407-1.6167-1.17163-2.97527.85946-1.35391,1.75374-2.69726,2.19081-3.29514-3.03238,6.20048-9.41331,11.23927-12.20531,18.64183-2.04295,1.54361-3.21,4.44461-6.44123,4.13865-1.23248-1.04406-1.01548-2.31761-.7061-3.69819a50.12567,50.12567,0,0,1,3.59917-10.34471c.06378-.38179.12811-.76559.19193-1.14784a14.09928,14.09928,0,0,1,3.66643-6.366,10.72469,10.72469,0,0,0,6.44987-4.78309c5.1533-7.41006,11.65066-13.66286,17.58705-20.38915,7.99855-9.06284,16.2659-17.89106,24.30257-26.9228,2.90835-3.26838,6.72086-5.58321,9.24672-9.26722,1.28172-1.86942,1.66421-4.1955,3.28183-5.83726,1.53985-2.38448,4.42359-3.3272,6.04625-5.629,1.63414-3.53153,3.17458-7.16515,5.61667-10.18277,1.45356-1.79616.62965-3.9667,1.74226-5.67582C314.40121,376.28741,315.08091,374.94379,316.81653,375.19112Z"
          class="cls-19"
        />
        <path
          id="path59"
          d="M250.7876,199.79008q.055,26.48237.13867,52.9646a48.03533,48.03533,0,0,0,.63761,5.48914q-.02,1.87729-.0399,3.75467c-.64081,1.98389-2.2227,2.46005-4.05811,2.53376-4.429.17788-8.85669.33523-13.20277-.79916-2.42676-1.11859-1.66086-3.03036-1.02321-4.73558a26.61111,26.61111,0,0,1,6.23594-9.76128,1.56076,1.56076,0,0,0,.27268-.628,38.62731,38.62731,0,0,1,.88037-12.23459c2.31984-10.60855,4.55787-21.2347,6.87465-31.84378.372-1.70327.62548-3.45973,2.0627-4.69684A1.2354,1.2354,0,0,1,250.7876,199.79008Z"
          class="cls-20"
        />
        <path
          id="path61"
          d="M185.61913,169.12c-.86719-11.30616-1.82708-22.60628-2.56118-33.92109-.351-5.40926-.2736-10.84632-.39022-16.27079,1.36059,10.38649,2.76258,20.76775,4.074,31.16042q5.8959,46.72207,11.75836,93.44834a8.549,8.549,0,0,0,.8003,2.00644,2.01124,2.01124,0,0,1-3.00507.28435c-4.06049-3.56846-8.16111-7.21138-7.22264-13.42721a19.63231,19.63231,0,0,0-.00055-5.19916c-1.54739-11.47206-2.50078-23.00307-3.34336-34.54908-.471-6.45387-1.113-12.89661-1.44917-19.36043C184.201,171.78046,184.20016,170.19653,185.61913,169.12Z"
          class="cls-9"
        />
        <path
          id="path63"
          d="M129.53424,482.40032l-.14755-.89428a4.5563,4.5563,0,0,1-2.44419-3.12482c-2.05768-6.45371-3.95631-12.96587-6.45912-19.27182q-1.46659-5.26925-2.93319-10.53854c1.88386-.32114,2.16144,1.33064,2.83524,2.39642,1.05327,1.666,1.79693,3.53584,3.35014,4.85709.632.851.48616,2.25039,2.30917,2.73636,2.46849-1.9377,3.88444-5.00975,5.72946-7.67591a74.92147,74.92147,0,0,1,5.90116-7.63689c1.5603-1.72962,3.11666-1.97855,4.4471.32544.77208,10.6429,1.56,21.276,1.08626,31.95057a11.63521,11.63521,0,0,1-1.0707,4.30508A13.33254,13.33254,0,0,1,129.53424,482.40032Z"
          class="cls-21"
        />
        <path
          id="path65"
          d="M110.71284,134.65673c-.87292-6.22708-1.77095-12.45089-2.5864-18.68547a8.38724,8.38724,0,0,1,.38314-2.36845c3.40636,10.98338,7.017,21.90832,10.18049,32.96116,9.139,31.931,18.099,63.91328,27.11927,95.87824a10.49761,10.49761,0,0,1,.2036,1.4725,1.30455,1.30455,0,0,1-.2445,1.78422c-2.46712.04445-2.76254-2.07043-3.31537-3.73892-1.96141-5.91952-3.64456-11.93434-5.752-17.80149a145.302,145.302,0,0,1-5.8496-18.83794c-.65115-3.06749-2.56466-5.444-3.97251-8.10169-.8946-1.91975-.6501-4.03808-1.05588-6.0427-3.96276-11.38834-7.63253-22.87232-11.16737-34.40006-1.40136-4.57013-1.49465-9.53186-4.15182-13.73475a1.96525,1.96525,0,0,1,.16915-1.7997A11.63628,11.63628,0,0,0,110.71284,134.65673Z"
          class="cls-16"
        />
        <path
          id="path67"
          d="M89.01542,107.71231q5.125,15.23216,10.237,30.46864c.432,1.294.68674,2.64722,1.02421,3.97312-3.95137-3.13388-7.76782-6.46473-11.9141-9.31639-1.98767-1.367-4.58033-1.8839-6.935-2.67923-1.72135-.58142-3.50149-.98891-5.25587-1.47406q-1.061-9.73025-2.12118-19.46023c.2057-.38245.43753-.38118.692-.04708,4.3588,3.49564,7.27,3.62016,11.56437.4964Q87.659,108.68993,89.01542,107.71231Z"
          class="cls-22"
        />
        <path
          id="path69"
          d="M228.46777,90.58322q.71778-2.31519,1.43562-4.63037c1.85005-.352,1.84621,1.05187,2.25034,2.2342,1.425,4.16924,4.17455,7.46334,7.18416,11.33657,3.20313-5.24611,3.39639-11.14027,7.05568-15.37171a6.08153,6.08153,0,0,1,1.60866-.61786c5.29146,1.19791,5.52013,5.93468,7.14888,9.69706a20.6454,20.6454,0,0,1-6.71364,7.19922c-5.4322,3.33467-7.67174,8.2654-7.66639,14.41393a11.60617,11.60617,0,0,1-1.884,6.35474,2.11816,2.11816,0,0,1-1.03259.6622c-4.5926.13673-8.98159-.25733-11.939-4.49847.76155-8.45714,1.72748-16.90182,2.692-25.34652A2.16853,2.16853,0,0,0,228.46777,90.58322Z"
          class="cls-23"
        />
        <path
          id="path71"
          d="M262.04469,599.23119c-1.95372-11.00786-3.88718-22.01933-5.86648-33.02257q-3.33385-18.53313-6.7426-37.05271c-.15474-.84516-.45483-1.66366-.68716-2.49429q-.118-.75042-.23636-1.5014a3.89038,3.89038,0,0,1-1.25087-1.50414,6.66611,6.66611,0,0,1-1-3.91186c2.02034-9.42391.75931-18.99467,1.324-28.4806.125-2.10019-.67347-4.58652,1.83871-5.99586q.66946,1.93551,1.33885,3.871c-.53672,2.30751.6555,4.367,1.01873,6.53411,2.23945,13.35973,2.89993,26.88278,4.36173,40.32131.74252,6.82608,1.55206,13.64562,1.82223,20.51555a2.19051,2.19051,0,0,1,.49925-1.62794c.61052,6.44877,1.29873,12.89141,1.81226,19.34791C260.93936,582.55771,261.46194,590.89685,262.04469,599.23119Z"
          class="cls-24"
        />
        <path
          id="path73"
          d="M71.6823,303.24121l-2.86745-8.276a7.79277,7.79277,0,0,0,1.32065-3.827c-3.76622-5.57516-7.10922-12.18036-11.88738-17.87743a3.04438,3.04438,0,0,1-.76069-1.41652c-.16992-1.0999-.49321-2.21986.44737-3.16045,3.92127-.62388,18.98392,11.10683,25.47493,19.83684.16718,1.9088-1.38557,2.46264-2.60067,3.26077-3.76708,2.47439-4.22772,3.63377-2.50531,8.07644,4.0016,10.32146,7.07091,20.95337,10.60068,31.43131.56856,1.68777,1.61959,3.54333-.31926,5.14233-2.59642.85363-3.23361-1.28883-4.06114-2.83194-3.40646-6.35209-5.62193-13.21951-8.42821-19.83277C74.60959,310.26444,73.25106,306.70876,71.6823,303.24121Z"
          class="cls-25"
        />
        <path
          id="path75"
          d="M128.47036,196.21453c2.01513,5.4493,4.132,10.86354,6.02351,16.3554,3.56956,10.36415,7.008,20.77342,10.51288,31.1599a.8539.8539,0,0,0,.44622.52194c.14733.03841.37046-.21383.56-.33706q.41267.79744.82537,1.5949c.37417,1.03846,1.08841,2.00436.48686,3.7868a17.00325,17.00325,0,0,1-9.42946,4.391,5.58837,5.58837,0,0,1-2.65159-1.38158c-.68661-.90428-.74614-2.15145-1.0902-3.30106.95038-7.91656-2.35008-15.25159-3.19357-22.93438-.90855-8.27546-2.58374-16.45579-3.6478-24.71874C127.076,199.515,126.63257,197.5988,128.47036,196.21453Z"
          class="cls-26"
        />
        <path
          id="path77"
          d="M247.14862,85.19934C244.87,91.307,242.5913,97.41456,239.9172,104.58221c-3.66171-5.58311-6.625-10.10122-9.61512-14.66041-.1298-1.29219-.26427-2.6306-.39874-3.969,2.46209-3.57142,4.847-7.20034,7.43772-10.676.69265-.92934,2.014-1.39051,3.04666-2.06661C245.23241,73.70591,249.10917,80.58058,247.14862,85.19934Z"
          class="cls-27"
        />
        <path
          id="path79"
          d="M305.65355,235.11747c.47688-1.89506.63523-3.94792,1.48362-5.659,4.65481-9.38787,9.47869-18.692,14.2445-28.0249,2.2196.06744,2.14383,1.57991,1.95332,3.13466a35.06816,35.06816,0,0,1-1.47708,7.31251,19.12654,19.12654,0,0,0-1.33854,9.06066c-3.98161,11.74452-6.34688,23.93989-9.92917,35.79792a19.40808,19.40808,0,0,1-1.0869,3.16171c-.6856,1.36528-1.55165,2.31259-3.18446,1.18094-1.73988-3.277-1.59288-6.84553-1.44647-10.353C305.08951,245.5242,305.70712,240.33782,305.65355,235.11747Z"
          class="cls-28"
        />
        <path
          id="path81"
          d="M110.708,611.93249q3.751-19.22909,7.49358-38.4598c1.10753-5.74173,2.00016-11.52868,3.27474-17.23158.29391-1.31512,1.755-2.36966,2.67844-3.54475-1.10062,10.74022-2.24164,21.47711-3.28265,32.22369-.48516,5.009-.77647,10.03666-1.15562,15.05587,1.47072.74309,1.57746,1.99785,1.42249,3.45407a41.3059,41.3059,0,0,1-2.1936,9.298q.00192.35775-.00334.71532Q114.82477,612.68767,110.708,611.93249Z"
          class="cls-29"
        />
        <path
          id="path83"
          d="M58.3161,271.75939l.65445.78383c.91116,1.86931,2.14584,3.55395,3.09269,5.4019.63582,1.2409,1.26963,2.51137-.89424,2.90455q-13.115-24.05056-26.21657-48.10838c-3.07549-5.67207-5.99674-11.42772-8.98845-17.14523,5.349,6.37118,10.672,12.76459,16.06637,19.0972,1.26945,1.49025,2.77965,2.77555,4.17908,4.15514,1.78028-.12231,2.592.8923,2.91929,2.47639,3.26074,8.039,5.64385,16.38563,8.53884,24.554C58.1029,267.81414,57.61627,269.85184,58.3161,271.75939Z"
          class="cls-30"
        />
        <path
          id="path85"
          d="M141.53683,76.9301q7.144-4.82425,14.28793-9.64846c1.38374,1.175.96913,2.80966.97077,4.26377a107.94113,107.94113,0,0,0,1.27467,14.58892c.41081,2.98109,1.91081,5.82054,1.29626,8.98266-.25539,1.261-1.03433,2.38479-1.03565,3.72357-.067,1.09528.06108,2.252-.94049,3.00818a2.41518,2.41518,0,0,1-3.26079-1.03637c-4.67577-7.40084-10.30416-14.27026-12.83231-22.874A.75594.75594,0,0,1,141.53683,76.9301Z"
          class="cls-14"
        />
        <path
          id="path87"
          d="M138.41143,252.4093c2.49507-1.26855,4.99014-2.53712,7.809-3.97036.18-.85348.39892-1.8914.61784-2.92933l2.11734,1.52541c.32073.55329.68734,1.02392,1.9373.6545a47.86236,47.86236,0,0,0,.01267-11.38313,152.82184,152.82184,0,0,1-.80314-17.60888,1.14791,1.14791,0,0,1,1.10008-.32736c1.41952.49424,1.5969,1.7699,1.86739,2.97344a164.17051,164.17051,0,0,1,3.35343,20.10052,11.88087,11.88087,0,0,1-.56957,4.822c-.37462,4.4839-2.83163,7.76054-5.94161,10.8005-3.453,3.37533-5.261,7.88642-7.652,11.98447-1.92778.90331-2.97345,2.93781-4.92466,3.81451-2.51058.09694-2.66939-2.0991-2.65868-3.47967.04117-5.28514-.10533-10.62374,1.46412-15.779C136.61,252.66523,137.623,252.75027,138.41143,252.4093Z"
          class="cls-31"
        />
        <path
          id="path89"
          d="M341.67572,279.375a23.39338,23.39338,0,0,0-3.60352,2.67738c-3.671,3.98145-7.2101,8.08436-10.7992,12.14129,3.962-10.10077,7.87461-20.22116,11.90348-30.29509,2.96276-7.4082,6.07773-14.75551,9.12485-22.13,1.67733,1.051,1.09687,2.70926.97983,4.13124-.85992,10.44835-3.62067,20.48462-6.75518,30.43332a2.54845,2.54845,0,0,0-.1691,1.446Q342.01635,278.57711,341.67572,279.375Z"
          class="cls-32"
        />
        <path
          id="path91"
          d="M252.40884,265.01607q4.81225,9.4017,9.6245,18.80345a105.721,105.721,0,0,0,8.3719,16.938c.48.82377,1.57311,1.38305.54262,2.49347-1.22557,1.12323-2.63324.72861-3.885.26578a93.82136,93.82136,0,0,0-10.489-3.421c-1.78641-1.53509-1.52635-3.80192-1.93351-5.7833-.56719-2.75968-1.14555-5.51385-1.83051-8.24852a10.5245,10.5245,0,0,0-.286-5.17743,85.45923,85.45923,0,0,1-2.1554-12.76039C250.20407,266.55454,250.26707,265.09381,252.40884,265.01607Z"
          class="cls-33"
        />
        <path
          id="path93"
          d="M252.40879,265.01607c.56967,5.00858,1.1499,10.016,1.7036,15.02632.218,1.97217.37673,3.9509.56244,5.92663-1.92582,1.36692-3.00421-.14107-4.04961-1.30445-4.06639-4.52525-8.04943-9.12625-12.26516-13.51514-1.78847-1.86188-2.17549-4.81183-4.74779-6.05255a2.09418,2.09418,0,0,1-.4814-1.56667,1.28039,1.28039,0,0,1,.66926-.86286l17.72385-.66886Q251.96637,263.5073,252.40879,265.01607Z"
          class="cls-34"
        />
        <path
          id="path95"
          d="M157.18827,99.43891l.02828-3.81271c1.0045-5.41395-.11553-10.8245-.15231-16.23379-.03267-4.81743-.16576-9.6281.11644-14.44169a3.56823,3.56823,0,0,1,.04168-.72,2.02285,2.02285,0,0,1,.92425-.61709c3.93165.56345,5.98521,3.63756,7.96208,6.46709a41.482,41.482,0,0,0,2.82106,3.59376,2.60043,2.60043,0,0,1,.62612,3.32205c-2.89353,7.38321-5.29823,14.94614-8.1208,22.35793-.63248,1.66093-1.187,3.28251-3.3732,3.30286C156.90721,101.81909,158.11339,100.33978,157.18827,99.43891Z"
          class="cls-35"
        />
        <path
          id="path97"
          d="M249.42394,485.26776c-.26056,10.6676-.50382,21.33565-.808,32.002a18.90959,18.90959,0,0,1-.6544,3.242c-2.25464-.64613-2.38919-2.6411-2.79484-4.43867a236.03845,236.03845,0,0,1-4.9318-29.55013c1.31722-5.12194,4.84465-9.14475,6.9435-13.88266.68295-.88783,1.45411-1.50634,2.63676-.85307Q249.61951,478.52754,249.42394,485.26776Z"
          class="cls-36"
        />
        <path
          id="path99"
          d="M228.46777,90.58322c-.02164,3.03311.09672,6.07509-.0948,9.09744-.374,5.90253-.92128,11.79408-1.39678,17.69018,3.38843,5.03157,3.57574,11.03.39988,13.76574-2.30763-.38741-1.90157-2.20932-2.099-3.78385,1.67619,7.20819-1.22164,14.17462-1.016,21.3108a20.401,20.401,0,0,0,.5268,4.82073,18.47443,18.47443,0,0,1-1.54154,8.63678c-2.19169,5.20783-1.57082,11.12124-3.54331,16.44539-.65947,1.78-.5385,3.99734-2.63534,4.91661-1.19492-.3154-1.07958-.99243-.765-1.7415,1.38342-11.13183,2.70919-22.27119,4.16325-33.3938q3.58729-27.441,7.31876-54.86306A29.40058,29.40058,0,0,1,228.46777,90.58322Z"
          class="cls-37"
        />
        <path
          id="path101"
          d="M86.73878,351.93322q-.73763-4.11641-1.47529-8.23286c1.20672-1.81884,2.49365-3.52385,4.9948-3.51823a5.71508,5.71508,0,0,1,2.49621,3.52742c.07449,5.1519,2.28585,9.85029,3.14362,14.8616,2.09876,12.26156,4.86244,24.40628,6.99341,36.66789.32594,1.87519,1.17945,4.059-1.65912,4.9283-3.17706-3.75019-4.16477-8.4886-5.53323-12.97209C92.157,375.59006,89.22959,363.81332,86.73878,351.93322Z"
          class="cls-38"
        />
        <path
          id="path103"
          d="M32.805,175.05547c1.66013,4.1811,3.32031,8.36217,5.33424,13.43435-2.67158-.76323-4.39334-1.288-6.13345-1.74265-1.62632-.42491-3.27208-.7754-5.37981-1.26878-2.057,7.35116-3.98532,14.24227-5.91393,21.13349q-2.21389-5.64923-4.4272-11.29857c.7411-2.2323-1.32275-3.87431-1.25531-6.06424.92974-2.43275,3.23077-3.14654,5.45874-3.68559,1.44024-.34847,2.79241-.59548,3.75939-1.80164a12.2638,12.2638,0,0,0,3.22263-4.41631c1.046-2.08481,2.15329-4.15532,4.40807-5.243C32.49273,174.12385,32.88021,174.36544,32.805,175.05547Z"
          class="cls-39"
        />
        <path
          id="path105"
          d="M216.30267,181.74154a14.70849,14.70849,0,0,0,1.38973-2.97082c1.86465-8.45926,3.64392-16.93732,5.44918-25.40966a3.73485,3.73485,0,0,1,1.45612,1.66138c.833,10.40764.37558,20.82711.242,31.24292a3.02572,3.02572,0,0,1-1.69033,3.07607c-.40257,2.39871-.8052,4.79743-1.29919,7.74067-2.23716-1.20443-4.24094-2.28325-6.4732-3.48507-.19-1.21787-.37668-2.41455-.56409-3.612Q215.55708,185.86249,216.30267,181.74154Z"
          class="cls-40"
        />
        <path
          id="path107"
          d="M247.14862,85.19934q-3.38031-5.99457-6.76081-11.98913c4.46824-6.80971,10.12189-7.91557,15.38681-2.22595,1.38978,1.50195,2.67539,3.10026,4.0088,4.65434q-.26436.44652-.55956.87365c-3.16356,3.48913-6.612,6.5704-11.29548,7.88313Z"
          class="cls-41"
        />
        <path
          id="path109"
          d="M190.23479,227.48805c.24349,2.05718.63006,4.10943.70129,6.17256.16018,4.63633,3.93655,10.11344,8.3643,11.88275q1.01852.76844,2.037,1.53683l-2.31129,2.8918c-1.3696,1.29082-2.11614.24971-3.01211-.71-2.03064-2.17516-3.94859-4.44825-5.94047-6.65634q-1.7729-1.92573-3.54573-3.85151c-.61537-.9474-1.7574-1.4098-2.44932-2.80912-1.79112-10.57764-3.30507-21.5794-4.94544-32.55492a3.32431,3.32431,0,0,1,2.24568-3.836c2.48441.31349,2.622,2.441,3.00434,4.14758,1.64013,7.32172,4.071,14.477,4.70574,22.01512A1.89306,1.89306,0,0,0,190.23479,227.48805Z"
          class="cls-42"
        />
        <path
          id="path111"
          d="M359.58061,208.83314q-.42865-.43713-.85736-.87423a3.64986,3.64986,0,0,1-1.716-1.29615,5.98521,5.98521,0,0,0-4.34187-3.65954c-2.32816-.7012-4.87466-1.32359-5.91905-4.02567.30169-3.46211,2.52129-5.73706,4.891-7.92415a15.44872,15.44872,0,0,1,12.08641-2.37079c.95266,1.60783.75,3.257,1.76852,4.41519Q362.53646,200.96545,359.58061,208.83314Z"
          class="cls-43"
        />
        <path
          id="path113"
          d="M149.58791,220.96489c-.35733-5.18016-.79614-10.35624-1.05579-15.54129-.62018-12.3835-1.15594-24.77124-1.72574-37.15727a177.75609,177.75609,0,0,0-.52428-21.08442c-.33939-4.42445-.83421-8.83739.24418-13.23271,2.21406-.36676,2.348,1.30255,2.58735,2.74a34.79233,34.79233,0,0,1,.7142,8.84411c-.48314,5.021,2.95273,9.16332,2.5621,14.05419-.74481,2.58463.03276,5.19067-.08048,7.78752-.53553,12.28788-1.0174,24.57746-.76571,36.88291.06606,3.2304-.01707,6.46149.37041,9.68242.20854,1.73366.40079,3.52479-1.38836,4.69666l-.15172.01726C149.72356,219.29242,150.50534,220.4175,149.58791,220.96489Z"
          class="cls-44"
        />
        <path
          id="path115"
          d="M86.73878,351.93322c2.31686,7.34136,4.73406,14.653,6.92437,22.03186,2.546,8.57733,4.89328,17.21356,7.32681,25.82422,1.54744.93879,1.99907,2.01811.43287,3.35652-3.13506-1.50346-3.5084-4.86254-5.01242-7.46156a51.63922,51.63922,0,0,1-5.94362-19.00788Q88.60283,364.3048,86.73878,351.93322Z"
          class="cls-45"
        />
        <path
          id="path117"
          d="M258.46469,554.88181v5.89626l-.49417.006q-2.02208-18.06772-4.04315-36.13555c-1.17164-10.50264-2.36134-21.0034-3.46718-31.51294a21.72071,21.72071,0,0,1,.30256-3.99683,74.90914,74.90914,0,0,1,4.32943,21.83786C256.00169,525.625,257.31726,540.2482,258.46469,554.88181Z"
          class="cls-46"
        />
        <path
          id="path119"
          d="M89.7745,340.67506q-2.25562,1.51265-4.51115,3.02535-6.7902-20.22955-13.58082-40.45914,6.03426,12.20262,12.076,24.40192c1.43873,2.89117,2.9584,5.742,4.44115,8.61131C90.67272,337.03458,91.38957,338.43981,89.7745,340.67506Z"
          class="cls-44"
        />
        <path
          id="path121"
          d="M97.1753,395.53545q1.96457,3.62,3.92918,7.24a4.90349,4.90349,0,0,1,3.61807,3.50858c5.55051,11.70622,9.78464,23.94272,14.51151,35.9812,1.45439,3.704,3.24844,7.27724,4.40611,11.09384.46929,1.54714.96465,3.29976-1.66429,3.4354q-2.21315-4.11167-4.426-8.22348Q106.98131,422.75471,96.412,396.93875C96.0362,396.12848,95.813,395.40112,97.1753,395.53545Z"
          class="cls-47"
        />
        <path
          id="path123"
          d="M305.65355,235.11747c.23155,1.69357.59419,3.38116.67169,5.08176.3205,7.03124.55466,14.06639.82057,21.10012a1.398,1.398,0,0,1-.07448,2.16764c-2.99524,5.53473-5.97373,11.07865-8.99834,16.59726-.706,1.28822-1.56876,2.49052-2.36065,3.7327,4.84543-10.93379,6.61225-22.57626,7.9674-34.3249C304.233,244.67512,304.98945,239.90161,305.65355,235.11747Z"
          class="cls-48"
        />
        <path
          id="path125"
          d="M31.97554,174.47454c-1.4273,2.9822-2.7662,6.01247-4.345,8.91221-.38642.70975-1.55838.9922-2.3692,1.4711a9.339,9.339,0,0,1-6.54024-.02364c-1.67248-.514-3.2595-1.38144-2.459-3.68344,3.43487-8.04707,6.39044-9.59235,14.48215-7.57189A1.13274,1.13274,0,0,1,31.97554,174.47454Z"
          class="cls-49"
        />
        <path
          id="path127"
          d="M318.27485,220.83576c1.0556-5.28825,2.15338-10.5687,3.13318-15.87094a18.13348,18.13348,0,0,0-.0264-3.53195q.5775-.79,1.155-1.58144c2.20939-2.7833,5.33886-4.33137,8.26941-6.144,1.08511-.67124,2.201-1.25654,3.49078-.46353,1.44532,1.1998,1.15109,2.66377.42193,4.02727-4.08127,7.63124-8.615,14.99918-13.191,22.33951a2.656,2.656,0,0,1-2.74749,1.524C318.61163,221.03605,318.44326,220.93589,318.27485,220.83576Z"
          class="cls-50"
        />
        <path
          id="path129"
          d="M150.40381,159.44563q-1.47057-10.99825-2.95035-21.99528c-.16512-1.21188-.45094-2.40737-.681-3.61043-1.72323-3.16566-.30892-6.7055-1.17969-9.98-.15144-.56961.01478-1.2188-.28947-1.78266q-.00543-1.233-.0108-2.466c1.58313-1.91425,3.23077-1.193,4.88765-.1192.7794.51161,1.64586.92968,2.00707,1.88715a7.29412,7.29412,0,0,1,.55187,1.76693c.16682,11.60435,1.30349,23.232-.79984,34.78535C151.5005,158.51064,151.14335,159.17214,150.40381,159.44563Z"
          class="cls-51"
        />
        <path
          id="path131"
          d="M334.11575,193.87347q-5.78677,2.98884-11.57636,5.97783c2.05869-2.07852,4.09037-4.18773,6.18726-6.23,5.77882-5.62833,12.344-8.7344,20.75088-7.3755,4.61708.74633,9.38312.57174,14.39952.82861.6065,2.26054,1.11124,4.14213,1.61561,6.02356-.77148-1.09762-1.54268-2.1951-2.78971-3.96992-3.36876,1.035-6.96295,2.13918-10.55717,3.24343-1.332-.00247-2.72155.13748-3.88115-.66031-4.76352-3.27709-8.70584-2.1068-12.11939,2.147A1.80038,1.80038,0,0,1,334.11575,193.87347Z"
          class="cls-22"
        />
        <path
          id="path133"
          d="M342.35688,277.77915c.9075-5.87318,1.76678-11.75435,2.73587-17.61741,1.01479-6.13995,2.135-12.26253,3.20876-18.39292q1.09456-2.55347,2.18972-5.10643c.16439,5.83465.36474,11.66862.466,17.50433a10.56211,10.56211,0,0,1-.50149,4.00022C347.83758,264.73679,345.07179,271.24785,342.35688,277.77915Z"
          class="cls-13"
        />
        <path
          id="path135"
          d="M168.37871,76.96656q-.37253-1.50191-.745-3.0038a1.369,1.369,0,0,1-.21472-1.0814c.55-1.25556,1.43823-2.31844,1.65894-3.77642.16654-1.09977.68817-2.34936,2.34134-1.87535,1.1548,3.77273,2.43125,7.51337,3.43753,11.32527,1.74839,6.62348,3.32987,13.291,4.98135,19.94l-.827,1.8618c-.65774-.73636-1.09459-1.22544-1.53139-1.71453a1.887,1.887,0,0,1-2.17992-1.05084C172.921,90.74094,168.75932,84.48451,168.37871,76.96656Z"
          class="cls-52"
        />
        <path
          id="path137"
          d="M97.38434,99.3907q-4.22011,4.13567-8.44043,8.27125c-2.39194-2.97676-4.78375-5.95346-7.54642-9.39169l10.06812-3.19987C93.56744,96.33405,96.372,96.63571,97.38434,99.3907Z"
          class="cls-53"
        />
        <path
          id="path139"
          d="M149.69684,120.43364q-2.20243-.411-4.4046-.82221a60.62058,60.62058,0,0,0-1.96786-7.93894c-4.80786-12.28965-1.809-25.02261-2.14149-37.57845q.17666,1.4181.35367,2.83613-.0208.38973-.04223.77961a42.885,42.885,0,0,1,2.56982,13.99249c.03,3.85425-.36176,7.74277.69947,11.532,1.6615,4.24054,4.26931,8.02672,5.96755,12.2439C151.44436,117.24929,152.879,119.38332,149.69684,120.43364Z"
          class="cls-54"
        />
        <path
          id="path141"
          d="M61.169,280.84967q-1.099-4.15335-2.19827-8.30656c4.95381,6.58323,9.90781,13.16637,15.46011,20.54459-2.54709.85159-4.08191,1.36473-5.61636,1.87768Q64.99206,287.90737,61.169,280.84967Z"
          class="cls-55"
        />
        <path
          id="path143"
          d="M157.93129,64.21905q-.35474.00173-.70916.01165-5.24392-2.091-10.48836-4.18216-.16519-.48228-.33047-.96457c4.69284-.98135,9.37085-2.53622,14.086-2.65853,1.85623-.04816,3.79559,3.10291,5.69706,4.79712C164.44147,64.99288,160.88348,63.77214,157.93129,64.21905Z"
          class="cls-39"
        />
        <path
          id="path145"
          d="M259.342,75.62392a2.41389,2.41389,0,0,0,.44151.01458c2.14964,2.9123,5.34632,5.34312,4.44436,9.65846l-.22373.025-.22314-.02967c-1.6481.59663-2.13349,2.121-3.01,3.43322-1.20449,1.80324-2.49086,3.91749-5.97336,3.53844C253.41443,85.94831,255.62236,80.61146,259.342,75.62392Z"
          class="cls-56"
        />
        <path
          id="path147"
          d="M157.93129,64.21906q4.12755-1.49824,8.255-2.9965,1.08167,1.17607,2.16341,2.35208c.83906,3.29435,1.12474,6.5589-.52391,9.71926a2.62015,2.62015,0,0,1-.19211.66886Q162.78248,69.09093,157.93129,64.21906Z"
          class="cls-57"
        />
        <path
          id="path149"
          d="M289.10654,296.45592a14.56261,14.56261,0,0,1-.07938,3.54761,68.94466,68.94466,0,0,1-4.65385,12.951c-.78374-2.75666-1.56749-5.51332-2.41437-8.49205l-4.163.20393a.71326.71326,0,0,1,.05989-.87483c.4454-.19171.97109-.13823,1.37724-.45011Q284.16984,299.89869,289.10654,296.45592Z"
          class="cls-35"
        />
        <path
          id="path151"
          d="M120.48338,459.1094c1.99628,4.64909,4.06251,9.26983,5.96211,13.95807,1.11751,2.7579,1.97047,5.62286,2.9418,8.43917-.94493,1.68068-2.57258,3.31068-2.70357,5.05306-.37114,4.93735-.13,9.92076-.13,14.886l-1.03684.01523q0-6.27342-.00041-12.54713c1.18728-9.02181-1.74482-17.37692-4.15859-25.82C120.98483,461.789,120.77089,460.43866,120.48338,459.1094Z"
          class="cls-58"
        />
        <path
          id="path153"
          d="M145.30332,122.07727q.7339,5.88185,1.46847,11.76318c.2251,9.89716.4821,19.7943.64054,29.693a32.21634,32.21634,0,0,1-.60613,4.7332Q146.055,145.17159,145.30332,122.07727Z"
          class="cls-59"
        />
        <path
          id="path155"
          d="M212.74184,205.205c-.02819,3.30877.18607,6.641-.13122,9.92179-.86129,8.90543-1.94787,17.78908-2.94509,26.6814q-1.82305,1.07905-3.64529,2.15738c.8941-1.82442,2.32762-3.57361,2.59152-5.48421C210.141,227.4103,211.39479,216.30123,212.74184,205.205Z"
          class="cls-60"
        />
        <path
          id="path157"
          d="M16.2621,181.15077q4.49958,1.85357,8.99916,3.70708c-3.02937,1.55455-6.05873,3.10912-8.9766,4.60645,0,2.047,0,3.94831.00009,5.84931C14.19331,190.5958,13.49833,185.87605,16.2621,181.15077Z"
          class="cls-28"
        />
        <path
          id="path159"
          d="M249.81517,471.78729q-.94893.78638-1.8979,1.5727c-2.5357,2.333-3.93468,5.61787-6.56453,7.86374-1.15182.98364-2.2142,2.54637-4.04494,1.07218l15.38631-21.03157q.44094.24765.88188.49539a55.84547,55.84547,0,0,0-2.71835,5.31279,19.65723,19.65723,0,0,0-.70747,4.028Q249.98265,471.44391,249.81517,471.78729Z"
          class="cls-33"
        />
        <path
          id="path161"
          d="M157.18068,64.95071a19.15371,19.15371,0,0,1,.70884,3.58121q.10617,11.74617.0205,23.49355a19.577,19.577,0,0,1-.69356,3.6012c-.53416-7.9573-1.094-15.91257-1.57975-23.87236a41.71378,41.71378,0,0,1,.18768-4.47284Q156.50286,66.11624,157.18068,64.95071Z"
          class="cls-61"
        />
        <path
          id="path163"
          d="M149.588,220.96489q.39366-1.1562.78672-2.31151,1.00959,15.22919,2.02043,30.45653l-.89844.62132q-1.27053-1.34808-2.541-2.69618c.50268-.97352,1.457-1.9566,1.43654-2.919C150.22808,236.39681,149.87981,228.68146,149.588,220.96489Z"
          class="cls-61"
        />
        <path
          id="path165"
          d="M101.62052,235.89982c.34736.24074.93789.42654,1.00656.73028,1.81514,8.02326,3.60379,16.05287,5.30835,24.10018a9.86889,9.86889,0,0,1-.24894,2.85591Q104.65343,249.7434,101.62052,235.89982Z"
          class="cls-44"
        />
        <path
          id="path167"
          d="M279.2331,303.3415l-1.27169.76447c-2.42882.041-5.14712,1.38706-6.91916-1.53333l-9.00891-18.75312c2.11492,4.07044,4.59132,7.99964,6.25236,12.24741C270.322,301.27421,274.2528,302.92523,279.2331,303.3415Z"
          class="cls-62"
        />
        <path
          id="path169"
          d="M31.97554,174.47456q-.616-.44783-1.23166-.89566c1.48-.16635,3.27543-.94923,4.38026-.3838,3.36729,1.72342,6.4684,3.96652,9.673,6.00669q-.01372.56051-.02722,1.12217-5.98265-2.63414-11.96516-5.26819Q32.39038,174.76486,31.97554,174.47456Z"
          class="cls-63"
        />
        <path
          id="path171"
          d="M263.71873,121.23953q.27041-15.04264.54089-30.08528Q263.98916,106.1969,263.71873,121.23953Z"
          class="cls-56"
        />
        <path
          id="path173"
          d="M167.82583,73.2939q.26189-4.85964.52387-9.71927,1.53481,1.82749,3.06958,3.655Q169.62251,70.26173,167.82583,73.2939Z"
          class="cls-64"
        />
        <path
          id="path175"
          d="M97.1753,395.53545q-.38137.70158-.763,1.40325a41.632,41.632,0,0,1-5.9454-20.26228Q93.821,386.10592,97.1753,395.53545Z"
          class="cls-7"
        />
        <path
          id="path177"
          d="M74.74255,109.17708q-.34685.0186-.6926.04673c1.22109-2.94719,1.37367-6.71092,5.231-7.64317q.5207.40075,1.04129.80155Q77.53243,105.77963,74.74255,109.17708Z"
          class="cls-65"
        />
        <path
          id="path179"
          d="M97.38434,99.3907q-2.95989-2.1604-5.91928-4.32055c5.63749,1.23177,9.27953,4.89175,11.91405,9.77949Q100.38217,102.12093,97.38434,99.3907Z"
          class="cls-12"
        />
        <path
          id="path181"
          d="M202.95532,566.21077c.68222,10.912,1.39088,21.8224,2.02863,32.737a58.40443,58.40443,0,0,1,.05687,8.57613c-.09174,1.02577-1.37729,1.94484-2.118,2.91235-.15432-1.20249.108-2.71729-.525-3.56067-11.822-15.752-23.75994-31.4169-35.65153-47.11675-4.74037-6.25843-9.55043-12.47071-14.07051-18.88573-1.52095-2.15865-2.2437-4.87923-3.33128-7.343q.323-.57344.64611-1.147c1.80508.60369,3.85909.84018,5.37657,1.8681,14.33976,9.71441,28.57882,19.57732,42.88,29.34894a27.957,27.957,0,0,0,3.93225,1.8885.657.657,0,0,1,.85557-.11306A.58826.58826,0,0,1,202.95532,566.21077Z"
          class="cls-66"
        />
        <path
          id="path183"
          d="M118.94537,612.728c-.26038-1.19188-.84359-2.41883-.71873-3.5689.3344-3.07863.97238-6.12438,1.48979-9.18317,1.74583-6.61213,3.67119-13.183,5.20243-19.84436,4.02508-17.51041,7.87589-35.0608,11.8108-52.592a19.1975,19.1975,0,0,1,.7006-2.048q.49311.03154.98629.063V612.728Z"
          class="cls-67"
        />
        <path
          id="path185"
          d="M173.54842,501.0845q-11.42223-7.41879-22.84612-14.83493c-2.82069-1.828-5.66087-3.62606-8.49213-5.43777a1.08819,1.08819,0,0,1-.325-1.05751A8.88993,8.88993,0,0,1,145.297,475.426c11.35642-8.57815,22.89324-16.90993,34.45144-25.21179a13.44821,13.44821,0,0,1,5.24845-2.45652c1.97253.88381,2.21287,2.35421,1.95766,4.10363a67.30738,67.30738,0,0,1-1.40378,6.58913c-2.84429,11.3831-5.7154,22.75908-8.05043,34.26306-.55612,2.73965-1.07423,5.54361-2.9892,7.78581A1.72093,1.72093,0,0,1,173.54842,501.0845Z"
          class="cls-53"
        />
        <path
          id="path187"
          d="M202.88958,565.527q-.35544-.01612-.71031-.03805c-4.51454-10.2431-8.99152-20.50284-13.554-30.72444-4.9173-11.0165-9.91467-21.99734-14.87713-32.99372,1.58455-1.62,3.79161-1.364,5.60245-1.27291a149.10223,149.10223,0,0,1,21.35633,2.44663,6.33749,6.33749,0,0,1,3.63394,1.7164c1.15182,1.63252,1.0982,3.52486,1.15072,5.38436.46668,16.53468-1.1159,33.03606-.82313,49.57024A8.6488,8.6488,0,0,1,202.88958,565.527Z"
          class="cls-68"
        />
        <path
          id="path189"
          d="M142.196,480.10763q.00343.35241.014.70444c-.75414,6.40194-1.60134,12.795-2.23648,19.209-.63582,6.42142-1.05981,12.86384-2.4382,19.65653a23.00539,23.00539,0,0,1-1.96374-3.01049c-1.55033-3.40334-2.89975-6.89994-4.51152-10.27232-.4465-.9343-1.53555-1.56177-2.32959-2.32992q.40136-10.83285.80292-21.66512,5.98134-1.18864,11.96113-2.37849Q141.91166,479.52615,142.196,480.10763Z"
          class="cls-14"
        />
        <path
          id="path191"
          d="M203.62372,504.84352q-14.93837-1.536-29.87618-3.07241-.0969-.344-.19788-.6867l.20584-.023c1.871-2.55653,4.50077-3.932,7.347-5.214,7.35724-3.31389,14.53243-7.02836,22.02591-10.04982,1.85262-.74693,3.60924-1.19234,4.84337,1.005a32.332,32.332,0,0,1-3.79517,17.72285C203.99391,504.63479,203.80879,504.7392,203.62372,504.84352Z"
          class="cls-69"
        />
        <path
          id="path193"
          d="M267.35313,317.59922c4.124-.44824,8.25266-.85838,12.36938-1.36539,1.44858-.17836,2.86791-.59418,5.33649-1.12391-2.48789,11.48907-4.82561,22.28477-7.16343,33.08043,2.83323-.61641,3.957-3.23624,5.6067-5.08778,8.34252-9.363,17.78122-17.56552,27.01821-25.98438.8892-.8105,1.77831-1.79771,3.13587-1.664,1.38626.20091,1.34806,1.34078,1.63827,2.25148a16.77935,16.77935,0,0,1-.30938,2.74c-1.91122,4.365-4.60646,8.31033-6.32978,12.80809-4.86688,12.70235-11.5748,24.58268-16.961,37.06272-1.42675,3.30593-3.58709,6.25216-4.96918,9.60593-.79385,1.92641-2.85139,2.25958-4.51628,3.04794a16.64311,16.64311,0,0,0-1.97669,1.25188,19.24251,19.24251,0,0,0-7.50855,2.49173,133.35014,133.35014,0,0,1-17.71918,7.118c-12.12443,4.21142-23.94126,9.23041-36.03928,13.4979-2.11766.747-4.2802,2.3467-6.72823.79133-1.40818-1.51558-1.34641-3.60306-2.0881-5.3743a6.24632,6.24632,0,0,1-.18992-.71857c-1.13865-7.72855-4.4499-14.10757-11.14642-18.54323-1.52242-1.00839-2.28749-2.91636-3.5805-4.22911-1.026-1.04164-1.82695-2.9332-3.89455-1.83353-1.69573,2.86542-.89575,6.09223-1.2248,9.09293-.82176,7.49389-1.35089,15.03049-1.81985,22.562a22.31815,22.31815,0,0,1-2.375,9.60264c-1.12395.85513-2.24823,1.69787-3.78831,1.44794-2.10219-.27546-4.22236-.32837-6.333-.4985-3.62635-.29247-4.55325-1.23606-4.55513-4.93635-.00215-4.3708.94557-8.659,1.4461-12.98417,1.97532-17.06734,3.90215-34.14054,5.93237-51.20157.21948-1.84436.33271-3.80827,2.57344-4.53334,12.797-6.73658,25.60921-13.44484,38.3647-20.25917a7.73881,7.73881,0,0,0,2.74159-2.87882c5.56291-9.45192,11.01982-18.96617,16.5691-28.42617a14.39544,14.39544,0,0,1,2.23918-2.37734,3.08889,3.08889,0,0,1,3.0591.89517c7.258,6.28626,14.05491,13.05025,20.68226,19.98547A12.01815,12.01815,0,0,1,267.35313,317.59922Z"
          class="cls-70"
        />
        <path
          id="path195"
          d="M181.19344,345.974c-2.80623,23.65039-5.61246,47.30083-8.53619,71.94154h9.28521c1.23491.75617,2.72864-.03544,4.0065.71647,1.72831,2.72255,2.77288,22.01079,1.49039,28.05312a2.4931,2.4931,0,0,1-.50337,1.16983,1.84213,1.84213,0,0,1-1.72015.38842c-5.16176-1.29674-9.96079-3.60238-14.80283-5.69924-10.95947-4.746-21.9507-9.43507-32.67862-14.70367-2.30117-1.13-4.23211-2.9369-6.76973-3.62639a2.68238,2.68238,0,0,1-.92461-1.57119c.302-1.8868-.44678-3.7351-.22913-5.6171a327.4522,327.4522,0,0,1-2.01243-42.417,8.41463,8.41463,0,0,0-.43666-2.1956c.7417-14.48708,2.2502-28.91836,3.25813-43.38445-.09644-3.72576.447-7.29489,2.609-10.456,6.60547-5.15882,13.81521-9.45309,20.69-14.23451,7.75012-5.39026,15.78692-10.35705,23.618-15.63084,1.37262-.92436,2.78605-1.789,4.39142-.41255Q181.56093,317.13448,181.19344,345.974Z"
          class="cls-39"
        />
        <path
          id="path197"
          d="M181.92837,288.29491q-13.44261,8.75508-26.88507,17.5104-10.16323,6.62023-20.325,13.24254c-2.119-.16767-1.93268-1.54554-1.3675-2.88161a41.15183,41.15183,0,0,1,2.75852-5.31229c9.38924-15.46091,18.64032-31.00458,28.28161-47.04284-7.03944,2.8868-13.57171,5.50338-20.05531,8.24205a26.75978,26.75978,0,0,1-3.8842,1.363c-1.41678.355-2.77526.4111-2.7932-1.66758q1.5318-1.83781,3.06364-3.67564A262.30406,262.30406,0,0,1,164.4244,242.3514c1.09239-.50076,1.8733-1.5681,3.14824-1.742a1.40729,1.40729,0,0,1,.8644.4921c.48219,6.40665.111,13.0325,1.686,19.15842,1.58171,6.152,5.16683,11.77781,7.74828,17.68907C179.35277,281.34128,180.58434,284.84264,181.92837,288.29491Z"
          class="cls-67"
        />
        <path
          id="path199"
          d="M211.91619,244.79872q7.46839-19.04638,14.93066-38.09521c1.0798-2.76265,2.08151-5.55579,3.11922-8.33489a3.3924,3.3924,0,0,1,.876.926,13.88493,13.88493,0,0,1,1.7752,4.45077c2.21676,10.72668,4.50439,21.439,6.74279,32.16133a26.39561,26.39561,0,0,1,.14311,12.02679Q225.70969,246.3661,211.91619,244.79872Z"
          class="cls-10"
        />
        <path
          id="path201"
          d="M168.437,241.10147q-.37348-.03149-.74828-.03453c-2.73486,1.44174-5.84137,1.46776-8.75091,2.2487a3.71556,3.71556,0,0,1-3.97073-1.47369q-2.22144-11.60346-4.44207-23.20591c-.2633-12.65977-.6527-25.31966-.74224-37.98165-.05-7.06821.39823-14.13995.62146-21.20943q.04049-.80565.0818-1.6126a10.45,10.45,0,0,1,7.14966,3.04037c.58358,1.32693.24194,2.684.19111,4.04458-.37581,10.06044-1.09564,20.10047-1.727,30.13973.78511,4.66,2.92711,8.92854,3.95819,13.51994a261.11942,261.11942,0,0,1,7.622,26.57115c.31679,1.29409.95449,2.34506,1.34064,3.54535a2.10653,2.10653,0,0,1-.58339,1.62651Q168.43709,240.71074,168.437,241.10147Z"
          class="cls-71"
        />
        <path
          id="path203"
          d="M239.50319,247.93349q-2.13738-11.14509-4.27828-22.28955-2.59032-13.34335-5.22086-26.67895c6.002-3.01293,12.31795-1.60265,18.54272-1.24241a1.91034,1.91034,0,0,1,1.67052,2.1404q-5.23452,24.37259-10.46891,48.74518A3.153,3.153,0,0,1,239.50319,247.93349Z"
          class="cls-72"
        />
        <path
          id="path205"
          d="M267.35313,317.59922q-13.12224-12.78352-26.2448-25.56688-.72438-.76434-1.44812-1.52907c-4.444-7.18061-5.00748-15.47687-6.70728-23.44161a2.293,2.293,0,0,1,1.42867-2.7405q8.5712,9.26838,17.149,18.53063c1.00359,1.08042,2.09369,2.0806,3.144,3.11753q1.47071,6.40119,2.941,12.803c2.55029,1.40035,5.08027,2.83956,7.55416,4.36789,1.21889.75306,2.71871,1.32659,2.93635,3.07274-.44641,1.38471-1.22434,2.75963-1.26561,4.15628A66.085,66.085,0,0,0,267.35313,317.59922Z"
          class="cls-73"
        />
        <path
          id="path207"
          d="M168.43727,240.32l-.00577-1.51611c-1.26894-2.18233-1.01236-4.55917-.37073-6.7427,3.11282-10.59369,5.27339-21.42511,8.17356-32.06891.49069-1.80093.95375-3.72778,3.49915-3.56259a2.42476,2.42476,0,0,1,1.30971,3.30154,3.8734,3.8734,0,0,0,.09553,3.15723q2.69445,17.93286,5.389,35.86565-6.07764.51819-12.15531,1.03741C172.39354,239.962,170.41556,240.1435,168.43727,240.32Z"
          class="cls-22"
        />
        <path
          id="path209"
          d="M234.3816,264.32116c1.39646,6.53528,2.81758,13.06546,4.17552,19.60872.45116,2.17387.73991,4.38138,1.10295,6.57346q-14.00638-9.85866-28.013-19.71715-.55755-.95139-1.115-1.90279l2.96293-.81912c1.95094.17649,3.43583-1.0321,5.02139-1.81161a44.67289,44.67289,0,0,1,11.1471-3.80745c1.56959-.3088,2.94423-.29018,4.01845,1.06915Z"
          class="cls-39"
        />
        <path
          id="path211"
          d="M233.68191,263.51439c-4.01927,1.1122-8.01091,2.34163-12.06755,3.295-2.6585.62475-5.41088.85019-8.1203,1.25471q12.99191-9.41371,25.98191-18.82783-2.83829,6.71567-5.67606,13.43126Q233.7411,263.09077,233.68191,263.51439Z"
          class="cls-22"
        />
        <path
          id="path213"
          d="M190.07356,242.60561q4.47632,3.68326,8.95267,7.36643,3.55641,6.54125,7.1131,13.08261l-.45359.37769Q197.87964,253.019,190.07356,242.60561Z"
          class="cls-74"
        />
        <path
          id="path215"
          d="M202.88958,565.527q.36757-30.342.73465-60.6837l.10184-.08292c1.7073-2.93814,4.67879-4.04293,7.578-5.2762,6.6359-2.80235,13.37951-5.29609,19.72822-8.80732a41.3318,41.3318,0,0,1,8.88753-3.39424,1.97716,1.97716,0,0,1,1.44248.98795c-.086,12.88752-4.62174,24.79516-8.126,36.92977-.294.84164-.70436,1.52884-1.77639,1.33845-3.82331,5.20416-7.744,10.34023-11.44587,15.62933-4.86217,6.94672-9.5313,14.02822-14.33724,21.01474a30.32207,30.32207,0,0,1-2.72182,3.02846Q202.92352,565.86854,202.88958,565.527Z"
          class="cls-28"
        />
        <path
          id="path217"
          d="M231.45989,526.53874q.34191-.74644.68377-1.49294c3.538-3.01475,12.38833-3.81006,16.36606-1.47076q.00163.79185.00283,1.58445c-2.15892,7.01066-4.37778,14.00271-6.46433,21.034-5.60158,18.87658-11.14651,37.77-17.25635,56.68952q-.08818-1.8608-.17679-3.72211,1.67688-17.4945,3.35032-34.98836Q229.738,545.358,231.45989,526.53874Z"
          class="cls-61"
        />
        <path
          id="path219"
          d="M307.07133,263.467q.03705-1.08384.07425-2.16766,4.45272-16.11891,8.903-32.23842c.7551-2.73848,1.48586-5.48369,2.22705-8.22547l.138-.01054c4.16028,3.15478,9.46016,4.74307,12.66934,9.21438a3.21334,3.21334,0,0,1,.3516,1.09533c.342,1.75771.18452,3.27716-1.83152,3.92928-1.942,4.69785-4.06525,9.33013-5.79369,14.10522-6.44767,17.81256-12.76509,35.6722-19.13719,53.51211a1.95788,1.95788,0,0,1-1.16079,1.24545Q305.29137,283.69683,307.07133,263.467Z"
          class="cls-39"
        />
        <path
          id="path221"
          d="M313.87212,319.7484l.7449-2.2524c.26692-.23535.283-.72164.75387-.75292a33.95959,33.95959,0,0,1,.69338,4.74079c.07439,8.2259.03495,16.45268.05224,24.67918.00248,1.18135.09764,2.36248.1703,4.00424l1.33917-1.95687c1.80595,1.81148.97517,3.79826.41324,5.77182.29794,2.26877-1.15612,3.777-2.3461,5.39872-5.56534,5.28232-8.15585,12.67253-13.05764,18.43927-1.76165,2.07249-3.32644,4.31547-5.13435,6.36051-1.11261,1.25842-2.29934,1.88237-3.86183.75873-1.64238-2.35837-.20287-4.59641.42161-6.767,3.2029-11.1334,7.149-22.03539,10.466-33.13444C307.1061,336.40771,310.66963,328.14581,313.87212,319.7484Z"
          class="cls-28"
        />
        <path
          id="path223"
          d="M315.37084,316.743q-.377.37643-.75391.75288c-.86266.22666-1.97418.18522-2.55071.72013-8.44848,7.83757-16.80683,15.772-25.2301,23.63685-2.8707,2.68043-5.862,5.23184-9.34519,8.32849.23224-1.14349.31826-1.567.40446-1.99081,4.3216-6.65649,8.73892-13.253,12.93273-19.98869,3.088-4.95968,5.81661-10.14189,8.84735-15.13893a42.12482,42.12482,0,0,1,3.71443-4.59489c3.49242,1.6375,7.0624,3.13593,10.42311,5.00947C314.67234,313.9566,314.86948,315.62246,315.37084,316.743Z"
          class="cls-75"
        />
        <path
          id="path225"
          d="M329.60308,235.06389q.41226-2.19622.82456-4.39243c3.3-1.28778,5.36014-.56169,7.9932,2.81726q-9.68738,35.25819-19.33421,70.5274a44.064,44.064,0,0,0-.79458,6.38541q-.63036,1.19957-1.26122,2.40438l-.55054-.223Q323.0417,273.82336,329.60308,235.06389Z"
          class="cls-76"
        />
        <path
          id="path227"
          d="M316.80459,354.17194q.41067-2.98077.82139-5.96152,2.5707-15.27244,5.15316-30.54283c.18507-1.08691.53292-2.14611.80533-3.21816-.75089,7.79468-1.397,15.60129-2.27916,23.38115-1.10739,9.76486-2.39546,19.50941-3.64561,29.25761a19.692,19.692,0,0,1-.79925,2.85038c-2.38677-1.53653-1.76907-3.94946-1.62833-6.1054A73.66465,73.66465,0,0,1,316.80459,354.17194Z"
          class="cls-77"
        />
        <path
          id="path229"
          d="M138.41143,252.40932q-.779.35121-1.55806.70236a7.75576,7.75576,0,0,1-4.87118,3.71786c-3.79778,1.1318-7.45007,2.78863-11.476,3.0677a2.6265,2.6265,0,0,1-1.53953-.81286c-1.2985-8.10219-2.77791-16.18076-3.84193-24.3136-.96382-7.36709-1.47461-14.7934-2.18514-22.1936-1.57471-.84059-1.65208-2.36322-1.73828-3.865a28.61715,28.61715,0,0,1,1.36452-11.386c2.7-2.11641,3.68665-.07919,4.53431,1.96071,3.4314,8.25769,6.74365,16.56875,10.35275,24.74751a221.774,221.774,0,0,1,8.77,24.51286Q137.31718,250.47827,138.41143,252.40932Z"
          class="cls-78"
        />
        <path
          id="path231"
          d="M118.96664,259.08438l1.47639-.11248a30.89124,30.89124,0,0,1,16.337,15.33979c-6.33192,5.70006-13.68509,9.30287-20.64268,13.4952-3.91706,1.59911-7.01515,4.49339-10.56724,6.66863a11.60537,11.60537,0,0,1-7.49257,1.99895c-1.97038-8.07336-2.12164-16.06211,1.38786-23.9778,1.82932.95725,3.63142,1.97326,5.503,2.83942a7.64878,7.64878,0,0,0,2.1936.31245,32.8913,32.8913,0,0,1,4.87228-4.56542c2.46648-1.62043,4.24822-3.6946,4.57484-6.8585.17414-1.6867,1.54607-2.96,2.33558-4.44238Q118.97152,259.43382,118.96664,259.08438Z"
          class="cls-67"
        />
        <path
          id="path233"
          d="M98.69712,196.86173c1.54369-4.98748,3.55927-9.89021,4.47579-14.99029.68418-3.80706.026-7.87286-.17135-11.81659-.36588-7.31109-.83178-14.61715-1.256-21.92531,2.15632-.39109,2.55089,1.3557,2.86388,2.69314,2.29774,9.81809,5.52705,19.41677,6.85323,29.4673.49934,3.78392,1.17639,7.56851,3.087,10.98372a3.43381,3.43381,0,0,1,.27859,2.88039,4.189,4.189,0,0,1-.414,1.2434,2.34611,2.34611,0,0,1-1.05021.77652c-3.74741,2.436-8.94823,2.79078-11.66928.79579Q100.19595,196.91578,98.69712,196.86173Z"
          class="cls-79"
        />
        <path
          id="path235"
          d="M101.69473,196.9698q5.933-.73,11.86588-1.46008a.82364.82364,0,0,1,.21092,1.32782q-.41581,7.86981-.83178,15.73962c-.38922,2.12663-.77825,4.25324-1.34311,7.34076-4.46449-7.55606-8.47278-14.34-12.62629-21.36961C100.05981,197.91709,100.87727,197.44345,101.69473,196.9698Z"
          class="cls-41"
        />
        <path
          id="path237"
          d="M118.94468,259.78226c.71882,7.448-3.37635,12.00681-9.33251,15.38955a7.93662,7.93662,0,0,1-2.45056.47655q1.05147-4.55669,2.10238-9.11379Q114.10458,263.15837,118.94468,259.78226Z"
          class="cls-80"
        />
        <path
          id="path239"
          d="M113.71809,194.59145q-2.26179-8.82168-4.52515-17.643-3.71632-14.41137-7.4476-28.81886-.35584-2.20686-.71164-4.41313c3.12028-1.18739,6.24-2.37527,9.67914-3.68477v-5.375l.7858,6.68915a124.40466,124.40466,0,0,1,2.72639,22.54491c.12834,7.69173.37943,15.42026,1.09495,23.11119C115.56165,189.59972,116.4012,192.52432,113.71809,194.59145Z"
          class="cls-81"
        />
        <path
          id="path241"
          d="M250.21729,199.863c-3.65311-.258-7.30311-.58395-10.96034-.75314-3.08025-.14249-6.16891-.10277-9.25341-.14427q-.00954-.29971-.03765-.597,3.73477-6.37608,7.46919-12.75231c-1.11769-2.64432.64434-4.85856,1.08274-7.27244,5.59347-10.28156,7.80808-21.84,12.32143-32.527.71324-1.689.77272-4.19655,3.72691-3.68934-.7998,11.52941-1.62641,23.05706-2.38984,34.5889-.509,7.68837-.92809,15.38271-1.388,23.07405Q250.50217,199.82656,250.21729,199.863Z"
          class="cls-81"
        />
        <path
          id="path243"
          d="M254.56621,142.12743c-3.0479,8.08678-6.07319,16.18221-9.1528,24.25692-1.66965,4.37786-3.43181,8.72052-5.15224,13.079-2.58561-1.96135-1.78307-4.80964-1.55275-7.2499.77052-8.1622,1.41435-16.33724,2.28754-24.49.54111-5.05181-.41566-6.3185-5.43792-7.5002-2.6456-.62253-5.44808-.75409-7.8069-2.341a2.16035,2.16035,0,0,1-.67732-2.94753c2.54151-4.49374,5.16249-8.94272,8.7419-12.72706a5.8933,5.8933,0,0,1,2.32839-1.04915l.02672.02762c1.43114-1.97376,3.42064-1.541,5.40434-1.30712,2.8114.33147,5.71453.17729,8.26606,1.70084,1.671,3.83725-.27927,7.09239-1.72642,10.40637-.71928,1.64709-2.37735,2.96467-1.70932,5.1221,1.68,1.73442,4.90239.22,6.13954,2.86675Q254.55559,141.05128,254.56621,142.12743Z"
          class="cls-58"
        />
        <path
          id="path245"
          d="M252.36158,122.649q-7.09554-.73158-14.19093-1.463c.52135-4.42911.62868-8.96431,1.72555-13.24624.61574-2.404,2.58539-4.67807,4.44752-6.49662,2.90039-2.83252,6.22825-5.22763,10.06062-8.37042-2.29751-3.07779-4.38712-5.877-6.47632-8.67683q5.70642-4.3871,11.41306-8.77257c-1.287,5.0658-2.57481,10.131-4.02631,15.83976,3.2956-2.40214,5.8808-4.28646,8.46609-6.17077q-1.86058,3.75879-3.72151,7.51759c-2.89513,2.57745-3.876,6.02726-4.24236,9.68061-.60544,6.03724-2.18413,11.92937-2.60263,17.99023q-.07426.69006-.14847,1.38011C252.85424,122.1442,252.86618,122.62723,252.36158,122.649Z"
          class="cls-82"
        />
        <path
          id="path247"
          d="M252.36153,122.649q.35234-.394.7045-.78808.73968,9.05678,1.47927,18.11392c-3.18333.00026-6.36642.00026-10.46576.00026C247.10548,133.64482,249.73355,128.1469,252.36153,122.649Z"
          class="cls-42"
        />
        <path
          id="path249"
          d="M253.21436,120.48074q.71175-13.2675,1.42144-26.49729c2.3068-.49933,3.8649-.83659,5.42332-1.1737Q256.637,106.64541,253.21436,120.48074Z"
          class="cls-83"
        />
        <path
          id="path251"
          d="M154.20319,196.14474l2.23017-35.2748c-.98821-1.35253-.32288-2.61987.28508-3.82114,2.62263-5.18217,5.663-10.12691,8.70209-15.0701.67531-1.09839,1.48911-2.03909,2.99926-1.332,1.54484,7.1286,3.10793,14.25335,4.62993,21.38683q2.99242,14.02458,5.93378,28.06006c.12656,1.41378,1.83482,2.54252.75053,4.17605a2.7063,2.7063,0,0,1-1.17543.58873c-6.30072,1.63367-12.76134,2.09551-19.20783,2.68747C157.41777,197.72341,155.66128,197.5624,154.20319,196.14474Z"
          class="cls-60"
        />
        <path
          id="path253"
          d="M168.41979,140.64675q-5.99314,10.11173-11.98634,20.22329c-1.35528-.0001-2.71052-.0001-4.175-.0001-.67087-1.14886-1.222-2.09274-1.77278-3.0371q.36984-18.32177.73886-36.6426a2.21848,2.21848,0,0,1,.89986-.97525c2.327-1.766,5.16-1.64281,7.84052-2.10484,2.64619-.35028,4.88729.62566,7.31666,2.31172,2.5179,6.18837,1.94014,12.85225,1.23957,19.526Q168.48312,140.29911,168.41979,140.64675Z"
          class="cls-14"
        />
        <path
          id="path255"
          d="M179.661,193.861q-.339-1.88364-.67778-3.76729c.48923-.6001,1.31392-1.14813,1.41622-1.80812,1.28927-8.31355,2.47426-16.64328,4.143-24.971q.53859,2.90289,1.07692,5.80562,2.30709,29.18415,4.6151,58.36823-.14623,1.56024-.29313,3.12121l-.63944.05841c-2.50706-9.77282-5.01416-19.54563-7.74549-30.19258-.23526,1.36038-.32622,1.88642-.41745,2.41272q-.72651-3.02016-1.45255-6.04089C178.5737,195.86123,178.86981,194.8632,179.661,193.861Z"
          class="cls-84"
        />
        <path
          id="path257"
          d="M168.37871,76.96657c1.40048,2.96848,2.91786,5.88858,4.17336,8.91714,1.74532,4.21029,3.29437,8.5019,4.92759,12.75857q-.03987,1.13835-.08,2.27692c-5.93227,3.77-12.42255,4.291-19.17379,3.29a1.043,1.043,0,0,1-.19985-1.653c2.33421-6.22719,4.60852-12.47781,7.033-18.66968C165.98919,81.51088,167.262,79.26926,168.37871,76.96657Z"
          class="cls-85"
        />
        <path
          id="path259"
          d="M157.92041,103.91776q9.73986-1.49912,19.47951-2.99843-1.52528,3.08881-3.04991,6.17794c.56184.82412,1.22877,1.813.71776,2.70694-2.14414,3.75073-3.70609,7.99687-7.96067,10.09425a4.99591,4.99591,0,0,1-4.10354-2.23632c-2.42425-4.15285-5.14186-8.21594-5.41019-13.2584Z"
          class="cls-63"
        />
        <path
          id="path261"
          d="M166.92926,118.90474q3.71091-5.90525,7.42125-11.809,1.99867-2.12692,3.99841-4.25687l.77344.23457q-5.30088,18.43711-10.60146,36.87432c-.8105-6.27793-1.62128-12.55591-2.47978-19.20375l-6.56829-.416c.41132-2.64148,2.30474-2.2244,4.08177-1.93138C164.67774,118.58184,165.651,119.7261,166.92926,118.90474Z"
          class="cls-57"
        />
        <path
          id="path263"
          d="M338.42084,233.48872q-3.99729-1.40979-7.99384-2.81841l-.107-.17925a2.80838,2.80838,0,0,1,.46114-3.20328c4.337-1.16206,6.52454-5.1,9.74113-7.69459,4.80315-3.87434,9.46648-7.93888,14.05161-12.0808,1.02294-.924,1.98264-1.99986,3.51439-.90279q.3181.67524.6356,1.3499Q348.57179,220.72353,338.42084,233.48872Z"
          class="cls-39"
        />
        <path
          id="path265"
          d="M316.80463,354.17194q.02787,7.8833.05582,15.76663-.02175,2.62624-.04365,5.25251-.73768,1.48911-1.47488,2.97806c-2.73641,3.81495-5.23107,7.82742-8.82232,10.95-1.29919,1.12963-2.554,2.584-4.53467,1.17276-1.237-1.33361-.73355-2.73421-.16293-4.14543,3.78982-9.373,7.24084-18.904,12.82412-27.43941Q315.72537,356.43952,316.80463,354.17194Z"
          class="cls-56"
        />
        <path
          id="path267"
          d="M268.10608,306.213q-5.24509-3.72045-10.49037-7.44075,6.714,1.89974,13.42741,3.79982,3.45813.76737,6.91815,1.53373-.08325.28062-.16494.56111Q272.95086,305.43946,268.10608,306.213Z"
          class="cls-59"
        />
        <path
          id="path269"
          d="M58.3161,271.75939l-1.59987-5.2628a3.74376,3.74376,0,0,1,.25731-3.36566c2.38577-4.31606,5.5-8.15392,8.335-12.17517a2.72134,2.72134,0,0,1,2.65063-.9641,30.04635,30.04635,0,0,1,2.1592,3.80308c4.00655,10.16638,7.90768,20.37437,11.94127,30.52984a14.7614,14.7614,0,0,0,2.32858,3.11012.76916.76916,0,0,1,.22625.64087q-.04969.34428-.12944.34427a1.14142,1.14142,0,0,1-1.49473-.13579L59.03808,269.36071C58.72509,270.40063,58.52057,271.08,58.3161,271.75939Z"
          class="cls-38"
        />
        <path
          id="path271"
          d="M84.34423,288.17507q.03747-.36908.04428-.74016,7.53819-7.46922,15.07689-14.93813v23.177c5.7257-3.35006,11.11233-6.50173,16.49891-9.6534,1.76715,1.04838,1.75429,2.53885.98286,4.16479-1.58931,3.35-3.07471,6.75727-4.93373,9.968q-3.17079,5.47626-8.12926,1.38531a13.01643,13.01643,0,0,0-4.99193-2.23811c-3.7938-2.84491-8.11133-4.81387-12.18738-7.19019C85.18145,291.222,83.45878,290.4906,84.34423,288.17507Z"
          class="cls-45"
        />
        <path
          id="path273"
          d="M67.95919,249.99166q-5.6214,8.2526-11.24287,16.50511a17.13249,17.13249,0,0,1-1.85517-3.12747c-2.4274-7.169-4.7525-14.37254-7.11132-21.56469,1.01767-1.66061,2.40155-1.32339,3.93367-.845a67.34847,67.34847,0,0,1,15.559,6.7542,1.97264,1.97264,0,0,1,.73067,1.5637Q67.95853,249.63445,67.95919,249.99166Z"
          class="cls-81"
        />
        <path
          id="path275"
          d="M67.97314,249.27757l-.76192-.70344c.01968-.212.03935-.42393.05253-.63094A74.56251,74.56251,0,0,1,68.4303,232.756c.29007-1.392.32329-3.12963,2.54014-2.86972q7.86308,11.22711,15.726,22.45454Q77.33459,250.80947,67.97314,249.27757Z"
          class="cls-86"
        />
        <path
          id="path277"
          d="M67.21122,248.57413c-5.30839-1.93048-10.61116-3.8766-15.92957-5.77909-1.14839-.41076-2.3531-.66437-3.53182-.99041q-.76988-1.47849-1.54-2.95657c-1.85179-5.47715-3.71561-10.95051-5.54535-16.43525-.4281-1.28314-.74082-2.60474-1.10629-3.90921q.34946.03217.69795.06789c6.16269,3.15185,10.13625,8.75068,14.77839,13.53675,3.44984,3.55676,6.7572,7.27473,10.22089,10.83523,1.50412,1.5462,2.82188,3.18092,2.00278,5.5716Z"
          class="cls-87"
        />
        <path
          id="path279"
          d="M67.25817,248.51507q-7.71959-8.61956-15.44332-17.23535c-3.83283-4.25416-7.7045-8.47335-11.55879-12.70816,7.28253,2.51455,14.58665,4.96909,21.83724,7.57248,3.0177,1.08353,5.92148,2.48418,8.877,3.74143-.72929,5.15272-1.39829,10.31447-2.23579,15.44877A12.91112,12.91112,0,0,1,67.25817,248.51507Z"
          class="cls-77"
        />
        <path
          id="path281"
          d="M227.7312,136.81892l15.69477,3.18266c-1.08814,13.57148-2.12608,26.51706-3.16443,39.46224q-1.41369,3.07576-2.82655,6.15242a34.40509,34.40509,0,0,0-4.6,2.74831c-2.99455,2.46118-5.82329,5.124-9.68544,8.56484,0-3.30341,0-5.44555-.0001-7.58782q.01388-17.2111.02782-34.42192c.63322-5.21457.72811-10.50488,2.10865-15.61307C225.6151,138.08854,225.76361,136.50921,227.7312,136.81892Z"
          class="cls-88"
        />
        <path
          id="path283"
          d="M240.37981,467.32319q-1.80069,2.64628-3.60137,5.29248c-1.786,1.34275-3.94044.78987-5.744.57172a89.47034,89.47034,0,0,1-12.33525-2.26219c-1.71554-.45775-3.32653-1.03053-3.83626-3.01579a3.81655,3.81655,0,0,1,.87621-3.03459,2.90843,2.90843,0,0,1,.99951-1.0807c11.49908-5.581,20.05394-15.22207,30.5773-22.15027,3.00338-1.97726,5.78486-4.288,8.83769-6.19655,1.23208-.77025,2.54847-1.72252,4.105-.57981.99146,1.1251.75,2.28482.06978,3.4391-5.86434,9.95049-11.64366,19.95838-19.28022,28.71946A1.21375,1.21375,0,0,1,240.37981,467.32319Z"
          class="cls-89"
        />
        <path
          id="path285"
          d="M240.37981,467.32314q9.79011-16.089,19.58026-32.17805c-.5494-2.76252,2.09592-3.76706,3.11067-5.67225,7.24336-4.73311,14.22565-9.824,20.26641-16.0505,4.48626-4.62421,9.55162-8.54005,14.53728-12.5629,1.12093-.90444,2.27527-2.15005,3.97223-1.01759-1.89786,2.52809-3.61518,5.21885-5.72318,7.55764-12.658,14.04346-25.41,28.00217-38.12139,41.99761-5.18523,5.70907-10.32891,11.45609-15.55386,17.12839C241.9994,467.01284,241.08042,467.06749,240.37981,467.32314Z"
          class="cls-90"
        />
        <path
          id="path287"
          d="M215.64982,467.33878a29.91883,29.91883,0,0,0,5.027,2.09512c5.339,1.18529,10.72971,2.13821,16.101,3.18163q-.097.37044-.19546.74066a12.935,12.935,0,0,1-5.97862,4.35786c-6.201,2.23987-11.93556,5.71063-18.50206,6.99529-1.194.23361-2.01768,1.27978-3.20382,1.56882a2.38431,2.38431,0,0,1-1.70007-.4953,2.74722,2.74722,0,0,1-.48255-3.39859c2.05694-4.69647,3.2697-9.78141,6.37269-14.00115C213.81821,467.73155,214.45042,466.83987,215.64982,467.33878Z"
          class="cls-91"
        />
        <path
          id="path289"
          d="M208.90947,485.32433c3.576-1.67583,7.10921-3.45141,10.7378-5.00431,5.61091-2.40126,11.287-4.65033,16.93526-6.96387q-1.83252,7.09506-3.66464,14.19008-.1059.31576-.21165.63172a2.19084,2.19084,0,0,1-1.68036.96014,89.6131,89.6131,0,0,1-18.18407-1.25627C211.141,487.62452,209.27682,487.62658,208.90947,485.32433Z"
          class="cls-92"
        />
        <path
          id="path291"
          d="M301.84666,399.84185Q283.973,414.90514,266.092,429.95972a18.90111,18.90111,0,0,1-1.86107,1.23285c-1.14245-1.16233-.69288-2.2604.1556-3.32042a28.11737,28.11737,0,0,1,2.572-2.72c8.49826-8.119,16.05306-17.19582,25.01978-24.8253,2.40754-2.04852,3.49577-4.875,5.38878-7.19772,1.15493-.77935,2.04024-2.052,3.65014-1.99478,2.75741.20745,5.19845,1.035,6.80057,3.49285Q304.83224,397.23456,301.84666,399.84185Z"
          class="cls-93"
        />
        <path
          id="path293"
          d="M241.05329,488.43214l-1.56415-.18714a10.25031,10.25031,0,0,0-3.85771.88408c-1.35629.45748-2.70682.49644-2.72827-1.56415l.01455-.01829q2.19578-2.62565,4.39068-5.25059c2.443-2.27947,4.8446-4.60638,7.35143-6.81391a25.82893,25.82893,0,0,1,3.2574-2.12211q-2.95858,6.3677-5.91718,12.73551C241.07355,486.62706,241.97309,487.89787,241.05329,488.43214Z"
          class="cls-92"
        />
        <path
          id="path295"
          d="M307.81774,394.62717q-3.3007-1.0876-6.60137-2.1753c-.68683-1.42132-.26426-2.21782,1.32779-2.35562q6.399-5.96349,12.79786-11.927Q311.57978,386.39813,307.81774,394.62717Z"
          class="cls-62"
        />
        <path
          id="path297"
          d="M214.18149,468.86721l-6.72755,16.4198c.45643.87059.47327,1.52349-.76956,1.5524-5.68937,2.33883-11.41141,4.60207-17.05879,7.03833-5.33145,2.3-10.58435,4.78195-15.871,7.18376q5.23569-22.60734,10.45757-45.21728c.48475-2.10788.80707-4.253,1.20462-6.38095l-.89909-.58612q-21.1608,15.615-42.32165,31.2303-.3518-.03739-.70194-.08557-.4047-18.69461-.81027-37.38789c-.04489-1.84523,1.2382-2.41974,2.69779-2.8275,9.339,1.411,18.71495,2.60789,28.04513,4.10906a63.33664,63.33664,0,0,1,13.50349,3.92083q.72994-.00083,1.45988-.0016c1.45053-.5146,2.63045.044,3.84829.81392,7.81412,4.93914,14.90243,10.88685,22.49694,16.13058C214.13107,465.74294,215.16983,466.98677,214.18149,468.86721Z"
          class="cls-82"
        />
        <path
          id="path299"
          d="M143.701,441.86648q-1.50839.38362-3.01692.76733c-4.942,6.57857-9.88383,13.1569-15.505,20.63958-1.24913-2.52607-2.22618-4.50183-3.20318-6.47822a18.36054,18.36054,0,0,0-.60517-4.2186c-5.99976-15.32762-12.0875-30.6209-18.15218-45.92314,4.96406-4.16349,8.56634-4.16522,12.92871.30139,4.22877,4.32978,9.40869,7.64819,13.13436,12.51164.712.92945,1.56932,1.70469,1.64659,2.95748l.76485.74a19.80709,19.80709,0,0,1,5.93332,8.227c1.29,3.20632,2.29623,6.60587,5.61833,8.5154A1.3704,1.3704,0,0,1,143.701,441.86648Z"
          class="cls-76"
        />
        <path
          id="path301"
          d="M113.77153,196.83754q-.10521-.6642-.2106-1.32812.13959-.15761.2796-.316c2.73861-3.856,7.31981-4.00888,11.21738-5.50528.83237-.31959,1.54675.55238,2.1796,1.12945q.61746,2.69795,1.2339,5.39639,3.71124,24.31808,7.41461,48.63653c.1853,1.22117.22785,2.46395.33679,3.69671-1.77644-3.67608-3.72156-7.28152-5.29879-11.04116-5.30972-12.65684-10.48223-25.37113-15.73064-38.05377A27.164,27.164,0,0,0,113.77153,196.83754Z"
          class="cls-59"
        />
        <path
          id="path303"
          d="M127.23751,190.81759q-6.69906,2.18865-13.39753,4.37656-.0735-.29934-.12193-.60263-1.08908-23.07592-2.16515-46.15231c-.10752-2.36011-.04086-4.72812-.05449-7.09289,3.15953,9.70755,6.359,19.40273,9.46437,29.12793C123.12129,177.234,125.15051,184.035,127.23751,190.81759Z"
          class="cls-94"
        />
        <path
          id="path305"
          d="M227.7312,136.81892q-2.27711,9.05-4.55412,18.10039-.01737-.77848-.03532-1.55793.72883-15.71931,1.458-31.438l1.28986-.05412q.29888,3.77154.59771,7.54307l1.30047-.058q-.40642-5.9913-.8122-11.983,5.5848,1.89333,11.16847,3.78737Q232.93765,128.9887,227.7312,136.81892Z"
          class="cls-28"
        />
        <path
          id="path307"
          d="M241.05329,488.43209q.473-1.1682.9463-2.3365a47.82737,47.82737,0,0,0,.38217,6.27347c1.78238,9.39569,3.70618,18.76454,5.57952,28.14289q.2754,1.53119.54935,3.06286-8.18433.73574-16.36688,1.471,4.00107-16.3053,7.99915-32.61134C240.46825,491.10571,240.75086,489.76648,241.05329,488.43209Z"
          class="cls-84"
        />
        <path
          id="path309"
          d="M84.34423,288.17507q7.5587,4.54149,15.11741,9.083c8.4807,7.61192,14.21861,17.32782,20.438,26.67028a7.328,7.328,0,0,1,.87236,4.30073,2.69105,2.69105,0,0,1-1.64027,1.89623c-8.17388,3.636-15.97839,7.99824-23.89253,12.14421-.99947.52361-2.13848.63822-3.12165,1.1803a3.13833,3.13833,0,0,1-1.0293.31466q-.65726-1.54443-1.3141-3.08911-.78656-2.21107-1.57421-4.4212c-2.281-7.34763-4.48251-14.72146-6.86915-22.03495-1.7332-5.31112-3.74073-10.53223-5.56008-15.81615-.47564-1.38133-.70564-2.84715-1.19172-4.87034,2.83868-1.77148,5.625-3.51024,8.41129-5.24884Q83.6673,288.22966,84.34423,288.17507Z"
          class="cls-53"
        />
        <path
          id="path311"
          d="M158.026,102.5562q-.05271.68086-.1055,1.36164l-.01492-.01236a3.36359,3.36359,0,0,1-.98125.91785c-4.64736,1.39824-9.26187,1.60978-13.81576-.37989a20.329,20.329,0,0,1-.80744-3.61746c-.32164-7.70327-.54894-15.41046-.80708-23.11628q3.31128,5.167,6.62181,10.334c2.72882,4.26093,5.45654,8.52261,8.4742,13.236.31752-.97708.45789-1.409.59821-1.84086Q157.60712,100.99757,158.026,102.5562Z"
          class="cls-88"
        />
        <path
          id="path313"
          d="M119.67974,327.95752c-2.58493-4.209-5.05195-8.49633-7.78251-12.60873-4.04709-6.09532-8.281-12.06668-12.43549-18.09078,1.88921,1.15892,3.66262,2.65662,5.70909,3.3561,1.33533.45638,4.04841.26857,4.45964-.51458,2.388-4.54791,4.27644-9.35794,6.33384-14.07924,6.38175-4.02332,12.76345-8.0467,19.888-12.53842-5.44949-5.13125-10.42929-9.82022-15.40923-14.50958q8.20568-2.93118,16.41089-5.86111c-.16219,4.42079-.46338,8.84253-.41735,13.26065.01866,1.79641.7922,3.585,1.22191,5.37692,3.381-1.05128,6.83763-1.90987,10.128-3.19413,6.60657-2.57855,13.12242-5.38943,20.61339-8.49292-.83887,1.70334-1.22433,2.644-1.739,3.50775q-15.51452,26.03846-31.01959,52.08251a13.15894,13.15894,0,0,0-.92306,3.39515q-1.11714,4.85532-2.23419,9.70916c-2.12987-.3024-1.29589-2.8367-2.96536-3.77846-2.108-.19382-3.64487,1.49139-5.50883,2.35219C122.64208,327.96168,121.37766,329.52656,119.67974,327.95752Z"
          class="cls-95"
        />
        <path
          id="path315"
          d="M165.33973,243.28175q-10.79162,11.03063-21.59145,22.0532c-.95156.96869-2.015,1.8276-3.02658,2.73766,2.84421-4.15412,5.81479-8.22925,8.489-12.49022,1.86162-2.96633,3.3166-6.1877,4.95326-9.29512,2.8916-.11973,4.70885-2.45964,7.174-3.4762C163.72942,241.82491,164.19994,241.81494,165.33973,243.28175Z"
          class="cls-21"
        />
        <path
          id="path317"
          d="M165.33973,243.28177c-2.02235.96135-4.07921,1.85778-6.0554,2.90617-1.38634.73547-2.6627,1.67816-4.35248,2.762-.3355-1.16405-.55141-1.91324-.76764-2.66257q.40094-2.22322.80269-4.44578,6.36112-.38712,12.72186-.77478Q166.5143,242.1744,165.33973,243.28177Z"
          class="cls-3"
        />
        <path
          id="path319"
          d="M130.92814,422.42394c-6.53259-5.71986-13.06523-11.43972-19.37643-16.96577-3.00736.43137-5.6703.81329-8.33323,1.19522q-1.0573-1.93812-2.11432-3.87715-.05682-1.49283-.11429-2.98552a21.77429,21.77429,0,0,0,.03271-4.31354q-4.89831-25.86958-9.9331-51.71311l.204-.05589a2.22979,2.22979,0,0,1,3.25442.75653c7.18635,10.56072,15.04344,20.65738,21.8145,31.50412a3.774,3.774,0,0,1,.34291,1.06c3.90988,10.90889,7.494,21.93971,12.06692,32.60113,1.1423,2.66332.01688,5.89233,2.1861,8.25957Z"
          class="cls-29"
        />
        <path
          id="path321"
          d="M358.08825,206.6096c-7.69338,6.70037-15.36841,13.422-23.10535,20.07161a15.15272,15.15272,0,0,1-3.1589,1.63163,2.76576,2.76576,0,0,1-.22876-3.45363c4.38429-7.92056,8.13654-16.18129,12.87838-23.908a4.82161,4.82161,0,0,1,1.553-1.58533,2.38273,2.38273,0,0,1,1.65144-.23628l12.61164,4.7358C359.3254,205.06735,358.70683,205.83847,358.08825,206.6096Z"
          class="cls-96"
        />
        <path
          id="path323"
          d="M347.67809,199.12957l-.7648.81713c-3.86861-.35641-6.88283-2.68912-10.16361-4.401a2.527,2.527,0,0,1-1.22676-2.53556c1.61922-1.98822,3.23841-3.97641,5.49332-6.74524,3.92356,2.15284,7.52611,4.12958,11.12912,6.10643Q349.91219,195.75061,347.67809,199.12957Z"
          class="cls-97"
        />
        <path
          id="path325"
          d="M335.52292,193.01017c2.83414,1.4328,5.71641,2.78049,8.47877,4.34032a17.80348,17.80348,0,0,1,2.91132,2.59593q-7.54416,14.18348-15.08891,28.36642-.75177,1.09017-1.50375,2.17925c-3.04982-1.8847-6.21251-3.61377-9.09561-5.72448-1.23687-.90554-1.89269-2.60417-2.81181-3.9426q7.852-13.47612,15.70264-26.95175Q334.81941,193.442,335.52292,193.01017Z"
          class="cls-67"
        />
        <path
          id="path327"
          d="M143.10857,104.44344l14.13081-.453a5.25669,5.25669,0,0,1,.709,4.58791c-1.58483,4.33013-2.61151,8.95636-5.93475,12.46807q-.39481.07167-.78941.1436-.7635-.37806-1.5275-.7565c-.15972-1.36894.01263-2.8925-.53974-4.079C147.27882,112.32,145.14488,108.40442,143.10857,104.44344Z"
          class="cls-98"
        />
        <path
          id="path329"
          d="M206.68438,486.83941q.38439-.77574.7692-1.552.72842.01812,1.45593.037c6.03842.74944,12.07831,1.48759,18.11426,2.25675,1.46138.18623,2.90968.4749,4.364.71642.48273,1.95668-1.022,2.77656-2.2734,3.43184q-6.58748,3.44973-13.29565,6.67286c-1.41485.67742-3.00814,1.21072-3.89011,2.70275q-4.10208,1.82842-8.20334,3.656Q205.20563,495.79951,206.68438,486.83941Z"
          class="cls-48"
        />
        <path
          id="path331"
          d="M280.12884,382.701q.73419-.39989,1.46839-.79971a2.11712,2.11712,0,0,1,2.39546-.01719c1.07345,1.52093.04278,2.66318-.67288,3.76427-7.21637,11.10249-14.26706,22.32146-22.39468,32.79848a11.86832,11.86832,0,0,0-2.168,5.04355c-.557,1.43234-.45212,3.16548-1.90518,4.19271-1.50864,1.11587-2.55606,2.90841-4.64622,3.1803-9.965-1.17116-19.70868-3.61861-29.60533-5.19763a5.11078,5.11078,0,0,1-3.31074-1.46861c-1.44011-2.17337-.16622-3.40695,1.538-4.54527,10.23915-6.8393,20.72723-13.29424,31.01217-20.06137C261.02546,393.54666,270.20237,387.49979,280.12884,382.701Z"
          class="cls-51"
        />
        <path
          id="path333"
          d="M280.12884,382.701c-3.915,2.81594-7.72458,5.794-11.76366,8.41927-15.83912,10.29528-31.75241,20.47654-47.62694,30.71758a9.69605,9.69605,0,0,0-1.34252,1.27777,1.6759,1.6759,0,0,1-1.95349,1.23271c-8.166-.52891-16.1841-2.18993-24.281-3.24789-2.41267-.3152-5.37949.17383-6.945-2.63415.10125-1.98435,1.24127-3.06637,3.01184-3.81934,6.29812-2.67864,12.69506-5.09106,19.14388-7.37625a4.67469,4.67469,0,0,1,4.28189.16811c10.59464-3.93193,21.17656-7.89845,31.78726-11.78662C256.32347,391.29814,268.23181,387.015,280.12884,382.701Z"
          class="cls-88"
        />
        <path
          id="path335"
          d="M257.67093,423.17169c.67682-1.76569,1.06233-3.72274,2.077-5.26668,7.68931-11.7,15.50183-23.31909,23.46593-35.24808-.64854-.30308-1.13237-.52915-1.61644-.75544,5.31457-2.898,6.37791-8.70588,8.72785-13.43949,7.581-15.27078,14.65235-30.79432,21.94512-46.20861a22.66116,22.66116,0,0,1,1.60161-2.50508c-2.26868,7.90288-4.413,15.84409-6.83547,23.69951-3.59931,11.67151-7.41791,23.27528-11.08736,34.92552-.67206,2.13368-1.07811,4.35109-1.607,6.52981a3.23278,3.23278,0,0,1-.71045,4.34853c-.71218.68995-1.35551,1.45306-2.0692,2.14356C281.367,401.259,272.28539,412.24776,261.309,421.323,260.23166,422.2137,259.575,423.91327,257.67093,423.17169Z"
          class="cls-88"
        />
        <path
          id="path337"
          d="M212.65386,407.43882l-26.223,10.45645a.46887.46887,0,0,1-.77482-.02456c.93335-11.25643,1.80251-22.5188,2.83624-33.766.34365-3.73912,1.10978-7.43946,1.68274-11.1575,7.32832,8.98312,14.63825,17.97809,19.76487,28.49015a1.43521,1.43521,0,0,0,1.24744.69813Q211.92058,404.78714,212.65386,407.43882Z"
          class="cls-95"
        />
        <path
          id="path339"
          d="M185.65606,417.87071l.77477.02456c7.94388,1.27392,15.89965,2.47942,23.82472,3.86068,2.58621.45076,5.09249,1.35968,7.63533,2.059.50044,1.96716-.79839,2.96919-2.11363,3.9833-8.10008,6.24516-16.25488,12.41614-24.55983,18.38883-1.49662,1.07635-2.90387,1.97237-4.75905.93992-.36483-9.1608-.72966-18.3216-1.09925-27.60222-1.20425-.56724-2.31068-1.08843-3.41689-1.60943Q183.7994,417.89324,185.65606,417.87071Z"
          class="cls-99"
        />
        <path
          id="path341"
          d="M211.18735,402.13551c-.07526.60026-.15057,1.20056-.22327,1.78028-.38245.03572-.7524.15116-.80868.064q-10.01287-15.50178-19.98046-31.03273c5.88259,5.49517,12.34518,10.51517,17.403,16.68565C210.10507,392.71594,210.06582,397.90108,211.18735,402.13551Z"
          class="cls-99"
        />
        <path
          id="path343"
          d="M219.53682,332.55768c-2.16075,17.38574.68382,35.62918-9.15394,52.816C213.55948,367.04562,216.54818,349.80165,219.53682,332.55768Z"
          class="cls-100"
        />
        <path
          id="path345"
          d="M186.45837,447.127q15.71641-11.65532,31.43264-23.31141.75231-.35049,1.5048-.69982,16.495,3.00507,32.9902,6.0105a1.78741,1.78741,0,0,1-.19889,2.38645,37.35567,37.35567,0,0,1-2.28461,2.96471c-10.76969,10.60709-20.80432,21.98068-32.73237,31.38045q-.76.74048-1.52018,1.481-.73453.76395-1.46865,1.52816a36.86309,36.86309,0,0,0-3.4416-3.26463c-8.08864-5.96-16.22692-11.85248-24.34923-17.7674Q186.42185,447.48055,186.45837,447.127Z"
          class="cls-37"
        />
        <path
          id="path347"
          d="M115.21864,377.42171q-11.96344-16.85679-23.926-33.71357c.61688-.83826,1.049-2.036,1.87723-2.45963,8.80064-4.50091,17.66423-8.87889,26.51021-13.29085,3.91505-2.33436,7.83041-4.66862,12.80339-7.63342,0,3.58321,0,6.0073.00037,8.43171-.93088,11.74308-1.8856,23.48405-2.77558,35.22992-.20621,2.72113-.19129,5.459-.27813,8.18914C127.046,376.70858,119.034,379.66647,115.21864,377.42171Z"
          class="cls-67"
        />
        <path
          id="path349"
          d="M143.701,441.86648c-3.66858-1.0892-5.51913-3.77452-6.84316-7.20539-1.51048-3.914-3.4254-7.67193-5.16469-11.49744,6.37137,2.83455,12.76222,5.62642,19.11,8.51284q15.157,6.89207,30.26005,13.902c1.34851.62455,2.581,1.49939,3.86719,2.25812Q164.31561,444.85133,143.701,441.86648Z"
          class="cls-71"
        />
        <path
          id="path351"
          d="M115.21864,377.42171q7.106-2.62324,14.21175-5.24661.76362,22.8571,1.5279,45.71441c-.68368-.44673-1.77305-.7489-1.99151-1.36146C124.32509,403.51361,119.7814,390.46427,115.21864,377.42171Z"
          class="cls-101"
        />
        <path
          id="path353"
          d="M179.661,193.861q.01263,1.49318.02535,2.98634a13.79887,13.79887,0,0,0-1.50783,2.88141c-3.28887,13.01505-6.50916,26.0474-9.747,39.07526-.69494-.81027-1.75681-1.514-2.02789-2.4472-2.65223-9.12991-5.17255-18.29809-7.73044-27.45537a6.838,6.838,0,0,1,2.7435-3.8461c5.68247-3.94474,10.71237-8.90695,17.46714-11.17744Z"
          class="cls-102"
        />
        <path
          id="path355"
          d="M178.88386,193.87784q-10.10518,7.51113-20.21046,15.02292-2.23537-6.37764-4.4703-12.7563Q166.5436,195.01142,178.88386,193.87784Z"
          class="cls-67"
        />
        <path
          id="path357"
          d="M211.92863,501.105a12.07228,12.07228,0,0,1,2.24183-2.45066c5.70072-3.51443,11.47058-6.91681,17.21746-10.35652q.75753-.36674,1.51528-.73293,3.29418.34047,6.58722.68048-11.27818,5.22411-22.55225,10.45242C215.25814,499.47837,213.598,500.30149,211.92863,501.105Z"
          class="cls-103"
        />
        <path
          id="path359"
          d="M257.67093,423.17174c9.70521-9.84978,19.44785-19.66321,29.09139-29.573,2.67772-2.75168,5.0617-5.789,7.58015-8.69546,5.02687-6.63953,10.03019-13.29712,15.09477-19.90779,1.65409-2.159,3.46767-4.19578,5.20861-6.28839q-4.73142,12.04931-9.4544,24.102c-.93738,2.40794-1.76724,4.85764-2.64688,7.28767q-.665,1.17686-1.32865,2.355-1.23135,1.07574-2.46359,2.15124c-11.9126,10.96729-24.77647,20.75625-37.78845,30.353-1.52347,1.12364-3.08747,3.3465-5.475,1.25906Q256.57989,424.69348,257.67093,423.17174Z"
          class="cls-44"
        />
        <path
          id="path361"
          d="M152.01366,121.0464c1.082-3.425,2.1818-6.84453,3.23946-10.277.69334-2.25029,1.32573-4.51935,1.98585-6.77948q.3336-.04374.66679-.08428c1.94577,3.87825,3.79362,7.81084,5.89156,11.60526.72344,1.30846,2.07007,2.27268,3.13194,3.394q-3.72859.71187-7.45684,1.42359Q155.74348,120.687,152.01366,121.0464Z"
          class="cls-96"
        />
        <path
          id="path363"
          d="M255.48885,426.21511c3.55173-2.48784,7.17561-4.87968,10.6415-7.48177,9.93393-7.458,19.79658-15.01063,29.71143-22.49414a24.08856,24.08856,0,0,1,2.91119-1.636q-14.03447,14.70018-28.0578,29.41005c-2.21744,2.3338-4.31236,4.78391-6.464,7.17992q-2.13621,1.97529-4.27146,3.95188-18.74383,13.63871-37.49714,27.26516c-1.70255,1.23409-3.52546,2.30243-5.29257,3.44761q11.08721-11.66169,22.18107-23.317c4.31007-4.50489,8.68777-8.94512,13.03494-13.41447Q253.93741,427.67072,255.48885,426.21511Z"
          class="cls-104"
        />
        <polygon
          id="polygon365"
          points="134.718 319.047 181.928 288.295 181.193 345.974 129.43 372.175 132.484 328.756 134.718 319.047"
          class="cls-105"
        />
        <polygon
          id="polygon367"
          points="130.958 417.89 185.656 417.871 186.458 447.127 131.693 423.164 130.958 417.89"
          class="cls-105"
        />
        <polygon
          id="polygon369"
          points="212.654 407.439 209.512 392.892 210.383 385.374 277.895 348.191 312.066 318.216 315.371 316.743 286.725 379.922 212.654 407.439"
          class="cls-3"
        />
        <polygon
          id="polygon371"
          points="210.383 385.374 217.17 358.707 219.558 325.715 241.108 292.032 267.353 317.599 210.383 385.374"
          class="cls-2"
        />
        <circle @click="falert" class="pa" id="p1" cx="47.017982" cy="217.06471" r="16" />
        <circle @click="falert" r="16" cy="253.40399" cx="69.317093" id="p2" class="pa" />
        <circle @click="falert" class="pa" id="p3" cx="98.223343" cy="307.91293" r="16" />
        <circle @click="falert" r="16" cy="150.99329" cx="100.70102" id="p4" class="pa" />
        <circle @click="falert" class="pa" id="p5" cx="112.26352" cy="199.72096" r="16" />
        <circle @click="falert" class="pa" id="p6" cx="130" cy="275" r="16" />
        <circle @click="falert" r="16" cy="113.00222" cx="163.46889" id="p7" class="pa" />
        <circle @click="falert" class="pa" id="p8" cx="166.77246" cy="174.11829" r="16" />
        <circle @click="falert" r="16" cy="260" cx="172" id="p9" class="pa" />
        <circle @click="falert" class="pa" id="p10" cx="243.58049" cy="126.2165" r="16" />
        <circle @click="falert" r="16" cy="180.72542" cx="236.97334" id="p11" class="pa" />
        <circle @click="falert" class="pa" id="p12" cx="220" cy="262" r="16" />
        <circle @click="falert" class="pa" id="p16" cx="336.90637" cy="267.62274" r="16" />
        <circle @click="falert" r="16" cy="359.11829" cx="315.43314" id="p15" class="pa" />
        <circle @click="falert" class="pa" id="p14" cx="253.49118" cy="431.79684" r="16" />
        <circle @click="falert" r="16" cy="492.9129" cx="238.62511" id="p13" class="pa" />
        <circle @click="falert" class="pa" id="p18" cx="224.58493" cy="543.29236" r="16" />
        <circle @click="falert" r="16" cy="543.29236" cx="155.20993" id="p19" class="pa" />
        <circle @click="falert" class="pa" id="p17" cx="136.2144" cy="476.39505" r="16" />
        <circle @click="falert" r="40" cy="450" cx="190" id="p50" class="pa" />

        <g
          transform="translate(148.000000,145.000000) scale(0.006,-0.006) rotate(15)"
          fill="#000000"
          stroke="none"
          v-if="selected=='p50'"
          class="pb"
        >
          <path
            class="pbc"
            d="M4780 12433 c-56 -169 -211 -639 -345 -1043 -307 -926 -541 -1638 -1055 -3200 -138 -421 -260 -790 -270 -820 -33 -98 -478 -1454 -484 -1475 -3 -11 -7 -24 -8 -28 -2 -4 169 -8 380 -7 363 0 383 -1 378 -17 -8 -31 -1071 -3933 -1155 -4243 -44 -162 -139 -513 -211 -780 -72 -267 -133 -491 -135 -497 -2 -7 -1 -13 3 -13 4 1 66 141 139 313 73 172 207 488 299 702 91 215 237 557 324 760 87 204 231 541 320 750 89 209 292 684 450 1055 158 371 360 845 449 1053 89 207 233 547 322 755 89 207 196 459 239 560 l78 182 -439 0 c-241 0 -439 3 -439 6 0 4 12 63 26 133 14 69 70 347 124 616 55 270 140 693 190 940 50 248 131 648 180 890 49 242 170 843 270 1335 99 492 221 1093 270 1335 49 242 116 575 149 739 34 165 59 301 57 303 -2 3 -50 -134 -106 -304z"
          />
        </g>
        <g
          transform="translate(223.000000,150.000000) scale(0.006,-0.006)"
          fill="#000000"
          stroke="none"
          v-if="selected=='p50'"
        >
          <path
            class="pb"
            d="M4780 12433 c-56 -169 -211 -639 -345 -1043 -307 -926 -541 -1638 -1055 -3200 -138 -421 -260 -790 -270 -820 -33 -98 -478 -1454 -484 -1475 -3 -11 -7 -24 -8 -28 -2 -4 169 -8 380 -7 363 0 383 -1 378 -17 -8 -31 -1071 -3933 -1155 -4243 -44 -162 -139 -513 -211 -780 -72 -267 -133 -491 -135 -497 -2 -7 -1 -13 3 -13 4 1 66 141 139 313 73 172 207 488 299 702 91 215 237 557 324 760 87 204 231 541 320 750 89 209 292 684 450 1055 158 371 360 845 449 1053 89 207 233 547 322 755 89 207 196 459 239 560 l78 182 -439 0 c-241 0 -439 3 -439 6 0 4 12 63 26 133 14 69 70 347 124 616 55 270 140 693 190 940 50 248 131 648 180 890 49 242 170 843 270 1335 99 492 221 1093 270 1335 49 242 116 575 149 739 34 165 59 301 57 303 -2 3 -50 -134 -106 -304z"
          />
        </g>
        <g
          transform="translate(300.000000,270.000000) scale(0.008,-0.006) rotate(-5)"
          fill="#000000"
          stroke="none"
          v-if="selected=='p50'"
        >
          <path
            class="pb"
            d="M4780 12433 c-56 -169 -211 -639 -345 -1043 -307 -926 -541 -1638 -1055 -3200 -138 -421 -260 -790 -270 -820 -33 -98 -478 -1454 -484 -1475 -3 -11 -7 -24 -8 -28 -2 -4 169 -8 380 -7 363 0 383 -1 378 -17 -8 -31 -1071 -3933 -1155 -4243 -44 -162 -139 -513 -211 -780 -72 -267 -133 -491 -135 -497 -2 -7 -1 -13 3 -13 4 1 66 141 139 313 73 172 207 488 299 702 91 215 237 557 324 760 87 204 231 541 320 750 89 209 292 684 450 1055 158 371 360 845 449 1053 89 207 233 547 322 755 89 207 196 459 239 560 l78 182 -439 0 c-241 0 -439 3 -439 6 0 4 12 63 26 133 14 69 70 347 124 616 55 270 140 693 190 940 50 248 131 648 180 890 49 242 170 843 270 1335 99 492 221 1093 270 1335 49 242 116 575 149 739 34 165 59 301 57 303 -2 3 -50 -134 -106 -304z"
          />
        </g>
      </svg>
    </div>
    <div class="flex-1 z-20" v-if="face==1" id="left-side">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        inkscape:version="1.0beta2 (2b71d25, 2019-12-03)"
        sodipodi:docname="left-side.svg"
        id="left-side-svg"
        :style="trans"
        version="1.1"
        viewBox="0 50 384 555"
      >
        <metadata id="metadata247">
          <rdf:RDF>
            <cc:Work rdf:about>
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <sodipodi:namedview
          inkscape:current-layer="svg243"
          inkscape:window-maximized="0"
          inkscape:window-y="23"
          inkscape:window-x="0"
          inkscape:cy="277.5"
          inkscape:cx="192"
          inkscape:zoom="1.2108108"
          showgrid="false"
          id="namedview245"
          inkscape:window-height="961"
          inkscape:window-width="1214"
          inkscape:pageshadow="2"
          inkscape:pageopacity="0"
          guidetolerance="10"
          gridtolerance="10"
          objecttolerance="10"
          borderopacity="1"
          inkscape:document-rotation="0"
          borderColor="#666666"
          pagecolor="#ffffff"
        />
        <defs id="defs11">
          <mask
            maskUnits="userSpaceOnUse"
            height="359.04"
            width="781.92"
            y="-377.2556"
            x="-939.69515"
            id="mask"
          />
        </defs>
        <filter id="f1" x="-40%" y="-40%" height="180%" width="180%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>

        <g data-name="Layer 3" id="Layer_3">
          <polygon
            id="polygon13"
            points="160.714 222.665 150.39 234.351 196.107 268.311 222.258 214.723 274.709 76.054 239.546 92.939 204.61 142.895 191.763 157.787 166.848 217.715 160.714 222.665"
            class="cls-2"
          />
          <path
            id="path15"
            d="M190.08433,601.579c-7.68268,1.21323-15.36242,2.44549-23.04995,3.62721-2.07588.31908-4.17538.48519-6.264.72154-2.25926-.88682-4.40268.26037-6.59935.33089-1.41833.04546-2.95406.90123-4.32059-.25337-2.72631-8.22567-2.77874-16.83579-3.53183-25.32576-1.52941-17.24466-2.916-34.50244-4.342-51.7562-1.1181-13.53-2.16575-27.06686-3.25978-40.59924-.5957-7.36875-1.55019-14.71926-1.42977-22.12113.043-2.64608-1.62787-4.95208-1.1116-7.59958.35723-1.0152.297-2.26443,1.62229-2.87292,1.97413-.31817,3.06844.91093,4.05285,2.47206q15.62021,24.77246,30.98372,49.70475c2.42873,3.94021,4.284,8.23789,6.82628,12.13859,2.19319,2.4887,4.133,5.09289,4.02952,8.65141-1.46079,11.37785,2.76848,22.133,3.6387,33.25856.894,11.43182,2.78788,22.7541,4.04672,34.14823C191.6002,598.13764,191.90254,600.07768,190.08433,601.579Z"
            class="cls-3"
          />
          <path
            id="path17"
            d="M107.01372,605.13262q-5.31284-1.45881-10.62557-2.91765a91.47484,91.47484,0,0,1,.00613-10.84523c.00851-3.53419,1.16687-6.75812,2.23766-10.09464a73.76448,73.76448,0,0,0,2.86686-17.13055,135.83657,135.83657,0,0,1,3.75372-21.26971,17.81157,17.81157,0,0,0,.6215-7.64568c2.04752-8.29816.9673-16.91089,2.45966-25.27436,3.223-3.71836,2.51227-8.37106,2.387-12.609a49.48026,49.48026,0,0,1,.48516-7.21322c.45643-3.92791-.11154-7.81919-.05664-11.5236,3.41616-2.24614,4.18938-2.11054,7.02805.99947,1.77941,4.27064,1.27448,8.86412,1.50855,13.26008.8564,16.08415,2.40247,32.12934,2.793,48.237.059,2.43388-.27955,4.87562-.18456,7.32559.5999,5.11462.64721,10.2613,1.0814,15.38067-1.75927,10.81976-1.67838,21.7897-2.6261,32.67678-.2909,3.34261-.31816,6.7009-1.84712,9.7907-2.15046,1.77557-4.15891-.20448-6.24074-.27381C110.76094,605.9422,109.04989,604.476,107.01372,605.13262Z"
            class="cls-4"
          />
          <path
            id="path19"
            d="M239.71194,203.10971c-3.82968,8.08646-7.24318,16.40681-11.61886,24.18651-3.59286,6.3879-3.78484,12.808-3.17843,19.727,1.12862,12.8756,1.87448,25.78473,2.77956,38.6799,1.51889,5.82645,1.56473,11.83645,2.277,17.76483.49989,4.16038-.54775,8.137-.81586,12.19393-1.10108,5.94337-.81083,12.02206-1.79981,18.00608-.76728,4.64347-1.32152,9.35-1.7321,14.05768-.69874,2.05945-.51673,4.1902-.57292,6.31258-.26555,10.02961-.652,20.05414-1.62614,30.0462-.0754,2.41993-.44425,4.71889-2.43668,6.20776-1.41724.519-2.30264-.33158-3.29327-.79408-3.1346-6.36741-3.8908-13.26658-4.49281-20.20036a90.57309,90.57309,0,0,1,4.89708-18.87635,8.963,8.963,0,0,0,.84569-3.6643,25.94049,25.94049,0,0,1,.22482-6.14474c1.13384-2.863.81669-5.77529.74669-8.79369-.23609-10.16782-.68153-20.35436.27222-30.5174.16188-1.72614.48452-3.48482-1.08589-5.04375-2.80765-1.04862-5.07194.95421-7.59364,1.74072-2.27436.70941-4.38849,2.62459-7.00252.9898a6.52175,6.52175,0,0,1-1.11709-3.729,9.6376,9.6376,0,0,1,1.52566-5.61014c2.157-3.42283,1.68022-7.55643,2.27308-11.35778,1.76221-11.297,4.29717-22.41854,6.85538-33.54177,1.35034-9.92926,4.82223-19.33657,7.163-29.02212,1.04069-2.522.50328-5.85115,3.7065-7.27526a16.49435,16.49435,0,0,0,5.21314-3.57818c2.34043-.83394,4.80978-1.25243,6.91175-2.81534C237.81714,201.47874,239.67762,200.61224,239.71194,203.10971Z"
            class="cls-5"
          />
          <path
            id="path21"
            d="M244.802,268.01455q6.01572-10.13022,12.03127-20.2605c5.62573-5.62473,10.78982-11.75234,17.6107-16.07759a5.56522,5.56522,0,0,1,1.33378-.56367c3.22025.22261,6.35851.6776,8.90537,2.93073,1.16312,1.75243.3759,3.2899-.50868,4.84341-1.943,3.41261-4.87639,5.96525-7.66254,8.60024-4.36059,4.12425-6.1679,8.53171-3.97425,14.62863,1.89068,5.25481,3.65444,10.70457,3.26408,16.48849a96.58351,96.58351,0,0,1-26.60438,19.72225c-5.45928-.51424-10.10381-3.044-14.45185-5.40984-.81074-2.12375.23068-3.38109.89281-4.65625,2.86805-5.5227,5.41756-11.199,8.17552-16.77432C244.34539,270.41163,245.23024,269.38394,244.802,268.01455Z"
            class="cls-6"
          />
          <path
            id="path23"
            d="M286.84868,275.63921c-4.569,8.97393-8.76042,18.16627-13.798,26.86915-7.06072,12.19779-9.79727,25.71-13.12989,39.08211-2.10379,8.44136-4.158,16.89515-6.23451,25.34333A145.58272,145.58272,0,0,1,243.496,379.96123c-2.41427,2.65321-3.31176,2.77756-5.62931.64247-.60475-7.209.06067-14.382.53842-21.55367-.16974-4.023-.7583-8.03556-.47107-12.07424,2.97639-7.55627,1.85682-15.72885,3.473-23.50217a59.01335,59.01335,0,0,0,.97681-7.0001c.16581-1.94785,1.02083-3.32088,3.69928-3.02491,2.50815,3.35786,2.95781,7.58931,3.90946,11.6895.64832,2.79389.41031,6.06694,3.305,7.90069,1.52759-.51757,1.30752-2.013,1.68937-3.08549,2.36239-6.63551,4.25554-13.43762,7.09961-19.90645,1.04764-1.78118.954-4.05658,2.44968-5.642,4.50727-2.8361,6.351-7.69219,8.72528-12.01922,2.955-5.38546,6.05023-10.67992,9.24165-15.91947.84157-1.38139,1.566-3.29941,3.88384-2.80779A1.29267,1.29267,0,0,1,286.84868,275.63921Z"
            class="cls-7"
          />
          <path
            id="path25"
            d="M150.38979,234.35117c4.87365-1.7667,9.62276-4.17055,14.64978-5.1531,7.84-1.53232,12.85454-6.48614,17.633-12.15069a24.50414,24.50414,0,0,1,3.658-2.97161c1.06713,1.69367-.26363,2.835-1.05451,3.97515-2.68787,3.87535-5.3643,7.7597-8.15081,11.56765,7.27895-9.49766,13.24216-19.88593,20.15-29.63419,1.0998-1.55216,2.266-3.14821,4.57992-1.88566,1.45585,1.38846,1.32545,3.20571,1.05478,4.88154-1.65816,10.26555-2.222,20.69407-4.54021,30.85387-.40518,1.77617.1734,3.43867-.04173,5.14816-.5439,1.41739-.49,3.12981-1.98913,4.08-10.62191.34989-20.48552,4.35164-30.74553,6.46967-2.54018.49811-3.55735-1.74178-5.17873-2.88906-1.09651-.77593-1.96764-1.82177-3.04831-2.61256-1.44834-1.28952.30508-3.114-.76151-4.46154A16.41057,16.41057,0,0,1,150.38979,234.35117Z"
            class="cls-8"
          />
          <path
            id="path27"
            d="M276.98114,98.6587q-1.48362,2.65125-2.96706,5.30252c-.77157.96435-.84907,2.25778-1.54826,3.258-9.9165,12.65646-19.1501,25.82639-29.13111,38.43837-2.75128,3.47645-6.48048,6.12386-8.48737,10.20091a2.50155,2.50155,0,0,1-1.67674.63993c-1.98968-.4199-2.53066-1.73659-1.989-3.51335.593-1.94523,1.02458-3.99871,2.61759-5.47807a5.48468,5.48468,0,0,0,3.31505-3.20227q9.553-20.15579,19.69061-40.02673c1.44331-2.844,2.55894-5.88748,4.87366-8.24259,1.1192-1.13879.61921-2.79171,1.0103-4.178,3.21943-4.10009,5.45865-8.80015,8.16107-13.21592,1.05222-1.71936,2.02739-3.95515,4.83632-2.64269,1.69751,1.31861,1.5888,3.24429,1.65926,5.07617C277.57134,86.94218,278.46471,92.82626,276.98114,98.6587Z"
            class="cls-9"
          />
          <path
            id="path29"
            d="M208.90949,435.31952c-1.3993,3.57924-2.8179,7.15116-4.1891,10.74119-.6216,1.62744-1.14894,3.29083-1.71856,4.93813-8.28853,23.96737-8.12748,23.94858-5.192,49.0813,1.34192,11.48875,1.90678,23.06815,2.82412,34.60643.23115,1.0099-.363,1.07681-1.11023.97071-1.79515-1.15414-1.89168-3.10369-2.27884-4.90557-1.43068-6.6586-2.37392-13.41178-3.9489-20.04518-.68583-2.88851-3.15711-5.15015-2.8405-8.36311a27.0386,27.0386,0,0,1-.18695-9.2213c.83123-5.46174-.25868-10.87875-1.00088-16.28982a48.06174,48.06174,0,0,1-.26116-5.58426,60.76987,60.76987,0,0,0-.4212-9.03632,21.21757,21.21757,0,0,1,1.07135-9.93855c.69489-3.30972,2.42836-6.12639,4.26047-8.8981,5.59911-2.33793,6.9683-8.16622,10.24171-12.42118,1.643-2.13564,2.71011-4.643,4.31383-6.80994.90718-1.22567,1.78581-2.45651,3.68088-2.207,2.10443.84357,1.92133,2.47023,1.416,4.30966C212.64674,429.60533,210.34365,432.23558,208.90949,435.31952Z"
            class="cls-10"
          />
          <path
            id="path31"
            d="M192.39008,502.53784q3.7323,16.4818,7.46452,32.96358c2.42306,4.79846,3.11173,10.10909,4.35684,15.23579,1.85535,7.63987,3.22262,15.40107,5.33575,22.97819,1.08635,3.89553.30508,8.14427,2.38874,11.8179.338,2.17621.676,4.35246,1.07143,6.8977-4.05184,1.84372-7.86468,3.57864-11.67751,5.31351a2.82257,2.82257,0,0,1-2.43047-2.88c-.21494-2.345-1.07573-4.63116-.65316-7.03517,1.03016-7.31777-.94525-14.39145-1.801-21.54837-1.4661-12.26-2.51951-24.559-3.68638-36.84731-.66012-6.9518-1.52832-13.88554-1.94567-20.8581C190.68515,506.43452,189.84285,504.01793,192.39008,502.53784Z"
            class="cls-11"
          />
          <path
            id="path33"
            d="M238.91566,381.15882c2.74177-2.78173,5.437-5.61143,8.24076-8.32931,2.10425-2.03983,4.34805-3.93574,6.52981-5.89571a23.20508,23.20508,0,0,1-1.1494,3.89823c-4.78361,9.71281-9.64281,19.38844-14.47894,29.07536a18.18128,18.18128,0,0,0-7.31153,4.9744c-4.06631,4.36659-8.61457,8.26725-12.4371,12.87673-1.56757,1.89019-3.38038,2.48734-5.48674.39405-.71117-2.70965.563-5.63-.47555-8.38671.76636-6.73781,2.92331-13.13879,4.71178-19.62758a2.067,2.067,0,0,1,1.5458-1.47652c.53741.21348,1.07472.427,1.70767.67842.46521-1.8794.8714-3.52056,1.27759-5.16177,1.40744.0605,1.68516,1.82552,3.64666,2.07376C229.55661,385.01589,233.99049,382.3876,238.91566,381.15882Z"
            class="cls-12"
          />
          <path
            id="path35"
            d="M253.76282,339.87a9.12881,9.12881,0,0,1-1.53738-2.232c-2.3386-7.5613-4.59026-15.14944-7.73035-22.7446-.64749,5.02459-1.199,10.06388-1.968,15.06979-.86115,5.60558-1.91941,11.18087-2.892,16.7693-2.43971-.75548-2.85926-2.95309-3.37132-4.95977-2.1124-8.27758-4.17785-16.566-7.05806-24.58533-.293-.71816-1.07263-.81832-1.63245-1.1996q.06039-15.14131.121-30.28366,2.07711,3.61346,4.15424,7.229a5.81562,5.81562,0,0,1,3.62625,2.376c2.24544,3.56471,4.73274,6.971,7.09238,10.46847.78511,4.0288,2.49717,5.70418,6.27075,6.07163a5.43134,5.43134,0,0,1,2.5023.57524,2.94556,2.94556,0,0,1,1.08744,2.28053c.55041,8.15257,2.631,16.23958,1.07565,24.48657C253.4635,339.40255,253.64688,339.647,253.76282,339.87Z"
            class="cls-13"
          />
          <path
            id="path37"
            d="M135.41443,330.32019q2.599-8.28777,5.198-16.57543c-.0614-3.2747,1.30349-6.264,2.043-9.35723,1.26726-5.30076,2.55309-10.58512,3.41452-15.97005.10687-.66781-.03093-1.55143.89144-1.8823a1.555,1.555,0,0,1,1.13429.66877,9.94788,9.94788,0,0,1,1.06522,4.69025c.02086,15.8103.23827,31.62113-.1121,47.4253-3.17166,6.97915-5.26035,14.37946-8.23125,21.44212a6.83216,6.83216,0,0,0-.60777,3.27511c.6818,6.63971-1.65158,13.01677-1.63776,19.60339.00494,2.36467-.58307,4.62535-3.93353,3.45941-1.55559-2.1-1.09925-4.52506-.97764-6.8333.54747-10.38835,1.93862-20.72186.8326-31.19674-.38752-3.67144.16425-7.52224.09535-11.2904C134.275,335.23079,136.27366,332.93338,135.41443,330.32019Z"
            class="cls-14"
          />
          <path
            id="path39"
            d="M199.75148,588.01327q.78909,4.86567,1.57828,9.73124-5.62263,1.91658-11.24543,3.83384-2.77672-22.74268-5.56058-45.48569c-1.03694-8.38026-2.17059-16.74862-3.18191-25.13181a10.40834,10.40834,0,0,1,.466-2.85911c2.25514.3892,2.26859,2.38142,2.79877,3.96889,4.31923,12.93029,6.72938,26.36009,10.33038,39.47762,1.14637,4.176,2.17837,8.41016,4.16934,12.30588C199.86394,585.15444,199.04808,586.70148,199.75148,588.01327Z"
            class="cls-15"
          />
          <path
            id="path41"
            d="M239.71194,203.10969c-1.7332.60629-3.4761,1.18666-5.19649,1.82728-1.35034.50277-2.67295,1.08-4.00783,1.62415-.702-2.93336,1.65249-4.19681,3.348-5.555,5.49442-4.40117,10.8568-8.96538,16.41244-13.28956a25.60594,25.60594,0,0,0,4.22068-4.1271c4.39938-2.572,6.78482-7.10968,10.24893-10.60074,7.50827-7.56635,14.23088-15.90161,22.33173-22.89731.86976-.75112,1.23038-1.85511,1.94055-2.71731,2.48006-2.98628,3.92822-6.67614,6.57189-9.555.79729-.86837,1.59741-1.61784,2.82477-1.14417.85365.32951.83763,1.0919.502,1.84718-.54509,1.7654-.96117,3.58326-1.65532,5.288a79.52086,79.52086,0,0,1-31.47144,37.72826c-7.41667,4.78062-14.12262,10.67873-21.03391,16.21621A50.34674,50.34674,0,0,0,239.71194,203.10969Z"
            class="cls-16"
          />
          <path
            id="path43"
            d="M197.58418,193.14843q9.69217-10.2026,19.376-20.41307c1.08864-1.15163,2.06719-2.40721,3.09653-3.61479,1.01873.15456,1.62037-.49119,2.211-1.16169,7.045-2.00672,12.43508-6.85631,18.34915-10.77359,4.98813-3.304,10.02438-6.52,15.15846-9.587,1.27-.75862,2.50843-1.73168,4.15744-1.07029,1.60006,1.19757.94077,2.18117-.17779,3.32543a202.20681,202.20681,0,0,1-15.53354,13.84975c-6.70906,5.58145-13.40733,11.18252-20.14915,16.71428-6.63979,5.448-13.16355,11.0517-19.938,16.3423-1.305,1.01909-2.59911.50785-3.93353.41264C198.24064,196.53592,197.20077,195.30392,197.58418,193.14843Z"
            class="cls-6"
          />
          <path
            id="path45"
            d="M214.07193,410.39672V418.327c7.33377-7.26489,13.96222-13.83111,20.69214-20.4978l3.29382,2.07815c-.65719,1.45818-1.01671,3.1728-2.01824,4.3344-8.97921,10.41446-18.07125,20.73178-27.13016,31.07769q1.70378-5.84022,3.40747-11.68052l-.69837-.46795c-.7594.98-1.56721,1.92668-2.27,2.94568-3.53639,5.127-6.99044,10.31188-10.60205,15.385a25.26358,25.26358,0,0,1-3.47262,3.34192c-2.18276-1.92645-.52441-3.77287.3867-5.31731,5.10535-8.65439,9.05617-17.96734,14.93711-26.17816a11.70174,11.70174,0,0,0,1.028-1.98883C212.24009,410.527,212.91275,409.84155,214.07193,410.39672Z"
            class="cls-17"
          />
          <path
            id="path47"
            d="M259.79492,147.34319q-16.92454,10.42852-33.86246,20.83507a28.58672,28.58672,0,0,1-3.70221,1.61833c-.95284-1.64883.46522-2.40651,1.33772-3.23864,2.29888-2.1926,4.86029-4.08668,7.276-6.14873q.7401-.33944,1.45548-.73623c3.14467-2.972,6.87112-5.13643,10.44769-7.50568a8.2628,8.2628,0,0,0,3.26344-3.39553c1.51267-2.7075,2.67972-5.72365,6.021-6.82209a3.84693,3.84693,0,0,0,4.11407-.63687,37.88,37.88,0,0,0,9.2153-9.01173c.65252-.91132,1.10611-1.93634,2.32734-2.21717,2.73033.36917,3.47884-2.27915,5.20883-3.43,1.47086-1.89089,3.17486-3.37151,5.76922-3.29115q3.33413-2.61934,6.66815-5.23872c1.20128,1.61973.08053,2.88593-.7992,3.9974-3.98788,5.03905-7.49491,10.484-12.23167,14.89777a10.7439,10.7439,0,0,0-3.5418,5.95928c-.87332.97558-1.857,1.85138-2.65621,2.89849C264.28856,147.59276,261.85425,146.65821,259.79492,147.34319Z"
            class="cls-18"
          />
          <path
            id="path49"
            d="M135.41443,330.32019l-.05353,6.64044c-1.92115,21.40115-7.36268,42.19673-10.89451,63.32077a24.65944,24.65944,0,0,1-.79673,3.648c-.03816,4.33682-.97965,8.57119-1.43343,12.86224-.88458,7.45912-3.63732,14.37521-5.73773,21.4954a3.52858,3.52858,0,0,1-.67192-3.973,255.81969,255.81969,0,0,1,10.66125-69.23029C129.92916,353.6358,132.46778,341.91669,135.41443,330.32019Z"
            class="cls-19"
          />
          <path
            id="path51"
            d="M264.29807,92.69338c-1.43818,3.15526-2.76793,6.36538-4.33285,9.4565q-11.47612,22.66731-23.05892,45.28055c-.33262.65226-.715,1.27918-1.36919,2.44231-.25667-.92538-.3684-1.328-.48-1.73067-1.6254-1.11177-1.17108-2.43469-.57117-3.94632,4.28207-10.78966,8.98223-21.40541,13.33577-32.16479q2.23509-5.55211,4.47-11.10426c.37307-.80816.33967-1.80229,1.11362-2.42869,2.56122-1.31756,4.06786-3.91309,6.53968-5.35353C261.36241,92.31846,262.682,91.28662,264.29807,92.69338Z"
            class="cls-20"
          />
          <path
            id="path53"
            d="M240.30754,101.7361q-.30074.32637-.60164.65271c-6.55753,7.76516-12.13523,16.29073-18.71124,24.04567-2.82467,3.33109-6.12855,6.17076-9.11372,9.33254-.71548.75783-1.59247,1.242-2.62757.44048-1.01717-1.56344.26683-2.56858.90663-3.7249,2.60414-4.70573,5.86484-9.00624,8.47172-13.70807q8.98709-14.58987,18.31868-28.96655c.66964-1.026,1.05872-2.80114,3.02232-1.81459,2.38618,3.73816,1.469,7.70822.78869,11.64524C240.64071,100.33666,240.08692,100.95205,240.30754,101.7361Z"
            class="cls-21"
          />
          <path
            id="path55"
            d="M286.06347,274.08842q-8.855,14.39483-17.73487,28.7742a20.71028,20.71028,0,0,1-2.416,2.71589c-3.09425-2.37634-.14046-4.61678.14869-6.91485,5.21982-7.17765,8.3837-15.39645,12.06651-23.38193,1.81967-3.94545,3.71995-7.68995,3.63989-12.13127,1.70583-2.80345,2.83373-5.93271,4.82113-8.58076.797-1.0621,1.42244-2.32271,3.00951-2.39122,4.25315.87811,3.68408,4.72076,4.67572,7.60605L292.0351,265.033C289.77263,267.87229,289.121,271.773,286.06347,274.08842Z"
            class="cls-22"
          />
          <path
            id="path57"
            d="M195.34926,163.13135q-.81256,15.25407-1.625,30.5081l-.9275.00226V157.98l-1.03336-.19309a20.18157,20.18157,0,0,0-1.35766,2.6879c-4.82131,14.4156-9.875,28.76218-14.27013,43.30736-1.75077,5.79437-4.40222,10.41641-9.288,13.93271-2.09263,1.50609-3.82116,3.51775-6.13368,4.95009,2.62583-3.31064,5.27838-6.60065,7.862-9.94381a14.26839,14.26839,0,0,0,2.16455-3.43636c6.34935-16.52455,12.77631-33.022,18.85307-49.64692,2.04715-5.60034,6.01582-9.31938,10.24427-13.01206,1.59292,1.37593.7863,2.62486-.27232,3.77a43.05093,43.05093,0,0,0-3.65371,3.737C195.22765,157.05618,196.28664,160.16235,195.34926,163.13135Z"
            class="cls-23"
          />
          <path
            id="path59"
            d="M195.34926,163.13135c-.25265-3.00875-.50538-6.0175-.81266-9.67642,1.4079-1.81366,3.35449-4.32118,5.30108-6.82889q8.52534-13.09375,17.05051-26.18715c.83187-.47257.98139-2.02924,2.42717-1.52649-2.6563,4.567-5.32935,9.12438-7.95765,13.70747-.66918,1.167-1.19606,2.41556-1.78838,3.62662.38735,1.27122-.86609,1.61382-1.22754,2.21906a177.65219,177.65219,0,0,0,13.80959-13.69949c.69781-.81052,1.49729-2.33234,3.1485-1.37459-5.27472,9.119-10.31,18.42545-19.30336,24.63286-.30682.21182-.59588.45206-.91478.64311C199.57359,151.968,195.17485,156.01127,195.34926,163.13135Z"
            class="cls-24"
          />
          <path
            id="path61"
            d="M241.0351,306.29487q-4.59333-6.68082-9.18665-13.36168c2.63287-4.73265,5.3535-9.41929,7.86962-14.2132,1.83431-3.49508,3.399-7.13162,5.08393-10.70528-.1885,1.38764-.05491,2.92592-.62132,4.13705-2.37017,5.0666-4.96553,10.02755-7.4422,15.0451-.58655,1.18838-1.03227,2.44627-1.77776,4.23678,5.0185,2.04086,9.69478,3.94248,14.371,5.84412,1.37789,1.18442,1.75461,2.88175,2.30227,4.49154.01391,3.55509,1.24346,7.19559-.74741,10.60824C245.92568,313.06568,243.8788,309.03534,241.0351,306.29487Z"
            class="cls-25"
          />
          <path
            id="path63"
            d="M267.20583,142.12274q7.12078-9.50454,14.24615-19.00574c1.26662-1.6845,2.5864-3.32909,3.8822-4.99251.78127-1.10685,1.56227-2.21318,2.85578-4.0455,2.5702,3.70287,4.63263,6.67429,6.69506,9.64573-.84166,2.87166-3.35659,4.22914-5.42323,5.99537a8.02893,8.02893,0,0,1-.73094.77057c-.26152.2514-.52213.49985-.78146.75351-6.263,2.7577-11.11851,7.7095-17.08134,10.93322C269.62687,142.8484,268.40638,143.52922,267.20583,142.12274Z"
            class="cls-26"
          />
          <path
            id="path65"
            d="M247.82167,112.031c-2.20207,6.58656-4.32463,13.20109-6.63055,19.75109-1.9336,5.49241-4.08113,10.90956-6.13405,16.36-.64191,2.44453-3.55268,4.3982-1.603,7.4034,2.02346,2.03162-.96373,3.58765-.51956,5.46933l-.812.6835c-2.718-.38888-4.529,1.24742-6.3435,2.85556-.9253.82013-1.55595,2.12679-3.10769,1.83531-.87351-.48583-.83554-1.13434-.40482-1.86362q11.042-23.22,22.10534-46.42971C245.37354,116.00331,246.66458,114.04917,247.82167,112.031Z"
            class="cls-27"
          />
          <path
            id="path67"
            d="M240.30754,101.73609c-.24953-2.933-.46576-5.86928-.762-8.79753-.16-1.58072-.45689-3.14762-.692-4.72075-.69874-1.89918,2.135-2.6903,1.44038-4.58818q5.23857-7.44941,10.47715-14.89877c.602-.64805.41781-2.13042,1.93094-1.81811,1.94311.76484,2.00176,2.30281,1.67875,4.02267a33.1333,33.1333,0,0,1-1.92545,6.82148,22.10546,22.10546,0,0,0-2.13573,9.81436c-1.682,3.26233-4.52547,5.71851-6.26361,8.95013Q242.1817,99.12872,240.30754,101.73609Z"
            class="cls-28"
          />
          <path
            id="path69"
            d="M97.90668,591.76218q-.75918,5.22645-1.51844,10.45284c-.39576-4.63465-1.533-9.346-1.062-13.89089,2.37419-22.91106,5.15156-45.78054,7.82973-68.65967.43282-3.69787,1.07774-7.37091,1.62458-11.05543,1.7741-.812,2.05987.45986,2.40384,1.695.73954,2.65568.47271,5.347.32338,8.0362-1.6686,5.987-1.112,12.31612-2.895,18.31963a19.04534,19.04534,0,0,0-1.15342,5.94414C102.23514,559.06345,100.18286,575.42544,97.90668,591.76218Z"
            class="cls-29"
          />
          <path
            id="path71"
            d="M253.83767,99.49268q-.77291.71708-1.5458,1.43409-3.36472-2.61588-6.729-5.23161c-.68217-2.28236,1.34751-3.36883,2.40549-4.64128a53.49256,53.49256,0,0,0,3.3715-4.3084c3.45011-2.30676,5.16711-5.82063,6.53356-9.5454a16.95982,16.95982,0,0,1,1.679-4.07379,21.09985,21.09985,0,0,0,4.28216-6.47249,5.15341,5.15341,0,0,1,.54985-.953,2.04864,2.04864,0,0,1,2.25908-.98785,14.11734,14.11734,0,0,1,2.78468,3.00134,2.82866,2.82866,0,0,1,.32668,1.0569,12.52663,12.52663,0,0,1-1.885,5.54129c-2.49745,4.268-4.58367,8.75939-6.74411,13.20386A55.86258,55.86258,0,0,1,253.83767,99.49268Z"
            class="cls-28"
          />
          <path
            id="path73"
            d="M283.77878,235.07843q-4.12281-1.47756-8.24571-2.95512c-1.21583-1.8512.72014-2.21047,1.48092-3.126a25.51209,25.51209,0,0,1,5.34161-.05251c3.2929.64483,6.51013,1.67639,10.08367,2.63467.85777,1.80869,1.75306,3.69639,2.64835,5.58411.61473,4.359-1.04472,8.23715-2.58219,12.13723a2.99876,2.99876,0,0,1-2.63974,2.26013c-1.68543-.0884-2.35616-1.292-2.71495-2.66524-1.06082-4.05972-3.27616-7.88962-2.50477-12.3253A1.39029,1.39029,0,0,0,283.77878,235.07843Z"
            class="cls-30"
          />
          <path
            id="path75"
            d="M268.02883,130.898c-2.81415,6.39481-8.237,10.15042-13.93239,14.05144-.68308-.76469-1.21921-1.36491-1.75534-1.96512-2.164-3.29573,1.51139-4.78346,2.21452-7.20062,5.30949-4.24409,8.11494-10.39848,11.97847-15.741a38.94829,38.94829,0,0,0,3.91816-6.88257c.60228-1.342,1.08131-2.3918,2.79136-1.837q.70194,1.30113,1.40369,2.60227a74.51189,74.51189,0,0,0-2.73143,9.74652,7.46541,7.46541,0,0,0-1.52621,4.1808C270.25752,129.39117,269.95208,130.76214,268.02883,130.898Z"
            class="cls-31"
          />
          <path
            id="path77"
            d="M146.7671,286.82045q-3.07731,13.4621-6.15472,26.92426c.49961-3.12258.87533-6.27093,1.51825-9.36374,4.6954-22.58619,9.16359-45.19535,8.30958-68.4531,2.30684-.35887,2.2782,1.42206,2.37794,2.80391a30.7679,30.7679,0,0,1-.6442,10.41636,65.22311,65.22311,0,0,1,2.62355-8.97055c.81229-1.64633,2.24-1.34462,3.06185-2.0998l2.83977-.48257c-1.05734,2.09533-1.97157,3.907-2.8858,5.71863a5.71307,5.71307,0,0,1,.32439,4.69364c-2.38829,8.745-3.78392,17.74521-6.79545,26.33024a66.80041,66.80041,0,0,0-1.74088,8.012C149.20644,284.15841,148.89368,286.0813,146.7671,286.82045Z"
            class="cls-30"
          />
          <path
            id="path79"
            d="M115.82658,434.314q.08962,1.07464.17944,2.14927l.4007.02767,3.97388-20.0905c2.30822,1.18863,1.84465,3.43737,1.74821,5.3025-.32851,6.34751-1.144,12.66471-1.5695,19.004-.74165,11.04628-3.64,21.62241-6.58379,32.19905-.48214,1.73222-.56569,3.80777-2.74149,4.5712a1.76409,1.76409,0,0,1-1.27568-.34625c1.17136-7.11941,2.48739-14.219,3.46823-21.36456.77679-5.65945,1.12332-11.37716,1.70337-17.06469C115.28,437.23075,115.59,435.77613,115.82658,434.314Z"
            class="cls-32"
          />
          <path
            id="path81"
            d="M197.58418,193.1484q1.50544,1.46848,3.01088,2.93688c1.11023.75809,1.42163,1.50929-.0194,2.24541q-12.9556,17.98749-25.91131,35.975l-.687-.45938q6.17673-9.88524,12.35328-19.77052,4.60239-8.70438,9.21154-17.40514C196.17921,195.47336,196.90128,194.3213,197.58418,193.1484Z"
            class="cls-33"
          />
          <path
            id="path83"
            d="M288.30205,129.41673a5.49406,5.49406,0,0,1,.32942-.66294c4.08406-1.44976,6.90479,1.44625,10.13227,2.943,2.43587,2.22448,1.11151,4.52868.14485,6.82533-.69113.194-1.66594.163-2.02738.6185-2.37621,2.994-4.6201,6.093-6.90717,9.15781-3.522-2.15568-2.33238-5.77283-2.76236-8.8875C287.38124,136.05933,286.64536,132.60725,288.30205,129.41673Z"
            class="cls-34"
          />
          <path
            id="path85"
            d="M276.98123,98.65872c-.47848-5.34865-.93335-10.69953-1.44651-16.04483-.21056-2.19286-.54693-4.37365-.82611-6.55992a1.50192,1.50192,0,0,1-.39622-1.04683c1.518-4.0442,2.235-4.41159,4.88344-2.50261a24.68009,24.68009,0,0,1-.43455,21.23747C278.025,95.314,277.56723,97.01639,276.98123,98.65872Z"
            class="cls-35"
          />
          <path
            id="path87"
            d="M289.86954,250.83317q2.60913-6.83473,5.21817-13.66954c.95138,1.73012,1.90284,3.46031,2.9902,5.43771-1.24667,5.63159-2.52527,11.40739-3.80387,17.18321q-2.289-3.42752-4.57818-6.855A1.3691,1.3691,0,0,1,289.86954,250.83317Z"
            class="cls-36"
          />
          <path
            id="path89"
            d="M265.10579,67.30319q-1.87961,3.33591-3.75912,6.67183a82.38564,82.38564,0,0,0-8.295,14.21688q-3.74439,3.75157-7.48887,7.50324-.75327.41229-1.50672.82538,2.23908-4.55165,4.47853-9.105c.37179-3.30288,2.44685-5.8848,3.85539-8.71809,1.93954-3.90143,4.64534-7.37168,7.14654-10.94217.84267-1.20289,1.74427-2.52378,3.583-2.20974C264.151,65.70987,264.38747,66.77766,265.10579,67.30319Z"
            class="cls-37"
          />
          <path
            id="path91"
            d="M273.24361,111.32322c-4.58038,7.05857-9.13962,14.13109-13.758,21.1648-1.02,1.55357-2.2492,2.96988-3.38212,4.4494-3.20232-1.02739-1.58185-2.87939-.71585-4.50659a220.27688,220.27688,0,0,1,12.71583-20.20722,67.28694,67.28694,0,0,0,3.6893-6.0455q1.11055-1.10849,2.22128-2.2169Q273.62894,107.64224,273.24361,111.32322Z"
            class="cls-12"
          />
          <path
            id="path93"
            d="M225.29988,123.39148q-10.34482,9.75158-20.68976,19.50309l-.57977-.54812q2.76959-3.05086,5.53917-6.10087c5.83656-6.41557,11.71924-12.7911,17.49495-19.262,4.28472-4.80044,8.43064-9.72479,12.64-14.59433Q232.50362,112.89,225.29988,123.39148Z"
            class="cls-38"
          />
          <path
            id="path95"
            d="M211.93593,585.53325a9.33632,9.33632,0,0,1-1.44249-2.43835q-5.37912-23.78282-10.639-47.593.39-.40812.77953-.81531c2.4808,9.662,5.16885,19.27708,7.37394,29.0016C209.64245,570.89622,210.64937,578.24645,211.93593,585.53325Z"
            class="cls-39"
          />
          <path
            id="path97"
            d="M277.014,228.99732q-.74037,1.56241-1.48074,3.12546-9.35054,7.81671-18.70035,15.6318C261.59035,239.38416,267.86613,232.64692,277.014,228.99732Z"
            class="cls-40"
          />
          <path
            id="path99"
            d="M157.85935,238.07779c-1.95446,5.07078-3.90882,10.14154-6.28942,16.318-.42129-6.88285-.776-12.67651-1.13018-18.46907q-.0247-.787-.05015-1.57588Q154.12466,236.21467,157.85935,238.07779Z"
            class="cls-40"
          />
          <path
            id="path101"
            d="M270.2459,122.651q2.2008-4.36284,4.4014-8.72559,2.00931,4.71878,4.019,9.43736-2.34682,2.24851-4.69384,4.49706c-1.72149.78717-2.72136.26809-3.23489-1.58018A18.81591,18.81591,0,0,1,270.2459,122.651Z"
            class="cls-41"
          />
          <path
            id="path103"
            d="M109.95835,477.13094q.34987-.03279.70066-.05406c1.4154,4.18586,1.00719,8.442.52926,12.704-1.39975,8.73359-2.84526,17.46431-3.63238,26.28782-.11585,1.29922-.58207,2.34506-2.18926,2.2181.13762-2.28683.38606-4.57491.35934-6.85983a9.66461,9.66461,0,0,0-.94562-2.818Q107.36959,492.87,109.95835,477.13094Z"
            class="cls-42"
          />
          <path
            id="path105"
            d="M240.29391,83.62962q-.7206,2.29395-1.44066,4.588-9.76863,15.34759-19.5378,30.69478-1.21171.76287-2.42525,1.52617Q228.5899,102.03434,240.29391,83.62962Z"
            class="cls-40"
          />
          <path
            id="path107"
            d="M298.76374,131.6968q-5.06646-1.47162-10.13254-2.94317,3.12714-2.51433,6.25382-5.02891Q296.82434,127.71079,298.76374,131.6968Z"
            class="cls-43"
          />
          <path
            id="path109"
            d="M107.01372,605.13262q5.56374.78542,11.12748,1.57087a4.40628,4.40628,0,0,1,3.59139-1.70295c9.10439-.01592,18.21939-.688,27.306.42409a3.1561,3.1561,0,0,1,1.30908.53134q5.21208-.01393,10.42343-.028c-10.29121.515-20.57812,1.1246-30.87336,1.51475C122.18151,607.7352,114.46754,607.61808,107.01372,605.13262Z"
            class="cls-44"
          />
          <path
            id="path111"
            d="M222.26649,164.52553c.62068-.11543,1.41009-.02821,1.83376-.38044,2.13994-1.77941,4.18471-3.67326,6.48515-5.72521.6355,1.35549,1.08626,2.31682,1.5371,3.27828q-4.9458,4.04962-9.89188,8.09872c-.51206.1946-1.02376.38947-1.67409.63717-.19948-.5243-.34964-.91889-.4998-1.31348Q221.16166,166.82305,222.26649,164.52553Z"
            class="cls-45"
          />
          <path
            id="path113"
            d="M279.19583,72.50453q-2.209,1.47234-4.41814,2.94468a8.86928,8.86928,0,0,1-6.12443-6.61668l.11859-.84375c2.44026-.88351,4.19313,1.21965,6.37342,1.46561Q277.17051,70.97946,279.19583,72.50453Z"
            class="cls-19"
          />
          <path
            id="path115"
            d="M256.787,57.46243q1.53248.66312,3.065,1.32628a10.06442,10.06442,0,0,0,2.53542,2.79861c1.27449,1.13754,1.56932,2.44472-.05975,3.63177a7.97035,7.97035,0,0,1-7.87822-2.4446c-.53283-1.66882.23425-3.1966.58417-4.7483C255.22983,57.15543,255.98136,56.97486,256.787,57.46243Z"
            class="cls-46"
          />
          <path
            id="path117"
            d="M262.88121,64.14758q-1.51451-2.6787-3.02919-5.35813,3.28568,2.03076,6.57144,4.063c-.20881,1.34851-1.78041,2.238-1.28848,3.82253a2.65566,2.65566,0,0,1-.02965.62753q-.8337-.4533-1.66823-.908A2.01873,2.01873,0,0,1,262.88121,64.14758Z"
            class="cls-47"
          />
          <path
            id="path119"
            d="M256.787,57.46245l-1.58725,5.159c.41726,2.40781.1045,4.35046-2.91352,4.56992q-.75725.76957-1.51478,1.53931c1.18307-3.39711,2.27775-6.83053,3.63257-10.15813C254.64612,57.97789,255.96516,57.8213,256.787,57.46245Z"
            class="cls-48"
          />
          <path
            id="path121"
            d="M265.135,66.67494c-1.80814-2.02781-.04841-2.854,1.28848-3.82253,1.66924,3.834,5.60505,4.67634,8.72108,6.60191q-3.18561-.73272-6.3726-1.46559c-.74028-.78656-1.48046-1.57314-2.95671-3.14182C265.5559,65.54361,265.34544,66.10927,265.135,66.67494Z"
            class="cls-49"
          />
          <path
            id="path123"
            d="M286.06347,274.08842q2.98592-4.5277,5.97163-9.05541-2.59322,5.3031-5.18642,10.60622Q286.456,274.8638,286.06347,274.08842Z"
            class="cls-13"
          />
          <path
            id="path125"
            d="M150.3477,605.956q-.35742.03684-.71493.0707a5.6574,5.6574,0,0,1-3.40052-2.71889c-7.41694-13.38228-14.92759-26.71292-22.199-40.17556-.23517-.43547-.31862-.94216-.52506-1.3963-.362,1.21177-.33637,2.82956-2.385,2.27147q.01305-7.8636.02618-15.72724c1.99307-1.56063.94762-3.79748,1.18865-5.70926,1.91-15.14885,4.45492-30.19914,6.97644-45.25139,1.75168-10.45773,2.99166-20.99814,5.03012-31.404.57127-2.91623.24981-6.3311,3.28778-8.33279.48315,3.93551,1.08754,7.86054,1.42867,11.8083q2.28163,26.41038,4.42866,52.83218c1.35135,16.74881,2.5626,33.509,3.91889,50.25735C148.31262,583.64517,149.36292,594.79792,150.3477,605.956Z"
            class="cls-50"
          />
          <path
            id="path127"
            d="M137.63233,457.58275q-3.0139,18.79491-6.03037,37.58935c-3.01582,18.66863-6.0505,37.33429-9.16323,56.53174-.556-1.47593-.92292-2.45-1.28958-3.42388q-1.45-22.55073-2.9041-45.10161c-.51791-7.94945-1.0739-15.89642-1.61277-23.84454a2.6564,2.6564,0,0,1,.15473-3.7104c5.99624-6.98894,11.95414-14.01112,18.33012-20.664a5.11717,5.11717,0,0,1,3.24669-1.6633,44.29914,44.29914,0,0,1,19.57678,1.64359,41.58818,41.58818,0,0,1,6.12417,12.71593c4.13063,13.28524,8.68786,26.42974,12.95327,39.6697a118.17048,118.17048,0,0,1,2.7985,11.86254c-.27012.82728-.58636,1.59314-1.70849,1.29861-5.81451-9.55045-11.58289-19.1293-17.45542-28.6439q-10.18726-16.50507-20.56952-32.88908C139.643,458.25825,138.4664,458.02884,137.63233,457.58275Z"
            class="cls-21"
          />
          <path
            id="path129"
            d="M178.10814,520.48648q.38844-.72882.77707-1.45777c1.021-2.97262-.59479-5.67441-1.01809-8.46574-1.254-8.267-1.23157-16.629-2.18313-24.91329-.19664-1.71246-.39091-3.94588,2.32277-4.35424,2.66984,1.855,2.88213,4.858,3.39959,7.63168,3.31322,17.75893,6.99356,35.44469,10.54112,53.15661,2.59362,12.94918,5.05254,25.91642,6.54956,39.04753.11988,1.05125.40976,2.10272-.17321,3.11088q-.08964.72771-.17945,1.45544l-.52917.12846q-2.633-9.573-5.26475-19.14632-5.27756-19.28773-10.54221-38.57853Q179.958,524.29438,178.10814,520.48648Z"
            class="cls-51"
          />
          <path
            id="path131"
            d="M137.63691,454.63291c-6.25731,7.10606-12.53108,14.19772-18.75315,21.33447a30.65532,30.65532,0,0,0-2.25157,3.36643c-1.29334-.12371-2.58667-.24742-3.771-.36075-.56559,11.526-1.11051,22.62984-1.65542,33.7337l-.90791.02355q-.21234-1.33944-.42459-2.67892a2.27625,2.27625,0,0,1-1.11553-2.17145c.25392-6.2689.40948-12.54576,1.19441-18.78132q.35331-6.01075.7067-12.0216c2.49406-10.91237,5.50009-21.74,7.32351-32.763,1.51945-9.18555,1.65149-18.6004,2.39817-27.91358q.76315-6.368,1.52612-12.73615c.96026-2.146,2.61522-1.94,4.35848-1.23313,1.48037.60035,2.88269,1.4789,4.58258,1.03217,1.9863-1.14312,1.87631-3.09285,1.88948-4.92564a35.483,35.483,0,0,1,.78475-8.47173c.29657-1.18094.27452-2.5344,1.84328-2.89286.44856-.72493,1.22791-1.42123,1.2937-2.17932.55672-6.418.95934-12.84925,1.4639-19.27209a19.24475,19.24475,0,0,1,.77633-5.49673c2.69473-6.811,5.62765-13.52794,8.47273-20.27956,2.33411-1.15776,3.12508.79115,4.0825,2.137q6.83585,9.61032,13.46451,19.36575a31.45091,31.45091,0,0,0,5.23666,6.27631,3.01048,3.01048,0,0,1,.07293,2.357c-4.975,11.6158-9.14035,23.53875-13.38711,35.4312-.92118,2.57967-1.82836,5.17659-4.1686,6.90574-2.52527.92315-4.90083-.13711-7.34017-.50568-2.52179-.381-5.02281-1.6922-7.56427-.4427-1.699,1.71932-1.41842,3.81422-1.22324,5.74012,1.05395,10.39745,1.58185,20.83729,2.606,31.23547C139.37413,450.7114,139.69733,452.94926,137.63691,454.63291Z"
            class="cls-52"
          />
          <path
            id="path133"
            d="M121.12316,564.00739c.4083-2.3623.8165-4.7246,1.3573-7.854,2.36724,4.42682,4.3582,8.21776,6.4103,11.97536q10.35321,18.95825,20.74182,37.8976a57.43358,57.43358,0,0,1-5.83482.62449c-8.5517.07633-17.10441.04514-25.65665.05283Q119.63228,585.35539,121.12316,564.00739Z"
            class="cls-53"
          />
          <path
            id="path135"
            d="M109.952,489.09862q-.03925,10.47641-.07869,20.95282c-.2467,3.82592-.42248,7.65816-.758,11.47631-.412,4.68733-.95751,9.36285-1.44542,14.0435-1.38685,2.63245-1.68342,5.6016-2.55354,8.39407-.442,1.4184-.93372,2.40927-2.71916,2.25153a4.70026,4.70026,0,0,1-.01739-3.94q1.4935-11.995,2.98691-23.99,1.87892-12.62933,3.769-25.25676C109.33566,491.70871,109.67643,490.40858,109.952,489.09862Z"
            class="cls-44"
          />
          <path
            id="path137"
            d="M102.37981,542.27687q.10638,1.24449.21266,2.48889l.762.19972q1.72122-4.81278,3.45176-9.622a.34238.34238,0,0,1,.297-.151,3.97455,3.97455,0,0,1,.566.37849c-2.13545,12.75312-4.23622,25.51191-6.42283,38.256-1.02824,5.99285-2.22165,11.95739-3.34,17.935.49468-6.78971.9501-13.58282,1.49355-20.36883q1.05249-13.14046,2.23858-26.27A17.28781,17.28781,0,0,1,102.37981,542.27687Z"
            class="cls-54"
          />
          <path
            id="path139"
            d="M214.07193,410.39672q-.66419.77724-1.32838,1.55441c-8.88175,8.80741-19.32615,15.53461-28.96749,22.32927-2.33859-.01464-2.95671-.94221-3.02369-2.37122.25493-5.76848,2.95525-10.81733,5.01237-15.98971,5.49022-13.80464,10.52775-27.78466,16.18927-41.52138.62159-1.50808,1.10428-3.072,2.66224-3.93367,3.3113-1.16732,6.48643-3.40714,10.20758-1.27635q1.89,9.73689,3.78044,19.47373c-1.08131,5.065-2.17288,10.12794-3.23955,15.19614C214.90719,406.03191,214.50128,408.21681,214.07193,410.39672Z"
            class="cls-55"
          />
          <path
            id="path141"
            d="M205.17407,295.11953l-.12847,3.65984a3.60921,3.60921,0,0,1,1.832,3.14374c-1.11069,3.35914.02571,6.71313.0345,10.07042q.06533,24.77743.016,49.55486a49.13383,49.13383,0,0,1-.72756,5.70221c-.0667,1.2752-.31743,2.432-1.67719,2.98163-2.69693-.05031-3.31972-1.69793-3.08931-4.00077a13.07677,13.07677,0,0,1,.55581-1.30927,11.47685,11.47685,0,0,0,.89-6.64612c-.88311-7.78919-.29949-15.61639-.38587-23.42648-.10048-9.09174.02937-18.18563-.04658-27.278-.0452-5.40263-1.15864-6.51911-6.47032-7.01425-2.851-.26578-5.68009-.73842-8.55445-.79529-1.505-.02975-3.00439-.24138-3.99511-1.6177a4.18218,4.18218,0,0,1-.43209-1.93652,11.87376,11.87376,0,0,1,.299-3.19294,1.77288,1.77288,0,0,1,.08473-.73461c6.73679-11.43044,10.09631-24.33466,15.80678-36.2162,1.50736-3.13635,2.81012-6.38086,4.31108-9.52574.90681-1.9,2.14771-3.25692,4.2472-1.162,1.18207,4.30385.78731,8.68347.44307,13.0122a82.868,82.868,0,0,0-.48726,9.33253C208.00881,276.96326,205.94116,285.98036,205.17407,295.11953Z"
            class="cls-54"
          />
          <path
            id="path143"
            d="M205.17187,367.66687q-.01908-32.96754-.03825-65.93512c2.487-.87308,3.084,1.10981,3.65518,2.65489,4.535,12.26616,10.794,23.9443,12.75224,37.09462q-.68534,2.68092-1.37075,5.36185c-3.1777,5.58582-5.53825,11.59614-8.88633,17.09364-1.26726,2.08086-2.04963,4.56339-4.32591,5.54064C205.37785,369.5223,205.57989,368.34634,205.17187,367.66687Z"
            class="cls-56"
          />
          <path
            id="path145"
            d="M221.541,341.48126c-4.54726-11.52082-9.06761-23.05242-13.66949-34.5514a54.25321,54.25321,0,0,0-2.73811-5.19806q-.04365-1.47633-.08784-2.9525c5.34371-2.25109,10.68743-4.50224,16.49544-6.949Z"
            class="cls-57"
          />
          <path
            id="path147"
            d="M256.04651,184.84893q-9.56933,8.01608-19.13134,16.04076c-2.17882,1.83935-4.27347,3.77838-6.40709,5.67166q-2.22152,1.50942-4.4423,3.01927c-2.56818-.67614-1.74555-2.05746-.66854-3.41078,6.40719-8.05154,12.6924-16.20457,18.52722-24.67316,3.039-4.41094,7.14719-8.28468,8.08054-13.943,3.84075-4.91037,7.70418-9.80572,11.66791-14.61856,1.21958-1.48076,2.26-3.4242,4.71864-3.13416,1.95638.98528,1.62394,2.54016,1.002,4.13932-3.10257,7.97851-6.4706,15.85112-9.56264,23.83274C258.85,180.30512,256.15577,181.88162,256.04651,184.84893Z"
            class="cls-58"
          />
          <path
            id="path149"
            d="M238.91566,381.15882c-.39906.61722-.65554,1.54311-1.21958,1.80329-5.0401,2.32521-10.13428,4.533-16.10664,7.17013,0-2.60075,0-4.27736.00019-5.95388q1.149-18.343,2.2976-36.6861c1.73914-1.146,2.68842-.07011,3.548,1.25179-.03093,7.00567,4.93679,12.159,6.90552,18.44009.83727,2.67133,2.21,5.175,2.49077,8.02409-.71539-3.48457-.60778-7.04167-.94507-10.566.1465-.54712.44719-1.03085.62187-1.56827.64109-1.70537.42221-3.98709,2.95681-4.42339Q239.19035,369.90473,238.91566,381.15882Z"
            class="cls-59"
          />
          <path
            id="path151"
            d="M226.07072,349.69559q-1.09215-1.102-2.18395-2.20369,1.84365-15.75163,3.68647-31.504.59171-2.063,1.18334-4.126l.71109-.08726q.50909,2.2131,1.01808,4.42618c.11054,5.436,2.01412,10.50959,3.3112,15.68723,2.54558,10.16173,4.76065,20.345,4.62687,30.896a2.3503,2.3503,0,0,1-.32814,1.05211q-.39351.42883-.78694.8577c-1.23541.77259-2.155.10926-2.859-.78507C231.01941,359.55118,227.81838,355.04853,226.07072,349.69559Z"
            class="cls-60"
          />
          <path
            id="path153"
            d="M205.17407,295.11953c.42166-12.54617.87177-25.09147,1.2495-37.639.12729-4.2288.071-8.46313.09864-12.69492-.854-1.2556-.54354-2.17609.80607-2.79828,1.95071-.03359,3.87771-.6615,5.84215-.2667,1.687.33907,3.147.89495,2.44648,3.12162Q210.39549,269.9809,205.17407,295.11953Z"
            class="cls-61"
          />
          <path
            id="path155"
            d="M253.88607,168.39982a51.47683,51.47683,0,0,1-3.4006,6.32831c-7.89881,10.88248-15.93168,21.66766-23.86489,32.52552a6.46857,6.46857,0,0,0-.5548,2.327q-1.81111,3.07737-3.62232,6.1548a3.45925,3.45925,0,0,0-1.00308.25361c-4.55787,3.97-8.176,8.82171-12.35319,13.14879a33.42408,33.42408,0,0,1-3.33563,3.45212c-1.33671,1.03638-2.67625,1.33259-3.72984-.44049-.60046-1.89673.79408-3.09368,1.73192-4.3025,2.28369-2.94374,4.51239-5.93531,6.91238-8.79262,6.443-6.26983,11.59278-13.58538,17.0259-20.69261,7.12248-9.317,14.22465-18.66005,21.77464-27.63984C250.49984,169.493,251.38972,167.18636,253.88607,168.39982Z"
            class="cls-60"
          />
          <path
            id="path157"
            d="M222.25734,214.7229q.09223.50543.1853,1.01169-3.41236,14.55461-6.826,29.10756c-1.379-.50912-2.73371-1.1048-4.14436-1.50287-1.36306-.38462-2.78358-.56557-4.17885-.836a2.73673,2.73673,0,0,1-.346-3.12445c4.036-8.3981,8.00578-16.8347,14.04987-24.062A1.36263,1.36263,0,0,1,222.25734,214.7229Z"
            class="cls-62"
          />
          <path
            id="path159"
            d="M205.172,367.66687c.85822-.44637,2.101-.66831,2.51364-1.37477,3.31377-5.6749,6.47316-11.43991,9.6741-17.18049.65362-1.17221,1.28318-2.35786,2.19924-4.04449.32511.94537.46777,1.36022.61088,1.77549q-2.67267,11.17319-5.346,22.34546l-9.75106,2.243c-.68555-.28689-1.16678-.67014-.707-1.49738Q204.76878,368.80026,205.172,367.66687Z"
            class="cls-63"
          />
          <path
            id="path161"
            d="M289.86954,250.83317q-.08674,1.04843-.1735,2.09663-2.96421,5.28876-5.928,10.578c-2.17572,5.32707-4.34393,10.65813-8.07221,15.15911a.93.93,0,0,1-.92841-.33294c-1.69431-6.73271-3.29538-13.49086-5.12649-20.1862-.78712-2.87841-.63339-5.09672,1.65387-7.39718,3.92721-3.94973,7.52739-8.23108,11.14861-12.47238a11.37636,11.37636,0,0,0,1.33552-3.19992,55.34933,55.34933,0,0,1,2.70608,5.47489C287.73646,243.93428,288.75409,247.40179,289.86954,250.83317Z"
            class="cls-64"
          />
          <path
            id="path163"
            d="M250.00489,301.79576q-.33684-2.25921-.67348-4.51818,12.71843-9.47013,25.43613-18.94217c.02955.12586.05563.2539.07814.38268,1.43462,1.05964.70423,2.28661.23746,3.46141-2.30117,5.79116-4.57736,11.593-7.13356,17.279q-1.01859,3.06-2.03708,6.11993-1.20979,2.56458-2.41967,5.12909c-1.70081,1.16311-2.78276-.04374-3.87405-1.05175-2.00955-1.85623-3.87451-3.86233-5.85889-5.74433C252.69633,302.90277,251.73488,301.6493,250.00489,301.79576Z"
            class="cls-65"
          />
          <path
            id="path165"
            d="M250.00489,301.79576c.13972-.92872.27936-1.85742.51526-3.426,4.61424,4.38841,8.79346,8.36313,12.97268,12.33783q-4.865,14.58126-9.73,29.16251c-.7454-5.14746-1.51615-10.29134-2.22788-15.44337-.52679-3.81376-.97718-7.638-1.4617-11.45766q-.42647-.205-.30389-.44485c.08382-.16549.17011-.2485.25988-.2485Q250.017,307.03573,250.00489,301.79576Z"
            class="cls-66"
          />
          <path
            id="path167"
            d="M238.09577,363.83618c-2.57889-14.19561-5.19035-28.38546-7.69219-42.59456a25.94457,25.94457,0,0,1,.08245-5.042q4.06186,13.48608,8.12245,26.97032c.356,1.18341.685,2.37488,1.02659,3.56259q-.08483,5.959-.16983,11.91806Q238.78033,361.24335,238.09577,363.83618Z"
            class="cls-67"
          />
          <path
            id="path169"
            d="M211.93383,220.15707q-4.65921,5.97727-9.31833,11.95453c-.72317,4.27954-3.341,6.97352-6.51837,6.70774,1.6987-12.17332,3.43126-24.34214,5.04577-36.52662.16865-1.27317-.36135-2.63888-.56724-3.96185q.00948-1.12287.01931-2.24545c3.81018-2.68534,7.793-5.15873,11.39742-8.09616,10.11223-8.24122,20.06258-16.68068,30.08806-25.02845,5.736-4.77607,11.501-9.51718,17.222-14.311.31066-.26032.33473-.86248.4923-1.306q2.59692-1.49531,5.19337-2.98947c1.56593,1.78634-.00768,3.1089-.86326,4.273-9.67291,13.16214-18.80411,26.71652-28.71933,39.70141-7.34264,9.6157-14.48342,19.38528-22.01539,28.8573A5.09932,5.09932,0,0,0,211.93383,220.15707Z"
            class="cls-3"
          />
          <path
            id="path171"
            d="M184.06018,295.73975q-.01592.75076-.03175,1.50156a2.15921,2.15921,0,0,1-.97462,1.45791,7.80559,7.80559,0,0,1-5.08613-.39592c-8.83783-2.84525-17.72883-5.52371-26.51762-8.525a6.85087,6.85087,0,0,1-4.04316-2.98158c-.21412.00311-.42815.01072-.6409.02325q4.8533-20.03071,9.72544-40.0571a28.38,28.38,0,0,1,1.32234-3.4492q3.74892,2.6321,7.49866,5.264c2.28909.15517,2.598,2.11917,3.19581,3.67539,3.57447,9.30593,6.79124,18.74567,10.35472,28.05444Q181.78024,287.928,184.06018,295.73975Z"
            class="cls-20"
          />
          <path
            id="path173"
            d="M184.06018,295.73977c-.79069-.75719-1.9712-1.36985-2.3137-2.29312-5.54063-14.93322-10.97485-29.90585-16.43358-44.86927a9.86838,9.86838,0,0,1,2.471-1.51213c8.042-2.05345,16.09144-4.087,24.18928-5.90108.971-.21751,2.24288.90718,3.37526,1.40975,1.86514,1.06194,1.40917,2.7595,1.055,4.30691-3.19005,13.93836-5.23089,28.15995-10.14956,41.671-.59442,1.63282-.8122,3.34355-1.42995,4.95128Z"
            class="cls-68"
          />
          <path
            id="path175"
            d="M184.82389,293.50315c1.46088-7.46025,2.85477-14.93438,4.39956-22.37725,1.97816-9.53058,4.07765-19.036,6.12489-28.55216q.37444-1.87713.74861-3.75449,3.26-3.354,6.51919-6.708a23.14387,23.14387,0,0,0,3.48854-2.45411c4.64361-4.7117,9.16359-9.54529,13.81232-14.25189.4988-.505,1.54726-.46765,2.34052-.68212q-7.48191,13.89009-14.96383,27.7804-.38554,1.14077-.771,2.28211-5.2059,11.76353-10.4152,23.52524Q190.49117,280.91838,184.82389,293.50315Z"
            class="cls-69"
          />
          <path
            id="path177"
            d="M271.7928,106.17813c-3.04538,5.80093-6.02845,11.63573-9.15884,17.39046-1.95519,3.59437-4.1881,7.03739-6.16506,10.62065a7.84048,7.84048,0,0,0-.36538,2.7482q-1.88126,3.02338-3.76242,6.04684-2.6547,3.29429-5.30931,6.58842c-2.98251,1.89106-6.018,3.69865-8.94663,5.67454-1.45091.979-2.83794,1.4468-3.94753-.46356,5.41252-7.11674,10.77015-14.276,16.25112-21.33968C257.47188,124.31544,264.65357,115.26324,271.7928,106.17813Z"
            class="cls-70"
          />
          <path
            id="path179"
            d="M268.65326,68.83252l6.12443,6.61669a1.92271,1.92271,0,0,0-.0689.60507c-2.5895,4.35993-5.15046,8.73748-7.78617,13.06954-.76471,1.2568-1.74372,2.38331-2.62455,3.56956q-5.23034,3.399-10.46058,6.79867a22.03071,22.03071,0,0,1,1.135-3.80088C259.48866,86.71612,264.08313,77.78043,268.65326,68.83252Z"
            class="cls-71"
          />
          <path
            id="path181"
            d="M234.13763,154.78366c3.58517-1.66637,7.15679-3.3631,10.7685-4.96992a7.13865,7.13865,0,0,1,2.12566-.241q-7.04859,5.721-14.09727,11.44206.26024-2.73426.52011-5.46892Q233.79558,155.16441,234.13763,154.78366Z"
            class="cls-12"
          />
          <path
            id="path183"
            d="M198.32382,584.24214q-2.57441-12.96711-5.14863-25.93426-7.60284-38.29914-15.20586-76.59832c-1.25069-.8807-2.058-1.92851-1.34851-3.54983,1.8387-1.879,3.04895-.61407,4.158.8818,2.33906,3.15473,4.85041,6.19193,6.54838,9.78415.38771.81992.35815,2.53042,2.101,1.412.29931-4.85311-.93875-9.61809-.39686-14.42391.19939-1.76858-.31761-3.84793,1.883-4.85362.20525,4.94911.38927,9.89922.62151,14.847.26179,5.578.56714,11.15407.85383,16.73079.84011,9.9112,1.63044,19.827,2.53112,29.73283,1.35153,14.86356,2.80573,29.71779,4.15854,44.58121.33775,3.71008.45451,7.44029.67247,11.16121Q199.03742,586.12773,198.32382,584.24214Z"
            class="cls-72"
          />
          <path
            id="path185"
            d="M181.777,432.0735c.80259-.07669,1.81153.13332,2.37685-.27312,8.17332-5.876,16.26777-11.86153,24.43561-17.74521a29.05332,29.05332,0,0,1,4.15277-2.104q-7.7523,14.23766-15.492,28.48374c-.7638,1.41282-1.32225,2.93654-1.976,4.4089q-2.21644,3.38649-4.43224,6.77326c-2.75027.66561-3.74118-1.54065-4.67819-3.23422-1.72094-3.11092-3.88632-6.01842-4.97559-9.43836-.41059-1.28906-1.61177-1.82365-2.12539-2.93906a3.406,3.406,0,0,1,.05124-2.49346C179.77884,432.62135,180.47566,431.7862,181.777,432.0735Z"
            class="cls-73"
          />
          <path
            id="path187"
            d="M190.91428,470.96014l-.112,21.88378c-2.30556.11635-2.44913-1.96121-3.12124-3.29345-4.29214-8.50767-6.80569-17.67158-9.36-26.78212-.65353-2.33056-2.83813-4.05473-2.41235-6.71069a12.87627,12.87627,0,0,1,.45057-1.23271,2.47362,2.47362,0,0,1,.86033-.99211c4.10583-1.84871,8.27041-3.21593,12.87669-1.74389.96464,3.38629-.265,6.7878.72389,10.01018Q190.8673,466.52965,190.91428,470.96014Z"
            class="cls-74"
          />
          <path
            id="path189"
            d="M190.82021,462.09913c-.365-2.79719-.72993-5.59442-1.19377-9.14942-4.04791.53976-8.13389,1.08459-12.21987,1.62937a2.68863,2.68863,0,0,1-1.53152-2.27014c1.24063-4.57025,2.5411-9.1174,2.30694-13.94925a2.36807,2.36807,0,0,1,2.18157-2.47124q3.00114,4.52013,6.0031,9.03961,2.23031,3.34931,4.47533,6.68892Q190.8313,456.8581,190.82021,462.09913Z"
            class="cls-56"
          />
          <path
            id="path191"
            d="M250.02923,312.27571q.022.34671.044.69342c-5.86914-.07034-6.76177-.72955-9.03814-6.67435Q245.53221,309.28533,250.02923,312.27571Z"
            class="cls-75"
          />
          <path
            id="path193"
            d="M147.4069,286.79676q17.95372,5.6142,35.90752,11.22846a7.84963,7.84963,0,0,1,1.98419,2.20088,4.49151,4.49151,0,0,1,.27,2.56778c-2.16264,12.69467-.96813,25.55316-1.8872,38.30751a26.837,26.837,0,0,1-.44527,4.07348,18.75579,18.75579,0,0,1-.43108,2.53486c-3.93335,5.31187-6.20835,11.5895-9.86974,17.06277-.92823,1.38757-1.60674,3.20385-3.8412,2.91326-1.32408-.86781-3.04748-1.44982-3.90681-2.65006-5.25724-7.343-10.30777-14.83361-15.45759-22.25386-.69837-1.00615-1.56794-1.89362-2.358-2.83629Q147.38947,313.371,147.4069,286.79676Z"
            class="cls-71"
          />
          <path
            id="path195"
            d="M135.3652,387.17307c-.50712,6.49053-1.01424,12.9811-1.5436,19.75637-4.45291-1.22028-8.18431-2.2428-11.91533-3.26527q6.02382-31.22871,12.07144-62.45284a35.331,35.331,0,0,1,1.38328-4.25065c.46677,9.17653,1.25975,18.35173,1.29892,27.5301C136.69212,372.04956,135.83069,379.61218,135.3652,387.17307Z"
            class="cls-20"
          />
          <path
            id="path197"
            d="M256.04651,184.84893a15.08136,15.08136,0,0,1,.4686-3.818c3.71968-9.384,7.564-18.71857,11.31753-28.08926a9.5605,9.5605,0,0,0,.29337-2.48919c-.79308-1.989.2401-2.92252,1.98428-3.44682,4.09358.30466,8.19291-.03034,12.29252-.02979,2.75028.00036,4.42116-1.32028,4.79277-4.17566.18456-1.41878.02214-3.10319,1.89086-3.69864q.44348,4.59819.88741,9.19665-10.3344,11.21668-20.67521,22.42753C264.91033,175.46042,260.46575,180.143,256.04651,184.84893Z"
            class="cls-54"
          />
          <path
            id="path199"
            d="M270.30026,148.15049q-1.08722,1.15088-2.17435,2.30188-7.11982,8.97388-14.23984,17.94748-19.05465,23.58606-38.11287,47.16927c-1.25362,1.5505-2.55839,3.05958-3.83928,4.588.42531-1.31932.55067-2.85355,1.32005-3.92647q25.80334-35.98379,51.7346-71.876,1.109-1.11614,2.21808-2.23173,8.29393-5.23574,16.59308-10.46557c1.24365-.78093,2.5314-1.49161,3.79883-2.23463.50594,2.87562-1.48778,4.67923-3.06542,6.48888-3.10788,3.56492-6.64025,6.73918-9.95914,10.11129C273.3417,147.275,271.62946,147.263,270.30026,148.15049Z"
            class="cls-76"
          />
          <path
            id="path201"
            d="M270.2459,122.651q1.86356,2.60481,3.72682,5.20917c-1.63336,1.48649-3.26636,2.97335-5.187,4.72206-.32393-.72067-.54043-1.20237-.75693-1.68415Q269.13731,126.77449,270.2459,122.651Z"
            class="cls-63"
          />
          <path
            id="path203"
            d="M267.94958,299.4585q3.44792-10.37132,6.89592-20.74153,4.46155-7.60329,8.92266-15.209c-1.96306,5.058-3.72956,10.20376-5.93612,15.15349C274.708,285.66957,271.25941,292.53315,267.94958,299.4585Z"
            class="cls-77"
          />
          <path
            id="path205"
            d="M270.30026,148.15049q8.64846-9.364,17.29766-18.72795.35276-.00093.70413-.00581.39188,4.84269.784,9.6851c.00028,2.9407.00028,5.88164.00028,9.34117C282.46376,149.08328,276.39056,149.29231,270.30026,148.15049Z"
            class="cls-78"
          />
          <path
            id="path207"
            d="M252.2862,67.19136q1.4574-2.28422,2.91407-4.5692,3.83924.76246,7.68039,1.52592.27932,1.12293.55708,2.24664c-2.77077,3.73911-5.59746,7.43832-8.29393,11.23008-2.2814,3.20817-4.41173,6.5236-6.609,9.79115.534-2.70063,1.09761-5.39546,1.59567-8.10232C250.87318,75.27732,251.5699,71.23254,252.2862,67.19136Z"
            class="cls-53"
          />
          <path
            id="path209"
            d="M253.05164,88.19189c.56138-1.69962.81915-3.59071,1.74656-5.0594,2.00021-3.16755,4.3442-6.11813,6.548-9.15747Q257.19939,81.08346,253.05164,88.19189Z"
            class="cls-65"
          />
          <path
            id="path211"
            d="M137.63691,454.63291q-1.39715-17.25735-2.7856-34.51538c-.29044-3.68054-.47867-7.36908-.77908-12.08124,6.51928,1.09675,12.523,2.10674,18.52667,3.11673,7.53691-1.81015,14.66681.44769,21.85069,2.18065a2.53485,2.53485,0,0,1,.89492.94431,2.70266,2.70266,0,0,1,.42714,1.82753c-4.0135,9.70879-7.62731,19.584-11.64924,29.29946-1.4768,3.56767-2.94573,7.07748-5.37006,10.11413a1.91128,1.91128,0,0,1-.94681.61Z"
            class="cls-26"
          />
          <path
            id="path213"
            d="M157.80554,456.1291q.0501-.398.10029-.796c1.119-.97633,2.27967-1.802,3.87021-1.08093,2.4624,7.40027,8.95222,11.84727,13.17463,17.95752.79985,1.15739,1.96562,1.86389,2.74058,2.98117.50593.95991.02873,1.80732-.30051,2.67155q.28949,1.92309.57877,3.84664c.16,4.92062.184,9.84983.513,14.75865.48141,7.182,1.19963,14.348,1.72615,21.52746.02279.31063-.86216.6878-1.3238,1.03378Q168.34551,487.57878,157.80554,456.1291Z"
            class="cls-79"
          />
          <path
            id="path215"
            d="M174.29549,414.21706Q163.44734,412.685,152.599,411.153q7.88173-20.96757,15.76367-41.93523c1.87924,1.05312,2.16,2.98278,2.42626,4.793q2.59608,17.65551,4.57964,35.39183C175.551,411.0359,176.0232,412.92393,174.29549,414.21706Z"
            class="cls-20"
          />
          <path
            id="path217"
            d="M174.29549,414.217q-1.65149-12.35113-3.29985-24.70264c-.89282-6.76384-1.75654-13.53142-2.63315-20.297q.36606-.76545.73167-1.53163,5.99844-10.11556,11.99678-20.23109c2.49854,1.46386,1.88125,3.95755,1.66438,6.0336-.82583,7.90545-1.51441,15.82667-2.456,23.71863-.91817,7.69608-1.23816,15.45691-3.1605,23.049-.82428,3.25516.026,6.79361.165,10.204-.70248,1.65653-.11831,4.1645-2.92313,4.43543Q174.33415,414.55666,174.29549,414.217Z"
            class="cls-80"
          />
          <path
            id="path219"
            d="M174.38059,414.89535l.72692-4.48885c2.37575-9.40172,3.62854-19.0479,6.53465-28.34745,3.0398-9.72768,5.56992-19.61291,8.36037-29.41851.614-2.15755,1.40094-4.28336,3.4878-5.55691a2.35286,2.35286,0,0,1,3.162,1.68095c1.81473,5.1041,4.38648,9.88322,6.28906,14.94456a2.74366,2.74366,0,0,1-.124,2.51587q.77385,1.85429,1.54808,3.70862.354.74878.70734,1.49742-11.64769,30.32145-23.29546,60.64273-.71854.79872-1.43636,1.598c-2.41674-.1361-2.12987-2.21787-2.79209-3.71127-1.22507-2.76311-.161-6.49634-3.52826-8.34834-.94863-1.82346-.26033-3.5624.27443-5.30976Q174.338,415.5989,174.38059,414.89535Z"
            class="cls-47"
          />
          <path
            id="path221"
            d="M183.38524,300.24416q-.03527-1.10958-.07064-2.21906.35728-.39185.71447-.78383,7.39916.75407,14.8,1.50362c1.57251.15634,3.15033.26075,5.01384.41236a42.78761,42.78761,0,0,1,.45112,4.27469q.0516,29.2011.00713,58.4021a25.86073,25.86073,0,0,1-.7421,4.35287,140.93239,140.93239,0,0,1-8.43394-22.90671c-2.56735-9.01994-4.95143-18.09252-7.68459-27.05858-.64411-2.68315-.93473-5.52-3.13771-7.56916C183.61318,305.89049,184.00794,303.0121,183.38524,300.24416Z"
            class="cls-65"
          />
          <path
            id="path223"
            d="M188.53936,315.31636l15.01983,50.87055q-.37018.02991-.74165.03787-4.43384-9.47243-8.86739-18.94527a4.3767,4.3767,0,0,1-2.59042-3.4237c-1.47872-7.327-3.188-14.60511-4.73045-21.91922a13.25389,13.25389,0,0,1-.57136-4.79439C186.60924,316.15755,187.08617,315.07164,188.53936,315.31636Z"
            class="cls-81"
          />
          <path
            id="path225"
            d="M226.07072,349.69559q5.61906,7.49912,11.238,14.99825l1.11535,14.761-1.00783.23915q-2.47518-5.97585-4.95153-11.95117c-1.95885-4.71134-3.98916-9.39455-5.845-14.146A16.745,16.745,0,0,1,226.07072,349.69559Z"
            class="cls-82"
          />
          <path
            id="path227"
            d="M177.39084,477.86241q-.43292-1.16066-.86583-2.32141c-2.72676-5.35431-1.98712-10.96048-1.12725-16.54941a3.23166,3.23166,0,0,1,2.0101-2.9085c3.67942,10.72673,7.32974,21.46357,11.06946,32.16922a37.4967,37.4967,0,0,0,2.32533,4.59143c-.05234.58342-.10432,1.16672-.222,2.48733C185.90721,489.14161,181.649,483.502,177.39084,477.86241Z"
            class="cls-83"
          />
          <path
            id="path229"
            d="M175.07841,421.63082q.05394-1.09233.10779-2.18462l.8133-.2267q2.17087,7.22568,4.34155,14.45186.011,1.1088.02233,2.217-1.49913,8.24419-2.99881,16.48812c-2.22549-.74688-2.451-2.68363-2.50486-4.54729-.20112-6.96387-.90032-13.88869-1.43361-20.82764C173.278,425.07432,172.9694,422.93685,175.07841,421.63082Z"
            class="cls-84"
          />
          <path
            id="path231"
            d="M175.07841,421.63082q1.14294,15.37268,2.286,30.74553.021,1.10159.04191,2.20287-.09361.39952-.18777.79934c-4.77583,2.58086-11.84707,2.57546-14.86619-.01134q-2.22371-.01689-4.44687-.03389,8.1955-19.51494,16.39-39.03015Q174.68654,418.96621,175.07841,421.63082Z"
            class="cls-33"
          />
          <path
            id="path233"
            d="M162.35234,455.36726q7.43388.00549,14.86692.01116.09815.3513.18823.70481-.44032,9.7292-.88193,19.45823c-5.63223-5.96679-11.264-11.93316-17.17056-18.19071C160.7973,456.39632,161.57482,455.88177,162.35234,455.36726Z"
            class="cls-25"
          />
          <path
            id="path235"
            d="M193.13593,343.62078q.40642,1.83021.81358,3.65955c-5.0822,17.66623-10.13191,35.34289-15.276,52.99211-1.00051,3.43284-2.36787,6.75876-3.566,10.134,1.11746-11.22848,2.2707-22.45358,3.34131-33.68659.92923-9.7504,1.76495-19.50977,2.64212-29.26516q.36249-.75687.7249-1.5137a3.67853,3.67853,0,0,1,3.59606-1.56946C188.09309,344.95823,190.59557,344.20568,193.13593,343.62078Z"
            class="cls-85"
          />
          <path
            id="path237"
            d="M193.136,343.62078c-.26519.90362-.53018,1.80723-.91277,3.11143-3.61491-.27473-7.01093-.5328-10.40715-.791q.784-22.84873,1.56886-45.6971,1.04206,4.15425,2.08357,8.30835c2.0036,2.71191,1.81391,5.96591,2.24288,9.067Q190.42377,330.62009,193.136,343.62078Z"
            class="cls-25"
          />
          <path
            id="path239"
            d="M187.71142,317.61944q-1.12071-4.53375-2.24224-9.06723c.1163-.33153.23325-.66328.71282-2.02387.94232,3.512,1.65,6.14956,2.35754,8.78752Z"
            class="cls-86"
          />
        </g>
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="265.79239"
          cx="269.18317"
          id="p46"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p47"
          cx="247.70995"
          cy="302.95755"
          r="16"
          fill="#ff0000"
        />
        <circle
          class="pa"
          @click="falert"
          id="p48"
          cx="221.28139"
          cy="394.63168"
          r="16"
          fill="#ff0000"
        />
        <circle
          fill="#ff0000"
          r="16"
          @click="falert"
          cy="492.91293"
          cx="153.55817"
          id="p49"
          class="pa"
        />
      </svg>
    </div>
    <div class="flex-1 z-20" v-if="face==2" id="back-hand">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        inkscape:version="1.0beta2 (2b71d25, 2019-12-03)"
        sodipodi:docname="back-side.svg"
        id="back-hand-svg"
        version="1.1"
        :style="trans"
        viewBox="0 50 384 555"
      >
        <metadata id="metadata321">
          <rdf:RDF>
            <cc:Work rdf:about>
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <sodipodi:namedview
          inkscape:current-layer="svg317"
          inkscape:window-maximized="0"
          inkscape:window-y="0"
          inkscape:window-x="0"
          inkscape:cy="277.5"
          inkscape:cx="192"
          inkscape:zoom="1.2108108"
          showgrid="false"
          id="namedview319"
          inkscape:window-height="1050"
          inkscape:window-width="1680"
          inkscape:pageshadow="2"
          inkscape:pageopacity="0"
          guidetolerance="10"
          gridtolerance="10"
          objecttolerance="10"
          borderopacity="1"
          inkscape:document-rotation="0"
          borderColor="#666666"
          pagecolor="#ffffff"
        />
        <defs id="defs11">
          <mask
            maskUnits="userSpaceOnUse"
            height="359.04"
            width="781.92"
            y="-1874.575"
            x="-1569.98814"
            id="mask"
          />
        </defs>
        <filter id="f1" x="-40%" y="-40%" height="180%" width="180%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>

        <g data-name="Layer 3" id="Layer_3">
          <polygon
            id="polygon13"
            points="206.824 54.584 212.516 50.331 213.653 69.542 203.304 71.783 206.824 54.584"
            class="cls-2"
          />
          <polygon
            id="polygon15"
            points="266.874 92.152 273.828 89.278 278.818 100.873 267.768 119.587 266.874 92.152"
            class="cls-2"
          />
          <path
            id="path17"
            d="M167.37931,608.93517q-6.04049-1.44151-12.081-2.88307c-8.58617-2.7541-17.93784-2.79-26.33734-6.73237,1.22351-9.36916,1.62026-18.187,2.33435-26.97932.68488-8.43281,1.26545-16.87293,1.90351-25.30848.92892-12.28078,1.77839-24.56741,2.75686-36.84489.3953-4.96008.5284-9.93947,1.03029-14.89576.20245-1.9994.28171-3.98768,1.72279-5.57914,1.505-1.38981,3.269-.89707,4.97577-.6185,4.31258.70389,8.63111,1.37133,12.96183,1.94571,4.19317.55612,4.71279.22542,5.969-3.66088.36455-1.12784.70721-2.13587,2.01072-2.42056,1.55755,1.05316,1.55755,1.05316,3.11457,4.20506,1.55771.872,2.83471-.14173,4.15884-.72287,12.50767-5.48969,24.90293-11.22931,37.3705-16.80831a19.00629,19.00629,0,0,1,3.47641-1.32866c2.3235-.526,3.69763.17882,3.07473,2.89834-4.70084,8.57481-11.09515,15.93991-16.98085,23.65707-4.53824,5.95037-9.007,11.95876-13.67081,17.809a20.32175,20.32175,0,0,0-4.82653,13.7143c.43133,22.18608,1.63373,44.35195,1.68127,66.54859.00768,3.59337.85417,7.18144.61127,10.814-.09859,1.47438.07229,3.0131-1.01428,4.42244-2.60808,1.79131-5.15469-.40525-7.77693-.40727C171.66635,609.75793,169.6687,608.191,167.37931,608.93517Z"
            class="cls-3"
          />
          <path
            id="path19"
            d="M167.37931,608.93517c2.5515.20384,5.10685.36935,7.6531.62546,1.579.15888,3.14423.45519,5.57316.81773,0-3.96894.06565-7.49028-.02226-11.00777-.06215-2.48693-.44156-4.96649-.49159-7.45309-.29611-14.71657-.50206-29.435-.8116-44.15127-.15988-7.60195-.24677-15.21717-.8014-22.79457-.31162-4.25743,1.93755-7.11324,4.16245-10.06432q15.09162-20.01786,30.334-39.92206a28.25183,28.25183,0,0,1,2.3164-2.40917c2.764.30774,2.03615,2.36106,1.83944,3.952-.65962,5.33451-2.0165,10.54-3.15016,15.78428-3.877,17.93565-7.6094,35.90162-11.35374,53.865a55.69778,55.69778,0,0,1-2.606,9.26873,4.88992,4.88992,0,0,0,.25949,4.54418,43.62987,43.62987,0,0,0,7.17672-6.18388c3.95414-3.95782,8.46548-7.29339,12.32-11.34876.94371-.99289,1.99366-1.93162,3.761-1.37961,2.23963,1.72129,2.66565,4.121,2.00236,6.87492-1.8,10.9506-2.54368,22.0154-3.78646,33.02088-.88161,7.80685-1.501,15.63866-3.12646,23.34645-.50519,1.63325-.46033,3.49252-1.82177,4.72181-1.46273.69973-3.063-.14292-4.43855.63561C197.34878,610.80259,182.31383,612.90845,167.37931,608.93517Z"
            class="cls-4"
          />
          <path
            id="path21"
            d="M139.59031,489.8262c-.75,8.6779-1.54855,17.352-2.23829,26.0346q-1.47812,18.60727-2.82562,37.22489c-.83423,11.29558-1.60355,22.596-2.44378,33.89116-.30382,4.08409-.73041,8.15913-1.17838,13.09027,5.42,1.17358,11.09556,2.3312,16.73221,3.6546,2.59325.60886,5.11021,1.54234,7.66183,2.32951-10.69885-2.27014-21.98816-2.51862-31.42344-9.11831-1.30672-.914-2.51181-1.9732-3.76394-2.96521a8.49124,8.49124,0,0,1-.91093-3.97964c.07449-8.3611-1.12478-16.68345-.91835-25.03476.39175-15.84785-.93025-31.6592-.79385-47.498.03912-4.54185.31255-9.05964.69-13.59.25156-3.01913.48318-6.22243-1.30277-9.10327-1.02748-1.6573-.66634-3.628-.5657-5.492a116.09792,116.09792,0,0,0,.64958-11.65413c2.4135-10.81193.347-21.72074.49183-32.65455,2.56723-.71629,3.34384.97006,4.02,2.51217,3.72882,8.50383,8.139,16.70847,11.2333,25.49073a20.59523,20.59523,0,0,0,6.07456,9.29841,11.10088,11.10088,0,0,1,.97485,6.98779Q139.67217,489.53808,139.59031,489.8262Z"
            class="cls-5"
          />
          <path
            id="path23"
            d="M137.34935,483.83024a16.33548,16.33548,0,0,1-2.33086-2.93914c-5.47242-11.5477-10.865-23.13318-16.43819-35.047v31.25546c-2.1916-.21211-1.37425-1.90738-1.428-3.06935-.066-1.426.7046-2.84913.0656-4.29716-.037-5.91579.09514-11.839-.16659-17.74485-.1956-4.41334-.89945-8.80422-1.377-13.20506-.73652-5.30378-2.62257-10.29514-4.18145-15.375-2.32511-4.34867-5.038-8.48147-7.21507-12.91373-9.98487-20.13075-20.77354-39.86206-30.4344-60.145a232.51707,232.51707,0,0,1-15.90562-43.55194c-.17649-.70595-.16861-1.50552-.94423-1.918a21.19847,21.19847,0,0,1-.11746-4.71091c.90775-4.63978,2.6865-9.19359,2.96712-13.85064.36235-6.01347-.31339-12.09974-.703-18.14429-.2315-3.59211-.77225-7.16428-1.174-10.74541a42.51917,42.51917,0,0,0-4.60867-15.60445c-.76273-3.48583-2.0772-6.9569-2.17078-10.46059-.1824-6.82854.35094-13.67454.50938-20.51516a14.15416,14.15416,0,0,0-.48109-4.0388c-1.62286-5.88061-3.33369-11.73722-5.04282-17.59372-1.201-4.1153-.178-5.905,4.004-6.44749,4.43542-.57538,8.8951-.964,13.3565-1.43543L74.33714,189.319c1.68018,3.52362,1.68743,7.34184,1.85818,11.10685.19169,4.22715-.14284,8.46974.28908,12.69414.06025,1.346-.767,2.24252-1.58995,3.13948-3.20024.63465-2.70208-1.94022-3.18535-3.66069-.98006-4.24631-4.28147-7.19366-6.1923-10.93178-1.0132-1.98209-2.387-3.78522-3.53238-5.713-1.86887-3.14538-4.85817-5.93687-2.35684-10.2648-3.42453-.76449-6.12184-.95335-8.81332,1.25485.69033,6.38287,5.61038,11.303,6.30154,17.657a9.5258,9.5258,0,0,0-.99735,3.83516c-.58194,6.10874-.79279,12.25332-2.01208,18.292A12.67339,12.67339,0,0,0,56.84971,238.184a55.6084,55.6084,0,0,1,6.56185,9.38437c-.10583,10.09467.61879,20.19905-.451,30.27295a7.72278,7.72278,0,0,0,.43934,2.49763c.59085,1.628.01036,3.15489-.47258,4.67436a21.13428,21.13428,0,0,0,1.04456,15.80015c4.262,9.30347,8.91506,18.41693,13.24234,27.68932,3.64957,7.82025,8.62032,14.9419,13.6469,21.89261,6.41258,8.86728,9.98381,18.88948,13.7562,28.92361,12.25485,32.5967,22.877,65.73448,32.97521,99.04632C138.12758,480.13022,139.54733,482.11156,137.34935,483.83024Z"
            class="cls-6"
          />
          <path
            id="path25"
            d="M194.36036,84.53526c2.02517-7.20034,3.6843-14.53416,6.2418-21.54034,1.1469-3.14194,4.09251-5.62783,6.22188-8.41142l1.33339.71646q-2.42664,8.24173-4.85327,16.48344l.92905.2681c2.77565-7.27907,5.5513-14.55815,8.28234-21.72019,5.84717-2.7605,11.48274-1.21883,14.6135,3.94431.9,1.48428,1.63382,3.06927,2.44385,4.60808-.54741,2.60812-.238,5.27587-.511,7.91146-2.3773,8.91321-2.08547,18.25973-4.407,27.17375a29.18028,29.18028,0,0,0-.36936,3.93134,52.3499,52.3499,0,0,0-3.50524,12.89317c-1.75619,13.22091-3.87625,26.39163-6.69973,39.43321-.45725,2.112-.205,5.0711-3.778,4.93722-2.01631-1.06522-1.9489-3.02664-2.0401-4.87564-.74049-15.01606-1.31372-30.041-2.71274-45.01877-.29748-3.18505.91372-6.4094-.11836-9.58908-.83876-2.59331.11879-4.84547,1.35876-7.0588,4.11242-7.34081,9.3606-13.879,13.23927-18.84471-4.988,7.55094-13.17968,15.06988-20.45136,23.38271-1.2523,1.4316-2.72562,2.78262-4.72347.93612C193.77045,90.95547,194.92964,87.70055,194.36036,84.53526Z"
            class="cls-7"
          />
          <path
            id="path27"
            d="M245.18451,459.10071c-1.01264,20.49411,5.7381,39.77136,9.48258,59.50336,3.45494,18.20621,7.5826,36.28478,11.39763,54.423a18.28066,18.28066,0,0,1,.19888,2.22464c-.4672.729.37931,1.82062-.726,2.3842-1.72542.90645-2.63064-.32443-3.64593-1.46358-3.87474-4.34761-7.46721-8.93044-11.19007-13.40368-1.13629-1.36525-2.24416-2.57958-4.09677-2.83981-1.37855-1.07132-1.581-2.81914-2.43758-4.19678-.19724-2.84251-.8472-5.62318-1.15764-8.449a6.34127,6.34127,0,0,1,.65845-4.3043c1.14027-6.05217.6924-12.16027.2392-18.18527-1.1071-14.71739-2.388-29.409-1.62992-44.19544.16517-3.22151-.54429-6.452-.33179-9.69228a22.35706,22.35706,0,0,0,1.51512-9.26086C243.38289,460.51417,243.2651,459.029,245.18451,459.10071Z"
            class="cls-8"
          />
          <path
            id="path29"
            d="M246.09455,555.702l1.32468,3.99272c1.8942.41106,2.03168,2.11822,2.33326,3.49225,2.0068,9.14292,3.72593,18.34579,5.60981,27.51446.34482,1.6783-.37174,3.20037-.30954,4.81154-12.61686,4.62321-25.21859,9.28867-37.87114,13.81218-1.46044.5221-3.20346.25451-4.81479.35284,1.17307-.38852,2.34546-.7768,3.74949-1.24177.43565-1.253.91573-2.6336,1.39579-4.01422,2.80118-4.8848,5.20278-9.97989,7.87514-14.934,5.56685-10.32016,11.00216-20.71139,16.56519-31.03356C242.76246,556.95145,243.52168,554.80744,246.09455,555.702Z"
            class="cls-9"
          />
          <path
            id="path31"
            d="M118.63974,128.75446c-1.93587-12.73915-.35541-25.4044.82906-38.07536a6.61992,6.61992,0,0,1,.673-1.71038c2.26252-1.66143,2.88609,2.1151,4.85317,1.43956,1.32253.27015,1.87828,1.56631,3.08485,2.2935,1.76811.60836,4.63956-1.03222,5.55079,2.09673.81021,2.78207-2.60922,3.30413-3.32433,5.667a17.93692,17.93692,0,0,0,8.99026-1.20377,1.32573,1.32573,0,0,0-.72012-1.46075c-5.63713-2.29316-6.51788-7.13048-6.85374-12.38933a55.67082,55.67082,0,0,0-1.28109-9.73532c-2.01231-.96938-2.93125.05235-4.01483.59772-1.282.64525-1.31182.58607-2.59615-.8117q2.36482-2.58514,4.72965-5.17031c3.77407.45389,7.67427-.91831,11.258.66121a16.7,16.7,0,0,1,2.07522,3.27887l1.42123,4.11115a8.2774,8.2774,0,0,1,1.5946,2.47969c2.58546,6.5887,5.3298,13.12259,6.65178,20.1254a2.32283,2.32283,0,0,1-2.56064,2.67228c-1.83927-.35168-2.98348.34049-4.14323,1.91157-2.49915,3.38562-5.2853,6.58034-9.19123,8.49927-1.82357.3254-2.99035-.91053-4.33054-1.78388-1.515-.98733-2.85228-2.38726-4.94416-2.52352-1.19768,2.17162-.53792,4.24771-.35637,6.30193.54685,6.1874,1.57767,12.32984,1.81745,18.54223.07916,2.05069.49562,4.30863-1.5298,5.87456-2.41587,1.99739-1.43113,4.89235-1.68843,7.31911a111.15991,111.15991,0,0,1-1.91952,12.61786c-.2987,1.33409-.62033,2.675-2.84525,2.957-.162-4.5584-.27626-8.96471-.51415-13.36073C118.97267,142.90738,119.21327,135.81716,118.63974,128.75446Z"
            class="cls-10"
          />
          <path
            id="path33"
            d="M118.63974,128.75446c.483,6.42981,1.08905,12.85355,1.40657,19.2915.22,4.46088.0423,8.94135.67746,13.46881,1.37032-8.1659,2.74066-16.3318,4.16048-24.79267l1.19634,3.2015c2.12645,1.04779,1.76191,3.09386,1.80012,4.85725.13574,6.26424-.10933,12.54317.92136,18.76172-.75636,1.5055-.30738,3.07747-.222,4.62707-3.03586,4.96352-1.46118,10.573-1.99958,15.85352-1.25837,12.34206-2.22438,24.71778-3.4518,37.06736-.12539,1.2616-.67494,2.378-.81746,3.2778,2.21837-8.19917,4.32289-16.77487,7.66279-24.31326,2.10162-1.00532,3.16806-.61411,4.05943.48632,2.05825,6.79161,1.4824,13.86093,2.01835,20.79322.42221,5.46124.90243,10.9351,1.15441,16.4069a13.19717,13.19717,0,0,1-2.02179,10.0976c-5.18425.13722-7.70536-5.1768-11.9859-6.05933-2.0498.76939-1.94616,2.4996-2.56176,3.78831-.613,1.2833-.88356,3.02819-3.0289,2.16624a1.73,1.73,0,0,1,.22745-1.59205c2.64183-9.48846,2.32539-19.19811,2.19865-28.9-.257-19.66913-.43789-39.33931-.72225-59.008C119.16961,148.40651,118.86878,138.581,118.63974,128.75446Z"
            class="cls-11"
          />
          <path
            id="path35"
            d="M267.76756,97.94014q.58227,3.812,1.16451,7.62392l.89.06948c1.09529-4.46529,2.19061-8.93057,3.31521-13.51529-.77688-.69156-1.425-1.26853-2.38069-2.11921,5.13172-2.07144,8.842.79446,12.75382,2.65115,2.70226,5.904.815,12.02116.76969,18.04048-.027,3.59294-1.11007,7.11494-1.1356,10.73013-.082,2.21568.01645,4.43682-.09875,6.65533-.02185,4.19763-3.05749,7.47086-3.46809,11.62408-.26747,2.70515.21519,5.67525-1.62676,8.10656a3.25887,3.25887,0,0,1-3.462.21075,46.7118,46.7118,0,0,1-6.86416-10.64314,12.45342,12.45342,0,0,0-4.3688-5.31966,15.41319,15.41319,0,0,1-.78538-2.41545c.49524-11.17039.26-22.4277,3.22882-33.19139C267.49986,96.39189,267.30228,97.45626,267.76756,97.94014Z"
            class="cls-12"
          />
          <path
            id="path37"
            d="M118.58282,489.0469q.38868,21.50532.78,43.01065c.23506,12.4649.4434,24.93063.76238,37.39352.14337,5.60228.64857,11.19628.74842,16.79833a63.52627,63.52627,0,0,1-.76279,7.71844c-1.64889-1.49024-3.09118-3.3491-4.98179-4.40807-9.23417-5.17192-6.46667-13.37085-5.60041-21.12565.73616-5.13995,1.18517-10.32358,1.49713-15.48892.73915-12.23792,2.00151-24.43048,2.86574-36.6561.56286-7.96248,1.21751-15.92212,2.163-23.85125C116.2382,490.89679,116.20273,489.02618,118.58282,489.0469Z"
            class="cls-13"
          />
          <path
            id="path39"
            d="M287.28925,323.51835c-4.054,24.89682-8.27949,49.72651-20.19826,72.457-4.2837,8.16947-8.0872,16.59052-12.10987,24.89678-2.47714-.23923-2.33409-1.99043-1.71721-3.51923,3.36711-8.34454,4.817-17.26089,7.83668-25.71446,2.43586-6.81917,3.88825-13.97083,6.69913-20.67526.68645-1.63732-.13156-3.10241-.3083-4.6441,1.09527-3.41378,2.9083-6.53238,4.13767-9.89685a7.45766,7.45766,0,0,0,1.94527-2.96768c2.56923-9.763,6.77508-18.95072,10.19062-28.41771.55066-1.52623.84571-3.506,2.98-3.99088C288.00075,321.649,287.75865,322.55816,287.28925,323.51835Z"
            class="cls-14"
          />
          <path
            id="path41"
            d="M304.7123,267.53594q-8.27183,25.77375-16.54366,51.54749c-2.02542,1.27172-3.606-.13217-5.14318-1.015-4.66811-2.681-9.52344-5.083-13.6397-8.64863a3.10675,3.10675,0,0,1,.42824-3.40856c9.46375-8.41455,16.77124-18.80846,25.50883-27.894a21.76148,21.76148,0,0,0,3.03355-4.642,5.56822,5.56822,0,0,0,2.28356-3.80052c.20568-1.7407.86431-3.66364,3.34321-3.55447C304.62,266.38836,304.961,266.81083,304.7123,267.53594Z"
            class="cls-15"
          />
          <path
            id="path43"
            d="M269.29864,246.13758l3.50453-3.59442q.44011-.50109.91727-.96711c5.85258-3.13216,12.42958-3.03127,18.72586-4.16841,1.55684-.28119,2.54087.72656,3.309,1.951,1.06425,2.26546-.21071,4.58171.15119,6.86255-.09869,5.98679.22323,12.00718-1.43082,17.86941-.33244,1.1782-.375,2.48418-1.45811,3.33486-1.63389.88634-3.29764,1.64416-5.2248,1.0165-4.76181-4.3212-10.95938-6.3629-16.12315-10.05723-1.49012-1.06608-3.2246-1.93633-3.82382-4.67566,5.10347-3.52637,10.65138-.82534,15.35554-1.03-4.761-.65472-10.29673-.46509-14.69791-3.20229C267.49894,247.601,268.47258,246.89775,269.29864,246.13758Z"
            class="cls-10"
          />
          <path
            id="path45"
            d="M270.13,309.22623q9.01933,4.92861,18.03867,9.8572-.43971,2.21745-.87939,4.43492c-.04506-.11566-.05758-.28511-.14183-.33615a3.82186,3.82186,0,0,0-.6277-.25295c-2.17876,5.81883-4.286,11.6657-6.55662,17.44853-2.21769,5.6482-4.602,11.23105-6.91321,16.84261-2.28033-.42683-2.52748-2.25866-2.492-4.001.13922-6.843-.57241-13.648-.98121-20.45546-.43593-7.259.0199-14.51877-.49415-21.7629A2.11087,2.11087,0,0,1,270.13,309.22623Z"
            class="cls-16"
          />
          <path
            id="path47"
            d="M56.99356,304.87954l.56163-1.465c3.68861,9.77892,7.07215,19.22446,10.81321,28.52635,3.38845,8.42522,6.90587,16.8186,10.828,25.00508,8.02337,16.74712,16.363,33.34281,24.5473,50.01318a36.76705,36.76705,0,0,1,1.30624,3.48063c-1.59984.30706-1.75538-1.1305-2.2605-1.99158C92.5011,390.90977,82.39246,373.267,72.21553,355.664c-1.78337-3.08471-2.95438-6.50946-4.61356-9.68038C61.729,332.88486,57.14957,319.45255,56.99356,304.87954Z"
            class="cls-17"
          />
          <path
            id="path49"
            d="M267.76756,97.94015c-.49338.34655-1.38232.65417-1.42083,1.04546q-.87559,8.89274-1.54035,17.8059c-.33159,4.45623-.53645,8.92189-.79774,13.38333-2.29758,5.743-6.98726,9.70472-10.83727,14.26307-1.20912,1.43157-2.81458,3.61866-5.45722,2.02824-.30476-4.56176,1.6125-8.69832,2.48011-13.03532.21018-1.05056,1.0763-2.033.37155-3.19182q2.53792-9.04962,5.07588-18.09921c2.3719-5.05975,5.64092-9.65966,7.64722-14.90681l3.58524-5.08078C267.27887,94.77429,267.52322,96.35722,267.76756,97.94015Z"
            class="cls-18"
          />
          <path
            id="path51"
            d="M74.47319,213.28926q-.068-11.98509-.136-23.97024l.79023.59006c5.83959,7.173,8.35979,15.98976,12.00558,24.24819.44377,1.00521.64751,2.13454,1.63708,2.817l.5401,2.42148c-.74391,6.03758.27433,12.05179.25459,18.08134a35.30618,35.30618,0,0,1-.72457,8.46472c-2.69494,2.171-3.93808.18937-4.6885-1.88694C80.49526,233.938,75.50362,224.232,74.47319,213.28926Z"
            class="cls-19"
          />
          <path
            id="path53"
            d="M269.253,366.13546c-.29807,2.80176-.20309,5.715-.96132,8.38625-3.53187,12.44236-7.32208,24.81121-10.96675,37.222-.8847,3.0125-1.56794,6.084-2.34381,9.12846q-.33052,1.14159-.66108,2.28314c-5.16551,2.23259-7.17181,2.06548-9.52161-.78718-.85706-1.645-.07931-3.18341.47509-4.64433,3.72925-9.827,6.56316-20.00722,11.34634-29.41339,1.00232-1.971.19227-3.93651.78875-5.81988.6309-1.23962,1.50908-2.33019,2.16954-3.5523,2.9533-3.10616,3.69269-7.49846,6.28875-10.82094C266.7545,366.98122,267.28178,365.36613,269.253,366.13546Z"
            class="cls-20"
          />
          <path
            id="path55"
            d="M255.05276,595.513a29.87007,29.87007,0,0,1-1.45484-4.13033c-2.1031-10.55459-4.12781-21.12478-6.17792-31.689.14472-.45771.29019-.91651.77-2.42971,5.75963,6.74453,11.07921,12.97374,17.24608,20.19518.30441-.812.566-1.50963.82753-2.20739.3161,1.3089.6322,2.61786.988,4.09113C263.14856,584.78166,259.10067,590.14731,255.05276,595.513Z"
            class="cls-21"
          />
          <path
            id="path57"
            d="M123.83055,75.46238c2.02863-1.25283,4.05727-2.50565,6.94876-4.29137.797,2.16929,1.71946,3.82153,1.98528,5.57334.653,4.30314,1.17439,8.64263,1.41624,12.986.16329,2.9326,1.7059,4.44483,4.07084,5.7028a23.81834,23.81834,0,0,1,6.09543,4.59893,65.13855,65.13855,0,0,1-18.778,3.02815l-.54162-1.0699,7.40391-6.71738-.50068-.82938-5.76037,1.3719-1.56756-4.62195c-3.10557-1.79592-2.303-4.95594-2.46292-7.64956-.0853-1.43715.35924-2.89111-.50131-4.23392Q122.73454,77.38622,123.83055,75.46238Z"
            class="cls-22"
          />
          <path
            id="path59"
            d="M273.8289,242.54566l-1.02348-.00247c1.3316-3.03676,2.52387-6.1454,4.024-9.09771,6.35589-12.509,12.80325-24.97149,19.21721-37.451,2.65957-3.5305,3.64808-7.91132,5.92969-11.62675.5197-.84629.52517-2.78134,2.4603-1.63868a2.8835,2.8835,0,0,1,.55566,3.12622c-3.63193,12.25773-6.1049,24.86154-10.96952,36.74828-6.52307,6.15648-11.18345,14.22943-19.26607,18.79924A2.78518,2.78518,0,0,0,273.8289,242.54566Z"
            class="cls-13"
          />
          <path
            id="path61"
            d="M168.02092,220.13571c1.56979-.26313,3.13959-.52624,4.42667-.742,6.11028-38.70832,12.15794-77.01989,18.20558-115.33147,2.14458.06128,1.96636,1.8442,1.67372,2.93322-1.32016,4.91263-.32413,9.96271-1.11556,14.88669a48.43331,48.43331,0,0,0-1.75642,8.88247c.6011,4.26093-2.42452,7.685-2.54,11.90361-.32354,11.81689-2.72724,23.3967-4.74243,35.01113-.03436,7.56217-.94562,15.08357-1.02424,22.6423a20.46144,20.46144,0,0,1-.72044,5.135,16.19378,16.19378,0,0,0,.28327,9.33681,25.17966,25.17966,0,0,1-9.21694,11.51246c-3.35867-.02677-3.15466-3.23044-4.50166-5.06339A1.26717,1.26717,0,0,1,168.02092,220.13571Z"
            class="cls-23"
          />
          <path
            id="path63"
            d="M118.58282,489.0469c-.98728,8.0137-2.08981,16.01518-2.9376,24.04361-1.71257,16.21783-3.29684,32.44934-4.907,48.67788-.23335,2.352-.31569,4.71884-.47685,7.07821-.00722.10569-.10353.20535-.15835.30779q-.28667-.35974-.57384-.7199c1.22768-20.78278,2.54194-41.56057,3.65136-62.34929.65128-12.20385.88233-24.43551,4.037-36.353q.68192,3.68436,1.36294,7.3672Q118.58147,483.07329,118.58282,489.0469Z"
            class="cls-24"
          />
          <path
            id="path65"
            d="M269.92456,210.30879l-4.42759,20.2393c-2.45837.13434-3.83854-3.01017-6.34679-1.99236-1.47859-.99284-2.36557-2.07077-2.3213-3.71289a18.94965,18.94965,0,0,0,.42152-5.99015,3.1802,3.1802,0,0,1,.10431-1.48572c5.15268-9.41327,4.41826-20.201,7.0544-30.20152.79177-3.00362,1.03863-6.14878,2.10741-9.09229a2.19642,2.19642,0,0,1,1.71357-1.30191c3.80634.58272,2.87695,3.60739,2.64985,5.82613-.6069,5.92983-.90016,11.88829-1.81429,17.79845-.52211,3.37565.16766,6.92354-1.25625,9.54668a1.568,1.568,0,0,1,.84912-1.2149C269.97,208.545,269.46237,209.81352,269.92456,210.30879Z"
            class="cls-25"
          />
          <path
            id="path67"
            d="M311.2368,170.61266c2.57587-1.90941,5.088-3.91353,7.74529-5.702,2.74087-1.84468,8.13828-1.07605,10.87522,1.35553a4.91053,4.91053,0,0,1-.83283.63269c-1.3762.61546-2.98534-.06078-4.5234.87633-.50925,2.79112,1.35238,5.02848,2.22449,7.48721a40.63047,40.63047,0,0,1,2.17684,7.47845c.59855.091,1.07084-.57728,1.72221-.34719,2.15868,1.36505.82689,3.60165,1.37926,5.37286a3.1442,3.1442,0,0,1-.82533,2.82448,2.20872,2.20872,0,0,1-1.02239.483c-4.28088-.36217-7.276-3.47121-10.929-5.18509-1.6607-.77917-3.08917-2.03992-4.7479-2.45789-1.51306-.06547-1.83283,1.41568-2.89166,1.76879-2.025.314-2.56438-.99552-2.7545-2.59829-.32759-2.761-.06575-5.39124,1.806-7.65247.67087-.81045,1.72869-1.48425,1.245-2.81159A4.532,4.532,0,0,1,311.2368,170.61266Z"
            class="cls-26"
          />
          <path
            id="path69"
            d="M245.99353,421.57828a25.61729,25.61729,0,0,0,3.4,1.072c1.62179.28442,3.28245.3473,4.92648.505q-4.56774,17.97265-9.13551,35.94539c-.19291,2.83341-.27161,5.68177-.64151,8.4919-.12713.96576-.98181,1.83581-1.50414,2.74957a1.453,1.453,0,0,1-1.887.03266,2.7041,2.7041,0,0,1-.66131-2.56829c1.36242-9.85989,1.53923-19.81157,2.07726-29.72538.27055-4.98565,2.00027-9.75886,1.68156-14.77616C244.43831,422.33353,244.79356,421.52961,245.99353,421.57828Z"
            class="cls-27"
          />
          <path
            id="path71"
            d="M225.91452,154.32115c-.74174,6.89841-1.59489,13.78721-2.18905,20.69831-.45375,5.27793-.57959,10.58406-.85132,15.87764-2.00517.4329-2.2225-1.04934-2.50845-2.38963-.28211-1.32221-.16123-2.72883-.96828-4.20174-2.47513-1.00514-4.58674-2.57782-4.06564-5.94181,2.01688-4.568-.62546-9.03108-.302-13.56071a11.51806,11.51806,0,0,1,.5979-4.01968,2.85713,2.85713,0,0,1,.55225-1.23631c5.03148-3.53473,7.59866-8.10235,7.08552-14.514-.56022-6.99991.1888-14.02722.51748-21.03756.09585-2.04444.44792-2.33,2.33139-2.41387C226.07848,132.49685,226.4603,143.41182,225.91452,154.32115Z"
            class="cls-28"
          />
          <path
            id="path73"
            d="M153.75007,117.47258q3.06,28.05982,6.12,56.11961c-.53785,4.94744.00573,9.93437-.53789,14.88046-.23628,2.14984-.40942,4.3957-3.53228,4.04414-2.68458-3.65641-1.66627-8.03688-2.19423-12.0808-.50753-3.88737-.1035-7.87618-.27983-11.81975a8.82964,8.82964,0,0,0-.72761-3.56529c-.21391-3.14262,1.20039-6.27393.12928-9.43287a19.56544,19.56544,0,0,0-.88314-4.08433,7.93378,7.93378,0,0,1,.26911-5.312,5.22361,5.22361,0,0,0,.49329-2.52589c-.3658-5.765-.47876-11.548-1.186-17.29567a20.74885,20.74885,0,0,1-.1336-5.821C151.40764,119.12608,151.87273,117.66606,153.75007,117.47258Z"
            class="cls-29"
          />
          <path
            id="path75"
            d="M258.713,225.23807c.78551.47063,1.56412,1.31005,2.35816,1.32492a14.84074,14.84074,0,0,0,3.71883-.90421c.26482,1.83135.4859,3.36033.707,4.88931-.67611,3.4-1.35221,6.79989-2.03466,10.23175.5801,1.17932,1.17772,2.39423,1.77534,3.60913a2.89229,2.89229,0,0,1-2.10094.98847c-2.26793-.81237-3.99522.66044-5.878,1.425-2.57106,1.04406-4.946,2.70018-7.62422,2.57631-1.70234-.74887-1.71776-1.97283-1.64572-3.23632a160.66278,160.66278,0,0,1,7.92772-18.571C256.49305,226.39457,256.81721,224.85939,258.713,225.23807Z"
            class="cls-30"
          />
          <path
            id="path77"
            d="M227.9886,212.52744q7.46895-27.33141,14.936-54.6633c.3272-1.198.62784-2.40321.94086-3.60507,3.885.92328,4.53632,1.90578,4.29406,6.48158a121.51433,121.51433,0,0,1-4.73672,20.25926c-4.89515,7.27306-6.81241,15.81526-10.11474,23.76715-.85768,2.06526-1.18447,4.30927-1.99552,6.39321-.53062,1.36349-.92592,2.89446-2.78944,3.09718C227.529,213.918,227.56916,213.28242,227.9886,212.52744Z"
            class="cls-31"
          />
          <path
            id="path79"
            d="M269.29864,246.13756c-.845,2.27289.86866,2.46836,2.32309,2.803a177.71713,177.71713,0,0,1,17.758,4.71026H269.94625l-.46732,1.09156,18.55755,11.78545c-.14039,2.176-1.59017,2.33312-3.14258,1.80446-8.59937-2.92844-17.12277-6.06554-25.47229-9.65486a2.7476,2.7476,0,0,1-1.9-2.11484c.93544-3.57105,5.11388-2.94326,6.96574-5.33418.97448-1.32972-.36518-3.66664,1.92551-4.40648Z"
            class="cls-32"
          />
          <path
            id="path81"
            d="M156.1799,192.235c.7022-3.95181,1.36261-7.91165,2.12262-11.85232.43962-2.27947,1.03971-4.528,1.56758-6.79045.968,8.88079,1.95954,17.75909,2.89541,26.64327.59817,5.67834,1.114,11.36532,1.67374,17.12012,1.24218.96417,2.412,1.87213,3.58169,2.78011q-.36.43551-.72.871a2.66184,2.66184,0,0,1-3.10243.88981,5.73513,5.73513,0,0,1-2.5459-3.06156c-2.42822-6.73625-5.18124-13.37107-6.83913-20.35518C154.29881,196.31144,153.4372,193.8075,156.1799,192.235Z"
            class="cls-33"
          />
          <path
            id="path83"
            d="M227.9886,212.52744a26.72088,26.72088,0,0,0,2.03112-3.45786c3.87791-9.5529,7.68841-19.13312,11.51973-28.70491,2.09442,1.0535,1.71286,2.91552,1.27131,4.56835-2.92895,10.96356-6.10577,21.85869-9.2126,32.773a5.40931,5.40931,0,0,1-4.409,4.12686c-3.09559.52452-6.09046,2.61885-9.388.76369-1.95779-1.83967-1.09181-3.64189.08167-5.43156a1.46914,1.46914,0,0,1,1.284-.25172c.1664.94354.33281,1.8871.4958,2.81125,2.54828.89085,3.82935-.3237,4.61584-2.381C226.88665,215.7527,227.42129,214.13383,227.9886,212.52744Z"
            class="cls-13"
          />
          <path
            id="path85"
            d="M281.30022,127.91151q.29119-3.05079.58236-6.10159c1.28263-1.79009-.23214-4.10025,1.35636-6.50082a18.15619,18.15619,0,0,1,2.671,8.611c-.45123,1.88342.78688,3.7804-.04223,5.66185q-3.73142,19.48356-7.46278,38.96708a1.88548,1.88548,0,0,1-1.63214-.95627,16.26081,16.26081,0,0,1,.677-7.59373c1.07443-10.11456,2.094-20.23257,3.43187-30.31477A3.21093,3.21093,0,0,1,281.30022,127.91151Z"
            class="cls-34"
          />
          <path
            id="path87"
            d="M67.602,345.98359c2.54835,4.34482,5.13809,8.666,7.63766,13.03863q14.01751,24.52192,28.00274,49.06232a21.33622,21.33622,0,0,0,1.80794,2.355q3.43006,6.34951,6.86093,12.69861c.22747.74834-.086.91705-.75543.70448-13.06073-22.25518-26.18847-44.47163-39.1109-66.80675C70.07645,353.63356,69.05919,349.68141,67.602,345.98359Z"
            class="cls-35"
          />
          <path
            id="path89"
            d="M153.012,126.43769q.3953,12.73194.79061,25.46388c-2.38647.0324-2.27628-1.8917-2.54928-3.38747-1.38307-7.57745-1.86648-15.27323-2.9445-22.8913-.97885-6.91735-.92214-13.91169-1.62195-20.8487-.0506-1.45581.15038-2.77265,1.81753-3.27641l1.76412.76238.62159-1.38689c.77948-.89362-.57924-2.36785.83918-3.088q.30669,3.06858.6134,6.13714c-1.01764,1.82476-.23991,3.74276.077,5.46427C153.46518,115.06594,152.10078,120.78673,153.012,126.43769Z"
            class="cls-36"
          />
          <path
            id="path91"
            d="M87.826,246.30209c.23763-7.40992.44027-14.82125.741-22.22861a38.91177,38.91177,0,0,1,.74319-4.67779c.57428,8.54894,1.02147,17.10942,1.79793,25.64a36.14346,36.14346,0,0,0,2.11918,7.86332c2.4208,7.30265,4.93957,14.57288,7.41974,21.85586a1.15071,1.15071,0,0,1-.221,1.68688c-3.28767.28469-2.6659-2.95959-3.94492-4.48857a5.34309,5.34309,0,0,1-1.57836-3.69956c-3.51638-6.14451-5.90025-12.78639-8.50111-19.33756A2.59976,2.59976,0,0,1,87.826,246.30209Z"
            class="cls-37"
          />
          <path
            id="path93"
            d="M221.16687,216.91324q-.26.16778-.51579.34189c-1.915-.60246-1.48993-2.22126-1.59752-3.62826-.59739-7.81243-.573-15.65449-1.038-22.4159a47.32328,47.32328,0,0,1,.2531,8.5168c-.02118.98271.37348,2.35855-1.37994,2.43861-1.35926-.9368-1.16893-2.3838-1.18982-3.7196-.07993-5.10908-.01492-10.21851-.27154-15.32769-.0835-1.66239-.58772-3.81431,2.06781-4.28l.28742,2.8016c3.40209.95746,4.56189,3.403,4.3429,6.7961a7.46588,7.46588,0,0,0,.7486,2.46024Q222.02053,203.90517,221.16687,216.91324Z"
            class="cls-38"
          />
          <path
            id="path95"
            d="M117.83531,246.14227l.133,1.64487a2.33468,2.33468,0,0,1,.82778,2.95984c-2.14446,6.31742-3.19575,12.93463-5.32418,19.25389a5.49565,5.49565,0,0,1-1.09782,1.9118c-4.77719,7.351-9.65447,14.63726-14.87808,21.68414-1.08032,1.45736-1.96706,3.37906-4.40583,2.59783-1.74363-1.37458-.89922-2.84017-.10777-4.26982a158.60032,158.60032,0,0,1,9.45918-14.52661,3.04894,3.04894,0,0,1,.38466-.95239c1.44778-1.54624,3.43725-2.8517,4.25072-4.68C110.84186,263.30415,114.28007,254.69719,117.83531,246.14227Z"
            class="cls-39"
          />
          <path
            id="path97"
            d="M225.91455,154.32115l-.18949-32.71994c-1.69513-3.90312-1.328-8.1626-2.11571-12.22626a51.44907,51.44907,0,0,0,.71568-11.36579c-.17191-2.49991,2.24041-3.91578,2.43278-6.42613.64385-8.40149.4694-16.83428,1.1941-25.22512l1.621-7.47421c.322,13.5901,3.21954,27.2936-2.10077,40.63122a19.56592,19.56592,0,0,0-1.0252,6.95863c-.11651,14.34446-.08906,28.69-.14731,43.0351C226.29313,151.11332,226.04867,152.717,225.91455,154.32115Z"
            class="cls-40"
          />
          <path
            id="path99"
            d="M284.99968,124.19773c-.56609-2.24886-1.13217-4.49771-1.78506-7.09147-.51229,1.80976-.92189,3.25683-1.33176,4.70377q.81352-14.57986,1.62762-29.15966,2.20422,3.0568,4.40851,6.114c-.81554,7.50983-.99985,15.059-1.42711,22.59327C286.42785,122.48664,286.86822,123.97582,284.99968,124.19773Z"
            class="cls-41"
          />
          <path
            id="path101"
            d="M330.70492,190.06282l-.04145-1.49324c.94545-1.77366.978-3.75179,1.343-5.66514.29316-1.53673.86532-3.10683,3.05924-2.43385-1.00751,5.35753-1.49869,10.87822-3.13032,16.03858-3.37695,10.68017-7.36064,21.16868-11.09488,31.736a1.45792,1.45792,0,0,1-1.60586-.73538c-.86333-1.35876-.368-2.87216-.4993-4.31507,1.84323-4.66839,4.08728-9.15952,5.43988-14.05393a85.162,85.162,0,0,0,2.6855-11.90377C328.53689,195.05926,329.02875,192.24378,330.70492,190.06282Z"
            class="cls-42"
          />
          <path
            id="path103"
            d="M277.56331,167.65683l.84165.89215-8.4804,41.75981-.81071-1.71649c-1.34179-3.80306-.08634-7.59564.30524-11.32017.77548-7.37651,1.85128-14.73336,3.31445-22.01611C273.43417,172.14837,275.40039,169.84012,277.56331,167.65683Z"
            class="cls-43"
          />
          <path
            id="path105"
            d="M189.08288,121.93476c.5948-4.39842,1.25993-8.7891,1.74605-13.19949a30.543,30.543,0,0,0-.17612-4.6741q1.85384-9.76274,3.70723-19.52678.73443,4.83436,1.46823,9.667c2.36364,1.44855,1.18149,3.57612,1.05983,5.50083-1.4596,4.47784-3.09621,8.89628-4.16762,13.5063-.50225,2.161-.51531,4.39975-1.318,6.522C190.93862,120.957,190.73939,122.1106,189.08288,121.93476Z"
            class="cls-44"
          />
          <path
            id="path107"
            d="M266.41282,246.822c.29685,2.04914.59369,4.0983.94031,6.491-3.24907.95108-6.28736,1.84045-9.32565,2.72984a.83115.83115,0,0,1-1.08337-.05461c-1.07551-4.412,1.93057-10.48159,6.21527-12.54953q1.03753.4741,2.07667.94924Q265.826,245.606,266.41282,246.822Z"
            class="cls-45"
          />
          <path
            id="path109"
            d="M88.77007,216.97423c-.40011-.20889-1.01417-.316-1.16914-.64156q-6.27984-13.19126-12.47351-26.42354a17.17013,17.17013,0,0,1,7.47581,9.84039C84.41614,205.56665,86.69249,211.2395,88.77007,216.97423Z"
            class="cls-46"
          />
          <path
            id="path111"
            d="M246.02638,160.12425v-4.46547c-.78966,1.2926-1.17291,1.91991-1.63089,2.66961-.19665-1.50829-.36374-2.79-.53041-4.07053q3.35052-12.00916,6.7005-24.01981c-.23075,2.41036-.37421,4.83219-.71461,7.226-.43684,3.072-1.032,6.12143-1.55895,9.18058a3.14035,3.14035,0,0,1,1.16452,1.619c.52286,3.46136-.63687,6.73617-1.16378,10.076C248.1132,159.47778,247.45812,160.38985,246.02638,160.12425Z"
            class="cls-4"
          />
          <path
            id="path113"
            d="M335.06573,180.47059q-2.20092,4.04952-4.40206,8.099-.30845-3.02648-.61656-6.05283a2.51894,2.51894,0,0,1-1.61465-2.28085c-.46729-3.891-.26585-7.82521-.61583-11.73117a2.49715,2.49715,0,0,1,1.51581-2.34373q.26045.06312.525.105Q332.46146,173.36846,335.06573,180.47059Z"
            class="cls-47"
          />
          <path
            id="path115"
            d="M320.17474,227.52043l.66579.72472q-6.61826,16.21887-13.24019,32.4362c-.93845,2.29475-1.92414,4.5702-2.88806,6.85457l-.96085-1.00386c-2.01739-1.526-.68587-3.15442-.07078-4.6818,3.81979-9.4848,8.17013-18.74432,12.01984-28.21743C316.31346,228.73945,317.01912,227.77883,320.17474,227.52043Z"
            class="cls-48"
          />
          <path
            id="path117"
            d="M151.72935,97.7852q-.41961,1.544-.83919,3.088-3.55736-10.05445-7.11473-20.10886c1.05673-.76189,1.73384.0691,2.13447.74113,2.44789,4.106,6.08266,7.75473,5.30978,13.16369a1.3465,1.3465,0,0,0,.35863,1.019Z"
            class="cls-16"
          />
          <path
            id="path119"
            d="M311.23678,170.61266l1.50837.755c-2.41647,4.2119-4.37109,8.79338-8.99852,11.236-1.75031,3.50888-3.438,7.05123-5.28778,10.50689a17.90968,17.90968,0,0,1-2.41121,2.88383c3.00274-6.53908,5.75638-13.21174,9.14031-19.54807C306.44331,174.09574,309.17718,172.53411,311.23678,170.61266Z"
            class="cls-32"
          />
          <path
            id="path121"
            d="M102.82622,276.44582q.00046.25812.0133.51593c-1.53022,3.35489-6.47966,5.4605-10.11728,4.3059-1.55561-4.79249.82618-9.81367,4.8194-10.16557q1.55271,1.82636,3.10538,3.65275Q101.73661,275.60033,102.82622,276.44582Z"
            class="cls-49"
          />
          <path
            id="path123"
            d="M284.99966,124.19773c.50559-5.807.93994-11.62146,1.54843-17.41765.28238-2.69022.9034-5.34495,1.37092-8.01574.03608,2.8076.28909,5.63248.06644,8.41942-.59716,7.4746-1.398,14.93295-2.1178,22.39793Q285.43374,126.88993,284.99966,124.19773Z"
            class="cls-50"
          />
          <path
            id="path125"
            d="M121.63852,79.31c.73774,2.513,1.53037,5.01166,2.19169,7.54459.37,1.417.52212,2.89075.77248,4.33892-.04119.83079-.08243,1.6616-.14048,2.83074-1.6165-1.8913-2.96887-3.47359-4.32085-5.05572Q120.89034,84.13946,121.63852,79.31Z"
            class="cls-51"
          />
          <path
            id="path127"
            d="M263.28891,97.233a21.93542,21.93542,0,0,1-1.00695,4.07365c-1.54231,3.38131-3.24,6.69472-4.98343,9.97814-.23933.45081-1.08848.57811-1.65606.8551C256.09574,106.097,260.40384,102.0297,263.28891,97.233Z"
            class="cls-52"
          />
          <path
            id="path129"
            d="M153.012,126.43769q-.33465-11.25768-.66931-22.51535.70367,6.77512,1.40732,13.55024Q153.38106,121.95514,153.012,126.43769Z"
            class="cls-53"
          />
          <path
            id="path131"
            d="M53.35764,241.82384a20.36979,20.36979,0,0,1,4.60849,15.60493Q55.66207,249.62582,53.35764,241.82384Z"
            class="cls-49"
          />
          <path
            id="path133"
            d="M151.57831,95.68814c-1.65953-4.04881-3.2174-8.14432-5.04356-12.11658-.51533-1.12092-1.81627-1.88095-2.75809-2.80687q-.23221-1.211-.462-2.42138c.3711.02443.95269-.09529,1.08262.09429C147.99224,83.68325,152.977,88.36642,151.57831,95.68814Z"
            class="cls-25"
          />
          <path
            id="path135"
            d="M141.89345,74.23216c-.9171-.80074-1.8342-1.60146-3.25082-2.83831-2.87214-.31391-6.47824-.70805-10.08338-1.102,3.86712-.24783,7.73329-.49586,11.68812-.74958C141.01928,71.74156,141.45636,72.98685,141.89345,74.23216Z"
            class="cls-54"
          />
          <path
            id="path137"
            d="M111.15582,423.84261q.37738-.35233.75507-.70458,1.8819,7.82307,3.76327,15.64548Q113.41516,431.31265,111.15582,423.84261Z"
            class="cls-55"
          />
          <path
            id="path139"
            d="M198.815,561.014c-.0586-1.81125-.48056-3.6981-.12124-5.42236,5.36382-25.7414,10.84905-51.45755,16.23609-77.19415a39.24971,39.24971,0,0,0,.36184-5.82111c-1.05762-.02818-2.27551-.41742-3.14865-.0301-13.86224,6.14945-27.67747,12.40481-41.51263,18.6154-1.53013.68692-3.11651,1.24863-5.55564,2.21746v-8.04937c-1.8957-1.0341-1.81986-2.90759-1.75886-4.61219.23625-6.60148,1.3501-13.12539,1.96209-19.69618a17.87533,17.87533,0,0,0-.04262-5.52037c1.42191-12.54535,2.32723-25.13853,3.32891-37.72413.204-2.56293.34067-5.19749,1.64005-7.54771a2.55661,2.55661,0,0,1,1.12114-.74885c5.17146-.62377,10.12719.85385,15.1217,1.71612,7.81927,1.34989,15.79513,1.949,23.36774,4.57158,1.55975,1.49047,1.75514,3.50336,2.04363,5.46,1.84788,12.53291,3.234,25.12824,5.08862,37.66087.49136,3.32043-.31207,6.84785,1.63362,9.924.13172.72122-.03138,1.60009.384,2.16564,4.86237,6.62037,7.37643,14.57461,12.12715,21.25192a2.611,2.611,0,0,1,.41726,1.39863c-.06392.98443.48271,1.90332.34273,2.8995-9.40793,19.7303-18.58194,39.58161-28.32782,59.158C202.459,557.826,201.78458,560.48221,198.815,561.014Z"
            class="cls-56"
          />
          <path
            id="path141"
            d="M167.325,455.35811c-.60442,6.90141-1.24593,13.79979-1.79639,20.70549-.2456,3.08119-.30814,6.177-.45377,9.26613-.44387,2.50677-.88773,5.01354-1.44739,8.17436a108.50337,108.50337,0,0,1-24.03711-3.67789l.0012-.002a21.178,21.178,0,0,1,.8047-8.78254q6.23988-18.78508,12.55432-37.54525c.61152-1.8097.87239-4.02144,3.30413-4.58644,1.79756-.06549,2.58178,1.03578,3.11927,2.57812,1.21617,3.48978,2.827,6.85068,3.17088,10.609a4.75793,4.75793,0,0,0,1.6079,3.24588C165.208,456.03809,166.2731,454.57931,167.325,455.35811Z"
            class="cls-57"
          />
          <path
            id="path143"
            d="M246.09455,555.702c-3.24719,5.72229-6.57336,11.40154-9.72417,17.17637-5.48153,10.04663-10.84931,20.15522-16.28164,30.22878-.58049,1.07644-1.27355,2.09224-2.26006,3.6991-.16293-1.2296-.23936-1.80644-.31618-2.38374q2.06124-20.08783,4.129-40.1741c.60613-5.82725,1.27519-11.648,1.91568-17.47168a8.79293,8.79293,0,0,0-.398-6.31157,5.85435,5.85435,0,0,1,.41388-5.89983c1.75251-1.26605,2.04045-3.27519,2.59806-5.15578,3.0473-10.27739,5.04685-20.84328,8.49179-31.00607.76409-2.25413.85086-5.3962,4.57825-5.15829,2.38567,4.24092,2.76771,9.01376,3.12156,13.65028.8534,11.18215,2.10718,22.33609,2.54718,33.549.03335.8496.35248,1.74448-.27557,2.52758Q245.36444,549.337,246.09455,555.702Z"
            class="cls-45"
          />
          <path
            id="path145"
            d="M225.053,534.79268c-.252,2.55228-.469,5.10867-.76974,7.65519-.17144,1.45128-.47965,2.88646-.72616,4.32886.00011-1.34517.00011-2.6904.00011-5.215-8.97761,8.19769-17.15025,15.66034-25.96807,23.71209.56836-1.97525.89707-3.1176,1.22585-4.25994q4.86959-10.08245,9.73813-20.16546,9.97476-20.69612,19.95049-41.39172c.48528-1.00482,1.10692-1.94383,1.66519-2.91349q.32.12939.64008.25858c1.39906,1.25558,1.23838,2.9332,1.05468,4.50887a164.77073,164.77073,0,0,1-5.69017,28.89078C225.711,531.72475,226.32662,533.4925,225.053,534.79268Z"
            class="cls-32"
          />
          <path
            id="path147"
            d="M156.83133,439.62268A12.11339,12.11339,0,0,0,155.508,441.86q-7.99341,23.97036-15.91647,47.96424-1.12113-2.997-2.24222-5.994c-8.496-26.32935-16.82932-52.71281-25.55555-78.96569q-6.71594-20.20493-14.66288-39.99075c-2.15606-5.35129-5.60058-10.28549-9.01046-15.01178C76.86709,334.26438,69.46649,316.64343,61.399,299.39319c-1.35583-2.89913-.85478-6.76985-.80877-10.18625a58.057,58.057,0,0,1,1.1011-7.75658c1.00895-4.729,3.68683-8.578,6.53178-12.33319.80445-1.06178,1.39352-2.42422,3.0362-2.47453,2.87177.79833,2.46257,2.706,1.46653,4.6667-2.17846,4.28812-4.48684,8.51-5.98659,11.55448,6.2784-13.44617,7.86416-15.896,11.11327-16.73292,2.50305,1.36825,1.55144,3.2803.69452,5.10774-2.59387,5.5316-5.15568,11.07625-7.56922,16.69017-.84,1.9539-1.095,3.84344-.00216,5.73789,2.61756,4.53754,5.48218,8.92318,8.30387,13.33428a3.32391,3.32391,0,0,0,2.42647,1.58557c2.60672.05886,3.02039-2.28953,4.08948-3.82494,1.4253-2.047,1.81234-4.63972,3.32446-6.67749.98957-1.33356,1.87478-2.74175,3.89982-2.13328q7.86348-10.67444,15.72929-21.34714c.73882-1.00164,1.50914-1.98012,2.26489-2.9693q.28048.187.56061.37422c1.28112,3.71817,1.00716,7.61569.876,11.39406-.2888,8.32171-.76776,16.64531-1.55207,24.94221a13.03823,13.03823,0,0,0,1.26784,6.5144c.03533.40928.055.82665.06072,1.23825a7.649,7.649,0,0,0,.87245,5.32852c1.20692,1.88374,1.38575,4.24846,2.0854,6.38063,6.76907,20.62792,13.66453,41.21679,20.939,61.66868,3.08786,8.68146,7.85722,16.69269,11.79733,25.03956,3.14146,6.65494,6.50252,13.20831,9.4855,19.9399C158.20372,436.25327,159.383,438.16518,156.83133,439.62268Z"
            class="cls-58"
          />
          <path
            id="path149"
            d="M71.39313,267.33089q-4.85139,7.06045-9.70228,14.12018.00744-17.21358.01384-34.42574c-.38949-2.98065-.73339-5.96763-1.24642-8.93737-1.14417-8.012-.66821-16.107-1.33163-24.13956,2.8957-4.95624,7.81451-3.03411,12.01448-3.45082a3.87417,3.87417,0,0,1,2.362.68441q.414,2.60286.828,5.2057c1.73781,2.88641,1.75779,6.13056,1.87024,9.33146.22608,6.43583-.31407,12.88737.37989,19.31147.50007,5.9424-.44533,11.85476-.48468,17.7946C76.08,265.31107,74.0702,266.97419,71.39313,267.33089Z"
            class="cls-59"
          />
          <path
            id="path151"
            d="M73.50308,211.182c-2.91748.465-5.85337.84062-8.74427,1.43484a24.83986,24.83986,0,0,0-3.89774,1.48555,1.31859,1.31859,0,0,1-1.86618-.67544c-1.07374-3.04843-3.24515-5.69588-3.3522-9.095-2.75085-6.35973-5.5017-12.71943-8.60281-19.88893l16.04422-1.989c-1.07117,2.98486-1.77084,4.9345-2.62812,7.32332C64.702,196.74323,69.10254,203.96263,73.50308,211.182Z"
            class="cls-18"
          />
          <path
            id="path153"
            d="M74.42519,245.43769q-.04674-14.52544-.09383-29.05043.07-1.54843.14125-3.09784c3.59933,9.52457,7.16328,19.06272,10.83125,28.56074a33.72922,33.72922,0,0,0,2.52216,4.452q.08538,1.43909.17093,2.87818c.09471,1.2452.21975,2.49669-.72321,3.53341-3.22822,1.15355-5.13545,3.7777-7.19616,6.29564-1.16218,1.42006-2.13625,3.56784-5.00017,2.52248C74.14606,256.23973,75.35014,250.77625,74.42519,245.43769Z"
            class="cls-60"
          />
          <path
            id="path155"
            d="M61.63805,238.80441q.03282,4.11081.06615,8.22128c-2.50956-3.08226-5.20454-6.0367-7.45412-9.29814-1.18077-1.71189-2.33818-4.0167-2.19638-5.95818.4788-6.5551,1.54751-13.06694,2.38162-19.5965.17293-1.35364.307-2.71226.459-4.06857a1.51928,1.51928,0,0,1,1.43547-.9013c2.26128,3.64257,2.7567,7.88971,3.02247,12.14348.39779,6.36645.86078,12.723,1.66552,19.05188.063.49514-.021-.124.14008.34575C61.2764,239.08977,61.49346,239.09034,61.63805,238.80441Z"
            class="cls-18"
          />
          <path
            id="path157"
            d="M61.63805,238.80441v3.61806l-.57087.02211c-1.5334-10.5231-3.03657-21.05086-4.65-31.56169-.15061-.98111-.99881-1.85522-1.523-2.7788q.37427-1.88577.74839-3.77205,2.60951,4.88491,5.21865,9.77016Q61.24948,226.45347,61.63805,238.80441Z"
            class="cls-61"
          />
          <path
            id="path159"
            d="M207.05427,94.19248q1.41348,23.47789,2.833,46.95542c.28087,4.58923.63324,9.17406.95284,13.76091,1.6618,1.45535,1.1529,2.84921-.11777,4.21848-.93753.64488-2.09738,1.294-3.09964.95685-4.91412-1.65294-9.46327.42526-14.13321,1.176a10.5476,10.5476,0,0,1-5.11159-.25115c-2.60154-1.72468-1.34467-4.31112-1.49112-6.58936,2.99775-4.73761,2.71344-10.10912,2.88659-15.37a20.60168,20.60168,0,0,1,.78123-5.87872c3.56463-4.62044,5.34678-10.08258,6.92842-15.55451,1.96187-6.78724,3.92667-13.57341,5.99269-20.32929C203.99647,95.58414,204.27634,93.38423,207.05427,94.19248Z"
            class="cls-62"
          />
          <path
            id="path161"
            d="M207.05427,94.19248c-1.58876,4.41475-3.19861,8.82206-4.76167,13.24587-2.72727,7.7189-5.38814,15.46163-8.18333,23.15571a10.40324,10.40324,0,0,1-2.04628,2.56417c-2.46032-1.48788-1.78-3.91895-1.58894-6.02186a87.00179,87.00179,0,0,1,1.609-10.39768c1.23227-5.73064,1.73612-11.57971,2.97574-17.30439q.38457-2.61652.76929-5.233Q206.744,82.50658,217.66033,70.8124q2.76276-2.9586,5.53935-5.90427l.7697.52673c-.641,1.09123-1.23944,2.21009-1.9298,3.26914-4.41089,6.7667-8.91184,13.47633-13.21192,20.31238C207.88237,90.51914,207.62723,92.45569,207.05427,94.19248Z"
            class="cls-63"
          />
          <path
            id="path163"
            d="M209.982,158.60211q.42876-1.84674.85782-3.69341c1.45824-6.80852,3.04515-13.59268,4.34427-20.43145,1.99968-10.52669,3.7653-21.09762,5.7211-31.63293a50.43643,50.43643,0,0,1,1.74338-5.69481c2.81728,2.04243,1.41787,4.92016,1.41689,7.47778-.002,5.2325-1.29994,10.33124-1.77762,15.52938-.64129,6.97864-1.66663,13.92658-2.14662,20.9248-.334,3.82481-.38618,7.66951-.66433,11.504a14.04751,14.04751,0,0,1-2.57459,7.59427q-.1004.35641-.225.70513a1.84259,1.84259,0,0,1-2.97771.99062c-1.27209-.73294-2.81941-.98932-3.82206-2.18856A1.0179,1.0179,0,0,1,209.982,158.60211Z"
            class="cls-64"
          />
          <path
            id="path165"
            d="M218.9476,141.30264c1.18915-12.236,2.4099-24.46915,3.541-36.71053.22775-2.46476.11547-4.96092.16-7.4426q.34276-1.53891.68556-3.07782c1.49343-1.45294-.27777-3.66667,1.15948-5.14952,2.55933,1.80378,2.89275,4.147,1.31335,9.00407q-.04886,5.52283-.0977,11.0457c-1.30114,10.01355-1.8628,20.11382-3.44066,30.09-.39036,2.46808.08363,5.53628-3.03662,7.17555A6.97684,6.97684,0,0,1,218.9476,141.30264Z"
            class="cls-65"
          />
          <path
            id="path167"
            d="M225.807,97.92622c-.25722-2.531-.51449-5.06192-.84251-8.289-.72568,1.97445-1.17779,3.20449-1.6301,4.43452q2.30884-13.85659,4.61781-27.71348a1.17839,1.17839,0,0,1,.14163.34348c.62449,9.72349,2.5954,19.49221-.88845,29.08078A11.08141,11.08141,0,0,1,225.807,97.92622Z"
            class="cls-66"
          />
          <path
            id="path169"
            d="M244.63436,542.97207q-2.4276-20.79929-4.85981-41.598c-.31325-2.66717-.687-5.32715-1.03284-7.99047a2.47556,2.47556,0,0,1-1.22434-1.4162,2.74039,2.74039,0,0,1-.04145-1.2795c.57636-5.56949,1.05864-11.151,2.17882-16.64828.28884-1.41735.13767-3.093,1.99637-3.66325l1.38777-.03417c.91985,24.95788,1.83966,49.91577,2.78079,75.45214Z"
            class="cls-67"
          />
          <path
            id="path171"
            d="M126.83021,163.87126q-.37464-11.97406-.74944-23.94791c-.90118-11.42393-1.8022-22.84808-2.78853-35.354,4.66037,3.11137,8.595,5.73821,12.52965,8.365,2.06505-.11748,2.60588,1.44113,3.36368,2.90436,2.04038,3.93981,2.77463,8.46954,5.50736,12.09394a11.31187,11.31187,0,0,1-.505,5.82425c-.64584,1.54639-.1828,3.13082.21183,4.71651.75128,3.01865.63254,6.13343.76912,9.21986.039,7.1103.01347,14.2178.02332,21.32523a30.10059,30.10059,0,0,1-.83159,6.68428c-1.06109,2.55987-2.92036,2.16825-4.49256.82493C135.25925,172.58986,129.89917,169.39879,126.83021,163.87126Z"
            class="cls-68"
          />
          <path
            id="path173"
            d="M142.58511,127.91833q-3.38137-7.49208-6.763-14.98407c3.45547-3.56411,6.87862-7.16112,10.40289-10.65624.513-.50879,1.50927-.53071,2.28068-.77912q-.33591,1.59049-.66937,3.18341c-1.54511,2.23881-.43639,4.76386-.56975,7.11151-.236,4.15415-.94744,8.21591-1.58345,12.29026C145.42328,125.74866,145.31276,128.02676,142.58511,127.91833Z"
            class="cls-69"
          />
          <path
            id="path175"
            d="M126.8302,163.87126c4.18539,3.30938,8.36026,6.63219,12.56251,9.92,1.26978.99348,2.61539,1.89008,3.92628,2.83105,3.00217,2.644,2.3707,6.16461,2.31008,9.5473-.61626,3.69959-.37817,7.43681-.464,11.15718.22622,4.87274-1.36122,9.59418-1.39068,14.41022-.06319,10.33544.99819,20.51277,5.74286,29.96885a40.226,40.226,0,0,1,2.14308,5.554c-1.83636,7.828-5.32713,15.06184-8.1647,22.5313-.61053,1.6071-1.613,2.80567-3.59469,2.58423-1.58472-.48705-1.8502-1.86314-2.1653-3.20836a95.05523,95.05523,0,0,1-2.09339-12.26125,7.16273,7.16273,0,0,0-.72447-2.92727,6.11678,6.11678,0,0,1-.37589-5.40046c1.46067-3.25473.967-6.50059.58354-9.79634q-1.14068-19.0939-2.28137-38.18782a15.209,15.209,0,0,1-2.90541-7.15383c-1.35741-8.32309-3.639-16.52538-3.04847-25.08381Q126.86022,166.11377,126.8302,163.87126Z"
            class="cls-70"
          />
          <path
            id="path177"
            d="M135.12548,238.78177c.24219,3.1725.45095,6.348.7394,9.51634.16714,1.83578.46246,3.65993.7001,5.48931-1.40978,5.89244-2.07776,11.919-3.15957,17.87108-2.33469,12.84552-4.64078,25.69751-7.19173,38.50046-.51441,2.58184-.17639,5.96145-3.71371,7.12108-2.472-.27774-2.7291-2.367-3.07416-4.11057-2.55827-12.9267-6.68816-25.5495-7.55883-38.80281a4.79354,4.79354,0,0,0-.70607-2.47231l-.14645-.25911q3.47561-11.92448,6.953-23.84769c1.00213-3.25088,2.00344-6.50136,3.195-10.36936,4.59527,3.23888,8.6817,6.11914,12.76813,8.99938l1.19491-.236Z"
            class="cls-12"
          />
          <path
            id="path179"
            d="M126.89025,168.35631c1.72193,8.65095,3.47177,17.29656,5.14549,25.95682.39975,2.06844.54568,4.1859.80836,6.28082-.77392.94722-1.90609,1.77585-2.26536,2.86034-3.00754,9.07837-5.87311,18.20375-9.48334,27.37927a29.72066,29.72066,0,0,1-.19879-4.02379c.77984-9.536,1.62886-19.06631,2.456-28.59843.66587-7.67328,1.261-15.35378,2.04091-23.01546A58.81517,58.81517,0,0,1,126.89025,168.35631Z"
            class="cls-71"
          />
          <path
            id="path181"
            d="M264.74633,131.67416c.56441.3166,1.341.49228,1.65979.972,2.66644,4.01256,5.21181,8.10558,7.88255,12.11521a20.88506,20.88506,0,0,0,2.4743,2.62811c1.38149.87636,1.31666,2.22352,1.18679,3.59915-3.53276,6.30814-3.84461,13.59721-6.16591,20.27253-.60958,1.75291-.56463,4.14194-3.31886,4.29145-1.63129-.67069-2.41524-2.03338-3.03861-3.773,3.34261-6.92185.392-14.06344.25111-21.16843a30.511,30.511,0,0,0-1.23164-9.191c-.24516-1.971-.69312-3.90459-1.00358-5.86219C263.19713,134.01216,263.11972,132.57023,264.74633,131.67416Z"
            class="cls-26"
          />
          <path
            id="path183"
            d="M264.74636,131.67416q.765,4.85994,1.5301,9.7199c.87513,1.83657.238,3.35462-1.22162,5.0269a95.24906,95.24906,0,0,1-13.22251,2.56541,4.69543,4.69543,0,0,1-3.544-.84809q.00174-.74679.00361-1.49359c4.30548-4.73383,8.59073-9.48626,12.93431-14.18477a25.3613,25.3613,0,0,1,2.78261-2.28528Q264.3774,130.92461,264.74636,131.67416Z"
            class="cls-72"
          />
          <path
            id="path185"
            d="M275.99725,150.34677q.38292-1.47862.76576-2.95727c1.11707-5.20124,2.212-10.40733,3.3667-15.60018.29225-1.31433.77507-2.58628,1.17042-3.87776q-1.2413,16.42785-2.48276,32.85578c-.93319,1.91241-1.71108.83824-2.17068-.23553-.48452-1.13194-.21477-2.42528-.25521-3.64667A52.52211,52.52211,0,0,0,275.99725,150.34677Z"
            class="cls-64"
          />
          <path
            id="path187"
            d="M269.253,366.13546q-4.12532,6.744-8.25067,13.48788c-1.71357-.1747-2.17592-1.42045-2.43946-2.84127a138.585,138.585,0,0,1-2.23062-15.8607,11.07,11.07,0,0,0-1.56995-5.61051c-.13712-3.47,1.68692-6.43981,2.59785-9.62985,2.87535-10.06908,5.93294-20.08876,9.02657-30.09386.58348-1.88712.336-4.77351,3.56028-4.9073.49717,6.3171,1.11407,12.62766,1.46108,18.953.43022,7.8411.61119,15.69564.96449,23.54145a32.6866,32.6866,0,0,0,.67723,4.046Q271.15147,361.678,269.253,366.13546Z"
            class="cls-73"
          />
          <path
            id="path189"
            d="M269.947,310.67985c-3.64614,11.98547-7.25937,23.98114-10.96259,35.949-.875,2.82778-2.05239,5.56217-3.09067,8.33951a2.1554,2.1554,0,0,1,.21021,1.04685c-5.0347,8.5964-11.09156,16.48849-16.99424,24.47918q-11.66391,15.79005-23.589,31.38653c-1.27928,1.679-2.19447,4.10866-5.06563,3.77837a2.05222,2.05222,0,0,1-.9447-.68377,15.38176,15.38176,0,0,1,.94788-7.62912c6.38084-18.78443,12.39073-37.69074,18.57618-56.53934.62349-1.9,1.56984-3.65831,2.18036-5.55188a3.31736,3.31736,0,0,1,.38187-1.43266c17.20985-22.01943,33.98961-44.36855,51.04214-66.50851a23.79855,23.79855,0,0,1,2.12109-2.61669c1.85885-1.81018,3.47888-1.88408,4.57154.81617a3.50962,3.50962,0,0,1-.55038,2.49067c-5.01759,10.10274-10.26861,20.06775-17.31326,28.96016q-.6689,1.131-1.33785,2.26191Q270.03849,309.953,269.947,310.67985Z"
            class="cls-62"
          />
          <path
            id="path191"
            d="M317.42465,234.30843q-6.83664,16.11182-13.67324,32.22363l-3.74041,8.25133c-2.20589.4106-2.34752-1.28515-2.603-2.68107a105.25419,105.25419,0,0,1-1.67139-18.32937c-.01535-2.48105.78281-5.04227-.8787-7.32q-.04357-3.43989-.08711-6.87981a2.53224,2.53224,0,0,1,1.062-2.589,29.26441,29.26441,0,0,1,2.72667-1.2955c4.54071.98124,8.16172-1.94738,12.24832-2.8941a18.73623,18.73623,0,0,1,4.35756-.91557C316.75657,231.89157,317.89668,232.36092,317.42465,234.30843Z"
            class="cls-7"
          />
          <path
            id="path193"
            d="M294.85791,246.45292l.88031-3.12759.43252-.01347c.7728,7.71042,1.48659,15.42742,2.34951,23.12775.314,2.80173.98345,5.56368,1.49075,8.34378-1.47746,1.95438-2.81767,4.03294-4.45573,5.842-7.98548,8.81914-16.05054,17.5663-24.08745,26.33891q8.26692-15.72634,16.53389-31.45266c-.18662-3.61031,1.38537-6.47141,3.82212-8.96408Z"
            class="cls-74"
          />
          <path
            id="path195"
            d="M291.82383,266.54758q-1.911,4.48206-3.82209,8.9641c-.865.4262-2.021.62736-2.55126,1.31245-7.86681,10.1646-15.60182,20.43113-23.46664,30.5973-9.77176,12.63119-19.63457,25.192-29.458,37.78317-1.05286,1.4087-2.47974,1.39173-4.03606,1.15776-11.32128-1.70149-22.60658-3.62529-33.90881-5.44437-1.50556-.24234-2.70986-1.213-4.10854-1.71392a2.35874,2.35874,0,0,1-.88984-1.57129c1.695-4.66482,5.25109-8.11088,8.08368-12.00884q18.26525-25.13514,36.86994-50.02257c1.343-1.79564,2.64976-4.323,5.68226-2.35624,1.32206,2.33044.90379,4.83507.66444,7.298q-1.87892,19.33424-3.50744,38.69091c-.42639,5.16745-1.70913,10.20043-2.32537,15.33426.94843-8.96149,3.66263-17.53059,5.946-26.18561,3.562-13.50121,7.49918-26.90439,10.88194-40.45127.969-3.8804,3.0757-7.30718,3.85255-11.216a1.38654,1.38654,0,0,1,1.54657-.71356l.7503.041c9.17339,3.56284,18.33833,7.14789,27.5369,10.64455a6.32572,6.32572,0,0,0,2.47185-.15947Z"
            class="cls-75"
          />
          <path
            id="path197"
            d="M296.26666,238.06363q-.748.75457-1.496,1.50932-10.47135,1.4866-20.94236,2.9728c3.44372-4.0599,6.7829-8.21429,10.36487-12.14783,2.597-2.85183,5.51563-5.411,8.29087-8.10068,1.11565-.49283,2.03429-1.34813,3.34092-1.50769,3.50256-.42785,5.35686,1.11794,4.82906,4.5868C299.97456,229.84205,299.63169,234.49649,296.26666,238.06363Z"
            class="cls-72"
          />
          <path
            id="path199"
            d="M255.705,355.63017a3.41578,3.41578,0,0,1,.18845-.6619c.9439,3.41569,2.08826,6.79109,2.78235,10.25658.95408,4.76384,1.56732,9.59583,2.32656,14.39854q-.71136,1.5272-1.42267,3.05444a90.60928,90.60928,0,0,1-8.30857,14.04981c-4.613,6.17245-9.03043,12.4869-13.66208,18.64146-1.301,1.72875-2.61757,4.299-5.68873,2.68276-1.96386-2.673-.08286-5.06143.79522-7.34264,3.66284-9.516,7.55915-18.941,11.16028-28.48379,2.8605-7.58024,5.27932-15.35255,9.40771-22.40863A37.57732,37.57732,0,0,0,255.705,355.63017Z"
            class="cls-76"
          />
          <path
            id="path201"
            d="M232.5755,417.92829a46.08421,46.08421,0,0,0,3.83482-4.04348c7.76194-10.37312,15.45425-20.79828,23.16909-31.20694-2.74406,7.95036-5.47162,15.90662-8.23873,23.84911-1.75175,5.02791-3.56246,10.03537-5.34692,15.05162q-.36779.77142-.73513,1.54343a7.77355,7.77355,0,0,1-.98972.83455c-4.39714,1.21035-8.65892-.09014-12.94072-.76545-.87636-.13821-1.2175-1.1192-1.35551-2.01C229.81127,419.27346,230.55347,418.08845,232.5755,417.92829Z"
            class="cls-77"
          />
          <path
            id="path203"
            d="M296.26666,238.06361c.962-4.94017,1.92405-9.88034,3.00942-15.45387-2.69016-.12358-4.74084-.21777-6.79174-.31223q5.631-19.84707,11.26236-39.69375,4.49919-5.61808,8.99852-11.23605,1.4389-1.06356,2.8779-2.12709c-2.5828,4.9789-6.9955,9.29345-4.39671,15.65053,1.74475.69307,1.68182,2.29669,1.829,3.74625.68555,6.75213,1.51969,13.47711,1.10966,20.31652-.1735,2.8941,1.38953,5.74859,1.16616,8.761.0329.8633.05964,1.73.15652,2.59259.92107,8.19954.72314,8.804-6.48382,12.59278-3.33522,1.75335-6.57954,3.85577-10.44158,4.42145Z"
            class="cls-78"
          />
          <path
            id="path205"
            d="M150.08537,247.80075c-2.21926-5.5246-4.51225-11.02144-6.611-16.59139a15.02588,15.02588,0,0,1-.8832-5.08734c-.06523-8.31385-.01874-16.62908.06106-24.94311a21.6554,21.6554,0,0,1,.63913-3.61973c2.2077.81013,1.79318,2.79588,1.8345,4.43309.1506,5.96447.02654,11.93269.079,17.89906.01391,1.58093-.26369,3.27522,1.236,4.6053,2.29075.78146,4.26147-.60209,6.32133-1.28631,2.5924-.86108,5.06348-2.06281,7.67069-2.90519a4.36346,4.36346,0,0,1,3.91733.47929q1.47521.11049,2.95058.22163c1.1689.32983,2.33763.659,3.32025.93572.15863,1.20438.2954,2.24273.43216,3.28105,1.731,1.69874.98432,3.99928,1.363,6.00083,1.21181,6.405,2.29209,12.84545,2.01513,19.41377-1.35348,7.26808-2.79368,14.50741-7.10075,20.77007-2.02582,1.1063-3.34181-.04921-4.40332-1.53413-3.90608-5.46419-7.75717-10.96606-11.43789-16.58842C150.354,251.55064,150.7886,249.56245,150.08537,247.80075Z"
            class="cls-71"
          />
          <path
            id="path207"
            d="M173.35523,250.84478c-1.0174-6.93232-2.11939-13.85407-2.987-20.805-.19379-1.55237.435-3.20732.68509-4.816q3.75142-4.81982,7.503-9.63774c1.617-11.3594,6.5759-21.67864,10.1799-32.41559.6595-1.96481,1.49421-4.65955,4.74477-2.99076,1.31,1.37072.81977,2.99727.62168,4.567-1.1299,8.95445-2.8087,17.82813-3.9527,26.77722-.11211,3.32784-1.89774,6.19726-2.95824,9.18982-3.2894,9.28241-6.864,18.484-10.858,27.50408-.44945,1.01505-.754,2.14282-1.83594,2.74306A1.13185,1.13185,0,0,1,173.35523,250.84478Z"
            class="cls-3"
          />
          <path
            id="path209"
            d="M192.77033,180.34781c-1.973,4.4607-4.08408,8.86648-5.88751,13.39465-2.88282,7.23838-5.56143,14.55806-8.32648,21.84345.53265-11.77219,1.05242-23.54512,1.62211-35.31564a16.36513,16.36513,0,0,1,.66156-2.88613c3.73706-3.58809,7.842-6.0278,13.30271-4.25514a7.41775,7.41775,0,0,1,.81284,1.137C195.27118,176.6686,195.65068,179.09546,192.77033,180.34781Z"
            class="cls-79"
          />
          <path
            id="path211"
            d="M193.52405,173.58416q-6.34225,1.89981-12.68427,3.79979,2.04555-14.59153,4.096-29.18267c.85539-6.01346,1.76306-12.01946,2.64727-18.02882,2.89216,2.87,2.04159,6.56668,2.10338,10.00633.08821,4.90912-.71671,9.79239-.63639,14.70965l-.05031,5.30158c3.66473,2.83491,4.76762,6.91308,5.44266,11.2001A1.90842,1.90842,0,0,1,193.52405,173.58416Z"
            class="cls-44"
          />
          <path
            id="path213"
            d="M189.05005,154.88844a38.1438,38.1438,0,0,1-.68377-4.3443c-.30886-6.78849-.53066-13.5809-.78342-20.37179q.75-4.1188,1.49988-8.23772c1.49242-5.98126,2.96193-11.96849,4.49258-17.94.39608-1.54527.98384-3.04147,1.4835-4.56024-.85381,8.89018-1.724,17.77887-2.5504,26.67164-.21786,2.34428-.30064,4.70114-.44543,7.05223Q190.55653,144.02334,189.05005,154.88844Z"
            class="cls-80"
          />
          <path
            id="path215"
            d="M248.2883,148.13828c4.80143-.98683,9.591-2.03743,14.40955-2.93213,2.2336-.41471,3.64834-1.35414,3.57856-3.812,2.40126,7.78386,3.12257,28.30108,1.14249,29.9371.39128,1.30468.76919,2.56477,1.14713,3.82483a1.21828,1.21828,0,0,1-.159,1.99977q-3.42756,16.69131-6.86094,33.38147c-.61221,2.96176-1.29535,5.90886-1.94592,8.86271-2.69892.02981-2.57791-2.07832-2.42905-3.68155,1.03259-11.12045.85831-22.35881,3.294-33.34715a11.19862,11.19862,0,0,0-1.45362-8.21479c-3.24194-1.63355-2.56841,1.37925-2.75886,2.59122-.84685,5.39-1.54248,10.80828-2.20573,16.22383a140.70373,140.70373,0,0,1-2.75165,14.989c-.81458,3.47414.81463,6.61858.22362,9.92264a28.82629,28.82629,0,0,1-1.98566,6.78464c-6.01319,4.25731-10.10855,10.39137-15.09919,15.6425-2.97744,3.13283-6.21095,6.05375-8.86341,9.50305a1.78526,1.78526,0,0,1-2.3609.4436c-2.28834-2.53014-1.87773-5.82-2.07447-8.75981-.29037-4.339-1.38893-8.68836-.52741-13.06371.32939-1.67286-1.10312-2.63687-1.323-4.05833a2.48258,2.48258,0,0,1,1.67221-2.8098c2.875-.59638,5.80634-1.01331,8.59431-1.88715a4.3489,4.3489,0,0,0,2.29125-2.67549c3.258-11.32329,6.38787-22.68355,9.5119-34.04491a12.97687,12.97687,0,0,0,.185-2.59317q2.24358-10.12013,4.487-20.24034Q247.15729,154.13124,248.2883,148.13828Z"
            class="cls-81"
          />
          <path
            id="path217"
            d="M261.82092,172.17905c-.03194,2.8139.08825,5.63924-.12237,8.43972-.87385,11.62-1.87867,23.23025-2.74087,34.85109a16.77661,16.77661,0,0,0,.64243,3.93q-.44341,2.91929-.887,5.8383-4.815,10.554-9.62973,21.10822a1.02244,1.02244,0,0,1-1.27585-.26551c-.789-5.64555-2.33354-11.21387-1.73892-17.00307.47761-1.63309.57975-3.45177,2.22659-4.50592q.70444-3.42559,1.40886-6.85121c-1.0095-2.92924.96062-5.39424,1.36212-8.11038,1.64339-11.11707,4.85245-21.90591,7.508-32.80959C259.039,174.89227,259.57849,172.90218,261.82092,172.17905Z"
            class="cls-82"
          />
          <path
            id="path219"
            d="M268.407,177.15581q.07926-1.00011.15874-2,3.71614-12.40386,7.43163-24.80861.71994,3.03367,1.44015,6.06829a2.72247,2.72247,0,0,0-.65929,2.41064,49.59286,49.59286,0,0,1-2.21527,16.35225q-2.724,16.708-5.44856,33.41492-.79341,3.803-1.58565,7.60813l-.63971-.04749c.402-6.8489.786-13.69894,1.21178-20.54636.31649-5.09033.73881-10.17477.99091-15.26791A12.46891,12.46891,0,0,0,268.407,177.15581Z"
            class="cls-83"
          />
          <path
            id="path221"
            d="M313.44047,218.61633a13.193,13.193,0,0,1-.62825-2.50572c-.55569-10.40527-1.06446-20.813-1.58558-31.21981-.00023-1.57739-.00023-3.15514-.00023-5.85048,6.83422,4.02842,12.89312,7.59981,18.952,11.17123.577,2.28688-1.24749,3.80216-2.2559,5.21605-3.452,4.84-6.6658,9.92024-11.07017,14.00978a3.54563,3.54563,0,0,0-.98077,2.23122C314.81563,213.90116,316.36349,217.04441,313.44047,218.61633Z"
            class="cls-6"
          />
          <path
            id="path223"
            d="M329.33244,166.16105q.357,8.17835.71435,16.35623-.0969,1.84568-.19447,3.69233l-.70578.2456c-2.787-6.95732-5.574-13.91463-8.805-21.98026C323.9776,165.15682,326.655,165.65894,329.33244,166.16105Z"
            class="cls-3"
          />
          <path
            id="path225"
            d="M314.1166,210.27621q8.02995-10.0329,16.06086-20.06524.26433-.07491.52746-.14813-.99892,3.79715-1.99783,7.5943c-2.3348,2.27037-2.205,5.56123-3.41053,8.30226-.521,1.1846-.73515,2.50341-1.68484,3.4874a10.808,10.808,0,0,1-6.12039,3.02679C315.78524,212.73693,314.26258,212.50718,314.1166,210.27621Z"
            class="cls-84"
          />
          <path
            id="path227"
            d="M244.56447,423.14343q.34744-.00521.69437-.02131-1.14792,21.75209-2.32428,43.5028a7.47667,7.47667,0,0,1-.76015,2.05328c-1.83173-1.287-3.69393-.87174-5.68478-.32206-3.18724.88006-6.26387,2.40634-9.50372,2.13029a4.2877,4.2877,0,0,1-2.18054-3.13923,2.70254,2.70254,0,0,1,.12817-1.14953c4.5024-6.24955,5.61823-13.93488,8.76516-20.77079,2.69432-5.85272,5.11555-11.83972,7.66287-17.765A12.27736,12.27736,0,0,1,244.56447,423.14343Z"
            class="cls-8"
          />
          <path
            id="path229"
            d="M226.50823,467.32813c1.0125.38453,2.14982,1.27854,3.01615,1.06642,4.018-.98374,7.96078-2.27426,12.477-3.61747.0716,1.60495.12289,2.75406.17358,3.90212q-.26264.84758-.524,1.6971-1.51844,10.51612-3.03716,21.03212c-1.97034.27962-2.98023-.99293-3.82579-2.43721-1.763-3.01141-3.78822-5.89786-5.032-9.17288a20.69466,20.69466,0,0,0-4.73406-7.35673,3.438,3.438,0,0,1-.47075-2.39619C224.7361,468.80323,224.559,467.29822,226.50823,467.32813Z"
            class="cls-54"
          />
          <path
            id="path231"
            d="M218.9476,141.30264l.28982,2.90761.30487.01939c1.56346-9.83563,3.09777-19.67606,4.71521-29.5028.32-1.94409.95966-3.83559,1.45182-5.75313q.00725,6.30909.01515,12.62461a54.66657,54.66657,0,0,0-.59938,5.47347c-.08506,6.83593-.45019,13.70155.04023,20.502.47849,6.63507-2.91015,10.11076-8.263,12.606Q217.925,150.74122,218.9476,141.30264Z"
            class="cls-85"
          />
          <path
            id="path233"
            d="M217.49521,178.83914l.04783,23.25939c1.84012,2.31652,1.19879,4.79427.468,7.275-2.21325.98653-2.63941-.65967-2.83931-2.123-1.643-12.02615-3.639-24.00892-4.3631-36.15-.15814-2.65193.03315-5.49259-2.02267-7.6865a3.11188,3.11188,0,0,1,.37643-3.02665c3.11332-1.68324,3.92385,1.02677,4.79708,2.82591a21.14621,21.14621,0,0,1,1.60727,7.31319c.31869-1.76424-1.82255-4.33451,1.28834-5.937Q217.17517,171.71436,217.49521,178.83914Z"
            class="cls-40"
          />
          <path
            id="path235"
            d="M216.85508,164.58958v11.131l-.89734.21755c-1.19295-3.85085-2.31519-7.72578-3.6148-11.54032a31.58568,31.58568,0,0,0-2.11822-4.16582.50332.50332,0,0,1-.25953-.5229q.06711-.29615.16189-.29619l6.55032,1.472Q216.76622,162.73724,216.85508,164.58958Z"
            class="cls-86"
          />
          <path
            id="path237"
            d="M164.35025,220.78442l-21.05831,8.021c0-10.87107,0-21.05842-.00032-31.246q.05691-5.58556.11444-11.17065c.90292-3.5119-.31842-7.165.74433-10.67648,1.35534-4.47823,4.84512-7.43628,7.67727-10.85451a2.03822,2.03822,0,0,1,2.73764-.23343q.80713,13.80549,1.61443,27.61076c.29282,2.58118.18493,5.28914.954,7.71986C159.34963,206.95807,161.91946,213.84927,164.35025,220.78442Z"
            class="cls-39"
          />
          <path
            id="path239"
            d="M154.5653,164.62436c-3.166,3.77091-6.53439,7.39716-9.38962,11.39006-1.0197,1.426-.82507,3.73508-1.133,5.64939-.25229,1.56854-.42781,3.14938-.637,4.72487q-.04281-4.88314-.08652-9.76641.00477-14.61238.00993-29.22495c-.80812-4.93031-.14933-9.87448-.38547-14.94168,2.566-.65312,3.14422.919,3.75546,2.62226a143.2176,143.2176,0,0,1,5.88876,19.09784c.1384.66513-.16021,1.90215,1.30315,1.33674Z"
            class="cls-71"
          />
          <path
            id="path241"
            d="M153.891,155.51248l-.19789,4.44514-.45546.12426q-4.49321-13.17453-8.98639-26.34907l-.922.10094q0,6.78178-.00006,13.56354-.29516-7.722-.59015-15.44406-.07707-2.01754-.15392-4.035c1.225-6.566,2.40509-13.141,3.715-19.69007a17.9845,17.9845,0,0,1,1.53622-3.54585q2.58354,21.80422,5.18294,43.60655c.14642,1.218.517,2.4091.78345,3.61271Z"
            class="cls-87"
          />
          <path
            id="path243"
            d="M248.399,246.39065q.3418-.0249.68416-.04445c.89154.27463,1.93694.99261,2.64718.74606,2.9412-1.02113,5.75665-2.39864,8.67374-3.49824a9.20483,9.20483,0,0,1,2.75557-.15614q-2.94147,6.28311-5.88243,12.56428-.35732.41706-.71459.83472c-3.17344,6.43491-9.055,10.05728-13.86448,13.98066-2.28248.173-2.8586-.9011-3.34193-2.09082.23565-3.88957,2.13792-7.27581,3.34167-10.86888,1.01617-3.03321,2.50274-5.90462,3.16924-9.0662A3.04545,3.04545,0,0,1,248.399,246.39065Z"
            class="cls-88"
          />
          <path
            id="path245"
            d="M217.43157,209.61915q.05579-3.76036.11152-7.52067-.00008-8.15257-.00005-16.30525l.59543-.0113q1.2562,15.73647,2.51252,31.47308.15284,2.15525.30574,4.3103-.24493,1.45389-.4904,2.90772c.86358,6.37014-1.82678,11.96023-3.884,17.69333-.79067.81617-1.59143,1.60689-3.00359,1.13391-1.75458-2.23107-.92989-4.80662-.617-7.25026.91548-7.15017,2.1565-14.25589,3.0239-21.41544C216.019,212.83263,215.48823,210.86894,217.43157,209.61915Z"
            class="cls-65"
          />
          <path
            id="path247"
            d="M274.563,175.17841c.50909-6.72233,1.0182-13.44469,1.58578-20.93944.657,1.10841.9735,1.64235,1.2894,2.17643q.68937,2.17644,1.37962,4.35228-.62789,3.444-1.25472,6.889Q276.06326,171.41769,274.563,175.17841Z"
            class="cls-89"
          />
          <path
            id="path249"
            d="M86.39711,251.554q.79971-1.1867,1.59964-2.37355,4.06405,9.416,8.12771,18.83231c.69543,2.8442-1.18445,2.51565-2.74784,2.026a33.78637,33.78637,0,0,1-6.35343-3.00651,8.3094,8.3094,0,0,0-5.24128-1.2267c-2.89747-1.73662-2.847-4.3647-1.39177-6.72588C82.0629,256.36554,83.802,253.58565,86.39711,251.554Z"
            class="cls-90"
          />
          <path
            id="path251"
            d="M82.64051,264.97077c1.19681-.103,2.535-.59882,3.5617-.22941,2.3171.83371,4.4336,2.21191,6.72843,3.126a9.823,9.823,0,0,0,3.19377.14544q.7088,1.54437,1.41734,3.08908-2.22358,4.82-4.44694,9.63959a1.43017,1.43017,0,0,1-1.09825,1.22171c-2.89792-1.25089-10.31806-13.17622-9.96984-16.07363C82.06863,265.54079,82.39692,265.25349,82.64051,264.97077Z"
            class="cls-47"
          />
          <path
            id="path253"
            d="M92.36263,281.48747q.36621-.37284.7323-.74585,4.8723-1.88945,9.74472-3.77923c-.15014,1.13669.02412,2.45976-.50376,3.38068-3.01193,5.25425-6.1911,10.4127-9.31476,15.60575-2.93359,4.50965-5.82927,9.04187-8.83107,13.50275a11.92085,11.92085,0,0,1-2.32663,2.0363c-1.66523-1.0859-1.09064-2.60055-.68986-4.00595,2.20879-7.74582,5.47414-15.12454,7.96958-22.77274C89.65424,283.14275,90.49983,281.7713,92.36263,281.48747Z"
            class="cls-79"
          />
          <path
            id="path255"
            d="M314.1166,210.27621c3.50371,1.221,6.39442-.08589,9.089-2.202,1.18053,1.00052.49692,2.08751.34237,3.28832-.54091,4.20266-2.41914,8.1081-2.62732,12.36717q-.37248,1.89561-.74545,3.791-1.3762,3.3939-2.7511,6.788c-1.33522-.11358-2.75345-.57181-3.99147-.2761-3.82256.913-7.56,2.17674-11.36713,3.16292a15.8381,15.8381,0,0,1-3.50341.1263c5.09773-3.212,10.19515-6.42406,15.56843-9.80993-.23854-3.07779-.464-5.98684-.68972-8.89568Q313.7784,214.44638,314.1166,210.27621Z"
            class="cls-91"
          />
          <path
            id="path257"
            d="M320.9206,223.72965q1.14256-7.82772,2.28507-15.65547c1.21377-2.919,2.36575-5.86639,3.68632-8.73632.31844-.692,1.19511-1.12734,1.8151-1.68072Z"
            class="cls-92"
          />
          <path
            id="path259"
            d="M156.83131,439.62268c-1.69661-4.38745-3.13779-8.89536-5.13971-13.13888-5.16106-10.94008-10.73015-21.68932-15.81-32.66562a159.35281,159.35281,0,0,1-6.02269-16.10666q-9.80182-29.07277-19.37874-58.22074c-.25131-.76353.39023-1.82076.61574-2.74111,2.5312.1548,4.42755,1.70414,6.094,3.27428,8.25343,7.77657,16.81566,15.21553,24.69162,23.41271,4.01519,4.179,7.87063,8.65141,12.78321,11.919,2.25281,1.25984,3.31964,3.89371,5.757,4.94783a2.62851,2.62851,0,0,1,.978,1.44753c3.37093,13.55364,6.27215,27.21421,9.405,40.821a17.21959,17.21959,0,0,1,.3084,7.88578q-1.78129,20.5902-3.55843,41.1807c-.10644,1.23729-.15448,2.47966-.22965,3.71964-.46058,1.56059-.92116,3.12121-1.39378,4.72259-2.87065-2.72616-5.49672-5.47212-5.81728-10.17943C159.87661,446.41679,157.9856,443.04478,156.83131,439.62268Z"
            class="cls-72"
          />
          <path
            id="path261"
            d="M171.113,410.45777c-1.608-6.39924-3.32532-12.77342-4.7986-19.20349-2.25569-9.84484-4.34316-19.7281-6.502-29.59508-1.19412-4.38137-.78435-8.89627-.56536-13.28459.85026-17.03913,2.19137-34.052,3.33222-51.07558.4829-7.20569.903-14.41756,1.461-21.61914.15085-1.947.55531-3.70987,2.48292-4.69407q3.41569-10.071,6.83173-20.14152.35364-.03632.70738-.06508c1.96336-.297,2.22023,1.19588,2.54718,2.50911,2.94656,11.83466,4.97145,23.86962,7.75487,35.74011a3.08008,3.08008,0,0,1-.97933,3.36609c-1.62254.96339-2.80083.23227-3.88755-1.00351-3.07283-3.49443-6.20223-6.944-8.15116-11.21991,5.30188,14.15859,11.07477,28.15261,15.05509,42.77154a15.21882,15.21882,0,0,0,3.12194,6.51088c.328,2.50581,1.81011,4.86248,1.0139,7.521q.03507.74.0701,1.48a2.85211,2.85211,0,0,1,1.04656,2.20621c-4.50553,21.77315-11.20882,42.98358-16.59278,64.53286-.51364,2.05584-1.04807,4.16592-3.23468,5.21643Q171.46957,410.43171,171.113,410.45777Z"
            class="cls-62"
          />
          <path
            id="path263"
            d="M171.82641,410.41c4.2608-16.15656,8.48737-32.32225,12.79816-48.46545,1.89561-7.09888,3.96262-14.152,5.95183-21.22589,2.56738-.4337,2.7759,1.65881,3.23384,3.21912,1.4388,4.90214,2.51712,9.89813,3.66569,14.87637,3.13673,13.59517,6.354,27.1731,9.82,40.68755,1.30323,5.08155,1.98458,10.24031,2.77551,15.39572q.37056-.00165.7411.00279c.23846,1.22059-.27809,1.70949-1.48413,1.53026Q190.57742,413.42029,171.82641,410.41Z"
            class="cls-93"
          />
          <path
            id="path265"
            d="M209.32845,416.4305q.74195-.76518,1.484-1.53031,21.09948-28.093,42.20915-56.17849c.81823-1.08769,1.786-2.06306,2.68375-3.09111-2.53348,6.88608-4.99293,13.80074-7.61567,20.65293-4.8115,12.5706-9.73457,25.09852-14.56331,37.66252a29.8769,29.8769,0,0,0-.9512,3.982q-.75159,1.50245-1.50372,3.00427c-.89223,1.07388.07526,1.79758.49561,2.62587a4.94227,4.94227,0,0,1-.56369,4.62819c-2.55581,3.18766-2.76161,7.06989-3.67142,10.81491-2.26811,9.336-5.0549,18.54108-7.621,27.80212a8.37519,8.37519,0,0,1-2.35956,3.29564q-.27866.12691-.55728.25438c-1.09365-7.3673-2.2522-14.72572-3.2655-22.104C212.07305,437.65068,210.72333,427.0375,209.32845,416.4305Z"
            class="cls-94"
          />
          <path
            id="path267"
            d="M225.81869,470.33505l.72562,1.5078a60.27465,60.27465,0,0,1,5.0853,17.17409c.22858,1.692.69411,3.49225-1.32467,4.54766q-6.75534-11.60572-13.51078-23.2113l.031-.03833c1.73766-2.08337,4.24618-1.75884,6.298-2.11785C224.65031,468.38778,225.20218,469.39887,225.81869,470.33505Z"
            class="cls-95"
          />
          <path
            id="path269"
            d="M230.30494,493.5646q-1.88032-10.86085-3.76063-21.72175,3.89145,6.30081,7.78241,12.60192,2.14706,3.47944,4.287,6.96356a1.8285,1.8285,0,0,1-.08661.665c-2.14779,2.49753-4.40064,4.80513-8.10879,4.48188l-.24862-.01179Q230.23642,495.05384,230.30494,493.5646Z"
            class="cls-60"
          />
          <path
            id="path271"
            d="M230.41827,496.55523q4.05441-2.24091,8.10881-4.48188.107.65554.21435,1.31064c-2.05426,6.358-4.185,12.69307-6.144,19.08074-2.43,7.92333-4.7178,15.89024-7.22643,24.37747-.15343-.98817-.23583-1.51892-.31816-2.04961,1.35306-9.17741,2.73019-18.35138,4.04681-27.53408C229.60977,503.70086,229.98282,500.12359,230.41827,496.55523Z"
            class="cls-96"
          />
          <path
            id="path273"
            d="M92.36263,281.48747q-5.24952,15.00024-10.49912,30.00043c-1.14586-.72326-2.68591-1.18463-3.37026-2.21428-3.23971-4.87434-6.18337-9.94418-9.36419-14.85922a5.7907,5.7907,0,0,1-.36257-6.27942c2.817-5.83065,5.43938-11.75552,8.11737-17.65281a3.88463,3.88463,0,0,0,.2397-3.06639Q70.6591,278.10186,64.19464,288.788l-.70352-.20171a18.01748,18.01748,0,0,1,.70013-2.40259c2.27407-5.12278,4.64753-10.20251,6.84424-15.35774a11.87682,11.87682,0,0,0,.35756-3.49568c2.59418-2.68221,3.35-5.8237,3.05362-9.55121-.32507-4.08791-.04073-8.22425-.02171-12.34043.35126,4.99889.7023,9.99867,1.07777,15.34651,3.87946-3.28725,7.38682-6.25918,10.89427-9.23114-1.84677,3.34071-3.69366,6.68142-5.64213,10.20591.67692,1.15287,1.28123,2.18209,1.88559,3.21108Q87.50159,273.229,92.36263,281.48747Z"
            class="cls-97"
          />
          <path
            id="path275"
            d="M111.16091,271.89435a37.607,37.607,0,0,1,2.13946,5.36984c3.07879,13.1422,6.04617,26.31046,9.049,39.47043,1.01472,1.06153.7526,2.04248-.18749,2.98113-2.55156,1.67528-4.75852-.08937-6.78667-1.05353a12.43992,12.43992,0,0,1-4.2661-2.69827c-.75005-1.56668-2.20236-3.164-2.13552-4.695.4163-9.5355,1.20458-19.05414,1.80007-28.58274C110.99815,279.09487,111.0373,275.492,111.16091,271.89435Z"
            class="cls-62"
          />
          <path
            id="path277"
            d="M111.10916,315.964l10.49717,3.07758a4.75679,4.75679,0,0,1,4.61385,1.67895c9.367,10.64779,18.60338,21.41029,28.0926,31.95134,1.13245,1.25792,2.3294,2.86931-.4822,3.78834-4.31741-3.95865-8.66067-7.88958-12.947-11.88152q-14.9157-13.8911-29.78762-27.82911Q111.10247,316.35686,111.10916,315.964Z"
            class="cls-98"
          />
          <path
            id="path279"
            d="M210.12708,159.41293q.04877.40951.09757.81907-.00048,1.44024-.00108,2.88044c1.44219,14.80864-2.21838,29.17765-3.77669,43.72756a3.01652,3.01652,0,0,1-.94,1.97791,1.90323,1.90323,0,0,1-1.15253.43818c-2.50029-.71057-1.92273-2.87123-2.11207-4.62682-1.15134-10.67467-.71336-21.39063-.80308-32.09335-.0185-2.20861.155-4.46653-1.12928-6.90383-1.397,2.48427-2.48448,4.82974-3.94961,6.94195-.684.986-1.07142,2.39351-2.77238,1.81127q-.03158-.40022-.06353-.8008-2.26221-6.69814-4.52417-13.395a100.15212,100.15212,0,0,1,10.29906-1.79106,106.33087,106.33087,0,0,1,10.683.20386Q210.05439,159.00742,210.12708,159.41293Z"
            class="cls-80"
          />
          <path
            id="path281"
            d="M153.83057,356.46016c-.25308-.87453-.25349-1.97-.79677-2.59075q-14.10887-16.11884-28.354-32.11832a32.47611,32.47611,0,0,0-3.07376-2.7102q.3719-1.15249.74331-2.30627c1.71818-7.74945,3.60966-15.46547,5.114-23.25617,2.26137-11.71154,4.18-23.48922,6.44047-35.201.31034-1.60792,1.74668-2.99869,2.66144-4.49q1.87966,8.98557,3.75991,17.97118c1.87508.55485,2.25,2.15945,2.58762,3.75708,5.0191,23.74892,10.47766,47.40229,15.51509,71.14529.97714,4.60551,2.23758,9.45281.64582,14.29Q156.45214,358.70556,153.83057,356.46016Z"
            class="cls-10"
          />
          <path
            id="path283"
            d="M159.07371,360.951c-1.48526-7.69192-2.8472-15.41008-4.47915-23.07076-4.69792-22.05281-9.50491-44.08246-14.26921-66.12139q4.87985-11.97929,9.76-23.95813c4.43738,6.529,8.84988,13.075,13.33308,19.57235a43.15612,43.15612,0,0,0,3.10522,3.61324q-1.10289,15.05007-2.20509,30.10111-1.41782,19.32645-2.84111,38.6525-.81275,10.96149-1.66488,21.91968Q159.443,361.30488,159.07371,360.951Z"
            class="cls-12"
          />
          <path
            id="path285"
            d="M210.07145,414.89745c-.90254-2.10619-2.125-4.13486-2.65791-6.33064-5.11891-21.09-10.10955-42.21109-15.18181-63.31245a40.88554,40.88554,0,0,0-1.65547-4.53572q.01521-1.13191.03057-2.264,20.96013,3.375,41.91912,6.75007c-2.95843,9.50728-5.83112,19.04237-8.89528,28.51549C219.18345,387.46938,214.598,401.1739,210.07145,414.89745Z"
            class="cls-78"
          />
          <path
            id="path287"
            d="M190.53719,336.97449q-1.48-3.3856-2.96-6.77125a17.00789,17.00789,0,0,0-.98423-6.06588c-.35078-1.27054-.71138-2.688.21991-3.955,3.00654-2.22953,3.63484-5.56645,4.01239-8.93405,2.31979-20.69163,4.68977-41.37775,6.91845-62.07955.15759-1.46374.02532-3.05339,1.49343-4.04083,1.65354-.88912,2.838.25794,4.06278,1.01653,8.55712,5.29982,17.1185,10.60243,25.16008,16.67115,2.78148,2.09908,6.062,3.36717,8.74745,5.58485,1.03325.85324,2.40631,1.34843,2.91579,2.75937a1.97269,1.97269,0,0,1-.82684,2.11959c-3.69958,4.67045-7.52083,9.25041-11.07628,14.02806-11.30859,15.19589-22.50053,30.47846-33.794,45.68567A39.96206,39.96206,0,0,1,190.53719,336.97449Z"
            class="cls-78"
          />
          <path
            id="path289"
            d="M239.29636,273.27943l.01179-2.27271a1.41759,1.41759,0,0,1-.42273-.94025c.25973-.94911.67725-1.67306,1.86114-1.30351.85367-.19478,1.92371-.128,2.52648-.62612,4.4818-3.70379,8.87091-7.51975,13.28933-11.30026-2.10334,8.33537-4.10837,16.69681-6.33039,25.00021-5.09544,19.04122-10.29593,38.05435-15.46029,57.07709a2.10462,2.10462,0,0,1-1.038,1.34966,14.21226,14.21226,0,0,1-.13277-2.19821c1.13693-12.53276,2.33395-25.06018,3.44635-37.5951C237.85122,291.41144,238.55044,282.34336,239.29636,273.27943Z"
            class="cls-99"
          />
          <path
            id="path291"
            d="M230.30089,423.13593q.385-1.102.77031-2.20383,6.74662,1.10578,13.493,2.21124c-2.1241,5.52522-4.18116,11.07738-6.38909,16.56893-3.14132,7.81325-6.37218,15.59087-9.62013,23.36053a32.90906,32.90906,0,0,1-1.9996,3.53474c-1.85533-.85408-1.8543-2.61941-1.72354-4.16591.96167-11.37428,1.48032-22.824,4.78983-33.85727C230.16818,426.76223,229.36843,424.85594,230.30089,423.13593Z"
            class="cls-54"
          />
          <path
            id="path293"
            d="M200.28589,245.5389c-.74341,6.13945-1.5129,12.27591-2.22522,18.41895-1.98651,17.13171-3.93149,34.26821-5.94,51.39734-.31572,2.69254-1.01758,5.23065-4.56782,5.14087-2.00357.25131-2.16918-1.35611-2.36484-2.59467-1.15886-7.33549-2.5504-14.633-3.58928-21.98762a4.86583,4.86583,0,0,1,.70841-3.89707,13.88719,13.88719,0,0,0,.089-3.246q-3.81237-18.3219-7.76032-36.61556a7.94293,7.94293,0,0,0-.57353-1.3757c1.42343-4.19875,2.75169-8.43251,4.29017-12.58847,3.261-8.809,6.63151-17.57749,9.95713-26.36258,1.54737.31259,1.67163,1.68939,2.05973,2.82547,2.94724,8.627,6.95,16.90464,8.59356,25.96481.2432,1.34051,1.53846,2.12434,1.96009,3.39175A1.65139,1.65139,0,0,1,200.28589,245.5389Z"
            class="cls-93"
          />
          <path
            id="path295"
            d="M200.28562,244.04354c-.61991-.47209-1.58352-.819-1.80808-1.43507q-5.05533-13.86879-9.90659-27.81145a12.00754,12.00754,0,0,1-.26127-2.96858q2.07047-14.25423,4.13628-28.50906c.14232-.98552.21836-1.98062.32478-2.97141q.408-2.98159.817-5.96278,3.79682-7.4298,7.59314-14.85983l1.40742.23016q.78024,24.607,1.5605,49.21388c2.04027,1.83307.90853,4.45578,1.653,6.61253-1.94574,5.27677-1.28606,10.895-2.09208,16.32567-.45574,3.07061-.76626,6.16042-1.49471,9.185C201.92472,242.298,201.71385,243.57348,200.28562,244.04354Z"
            class="cls-62"
          />
          <path
            id="path297"
            d="M240.74658,268.763q-.70814.82468-1.41624,1.64935c-2.38893-.30749-2.97353-2.88524-4.84545-3.84787-2.97549-4.46037-7.08634-8.015-9.97589-12.539-.79874-1.25057-1.90273-2.50114-.254-3.919.49614-1.11516.74826-2.45128,1.527-3.31053q9.29324-10.25362,18.80371-20.3084c.90553-.95275,2.45686-1.29224,3.70941-1.91559q-.0044,2.24689-.009,4.49376c-.835,4.9095-.13554,9.85881-.38963,14.78226-.09468,1.83442.394,3.708-.34225,5.50206Q244.15037,259.05649,240.74658,268.763Z"
            class="cls-22"
          />
          <path
            id="path299"
            d="M224.255,250.10643l11.23228,15.74421c.5668.56457.485,1.04825-.49557,1.65836a156.62267,156.62267,0,0,1-17.6355-13.281c-1.42778-1.1981-2.87553-2.38288-4.2465-3.64811-1.20057-1.10793-2.39762-2.26581-1.79634-4.17143,1.16937-1.90192,3.92756-2.64013,3.961-5.38609l5.192-16.5493c.7731,4.60729,1.61053,9.205,2.29966,13.82478C223.35124,242.22076,223.76523,246.16926,224.255,250.10643Z"
            class="cls-100"
          />
          <path
            id="path301"
            d="M261.82089,172.17905q-5.90222,21.66981-11.793,43.34269a18.15366,18.15366,0,0,0-.32338,2.2c.261-3.92.35795-7.85814.81563-11.754,1.21958-10.38112,2.57566-20.74644,3.929-31.11133a43.27875,43.27875,0,0,1,1.03527-4.38672C258.05889,170.00529,260.57786,168.59552,261.82089,172.17905Z"
            class="cls-62"
          />
          <path
            id="path303"
            d="M247.55417,249.35c-.00558-5.44308-.05888-10.88683.01762-16.32876a23.674,23.674,0,0,1,.71422-3.95554q.056,8.66208.11241,17.3246Q247.97691,247.87052,247.55417,249.35Z"
            class="cls-81"
          />
          <path
            id="path305"
            d="M230.30089,423.13593c-1.10959,11.88522-2.23716,23.76884-3.31471,35.657-.23535,2.59651-.292,5.20925-.43094,7.81458q-.02876.36007-.04676.72067-.34537,1.50347-.69,3.00692-4.4968-.00973-8.99369-.01975,6.0356-20.91249,12.06483-41.82592C229.39988,426.7164,229.83238,424.921,230.30089,423.13593Z"
            class="cls-101"
          />
          <path
            id="path307"
            d="M204.74825,208.73225q2.126-18.4118,4.26137-36.82252c.34479-2.93947.80607-5.86526,1.21384-8.79731.93244,4.57532,2.07689,9.11946,2.75467,13.73215,1.60275,10.90754,2.98368,21.84764,4.45387,32.7746q-.0137,2.63891-.02656,5.27789a2.82785,2.82785,0,0,1-3.27963,1.82255c-1.36357-.12861-2.7237-.23135-4.075-.48282C204.52345,215.20812,203.96444,214.43258,204.74825,208.73225Z"
            class="cls-102"
          />
          <path
            id="path309"
            d="M204.74827,208.73225c.13026,1.32455.26052,2.64907.4834,4.9154,4.08767.41952,8.13078.83444,12.17384,1.24941q-1.55605,12.54453-3.114,25.0888c-.07486.60179-.17707,1.20015-.26855,1.81344.24915.011.40688.0662.46727.01235.27626-.24642.52524-.52334.784-.7893-.50417,1.99958.82442,5.03335-2.93457,5.19634-1.5551.01754-2.18718-.99448-2.44028-2.30435-1.83081-9.47632-5.66162-18.54478-5.79476-28.36687q.02165-3.28956.04369-6.57859Q204.44817,208.84964,204.74827,208.73225Z"
            class="cls-73"
          />
          <path
            id="path311"
            d="M182.30718,292.0167q2.25174,12.43854,4.50738,24.87639c.2194,1.20573.4911,2.402.73847,3.60279q.01183,4.85413.02406,9.70759-9.66507-27.05217-19.33034-54.10385l.77391-.52944Q175.66389,283.79345,182.30718,292.0167Z"
            class="cls-92"
          />
          <path
            id="path313"
            d="M204.10467,215.54747q3.74751,13.89526,7.49349,27.791c.258.95763.49454,1.921.74131,2.881,1.614,1.78339,3.10127,3.70518,4.866,5.325,4.63519,4.2545,9.334,8.44513,14.14212,12.50185,1.10256.93021,2.74643,1.21934,4.14044,1.80393q1.92011,2.2803,3.842,4.56087c-.00856.19952-.01613.3978-.02213.59592-4.67378-2.85938-9.38487-5.66-14.01347-8.59089q-11.3832-7.2078-22.665-14.575a16.18667,16.18667,0,0,1-2.3433-2.30205q-.00032-.74778-.00035-1.49541Q202.195,229.79546,204.10467,215.54747Z"
            class="cls-5"
          />
        </g>
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="235.23436"
          cx="66.013519"
          id="p32"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p33"
          cx="78.401917"
          cy="304.60938"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="360.77008"
          cx="104.00459"
          id="p34"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p35"
          cx="144.47334"
          cy="419.40848"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="455.74777"
          cx="192.37512"
          id="p38"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p36"
          cx="118.04476"
          cy="459.05133"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="461.52902"
          cx="246.05815"
          id="p37"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p20"
          cx="136.2144"
          cy="114.65401"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="175.77008"
          cx="141.99565"
          id="p21"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p22"
          cx="147.7769"
          cy="251.75223"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="104.7433"
          cx="208.89297"
          id="p23"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p24"
          cx="203.93761"
          cy="165.03348"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="230.27901"
          cx="196.50458"
          id="p25"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p26"
          cx="267.53137"
          cy="129.52008"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="178.24776"
          cx="257.62067"
          id="p27"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p28"
          cx="241.92871"
          cy="241.01561"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="195.59151"
          cx="316.25906"
          id="p29"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p30"
          cx="299.74118"
          cy="237.71205"
          r="16"
          fill="#ff0000"
        />
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="282.31027"
          cx="282.39743"
          id="p31"
          class="pa"
        />
      </svg>
    </div>
    <div class="flex-1 z-20" v-if="face==3" id="right-side">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        inkscape:version="1.0beta2 (2b71d25, 2019-12-03)"
        sodipodi:docname="right-side.svg"
        id="right-side-svg"
        :style="trans"
        version="1.1"
        viewBox="0 50 384 555"
      >
        <metadata id="metadata1069">
          <rdf:RDF>
            <cc:Work rdf:about>
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <sodipodi:namedview
          inkscape:current-layer="svg1065"
          inkscape:window-maximized="0"
          inkscape:window-y="82"
          inkscape:window-x="31"
          inkscape:cy="277.5"
          inkscape:cx="192"
          inkscape:zoom="0.98018018"
          showgrid="false"
          id="namedview1067"
          inkscape:window-height="783"
          inkscape:window-width="932"
          inkscape:pageshadow="2"
          inkscape:pageopacity="0"
          guidetolerance="10"
          gridtolerance="10"
          objecttolerance="10"
          borderopacity="1"
          inkscape:document-rotation="0"
          borderColor="#666666"
          pagecolor="#ffffff"
        />
        <defs id="defs735">
          <mask
            maskUnits="userSpaceOnUse"
            height="359.04"
            width="781.92"
            y="-1122.64604"
            x="-1343.83276"
            id="mask"
          />
        </defs>
        <filter id="f1" x="-40%" y="-40%" height="180%" width="180%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>

        <g data-name="Layer 3" id="Layer_3">
          <polygon
            id="polygon737"
            points="68.232 200.453 76.383 199.23 98.467 230.573 72.272 226.189 62.702 212.407 68.232 200.453"
            class="cls-2"
          />
          <polygon
            id="polygon739"
            points="183.161 67.668 192.743 75.543 181.885 106.111 172.741 102.324 167.72 86.172 177.67 69.949 183.161 67.668"
            class="cls-2"
          />
          <polygon
            id="polygon741"
            points="219.09 600.724 250.008 612.921 280.179 530.702 224.081 523.02 219.09 600.724"
            class="cls-2"
          />
          <path
            id="path743"
            d="M285.84964,615.69928l-35.7902-3.28635c6.359-25.79285,12.58286-51.03767,19.02153-77.154-8.47475-1.78212-16.09374-3.38423-23.71272-4.98639a6.45159,6.45159,0,0,1-4.16065-2.1794c-5.98773-6.99667-11.62856-14.279-17.61821-21.27364a6.353,6.353,0,0,1-1.51184-5.17225,2.61121,2.61121,0,0,1,.82446-.91175,8.27476,8.27476,0,0,1,5.13947-.932c5.9353.472,11.61959-1.45342,17.46659-1.79259a7.576,7.576,0,0,0,2.789-.184c5.66508.93681,10.97613-1.64245,16.55034-1.59576,2.75156.08393,5.43065-.73023,8.17434-.659,1.47286.03814,3.01866-.10633,4.2333,1.03766a3.32041,3.32041,0,0,1,.67356,1.24644c1.717,10.0457,2.42077,20.2004,3.302,30.3378.99338,11.4288,1.72176,22.878,2.716,34.30647.86381,9.9294.7982,19.92988,1.74528,29.82466.61217,6.3965,1.3906,12.74567,1.27238,19.17816C286.93691,612.99155,287.107,614.5359,285.84964,615.69928Z"
            class="cls-3"
          />
          <path
            id="path745"
            d="M204.13852,593.26235q-17.02338-11.74806-34.02507-23.52737a10.22642,10.22642,0,0,1-1.81839-2.28382c-.69379-9.45816,2.68851-18.26466,4.32142-27.35631,2.59957-14.47271,5.81689-28.80329,9.36957-43.05721.31213-1.09661.94964-1.71814,3.05243-1.28206,8.57686,16.2744,16.31518,33.56466,23.20313,47.97545-1.47177-4.45683-2.11935-12.1-3.41762-19.60627-1.76166-10.18511-3.82254-20.32384-5.07671-30.59314-.238-1.94854-.82812-4.04394,1.527-5.26357a14.35793,14.35793,0,0,1,6.7259,2.42623c4.19258,2.81543,8.84781,4.94316,12.58433,8.43734,1.013.67032,2.798.6753,2.29421,2.65422l-.01226.07207c-.71822,9.32956-2.69967,18.47161-4.131,27.69479-3.09828,19.96432-7.08964,39.769-10.80127,59.623C207.56383,591.15676,207.24686,593.62219,204.13852,593.26235Z"
            class="cls-4"
          />
          <path
            id="path747"
            d="M188.388,85.94183q.70345-1.90536,1.407-3.8107c2.96174,2.45163,3.63064,6.27846,5.55957,9.35467.84176,1.34225,1.40488,2.88434,2.29028,4.23243,3.55717,5.7793,5.97547,12.30964,11.21633,16.98194,1.27064,2.21251,1.86863,4.69049,2.80619,7.03723,2.06609,6.1435,2.39368,12.66528,4.07573,18.87119,1.28711,4.74833,2.34719,9.61112,4.63107,14.04546-.04841,4.19471,1.6556,8.02287,2.7209,11.96133,3.28476,12.1449,6.38971,24.34033,9.94624,36.41069.64694,2.19585.88925,4.75428,3.81649,5.51559,3.17477-1.32119,2.76684-4.49312,3.59561-6.93966.69443-2.04978,1.26075-3.91264,4.048-2.99,1.84291,2.2741,2.51794,5.014,3.12087,7.78508.62379,2.65737.67009,5.18969-1.4897,7.22842-1.521.69683-3.02626-.23164-4.48723.15316-7.53242,1.20722-15.12387,1.9501-22.68082,2.95442-1.67335.22238-2.884.05081-3.90974-1.23937-1.14079-3.94852,2.58493-3.01181,4.20311-4.09383,1.17062-1.62443.61372-3.27449-.06012-4.65367-8.02106-16.41909-14.24121-33.59784-21.33954-50.40473-.78054-1.84795-1.91428-3.48877-2.69574-5.315A107.99786,107.99786,0,0,1,182.299,136.223c-.73689-.567-1.59832-1.02085-1.81729-2.0468-.15446-.35648-.30608-.71233-.47345-1.06426-3.00841-8.50111-5.35835-17.195-7.62786-25.91133-.39457-1.51577-1.21812-3.02856-.37051-4.65787.52524-.83849,1.43608-.58336,2.19082-.77253l5.11715-.97773c2.48976.97718,2.55674,3.28239,2.567,5.31891.02773,5.49956,1.07043,10.99224-.07888,17.34788C183.22741,110.22555,184.26865,97.81764,188.388,85.94183Z"
            class="cls-5"
          />
          <path
            id="path749"
            d="M131.52127,151.90109q1.06566,1.00164,2.13134,2.00333c2.08485,3.42779,4.70866,6.48856,6.76973,9.93437,8.19977,13.21837,17.50044,25.7004,25.89493,38.78879,2.98984,4.66167,5.306,9.42416,6.09973,15.06445.86921,6.17711,3.73387,11.87911,5.48637,17.86378.48187,1.64541,1.34412,3.29413.26912,5.03271a3.40133,3.40133,0,0,1-3.28458,1.13626c-7.38217-10.39825-13.88644-21.35834-19.18294-29.877,1.25069,3.1559,3.0258,9.00457,4.614,14.8982,2.04285,7.58111,4.61908,14.9998,6.67969,22.57192.51929,1.90875,1.22644,3.89354-.68794,5.531-1.8689.69534-2.77965-.50735-3.56238-1.8538-7.1913-12.36824-15.14089-24.308-21.30111-37.25512-1.026-2.15657-3.81384-3.01653-3.83928-5.74875a5.29381,5.29381,0,0,1-.43849-3.30627c1.09147-2.41382,3.80817-2.589,5.61183-4.03594,1.04151-.83551,2.53716-1.11735,3.51105-2.97479A452.67935,452.67935,0,0,0,115.88451,165.49c-3.84916-.21724-5.86849,3.26165-9.142,2.458a3.1411,3.1411,0,0,1-1.40744-1.038c-.15446-3.71093-2.70635-6.32763-4.2699-9.39773a159.50176,159.50176,0,0,1-7.18791-15.20238c-.65224-1.70357-1.63739-3.44473-.42842-5.328,1.24639-1.77775,3.19545-2.28748,5.12346-2.46925,3.27249-.30854,6.42631-1.58567,9.77466-1.18216a5.23666,5.23666,0,0,1,2.48446.60655c6.18446,4.848,13.05384,8.82731,18.47826,14.64735A15.72957,15.72957,0,0,1,131.52127,151.90109Z"
            class="cls-6"
          />
          <path
            id="path751"
            d="M204.13852,593.26235c.70724-1.68516,1.75269-3.30908,2.07085-5.06468q6.77311-37.38207,13.3667-74.79658c.45817-2.57881.67805-5.21062,1.30486-7.74446a17.58737,17.58737,0,0,1,1.98557-3.79927c1.3831,2.00759,2.64359,4.1136,4.171,6.00415,6.06505,7.507,12.21327,14.94679,18.33076,22.41123-.76993,1.688-1.65652,3.3336-2.29212,5.0709q-11.49751,31.42482-22.934,62.87184c-.20936.57451-.47152,1.12977-1.05185,2.5081C214.0035,598.18521,209.071,595.7238,204.13852,593.26235Z"
            class="cls-7"
          />
          <path
            id="path753"
            d="M163.58868,414.94305q-2.27354-4.83075-4.54716-9.6615c.491-8.83659-2.02062-17.33983-2.86942-26.02618-.3102-3.17454-1.19387-6.34688-.4072-9.57127,2.84773-2.58026,4.043.09893,5.02354,1.88438,2.76327,5.031,5.617,10.01329,8.34426,15.06095,3.97361,7.35417,7.91693,14.72558,12.119,22.46721a25.66025,25.66025,0,0,1,.32621-3.726c.4793-1.68031,1.315-2.74294,3.21961-1.55706,1.49281,2.51816.79728,5.29824.9242,7.96916a37.207,37.207,0,0,0,.44352,5.52865,9.03757,9.03757,0,0,0,.81394,4.5863c2.071,6.05088,3.2348,12.44272,7.19962,17.73186a3.93468,3.93468,0,0,1,.421,1.80018c.05463,1.44588.80378,2.94664-.31094,4.31139a2.36365,2.36365,0,0,1-1.09742.65615c-1.6049.1795-2.74186-.8153-3.9661-1.59031-1.42529-4.72506-5.58492-7.11754-8.70058-10.45709-5.0509-5.41376-10.87959-10.18583-14.61519-16.76751A7.02629,7.02629,0,0,0,163.58868,414.94305Z"
            class="cls-8"
          />
          <path
            id="path755"
            d="M177.14818,240.31093c-1.34247-4.40736-2.76345-8.79278-4.00527-13.22831-1.24044-4.43053-2.08924-8.98041-3.51389-13.34624a38.95175,38.95175,0,0,0-4.0792-8.71433c-7.95289-12.53053-16.09145-24.94322-24.127-37.42161a33.75179,33.75179,0,0,1-1.79606-3.66888c1.8678-.48354,2.20793,1.23923,2.87509,2.19373,2.83318,4.05354,5.6207,8.144,8.21551,12.35706a5.17664,5.17664,0,0,0,2.52115,2.58315q3.695,3.76139,7.38986,7.52283c1.27393-.14959,1.80823.91656,2.592,1.57316a14.25768,14.25768,0,0,1,4.57764,6.13856c2.24416,5.20435,2.51035,5.17181,8.048,4.8326,1.46509-.08973,2.87884-.82568,4.3884-.3666,2.21708,1.88687,2.26768,4.64655,2.90511,7.17409-.17624,4.32987,1.98648,8.01758,3.36281,11.89823,2.54036,7.16252,4.53142,14.48207,6.54453,21.79668.4148,1.50686,1.0384,3.16717-.451,4.54866a32.14543,32.14543,0,0,1-9.20368,2.76617,6.16059,6.16059,0,0,1-4.58687-.95529A6.5974,6.5974,0,0,1,177.14818,240.31093Z"
            class="cls-9"
          />
          <path
            id="path757"
            d="M138.96567,209.556q12.56525,21.08122,25.13617,42.15906c.5687.953,1.21839,1.85763,1.83047,2.78477,2.50129.62967,2.81909,2.1374,1.70922,4.224a111.02509,111.02509,0,0,0-10.03426,6.555,4.63045,4.63045,0,0,1-2.02977.828c-2.74012.20583-4.33267-1.8887-5.97116-3.39849-13.49728-12.4384-27.80492-23.99415-40.61015-37.18915A22.44269,22.44269,0,0,0,104.891,222.384c-1.62952-1.04036-3.43583-2.16868-2.97813-4.63663,1.21958-1.05657,2.18441-.25192,3.20424.40333.73131.46971,1.09943,1.71057,2.33933,1.15734,6.42484,4.81911,12.81638,9.68332,19.28442,14.44382,5.74963,4.23188,11.584,8.34879,17.38094,12.51644,4.452,2.7147,5.64019,7.74833,8.33108,11.71436.74448,1.09736.80094,2.67944,2.29083,3.252.3026.177.6053.354,1.4412.84279-5.10251-13.37192-10.0156-26.24754-14.92869-39.12315-.53238-3.52438-2.08485-6.76614-2.84526-10.24083C138.12775,211.41912,137.68514,210.43285,138.96567,209.556Z"
            class="cls-10"
          />
          <path
            id="path759"
            d="M300.09122,610.45958q-6.70724,2.59244-13.41446,5.185a2.0308,2.0308,0,0,1-.45277-1.37975c.20817-13.64694-1.54726-27.24856-1.34705-40.86377.25494-17.32231.69709-34.64146.61062-51.96835a63.75715,63.75715,0,0,0-.29456-7.47106c.462-1.8563.48928-3.95193,2.65969-4.876,2.04386.63757,1.90175,2.44091,1.99829,3.9971,1.13374,18.27509,4.34219,36.30477,6.42658,54.46694.77963,6.794.878,13.64214,1.80046,20.42006a38.42131,38.42131,0,0,0,2.28662,10.13942c1.60555,3.78175.19435,7.77227-.26949,11.661Q300.09323,610.11479,300.09122,610.45958Z"
            class="cls-11"
          />
          <path
            id="path761"
            d="M292.50957,444.84286c-2.1447,10.60576,1.2505,20.86788,1.95308,31.29684.29044,4.31327.68958,8.61922,1.03922,12.92851-1.83577.62075-2.32642-.49713-2.617-1.96844-.182-.92177-.417-1.898-1.78646-1.51425-3.11922-2.98456-2.80884-6.86738-2.83208-10.65827-.04612-3.74567-.85456-7.42145-.42852-11.88737a69.08746,69.08746,0,0,0-6.56869,5.00805c-1.34357,1.09607-2.71807,2.22163-4.65432,1.28861-1.97166-1.957-.8886-4.28249-.54317-6.356,1.53216-9.19785,3.09736-18.39231,4.47844-27.6121.67925-4.534,1.80027-8.98066,2.35544-13.53a3.34084,3.34084,0,0,1,.73972-2.416c3.05508-1.95083,4.77108-5.25479,7.559-7.4852,1.52045-1.21639,2.96944-2.46291,4.76888-.44142,1.72341,5.156-.26225,10.1358-.80908,15.16156C294.50145,432.74415,292.61223,438.664,292.50957,444.84286Z"
            class="cls-12"
          />
          <path
            id="path763"
            d="M287.28151,513.79971c-.00732,14.60822.055,29.217-.03916,43.82463-.12463,19.34069-.37188,38.6807-.566,58.02056q-.41288.027-.82666.05447c-.931-13.03108-1.84062-26.06364-2.79951-39.09257q-1.17876-16.01342-2.45819-32.01931c-.86188-10.66833-1.82132-21.3288-2.69793-31.996-.3975-4.83752-.69828-9.683-1.043-14.5249,2.14223-.92346,2.92423.82728,3.81018,2.07349C283.6289,504.31456,286.34935,508.63034,287.28151,513.79971Z"
            class="cls-13"
          />
          <path
            id="path765"
            d="M84.945,223.8272c-.03642-.92952.26079-2.06311-.16324-2.75552-2.83977-4.63832-5.83318-9.18268-8.7768-13.75751.95815-1.66734,2.39716-1.30913,3.88585-.98193a90.28439,90.28439,0,0,1,13.35242,3.99329l2.853,1.46845c1.99106,1.70492,4.76293,2.54563,5.83583,5.27053-.56614,1.90587,1.07088,2.63695,2.04395,3.62767,3.307,3.36712,6.78648,6.56009,9.79324,10.22231,4.05285,4.93621,3.78685,6.84576-1.613,10.30618a2.567,2.567,0,0,1-2.25816-.18062c-3.65966-3.0506-8.24324-4.54407-12.1603-7.20394-3.71108-2.52-7.64241-4.71986-11.23545-7.43214C85.49366,225.83968,84.38215,225.33745,84.945,223.8272Z"
            class="cls-14"
          />
          <path
            id="path767"
            d="M156.93827,369.17691c1.06576,10.01136,2.22275,20.01459,3.11923,30.041.17651,1.9747-.65088,4.03909-1.01562,6.06287q-.30072-.83262-.60073-1.66669c-.94021-6.72505-3.73835-13.00817-4.7105-19.723-.99575-6.87744-2.26054-13.71147-2.10233-20.728.23005-10.20651-.63413-20.39985.01135-30.63558.55516-8.80243-4.27457-16.27619-7.35747-24.14631-.79161-2.02087-2.28607-3.98792-1.03227-6.36579,1.524-1.5429,3.029-1.02808,4.10126.39869,4.37642,5.824,8.39926,11.897,12.24988,18.07946a3.59641,3.59641,0,0,1,.51426,3.1964c.078,4.33947-.69471,8.65018-.54912,12.9682.31468,9.32768-1.02925,18.59212-.87223,27.90937C158.72271,366.27216,158.78567,368.12434,156.93827,369.17691Z"
            class="cls-15"
          />
          <path
            id="path769"
            d="M128.40772,88.1704q.05668-4.44666.11346-8.89333c1.89553-1.47878,2.51969.67966,3.6947,1.2767,8.46487,8.86031,15.45412,18.89516,22.77818,28.66428a3.76142,3.76142,0,0,1,1.17649,2.27794,2.31242,2.31242,0,0,1-.7175,1.53552c-4.02485,3.33832-8.8274,5.34-13.38783,7.75626-1.31246.69541-2.64111,1.463-4.23705.90865-2.79091-3.25058-3.15986-7.39269-4.16669-11.29523A133.5251,133.5251,0,0,0,130.408,90.14812c-.183-.82641-.00449-1.68058-1.25454-1.52566A1.23419,1.23419,0,0,1,128.40772,88.1704Z"
            class="cls-16"
          />
          <path
            id="path771"
            d="M256.71689,227.452c4.67234,11.14726,9.01527,22.4475,14.1078,33.39954,5.30162,11.40158,7.41429,23.39348,8.41206,35.7303a26.15676,26.15676,0,0,0,.79893,3.61194,1.26072,1.26072,0,0,1-.42293,1.63567c-1.60189.08514-2.26155-.87777-2.4398-2.35838.57245-3.05433-.87186-5.78552-1.4155-8.66352-.4157-2.20051-.88805-4.39135-1.26725-6.59736-1.57288-9.15254-3.13231-10.749-12.39226-12.40917a2.26233,2.26233,0,0,1-1.82269-1.08893,210.82492,210.82492,0,0,0-4.12185-20.6994c.81714-5.72208-.79143-11.27008-1.18764-16.90428C254.8231,231.079,253.65559,228.5598,256.71689,227.452Z"
            class="cls-17"
          />
          <path
            id="path773"
            d="M147.72646,144.55065q-1.34994-4.99467-2.69968-9.98939c1.00994-1.88737,3.083-1.5202,4.664-2.20008a2.25541,2.25541,0,0,1,1.11389.42777c2.16711,2.84217,2.77306,6.27766,3.62488,9.61526,1.00473,3.9366,1.90212,7.89953,2.85688,11.84706.1637,2.01083,1.85847,3.174,2.69428,4.82446,5.84342,11.54068,11.61282,23.1194,17.60256,34.58638.86939,1.66454,2.352,3.416.85,5.52815-1.79085,1.36605-3.16974.23473-4.20054-.988-3.91029-4.63816-8.2307-8.92566-11.53861-14.08853a57.25127,57.25127,0,0,0-5.03891-6.27932c-2.51887-3.71034-3.49083-7.9848-4.47607-12.25384C151.18279,158.61731,150.34213,151.354,147.72646,144.55065Z"
            class="cls-18"
          />
          <path
            id="path775"
            d="M283.71821,314.42007q4.674,14.96168,9.34826,29.92336.49411,1.58187.99191,3.16255c-.4782.50779-.22693,1.56141-1.93048,1.66417-3.05106-.73833-1.62916-5.04062-4.18764-6.91283a54.55066,54.55066,0,0,1-7.00188-5.97529,12.90374,12.90374,0,0,1-4.35884-6.74056c-1.53573-5.265-4.02348-10.16736-6.02479-15.25589-.74641-1.89782-1.94723-3.84058-.68739-6.00732,2.71313-2.29409,5.221-4.95087,9.23543-5.48534C282.05868,306.22338,281.642,310.8427,283.71821,314.42007Z"
            class="cls-19"
          />
          <path
            id="path777"
            d="M143.98435,301.78787c2.55821,6.49515,4.83248,13.12233,7.7719,19.4403,2.04889,4.40378,1.52758,8.79854,1.20841,13.19934-1.51523,20.89-1.429,41.62236,4.66219,61.94446.6862,2.28985.56248,4.82228.8143,7.24221-5.65126-11.96937-6.70329-24.8982-7.52794-37.79318-.65133-10.184-.47226-20.41869-.91285-30.62008a34.10488,34.10488,0,0,0-1.74418-9.43324c-3.58041-10.48091-7.36186-20.89587-11.24726-31.2684a72.88684,72.88684,0,0,0-4.54725-9.36619c-2.21159-4.02928-4.63016-7.9451-6.9597-11.90966a1.64,1.64,0,0,1,1.04728-1.22328c2.458-.33088,3.1421,1.73408,4.06694,3.22352,3.73121,6.009,8.02564,11.69131,10.78452,18.27514a4.31552,4.31552,0,0,0,1.23285,1.37952C143.69556,297.06137,145.234,299.15389,143.98435,301.78787Z"
            class="cls-17"
          />
          <path
            id="path779"
            d="M258.17457,250.0362q1.49281,10.49936,2.98553,20.99869c2.13711,1.38227,2.40027,2.90164.52113,4.65223a2.96341,2.96341,0,0,1-2.348-2.79094c-1.34988-7.35605-4.4-14.18318-6.516-21.29825-.92979-3.12615-.26976-6.69567-2.63883-9.41426a3.92078,3.92078,0,0,1,.67925-3.54567c1.52218-1.46364.87762-3.10554.49595-4.81051-1.4013-6.25888-3.32721-12.39424-4.36836-18.73819-.59387-3.61815-.49193-7.33329-1.54058-10.88563q-.79581-3.67236-1.59127-7.34475a2.2164,2.2164,0,0,1-1.04517-1.46564c.242-2.19834,1.31914-4.1728,1.68442-6.348.1907-1.1351.767-2.10669,2.23383-1.84329q1.52,5.97336,3.03989,11.94671c.51718,6.45492,2.41216,12.64557,3.60511,18.96958,1.81693,9.63157,2.48071,19.43484,3.96867,29.12062C257.49148,248.22415,257.4191,249.24391,258.17457,250.0362Z"
            class="cls-20"
          />
          <path
            id="path781"
            d="M172.74056,102.324q4.45169,15.41745,8.90345,30.8349c-2.28845.61375-3.63166-1.0029-5.07588-2.23827a41.88226,41.88226,0,0,1-6.293-7.35282,9.696,9.696,0,0,0-4.15424-3.34556,2.33756,2.33756,0,0,1-.59131-1.6322c-.98184-5.38713-.0786-10.98026-1.81143-16.27527a2.68535,2.68535,0,0,1,.09215-1.15143c1.011-1.22414.93216-3.04549,2.22275-4.12832q.32406-1.38827.648-2.77651c1.92747-1.086,2.937.15956,3.95284,1.51122A10.49428,10.49428,0,0,1,172.74056,102.324Z"
            class="cls-21"
          />
          <path
            id="path783"
            d="M182.478,496.60911q-6.377,33.33345-12.78006,66.66187a32.11189,32.11189,0,0,1-1.40323,4.18114q-1.47772-3.29861-2.95626-6.5953c1.67317-8.72015,4.59017-17.12794,6.48067-25.79326.17715-.812.74961-1.6118.14558-2.4738,2.78194-10.58619,5.915-21.09628,8.23116-31.78332,1.75589-8.10155,2.52115-16.42172,3.62927-24.65777.62837-4.66945,1.05945-9.36542,1.57947-14.04941a.94611.94611,0,0,1,1.22141.20832,12.84529,12.84529,0,0,1,.80818,6.48481c-.50566,6.64827-.96859,13.29886-1.60738,19.93821C185.53261,491.78746,184.93115,494.54737,182.478,496.60911Z"
            class="cls-22"
          />
          <path
            id="path785"
            d="M87.20444,225.30059,110.33125,239.584c.15373,2.26233-1.36,2.16313-2.90062,2.06446a207.85974,207.85974,0,0,1-21.97906-2.3961,2.01192,2.01192,0,0,0-1.99564.48723,3.89624,3.89624,0,0,1-1.40131.43731q-3.05383-2.14323-6.10769-4.28638a1.17085,1.17085,0,0,1-.31633-.94912c2.40567-2.79889,5.08832-5.33,7.74481-7.88134C84.414,226.06268,85.56851,225.10048,87.20444,225.30059Z"
            class="cls-23"
          />
          <path
            id="path787"
            d="M190.62139,443.40882q1.13622,1.1027,2.27235,2.20529c1.48613.62432,2.27875,1.69317,1.44257,3.21666a124.56832,124.56832,0,0,1-6.42558,11.28775c-.61546.8883-1.26643,1.52619-2.43861,1.19458a45.99421,45.99421,0,0,0-1.84748-5.55275c-3.86747-8.14-7.851-16.225-11.79282-24.32968,1.05241-2.84123,2.76556-1.08006,3.94525-.35161,4.66246,2.8791,8.61145,6.67264,12.63081,10.35757A26.23807,26.23807,0,0,0,190.62139,443.40882Z"
            class="cls-17"
          />
          <path
            id="path789"
            d="M297.00219,357.25245c1.86533,5.542,3.52578,11.16423,5.65621,16.60251,1.96671,5.02072,2.728,9.972,1.45127,15.2731-.75236,3.12382-1.0912,6.34706-1.616,9.52562a3.73056,3.73056,0,0,1-2.07552-1.32034c-2.78029-11.7402-6.72563-23.16035-9.64134-34.867-.29941-2.14086.28055-4.20913.60814-6.2796.26-1.64277.97453-3.13548,3.22363-2.95767C295.9335,354.21036,296.06179,355.98461,297.00219,357.25245Z"
            class="cls-24"
          />
          <path
            id="path791"
            d="M185.47212,461.3131c2.175-3.76414,4.4531-7.47436,6.46694-11.32274.66781-1.276.65582-2.90731.95468-4.37615q.36564-.01351.7314-.00261c1.80018-.31424,2.34.81187,2.59343,2.26452-.12929,5.68,2.02153,10.99309,2.67671,16.56061.7368,6.26126,1.89031,12.47254,2.74836,18.72292.20817,1.51645.43071,2.9835-1.12167,3.97909-1.837.71326-2.888-.3774-3.57-1.78569-3.71831-7.678-9.00758-14.63114-10.76814-23.21523l-.77926-.03856Z"
            class="cls-25"
          />
          <path
            id="path793"
            d="M172.74056,102.324q-3.02982-4.03312-6.05956-8.06586c.31606-2.458.63194-4.91648,1.03932-8.08623.39082.801.61638,1.26333,1.21427,2.48868,3.1346-6.676,6.0365-12.6487,8.73508-18.71187.99283-2.23074,1.60994-2.73172,5.49149-2.28119-1.20128.73425-2.03946,1.24657-3.04373,1.86037,2.67844,10.21383-4.02522,18.5573-5.68256,27.95919a34.48127,34.48127,0,0,0-.23425,4.28237Q173.47068,102.04747,172.74056,102.324Z"
            class="cls-26"
          />
          <path
            id="path795"
            d="M108.89792,134.64532l-15.04381,3.073c-1.96434-.55317-.65225-2.15681-1.03254-3.21553a30.94239,30.94239,0,0,1,.96483-5.10015c3.45377-2.88883,7.79944-4.6233,10.64982-8.26922,3.46429-1.58717,4.57873,1.98967,6.81594,3.099a35.85771,35.85771,0,0,1,.20259,6.26316A4.44173,4.44173,0,0,1,108.89792,134.64532Z"
            class="cls-27"
          />
          <path
            id="path797"
            d="M283.71821,314.42007c-.82821-1.94878-1.66484-3.894-2.48161-5.84756-.555-1.32731-1.08224-2.66613-1.77594-4.38065-3.10824,1.53847-5.89722,2.9189-8.68621,4.29936-1.41229.43431-2.11111-.51115-2.61622-1.51236a39.14667,39.14667,0,0,1-3.68738-13.14931c-.17908-2.34515-1.09074-4.544-1.40433-6.86568a7.64909,7.64909,0,0,1,.07174-2.29429,2.14815,2.14815,0,0,1,.58984-.93949c1.42089-.83874,2.24179.09835,3.2132.96137,2.06344,1.83318,3.44572,4.23054,4.95015,6.42938a21.01771,21.01771,0,0,0,5.44035,5.3721c.64859.64028.499,1.61467.9694,2.33175q.86692.68454,1.73421,1.36907Q281.87712,307.30694,283.71821,314.42007Z"
            class="cls-28"
          />
          <path
            id="path799"
            d="M188.388,85.94183c-.49147,4.30728-.87588,8.63-1.49693,12.91855-1.26954,8.76737-2.65968,17.5174-4.02265,26.27107a2.91725,2.91725,0,0,1-1.39445,2.09625q-1.07761-13.21663-2.15568-26.43427Q183.85262,93.36662,188.388,85.94183Z"
            class="cls-29"
          />
          <path
            id="path801"
            d="M299.48353,547.25383c.4029,5.32563.91258,10.64583,1.18765,15.97805.66094,12.81586,1.3788,25.63342,1.68031,38.45957.06817,2.90347-1.46454,5.84445-2.26027,8.76818l.17752-.11228c-1.28226-6.71961-1.385-13.55913-2.07836-20.33856-1.45447-14.22283-2.02034-28.50337-2.76949-42.77-.25942-4.94124-.78831-9.93732.52542-14.8315a1.45688,1.45688,0,0,1,2.07854-.56308C298.48229,536.90124,298.043,542.17845,299.48353,547.25383Z"
            class="cls-30"
          />
          <path
            id="path803"
            d="M87.20453,225.30061c-2.82641,3.14147-5.59069,6.34336-8.53825,9.36672-.50895.52212-1.79487.28719-2.72191.402a3.26514,3.26514,0,0,1-1.54708-1.62434c-3.22134-4.30206-4.10647-9.67752-6.572-14.332a1.90663,1.90663,0,0,1,.63129-2.78q8.24424,3.74709,16.48849,7.49423Q86.07471,224.56388,87.20453,225.30061Z"
            class="cls-10"
          />
          <path
            id="path805"
            d="M246.72646,187.202q-1.45164,4.08684-2.90346,8.17368c-2.92908.4275-3.04163-2.16944-3.72618-3.77805-3.59725-8.453-6.50967-17.17847-10.03436-25.66419a100.06021,100.06021,0,0,1-3.83571-10.49432c-.33911-1.17058-.961-2.33691-.27433-3.59574a1.88441,1.88441,0,0,1,1.55211-.84617Q237.11559,169.09949,246.72646,187.202Z"
            class="cls-31"
          />
          <path
            id="path807"
            d="M108.89792,134.64537q1.17657-5.20716,2.35369-10.41357c6.36326,8.20864,12.74712,16.40045,19.0563,24.64927a12.11813,12.11813,0,0,1,1.21244,3.01981q-7.01675-5.39334-14.03816-10.78346C114.63464,138.9418,111.76029,136.8015,108.89792,134.64537Z"
            class="cls-32"
          />
          <path
            id="path809"
            d="M301.66355,396.98718q.41507.83323.83014,1.6665-4.99206,23.09461-9.98412,46.18918c.14018-3.92979.16-7.86845.44672-11.78749.5354-7.31832,1.226-14.62529,1.852-21.937-.82629-1.0522-.36473-2.09178-.04383-3.18332,1.03319-3.51594,3.16654-6.48682,4.74381-9.73174A2.215,2.215,0,0,1,301.66355,396.98718Z"
            class="cls-33"
          />
          <path
            id="path811"
            d="M190.62139,443.40886c-4.36049-2.97632-8.68484-6.00766-13.099-8.90231-1.79652-1.17811-3.78786-2.05949-5.69052-3.07588q-4.12144-8.24387-8.243-16.48767c.46952.09289,1.12213.01848,1.38246.3029Q177.83136,429.29546,190.62139,443.40886Z"
            class="cls-34"
          />
          <path
            id="path813"
            d="M93.16819,133.92368q.34369,1.89675.68656,3.7941c3.36675,7.17119,6.76552,14.3273,10.083,21.52088,1.03273,2.23941,1.84547,4.58024,2.759,6.87464-1.61076.98356-2.24938-.4789-3.06771-1.2899-1.77959-1.76319-3.04575-4.0178-5.18843-5.43972-4.10492-7.98182-8.80709-15.82448-5.93127-25.433C92.71231,133.537,92.93275,133.54688,93.16819,133.92368Z"
            class="cls-29"
          />
          <path
            id="path815"
            d="M299.48353,547.25383q-.14343,1.09289-.28677,2.18576l-.49093.04446c-.2876-3.977-.53356-7.95754-.88083-11.92931-.16836-1.92559-.52624-3.83466-.79829-5.75119-2.614-1.87583-2.47237-4.7525-2.48-7.43068-.01967-6.978-.02452-13.941-1.8807-20.75145,1.06558-4.1313-.46823-7.87769-1.579-11.738-.59158-2.05552-1.92225-4.44224.60649-6.30686.09187-.58663.18375-1.17331.3566-2.27614,1.31758,2.20159,2.38462,3.98471,3.45175,5.76784q1.6121,22.08384,3.212,44.1685C299.04413,537.90387,299.231,542.58118,299.48353,547.25383Z"
            class="cls-35"
          />
          <path
            id="path817"
            d="M297.00228,357.25241c-.8714-1.00249-1.74271-2.005-3.2294-3.71544-.77413,3.39708-1.39289,6.11249-2.01173,8.82795a.90535.90535,0,0,1-1.08937.14013,2.54238,2.54238,0,0,1-1.05176-1.38574c-.119-3.4033-2.78981-5.68424-3.85859-8.7003-.994-2.80551-2.65575-5.36081-3.89025-8.08944-.60393-1.3347-1.49656-2.68678-.442-4.21389,1.86918-1.495,2.48318.57858,3.3985,1.11445-.78227-1.80645-4.40093-2.4336-2.76757-5.70656,3.75189,3.46445,8.313,6.2057,10.09027,11.44792.11969.353,1.24858.36418,1.908.5344Q295.53033,352.37924,297.00228,357.25241Z"
            class="cls-36"
          />
          <path
            id="path819"
            d="M126.29066,272.4392q-.39435.39208-.78869.78423c-2.542-2.82628-4.74948-6.0762-7.69063-8.39684-7.78462-6.14217-15.88675-11.88218-23.86261-17.78221-.27891-1.03794.38816-1.45942,1.17282-1.80389a59.97779,59.97779,0,0,1,22.86136,11.57883c2.41811,3.9966,5.7445,7.37038,7.88883,11.56368C126.56215,269.7331,127.47757,270.94521,126.29066,272.4392Z"
            class="cls-37"
          />
          <path
            id="path821"
            d="M150.11446,72.58493q3.71433,5.605,7.42875,11.21c1.52137,4.07928,4.1881,7.52784,6.213,11.327.92054,1.72718,2.95442,3.266,1.50956,5.662l-.15529.23926c-1.9152.81036-2.83391-.69265-3.65-1.82144A116.10983,116.10983,0,0,1,153.83579,88.145c-1.749-3.12492-3.38614-6.29675-6.62478-8.2054a9.97616,9.97616,0,0,1-.93381-2.85677c.221-1.2.41735-2.40641.54592-3.414C147.748,72.27207,148.79405,71.94536,150.11446,72.58493Z"
            class="cls-22"
          />
          <path
            id="path823"
            d="M93.24322,210.32553c-4.20328-.61185-8.41371-1.18028-12.60629-1.858-1.56565-.25311-3.08985-.76115-4.63244-1.15314q-.44443-3.69228-.88961-7.38412l1.26789-.69991Q84.813,204.778,93.24322,210.32553Z"
            class="cls-38"
          />
          <path
            id="path825"
            d="M258.17457,250.0362a11.90159,11.90159,0,0,1-1.499-3.05969q-3.60219-21.7336-7.01551-43.49819a23.52182,23.52182,0,0,1,.10624-4.32966q3.124,13.51618,6.26434,27.02854a5.52065,5.52065,0,0,0,.68629,1.27483,31.76911,31.76911,0,0,0-.4082,5.37986C256.81846,238.57661,257.53659,244.30285,258.17457,250.0362Z"
            class="cls-30"
          />
          <path
            id="path827"
            d="M98.44053,159.38368q4.128,3.36485,8.25614,6.72962l.734.76749c4.36525,1.11106,5.34811,5.42021,7.85562,8.29293,1.94842,8.129,7.61423,14.04181,12.22536,20.59019.70258.99785,2.20573,1.93876.97224,3.53565a1.20791,1.20791,0,0,1-1.08324-.14575c-3.53941-4.62724-7.184-9.17857-10.59528-13.89832C110.61053,176.6844,104.55454,168.01314,98.44053,159.38368Z"
            class="cls-39"
          />
          <path
            id="path829"
            d="M196.50526,96.54455c-2.74177-4.56943-6.51452-8.6593-6.71016-14.41333.56248-2.50045,1.12505-5.00081,1.81537-8.069.62269.81419.87762,1.14741,1.13246,1.4806,1.363,6.71625,4.3282,12.89447,6.49449,19.341.41021,1.221,1.50443,2.386.43144,3.817C197.81854,99.09713,197.74113,96.96328,196.50526,96.54455Z"
            class="cls-40"
          />
          <path
            id="path831"
            d="M196.50526,96.54455c.84358.334,1.68726.66792,2.96623,1.17421C197.374,91.733,195.28961,85.978,193.36938,80.16882a24.63116,24.63116,0,0,1-.62645-4.626c3.10468,8.3106,6.18685,16.62968,9.33819,24.92256a28.93964,28.93964,0,0,0,1.90761,3.51831c1.11407,2.14926,1.67116,4.5777,3.24056,6.49759a2.22065,2.22065,0,0,1-.15538,3.19059,17.14349,17.14349,0,0,1-2.31553-2.60088C201.95082,106.26179,199.24629,101.39256,196.50526,96.54455Z"
            class="cls-41"
          />
          <path
            id="path833"
            d="M134.28957,110.08722q1.916,5.56507,3.832,11.13013c.64127.249,1.16065.59417,1.10053,1.39583a1.17766,1.17766,0,0,1-1.07381.82623,41.129,41.129,0,0,1-2.91773-5.532c-2.35488-6.68309-4.79468-13.36027-6.61829-20.19534-.79664-2.9863-.17944-6.3495-.20442-9.54162q.34466.074.68867.15306c2.10351,1.54191,1.88143,4.02169,2.25926,6.144C132.28433,99.68408,134.51,104.66053,134.28957,110.08722Z"
            class="cls-42"
          />
          <path
            id="path835"
            d="M68.4566,216.333q3.34113,8.6319,6.68225,17.26389c-3.98422-2.29446-5.753-6.27076-7.78434-10.08765-1.23523-2.32125-1.849-4.95727-3.57821-7.02191-2.72384-5.59448-1.57188-8.55423,4.45556-16.03478-1.92481,4.16115-3.70339,8.00615-5.52983,11.95453C65.01381,213.98416,66.73521,215.15857,68.4566,216.333Z"
            class="cls-43"
          />
          <path
            id="path837"
            d="M207.07391,113.67183q-1.5425-4.84408-3.08509-9.68818,4.19815,5.22333,8.39642,10.44669a2.67359,2.67359,0,0,1,1.43434,1.81276c-.07,2.4709-1.12625,3.83056-3.79792,3.37125Z"
            class="cls-44"
          />
          <path
            id="path839"
            d="M213.20055,115.9015l-.81531-1.47115c.84486.71049,2.12987,1.25587,2.46807,2.15648,4.29616,11.44043,8.45626,22.93193,12.65113,34.41033l-.76032.79348c-1.70519.02484-2.30373-1.20491-2.81469-2.50789-2.63032-6.708-5.69034-13.3003-7.09668-20.38956-.685-3.45257-3.48882-5.71749-4.12231-9.05941C212.773,118.51248,213.963,117.33232,213.20055,115.9015Z"
            class="cls-45"
          />
          <path
            id="path841"
            d="M63.7763,216.48732c1.35665,1.80851,2.81744,3.54931,4.048,5.43979,2.50422,3.84708,4.88408,7.77495,7.31492,11.66963q.4023.73636.80524,1.4725.00109.41065.00247.82127C69.07691,231.18587,65.21046,224.59882,63.7763,216.48732Z"
            class="cls-46"
          />
          <path
            id="path843"
            d="M150.11446,72.58491q-1.14582,2.2016-2.29174,4.40316c-3.33756,1.12491-4.97257-1.85237-6.99291-2.6774-1.28547-1.4075-.64182-2.7711-1.08727-3.90842a5.53979,5.53979,0,0,1-.17605-1.06347C145.31182,67.71766,147.34717,68.34405,150.11446,72.58491Z"
            class="cls-47"
          />
          <path
            id="path845"
            d="M153.23854,181.0655a18.56031,18.56031,0,0,1-3.48241-2.88088c-3.4718-4.68047-6.76781-9.49112-10.12907-14.25331q-2.98754-5.013-5.97445-10.0267,8.767,12.03461,17.52825,24.07372C151.90714,178.97806,152.55454,180.035,153.23854,181.0655Z"
            class="cls-48"
          />
          <path
            id="path847"
            d="M138.14825,123.43943l.75684-.74315c4.33313.56591,10.67672,6.72866,10.69923,10.39418q-2.28876.73536-4.57754,1.4708Z"
            class="cls-49"
          />
          <path
            id="path849"
            d="M153.88539,165.43312q2.20779,6.02432,4.41539,12.04863c2.04551,3.17861,4.31593,6.23833,5.81113,9.725.78886,1.8394,1.46966,4.01122-2.01668,3.70853q-.73338-1.16347-1.46683-2.32695c-1.16239-3.212-2.35132-6.41481-3.4804-9.63849-1.389-3.96617-2.72813-7.94981-4.08872-11.92588C152.84287,166.23852,152.36924,165.31961,153.88539,165.43312Z"
            class="cls-12"
          />
          <path
            id="path851"
            d="M171.96469,532.58976c.1745.57643.61446,1.22256.484,1.719-2.3289,8.86014-4.72706,17.70217-7.11031,26.548a23.47982,23.47982,0,0,1,.30416-4.31679C167.68646,548.54037,169.84488,540.57,171.96469,532.58976Z"
            class="cls-50"
          />
          <path
            id="path853"
            d="M153.88539,165.43312q-.413.7954-.82611,1.59079-2.66637-11.23658-5.33273-22.47324a10.44292,10.44292,0,0,1,1.60015,2.5958C150.91449,153.2242,152.37986,159.3339,153.88539,165.43312Z"
            class="cls-51"
          />
          <path
            id="path855"
            d="M138.96567,209.556q1.14513,6.69943,2.29055,13.39853-3.00635-7.45912-6.0128-14.91764a3.20067,3.20067,0,0,1,1.95144-1.78141,1.4014,1.4014,0,0,1,.997.33153Q138.57883,208.07147,138.96567,209.556Z"
            class="cls-52"
          />
          <path
            id="path857"
            d="M130.6894,82.19686q-1.08476-1.46072-2.16886-2.92062,5.52462-4.96664,11.047-9.93623l.1809.26232c.29968.56974.54684,1.31276.17624,1.76538C136.91952,75.03859,135.13416,79.75715,130.6894,82.19686Z"
            class="cls-47"
          />
          <path
            id="path859"
            d="M165.26569,100.784c-2.203-4.42594-4.44568-8.83291-6.58214-13.2908a25.28909,25.28909,0,0,1-1.14034-3.69829q4.245,6.62016,8.48985,13.24025Q165.64956,98.90948,165.26569,100.784Z"
            class="cls-53"
          />
          <path
            id="path861"
            d="M93.16819,133.92368q-.33037-.001-.6592.0268a7.776,7.776,0,0,1,4.19258-7.65365c2.67488-1.55469,5.16363-3.42929,7.73465-5.163q-1.87947,2.58561-3.75976,5.17621C96.6485,127.38571,93.81175,129.60093,93.16819,133.92368Z"
            class="cls-19"
          />
          <path
            id="path863"
            d="M137.40285,206.603q-1.07981.71688-2.15943,1.43379-3.92131-4.44152-7.84272-8.883l1.04957-.08086c1.24849-.66975,1.89077.12238,2.7069.9314a8.10342,8.10342,0,0,0,4.05715,2.34745C136.48908,203.48608,137.81975,204.59737,137.40285,206.603Z"
            class="cls-54"
          />
          <path
            id="path865"
            d="M154.74371,261.23459a15.67878,15.67878,0,0,1-2.38472-2.31988c-2.80207-4.17769-5.50119-8.42439-8.23719-12.64639,1.60865,1.4081,3.61527,2.55625,4.7417,4.27942C151.08186,253.94125,152.81176,257.65389,154.74371,261.23459Z"
            class="cls-55"
          />
          <path
            id="path867"
            d="M95.50807,246.26594q-.77963.38921-1.55934.77844-5.9471-3.43375-11.89411-6.86747.321-.30178.642-.60358c1.03877-1.08513,2.3569-.63684,3.3414-.22412a51.34761,51.34761,0,0,1,7.62375,3.7172C94.81547,243.79346,96.13149,244.48734,95.50807,246.26594Z"
            class="cls-56"
          />
          <path
            id="path869"
            d="M101.57906,216.93739q-2.74116-2.57164-5.48262-5.14336,5.67987,3.75693,11.36,7.514l-5.22074-1.51266C101.75594,217.70888,101.49342,217.45627,101.57906,216.93739Z"
            class="cls-57"
          />
          <path
            id="path871"
            d="M291.69334,485.57651q1.5834,8.85743,3.16681,17.7148c.60421.7761.26728,1.29958-.50895,1.86284-2.90712-1.17514-3.21229-3.93423-3.95339-6.36966-.45267-1.48768-.40372-3.2612-2.56159-3.44089-1.91566-1.03436-3.51435.0118-5.16885.76532-1.85078.84278-3.60356,2.18837-5.83958,1.25068q-5.9865.36009-11.973.72022c-2.41683.74588-4.80237.33876-7.95755.06321,1.32938-6.63358,5.458-11.15979,8.93291-16.02758,4.4659-.60012,7.77153-3.77841,11.81587-5.36863,3.26856-1.28512,6.33737-3.06958,9.87779-3.62378a2.0792,2.0792,0,0,1,1.89077,1.10658Z"
            class="cls-58"
          />
          <path
            id="path873"
            d="M222.87876,501.78584q-1.48-.74975-2.96018-1.49962c-.21989-3.08028-.48434-6.155-.84807-9.2236-.24936-2.10449-.32338-4.23158,1.65907-5.72334,3.21009-.59929,5.90977,1.264,8.7844,2.04912,4.65871,1.27246,9.003,3.55481,13.41126,5.56857,1.67144.76358,3.1055,1.7754,2.15046,4.00054-4.07838,2.716-8.95963,1.89632-13.38454,3.0634-1.409.37164-3.024-.14173-4.24144.98434Q225.16425,501.39545,222.87876,501.78584Z"
            class="cls-16"
          />
          <path
            id="path875"
            d="M266.96628,483.05876c-2.86859,4.61287-5.73718,9.22574-9.14318,14.70276,2.973.1345,5.0024.22629,7.0318.31821q-8.27719.72429-16.55419,1.4484c-.30105-.6315.27021-1.08124.34992-1.64418-1.45951.05328-2.88452.05318-3.22611-1.83956-.343-1.61926.69361-2.56271,1.75251-3.43545,7.96606-6.56585,15.381-13.81328,24.08212-19.47122,1.17411-.76348,2.32369-1.64052,3.43456.07981.57145,3.74918-2.42983,5.45867-4.4703,7.67572A11.265,11.265,0,0,1,266.96628,483.05876Z"
            class="cls-59"
          />
          <path
            id="path877"
            d="M276.82779,497.3596c3.565-1.9479,7.12989-3.89576,10.94529-5.98054.51682,1.02947.822,1.63746,1.12725,2.24545,2.03279,5.3399,2.68677,10.6021-.88092,15.62654q-.36853,2.27446-.73735,4.54879-5.21592-7.86675-10.43094-15.73323Q276.838,497.71318,276.82779,497.3596Z"
            class="cls-60"
          />
          <path
            id="path879"
            d="M246.09708,495.83053c2.55236.727,5.10471,1.454,8.58977,2.44673-2.73564.53618-4.56043.89382-6.38559,1.25114q-10.42692.7385-20.85218,1.47721A11.24766,11.24766,0,0,1,230.246,499.451c4.74674-1.05984,9.52852-1.963,14.29777-2.922C245.00982,496.18122,245.263,495.36052,246.09708,495.83053Z"
            class="cls-57"
          />
          <path
            id="path881"
            d="M186.18385,462.13782q6.73633,12.30038,13.47248,24.60083c.81686.52686,2.11166.20759,2.53533,1.43084a.94124.94124,0,0,1-.29922.90219,69.52238,69.52238,0,0,0,.37279,8.75834c2.89028,17.46313,5.93694,34.90037,8.92284,52.34772a3.11232,3.11232,0,0,1-.48827,2.451c-.62626-1.09922-1.32261-2.16487-1.86807-3.30277q-12.0434-25.128-24.091-50.25388a11.604,11.604,0,0,0-2.26319-2.46333Q184.33119,479.37362,186.18385,462.13782Z"
            class="cls-61"
          />
          <path
            id="path883"
            d="M201.89244,489.07168q-.01345-.36084-.02187-.72172c.20122-1.90643,1.64755-2.26091,3.15967-2.531a68.171,68.171,0,0,1,15.08178-1.44675,2.4282,2.4282,0,0,1,1.15571.54044.90271.90271,0,0,1,.11474,1.16462c-.09,1.93473-.082,3.88021-.29263,5.80173-.30828,2.81163-.77358,5.60616-1.17163,8.4076Q210.90573,494.67878,201.89244,489.07168Z"
            class="cls-10"
          />
          <path
            id="path885"
            d="M196.49492,147.45769c3.18364,7.293,6.44406,14.55378,9.53391,21.88636,5.17077,12.27048,10.24491,24.58181,15.31686,36.89357a20.12416,20.12416,0,0,1,.729,3.33037l-6.70833,2.97976c-1.99692,2.33042-4.09247,4.49371-7.50287,4.42429-.74485-.23533-1.53417-.24779-2.28726-.43025-2.77443-1.89137-3.53384-4.56762-3.08921-8.03734,3.94286-2.52923,8.66626-1.15453,13.31252-2.66081-6.25592-3.68792-12.236-7.421-18.06182-11.39367-4.64809-13.76137-8.8328-27.66117-12.83075-41.61817a2.26915,2.26915,0,0,1,.14924-1.102c1.53546-3.93717,5.26045-3.56426,8.41957-4.159C194.41711,147.39357,195.49248,147.90984,196.49492,147.45769Z"
            class="cls-62"
          />
          <path
            id="path887"
            d="M214.44749,119.15437q6.14777,16.31856,12.29618,32.63673,8.54044,21.7917,17.0797,43.58439.01482.74178.0301,1.48334c-.73167,1.93448-1.52228,3.84913-2.179,5.80861-.73479,2.192-1.34805,4.4246-2.1339,7.03741-2.3805-.49944-4.25874-.89353-6.31092-1.32409-1.45987-5.01558-2.90245-9.76565-4.22305-14.54934q-5.16954-18.72587-10.236-37.48a21.839,21.839,0,0,1-.39338-2.95492c-.49577-7.44584-2.91059-14.52977-4.1073-21.83985-.49595-3.02965-1.19524-6.02587-1.53646-9.07838C212.57191,121.03371,212.22446,119.40808,214.44749,119.15437Z"
            class="cls-63"
          />
          <path
            id="path889"
            d="M186.15228,151.8902q6.409,20.84646,12.818,41.69284c5.18734,5.70888,5.86548,12.21194,3.40033,19.26911-1.76458.5101-2.51913-.52957-2.95543-1.97786-2.435-8.08344-5.753-15.88973-7.5898-24.16-3.36537-9.49953-7.012-18.92584-9.09515-28.81241a40.70489,40.70489,0,0,0-9.61874-19.04688c-1.17675-1.32278-2.26694-2.72412-1.35208-4.68533,3.20113-3.55658,6.58874-1.68359,9.95777-.35142q.71169.79731,1.42364,1.59456c.81924,2.40947,1.91309,4.70706,2.52545,7.20965C186.42185,145.71044,187.106,148.73979,186.15228,151.8902Z"
            class="cls-45"
          />
          <path
            id="path891"
            d="M207.89032,215.58458q3.73821-1.518,7.47624-3.03644c2.25231.18691,4.546.74025,6.74951.49258,6.50107-.73065,12.96655-1.77835,19.44593-2.702a2.91092,2.91092,0,0,1,1.15635,2.6183,8.81185,8.81185,0,0,1-.07851,1.18206c-.57154,1.306-1.80531,2.04329-2.66719,3.101-1.85911,1.70184-3.52386,3.60581-5.4376,5.2502-1.48183,1.27333-3.022,2.26256-4.9302.729-1.52128-1.50719.09425-3.69469-1.13567-5.27789-1.1181-1.151-2.4883-.79861-3.84724-.6928a126.48438,126.48438,0,0,1-13.02191.1034C210.16962,217.31584,208.50752,217.46153,207.89032,215.58458Z"
            class="cls-64"
          />
          <path
            id="path893"
            d="M186.15228,151.8902l-3.01143-16.47742q6.67771,6.02222,13.35471,12.04468c-1.44761.71491-2.86493,1.49975-4.34887,2.12693C190.17576,150.41736,188.15286,151.12738,186.15228,151.8902Z"
            class="cls-65"
          />
          <path
            id="path895"
            d="M214.44749,119.15438c.95586,7.25282,1.97687,14.49787,2.84214,21.76149.49367,4.14451.73351,8.31927,1.08754,12.48049q-4.17715-16.89063-8.35487-33.7818,1.58835-1.85679,3.17815-3.71306Q213.824,117.528,214.44749,119.15438Z"
            class="cls-66"
          />
          <path
            id="path897"
            d="M181.71721,133.81824l-9.0138,1.54151c-1.75086.69368-2.57861-.43977-3.08244-1.75177a109.25912,109.25912,0,0,1-3.397-10.9601,2.43759,2.43759,0,0,1,1.09019-2.88742c2.44565,2.09982,4.96515,4.12076,7.31629,6.32135,2.42333,2.2679,4.68268,4.71074,7.01359,7.07709A6.56348,6.56348,0,0,1,181.71721,133.81824Z"
            class="cls-67"
          />
          <path
            id="path899"
            d="M241.70411,213.43032q-.07041-1.54581-.14156-3.09164c1.296,0,2.59252,0,4.20109,0-.11155-2.1403-.21559-4.13682-.31935-6.13419q4.41476,18.17718,8.82887,36.35606l-.56651.28714q-.80419-1.00771-1.60848-2.01543c-1.80366-.12485-2.00048-1.44506-2.37071-2.86155a92.45693,92.45693,0,0,1-1.6794-9.17157,16.828,16.828,0,0,0-2.51163-6.7996c-.38587-1.29075.11082-2.7482-.40143-3.472C244.07784,214.80372,242.51374,214.56935,241.70411,213.43032Z"
            class="cls-68"
          />
          <path
            id="path901"
            d="M137.40285,206.60308q-1.5064-1.47842-3.01262-2.95691a155.32366,155.32366,0,0,1-17.72143-23.23261,43.12542,43.12542,0,0,0-3.349-4.46877q-2.94445-4.532-5.88909-9.064c2.54723-1.49619,5.09446-2.99238,8.22915-4.83366l34.95805,38.72861c-4.55613,2.13072-8.49112,3.971-12.42611,5.81128Z"
            class="cls-69"
          />
          <path
            id="path903"
            d="M166.54649,258.144q-.30732-1.82169-.61446-3.64381c-1.70583-6.35035-3.34039-12.72055-5.13453-19.04555-2.74881-9.69074-5.61393-19.34848-8.4073-29.0267a3.652,3.652,0,0,1,.1971-2.6847q6.84709,10.78459,13.68742,21.57338c2.65365,4.2106,5.16986,8.50976,7.9097,12.66234.65682.9956,1.95867,1.56593,2.96376,2.33193q1.16778,3.332,2.33558,6.664a3.58092,3.58092,0,0,1,.25868,3.26335c-3.44626,7.94339-8.77131,14.76564-13.22166,22.11a21.13163,21.13163,0,0,1-4.86643,5.61175q-2.20367.7494-2.562-1.54522c1.22617-3.50517,1.95382-7.15536,3.15748-10.67647A18.38879,18.38879,0,0,1,166.54649,258.144Z"
            class="cls-7"
          />
          <path
            id="path905"
            d="M195.17276,447.80665q-.77372-1.09748-1.54762-2.195-.42673-1.85195-.85366-3.70386c-1.49848-5.83182-3.306-11.57674-4.89543-17.38318-.46008-1.681-1.4886-3.39648.6636-4.65847a2.88883,2.88883,0,0,1,3.02946,1.76456,5.11277,5.11277,0,0,1,.65133,1.33776c2.01787,10.55089,10.33248,15.92308,17.96629,21.85081a53.53229,53.53229,0,0,1,4.6297,3.75064c3.43309,3.28179,8.28972,4.57949,11.48115,8.20231,4.21884,3.12309,6.42988,7.8373,9.40352,11.9401,1.736,2.39505,3.1572,5.02142,5.70937,7.57351,2.05264-14.4005-.10578-28.64084,3.28146-42.4098a11.39032,11.39032,0,0,1,1.84291-1.45224c5.77517-1.95577,11.83912-2.49927,17.78164-3.63284a26.333,26.333,0,0,0,6.80194-1.74754,6.47822,6.47822,0,0,1,1.12387-.26823c3.02186-.86881,5.05437-3.36543,7.77976-4.74051,1.44194-.72754,2.73984-1.81537,4.32874-.38838-1.37487,9.23558-2.78789,18.46566-4.11142,27.70865-.9306,6.49761-1.73942,13.01266-2.60258,19.51992.41268,1.62507-1.06732,1.82429-1.8959,2.51469-10.00837,5.27139-20.55122,9.33934-30.94327,13.75547-3.595.47394-6.18089-2.14333-9.29243-3.16283a120.73915,120.73915,0,0,1-16.595-7.34178c-3.90983-2.27426-6.68756-5.80721-9.50207-9.16071-3.82675-4.55931-7.16961-9.52068-12.50216-12.57C196.59631,451.12977,194.89834,449.79535,195.17276,447.80665Z"
            class="cls-70"
          />
          <path
            id="path907"
            d="M156.93818,369.17691q.7401-23.22028,1.48-46.44057c1.30221-.89611,2.39973-.35133,3.33967.581,9.1657,9.0911,18.37285,18.14506,26.35923,28.342a20.91657,20.91657,0,0,1,.90526,7.65592c-1.8905,2.75475-1.71856,5.86919-1.72121,9.004a256.31513,256.31513,0,0,1-1.56154,31.54752c-.18136,1.45461-.15473,3.05956-1.87439,3.77113-.387,3.39278-.774,6.78552-1.30367,11.429-2.68385-4.73329-4.89561-8.49733-6.97736-12.332-5.45773-10.05357-10.84436-20.1457-16.30145-30.19959A35.18348,35.18348,0,0,0,156.93818,369.17691Z"
            class="cls-71"
          />
          <path
            id="path909"
            d="M183.8652,403.63791c.7767-13.34281,1.5134-26.68827,2.38069-40.02518a24.48663,24.48663,0,0,1,1.38347-4.95949c2.07863.00146,2.35323,1.525,2.48289,3.058a46.24427,46.24427,0,0,1,.00019,7.46677c2.29714-5.05092,4.338-10.52061,6.576-15.90827,1.39326-3.35418,2.8082-3.5935,5.70946-1.0677-2.32981,9.37241-6.10677,18.54089-8.29878,28.2988,4.04132,1.85835,7.58019.07582,11.07111.09206a11.46149,11.46149,0,0,0,6.75893-1.81834,2.13012,2.13012,0,0,1,2.76629.13633c1.69349,3.07031,1.03511,6.5514,1.69029,9.81311a68.91082,68.91082,0,0,1,1.46572,16.82975.57136.57136,0,0,0,.21239-.42432c-.27918-16.85248,3.77834-33.26935,5.03992-49.96621.05545-.73407.83928-1.19311,1.70327-1.38565,1.497-.04381,2.099.9252,2.33585,2.29759a30.12412,30.12412,0,0,0-.46118,9.53486,125.08683,125.08683,0,0,1-.1498,19.59863c-.77065,9.71112-.16041,19.4676-.30352,29.20337-.03843,2.61558.17715,5.24986-.47894,7.81855-1.0868,1.93757-2.41948,1.86339-3.90242.44523a13.25589,13.25589,0,0,1-2.052-2.659c-1.748-2.82659-4.227-3.60878-7.39187-2.95241-5.36851,1.11349-10.82926,1.81807-16.15769,3.04013-3.40436.78077-6.5601-.40928-9.82628-.07921-1.12194-.38143-1.61936-1.525-2.57431-2.11017Q183.85518,410.77649,183.8652,403.63791Z"
            class="cls-72"
          />
          <path
            id="path911"
            d="M183.84489,417.91512q2.27327.29148,4.54652.58311l.14943-.13748a20.80364,20.80364,0,0,0,4.59182.25666c8.20809-1.34307,16.39075-2.841,24.80391-4.32516,2.24069,3.06157,4.34888,5.942,6.457,8.82255a1.98968,1.98968,0,0,1,2.42681-.07011c2.53258,2.11575,5.7359,3.48274,7.40944,6.56576a3.209,3.209,0,0,1,.1411,1.12739c-.8617,2.92254-3.53283,4.42587-5.30757,6.6265-3.204,3.97286-6.73624,7.67924-10.23109,11.40611-1.34787,1.43737-2.87811,2.39518-4.92362,1.30859-4.19441-3.29953-8.19629-6.89016-12.6331-9.82344a23.14789,23.14789,0,0,1-9.86873-14.24158,12.282,12.282,0,0,0-2.48812-4.77495q1.92683,10.33432,3.85328,20.66871Q188.308,429.91146,183.84489,417.91512Z"
            class="cls-73"
          />
          <path
            id="path913"
            d="M193.08956,186.2457l8.57723,26.48988c1.8548.66479,2.21067,3.23088,4.40633,3.469,3.68061,1.15222,3.40463,4.71614,4.77721,7.21918a34.90094,34.90094,0,0,1-9.49045,11.37533,2.33194,2.33194,0,0,1-1.09459.0646,2.22239,2.22239,0,0,1-1.42995-1.69936c-.40683,2.1249-.29245,4.37037-.64529,6.57957-.23819,1.49171-.691,2.607-2.50166,2.39864A2.51859,2.51859,0,0,1,194.237,239.714c-.18145-4.38136-2.0779-8.19272-4.10281-11.89734-3.45084-6.31378-5.1673-13.35888-8.53679-19.69439q-1.13031-3.3727-2.26081-6.74536c-1.67958.02705-1.912-.90579-1.50288-2.26409q-6.92191-14.03351-13.84271-28.06759-3.95467-8.02632-7.89067-16.06174c-.53723-2.902,1.22434-2.38782,2.833-1.82184,4.69064,1.65022,8.8932,4.5118,13.63792,5.93854,11.33409,3.40821,13.98069,13.30661,17.43812,22.65225C190.66723,183.53077,190.98814,185.4813,193.08956,186.2457Z"
            class="cls-14"
          />
          <path
            id="path915"
            d="M178.65106,250.04819q.41576-1.536.832-3.07269,6.28366-.7662,12.56594-1.53113a1.68025,1.68025,0,0,1,1.74519,1.596c-.17039,2.61631,1.66191,4.25564,2.74707,6.26851a31.72226,31.72226,0,0,0,.39009,11.94381,21.05807,21.05807,0,0,0,.45633,2.27961,16.42784,16.42784,0,0,1,.72582,2.75083c.66277,2.781,3.19161,5.13779,1.90468,8.36142-1.20293,2.30015-2.89559,1.93917-4.70776.85216-5.86428-3.51761-12.05122-6.51785-17.41332-10.84287-1.7127-1.334-1.67528-3.14063-1.55861-5.08753C176.61425,258.96779,177.78835,254.53765,178.65106,250.04819Z"
            class="cls-6"
          />
          <path
            id="path917"
            d="M195.04328,253.02309q-1.49625-3.7886-2.9935-7.578-4.92041-17.02324-9.82572-34.04878c-.30526-1.06373-.42166-2.18156-.62617-3.27419.68894.59052,1.65972,1.04395,2.02427,1.79241,3.8682,7.94189,7.82186,15.85221,11.32559,23.95546,1.02833,2.37828.704,5.34086.99969,8.03567C198.18291,244.958,197.77581,249.96335,195.04328,253.02309Z"
            class="cls-74"
          />
          <path
            id="path919"
            d="M177.83374,199.11287q.75149,1.132,1.50288,2.264l-9.18153,2.87711c-2.90977-4.81563-5.48473-9.07727-8.05977-13.33883.147-1.0372.68363-2.21307.37242-3.08742-1.24556-3.5-2.7543-6.90634-4.16632-10.34668,5.04267,5.72348,10.06739,11.46271,15.14126,17.15831C174.8309,196.19776,176.366,197.62528,177.83374,199.11287Z"
            class="cls-75"
          />
          <path
            id="path921"
            d="M186.84955,351.20445Q174.832,338.98077,162.80439,326.767c-1.39408-1.41076-2.92075-2.69053-4.38621-4.03072q-7.21549-10.47394-14.43245-20.94824-1.4353-2.99361-2.868-5.98691c-.14384-6.70966,2.44337-12.77872,4.45722-18.98207a3.00164,3.00164,0,0,1,2.679-2.20051c3.34-.29005,4.32133-2.755,5.06911-5.46522.40756-1.47693.17212-3.28791,2.00607-4.06792q.80761-.391,1.61524-.782c2.33942.28275,2.35644,2.28071,2.82779,3.89681.77889,2.66973.37809,5.37771.132,8.07464q.74667.36743,1.49345.73488c5.68787-2.27037,10.30585-6.27684,15.06778-9.7051a6.02635,6.02635,0,0,1,3.677,3.43663c1.91026,9.13487,2.91938,18.41362,4.55585,27.59477a9.07278,9.07278,0,0,0-.28156,5.70132c1.7031,8.80979,1.7774,17.8164,2.78286,26.71857.543,4.80757.7852,9.648,1.24154,14.467.18713,1.97566.47765,3.97474-.98322,5.6669C187.25254,350.99329,187.051,351.09889,186.84955,351.20445Z"
            class="cls-16"
          />
          <path
            id="path923"
            d="M155.32916,265.08538c.5805,5.3788-1.42382,9.56858-6.00914,12.90886l-.71045-1.69143c-.56587-1.68244-3.01958-1.35423-3.43556-3.20417-.24157-.82093.09864-1.9072-.5859-2.4781-4.40039-3.66979-6.64392-9.26116-11.35158-12.64418-.69736-.83281-.9533-1.99558-2.09473-2.49783-6.2951-2.77006-11.45864-7.30022-17.09636-11.08956-1.33469-.8971-3.31523-1.71908-2.12731-4.05442.95733-1.27021,1.91466-2.54043,3.24578-4.30656-1.5931-2.18227-3.08528-4.38857-4.74426-6.4616-2.62959-3.28588-5.42864-6.43727-8.01905-9.75256-.56889-.728-.5634-1.9045-.8219-2.87543q.32872.42762.65682.8571c4.22516,3.816,8.43458,7.64936,12.67794,11.4448q16.662,14.90324,33.35352,29.77359C150.58489,261.07823,152.97327,263.06359,155.32916,265.08538Z"
            class="cls-76"
          />
          <path
            id="path925"
            d="M159.90423,276.27482q-1.48019-5.98591-2.9601-11.97161,4.8021-3.07827,9.603-6.15809Q163.22495,267.20887,159.90423,276.27482Z"
            class="cls-14"
          />
          <path
            id="path927"
            d="M288.01941,509.25105q.44005-7.81374.88046-15.627a17.18525,17.18525,0,0,1,2.24746,2.84365c1.15406,2.30847,2.08952,4.726,3.12828,7.09284.01574.03568.22492.02347.31734-.02108a1.20248,1.20248,0,0,0,.2672-.24815c.44654,4.17346,1.00427,8.33877,1.31172,12.52243.3911,5.32212.5796,10.65909.85512,15.98972.67137,17.70583,1.31612,35.41268,2.02665,53.11687.34022,8.47813.80516,16.95122,1.21428,25.42684-.344-1.54472-.81028-3.0737-1.01507-4.63689-2.58877-19.76345-5.28909-39.5141-7.64617-59.30546C290.13565,534.053,289.197,521.63779,288.01941,509.25105Z"
            class="cls-77"
          />
          <path
            id="path929"
            d="M291.17743,362.55723q.294-.09061.58417-.19194,4.95006,17.31,9.9014,34.62139-3.42636,7.06667-6.85428,14.132-4.82281,4.54605-9.64482,9.09261c-2.66545-1.63494-2.28277-4.46638-2.58053-6.93748-.80946-6.71856-.43895-13.52218-1.34668-20.23585-.22986-4.72217,1.85673-8.94137,2.988-13.3659,1.108-4.33385,2.64249-8.54833,3.88522-12.84852C288.60687,365.10421,288.89557,363.06749,291.17743,362.55723Z"
            class="cls-78"
          />
          <path
            id="path931"
            d="M282.71779,392.25778q1.22241,13.97622,2.44538,27.953-.4056.71826-.81238,1.43541-5.65379,3.30856-11.30765,6.61689a2.90461,2.90461,0,0,1-.9695-3.03788c2.61933-11.05867,4.59072-22.3086,9.49292-32.70568A1.17884,1.17884,0,0,1,282.71779,392.25778Z"
            class="cls-79"
          />
          <path
            id="path933"
            d="M275.36426,470.36528q1.13594-.74542,2.27225-1.49066c3.87744-3.3421,7.7546-6.68453,11.77835-10.15323,0,5.54311,0,10.52555-.00018,15.50809q-1.02847-.05921-2.05676-.11868c-3.81814-.64036-7.71461-.87768-11.39934-2.21448A1.90524,1.90524,0,0,1,275.36426,470.36528Z"
            class="cls-42"
          />
          <path
            id="path935"
            d="M111.91813,240.33453c6.178,4.35537,12.3725,8.68743,18.52118,13.08375,1.39408.99677,2.62867,2.21646,3.93664,3.33351-.79152,1.92334-2.56891,1.646-4.12541,1.827-4.03657.46928-7.98364-.59818-11.98607-.72369q-.6657-.102-1.3336-.19753-10.71144-5.69577-21.4228-11.39159-6.40568-3.3464-12.81145-6.69267c-.61674-.55215-1.23349-1.10436-2.70727-2.424,5.13875.50427,9.25464.97581,13.38216,1.29675,5.64925.43923,11.30756.764,16.96084,1.13788Q111.12419,239.95928,111.91813,240.33453Z"
            class="cls-80"
          />
          <path
            id="path937"
            d="M130.6894,82.19685q4.52868-6.29908,9.05809-12.59638,1.48155,1.65423,2.96128,3.30475l-.2736.2178q2.69411,1.93247,5.38791,3.865.48219,1.076.965,2.152c5.69491,8.97638,8.89786,19.0179,12.41925,28.22239a3.91526,3.91526,0,0,1-1.97358,3.31625c-1.158.62328-2.11322,2.09616-3.71017.8876-2.2825-2.54933-4.67975-5.00619-6.82463-7.6665-5.05538-6.2703-9.96582-12.6573-14.99842-18.94631A25.59621,25.59621,0,0,0,130.6894,82.19685Z"
            class="cls-81"
          />
          <path
            id="path939"
            d="M149.60432,133.09046l-10.69923-10.39418q-.39159-.73971-.78328-1.47918,8.32755-4.494,16.65566-8.98852a2.25192,2.25192,0,0,1,1.15251,2.855c-2.02684,4.37767-2.12905,8.96148-1.75836,13.62671-.61812,2.06428-.59881,4.70526-3.90572,4.36568l-.33106-.00377Z"
            class="cls-69"
          />
          <path
            id="path941"
            d="M134.28957,110.08723q-2.59623-10.88232-5.19273-21.76417.29757-2.09221.596-4.18535l.97014.00471c.28879,1.377.6075,2.74844.86116,4.13183,1.07115,5.84386,2.194,11.68,3.1291,17.54577A17.48715,17.48715,0,0,1,134.28957,110.08723Z"
            class="cls-82"
          />
          <path
            id="path943"
            d="M152.36952,128.59032c.18072-2.40632.2143-4.83519.57895-7.21332.471-3.0708,1.20658-6.10107,1.82854-9.14858q.37376-.331.7465-.66233,1.44574-.80987,2.89138-1.62c1.07857-.27626,1.45209.42378,1.73375,1.24978-.5591,5.99-3.4147,11.16672-5.88515,16.47424A1.96661,1.96661,0,0,1,152.36952,128.59032Z"
            class="cls-83"
          />
          <path
            id="path945"
            d="M239.2622,216.225q1.18248-1.06431,2.36495-2.12869c2.76675,1.59026,2.91508,4.46638,3.24615,7.1.49522,3.94013,1.45731,7.79912,1.77281,11.77425a17.64753,17.64753,0,0,0,3.28019,8.13135,1.50428,1.50428,0,0,0,1.504.76534c.938,2.38754,2.08036,4.71719,2.77708,7.17317,2.37383,8.36855,4.59081,16.78158,7.4325,25.06826q-.24033-1.5368-.48021-3.07364c.656-.48218,1.32783-1.40266,1.96452-1.379a13.71477,13.71477,0,0,1,12.96041,12.18178c.70414,5.66633,1.47562,11.32432,2.217,16.98644q-.73461-.7707-1.46857-1.54229c-2.96394-2.14794-4.41365-5.53242-6.578-8.31348a36.85223,36.85223,0,0,1-5.51712-9.8062,2.50375,2.50375,0,0,1-1.21583,2.74089c-2.14716.45109-2.88049-1.06412-3.472-2.6116-2.93018-7.66665-6.83662-14.94019-9.19636-22.8355-.42513-1.422-.63559-3.032-2.65182-3.069-1.89022-.13929-2.9062,1.24366-4.06685,2.343-6.42247,6.08395-13.03774,11.96542-19.17892,18.34557-1.36507,1.41825-2.77123,3.01494-5.15265,2.1532a4.35164,4.35164,0,0,1-1.518-1.883,4.26208,4.26208,0,0,1-.15565-1.86892,6.23683,6.23683,0,0,1,1.93863-4.9862c3.34652-2.80866,3.73606-7.02461,4.78032-10.78834,3.33728-12.02777,8.30509-23.48273,12.05213-35.35757C237.47822,219.51556,239.40852,218.35441,239.2622,216.225Z"
            class="cls-84"
          />
          <path
            id="path947"
            d="M152.36952,128.59032q3.42087-8.59,6.84156-17.18006c.44682-.54631.23407-1.52667,1.59191-1.86085,4.11416,1.52745,4.25133,5.91019,5.77946,9.36025q.36662.42477.73241.85017,2.6934,7.80069,5.38837,15.6c6.99922,7.31111,10.8094,16.06277,12.94815,25.93867,1.83129,8.456,4.91053,16.64193,7.43808,24.94723-1.16174-.79818-2.81542-1.335-3.402-2.43866-2.86082-5.383-5.296-10.99334-8.19913-16.35156a10.05853,10.05853,0,0,0-4.22022-3.87214c-6.13843-3.03832-12.40754-5.816-18.66932-8.59765a6.4864,6.4864,0,0,0-2.49791-.00265c-.9447-3.07729-1.99152-6.12807-2.80811-9.23922-1.1019-4.19815-2.02674-8.44275-3.02726-12.66766Q151.3179,130.833,152.36952,128.59032Z"
            class="cls-85"
          />
          <path
            id="path949"
            d="M282.06023,335.52353q3.07445,4.63085,6.149,9.26169l-.29062.3672q-2.885-2.62159-5.77012-5.24309a2.06076,2.06076,0,0,1-1.95465-.85166c-2.93722-2.51413-4.14344-6.14519-5.89393-9.38741-4.54634-8.42037-8.88395-16.95326-12.84585-25.67536a3.77127,3.77127,0,0,1,.29364-2.98739c2.60158-1.831,1.7429-5.45088,3.88073-7.52q2.57331,7.50189,5.14643,15.00373c2.70269,7.81517,5.322,15.6613,8.18623,23.41706C279.47677,333.30438,281.00134,334.328,282.06023,335.52353Z"
            class="cls-79"
          />
          <path
            id="path951"
            d="M146.41418,272.53165q1.09833,1.88513,2.19594,3.77075c-.51051.54517-1.2862,1.00631-1.48824,1.64793-1.52274,4.83539-2.89577,9.71782-4.405,14.55765a23.62354,23.62354,0,0,1-1.599,3.293c-4.12533-6.71815-8.23455-13.44645-12.39153-20.145-.70615-1.13777-1.61854-2.14772-2.43568-3.21675q-4.67981-7.39083-9.35979-14.78165a3.29062,3.29062,0,0,0,.45533-.126,8.70408,8.70408,0,0,1,3.27524.35535c8.89613,3.45793,17.64447,7.17969,25.082,13.3724A2.10958,2.10958,0,0,1,146.41418,272.53165Z"
            class="cls-85"
          />
          <path
            id="path953"
            d="M251.43028,241.86712q-.87791,2.2591-1.75571,4.51821l-.83023-.09161-.518-2.97344c-1.20238-6.37613-1.8549-12.83766-2.97044-19.23139-.32841-1.88209-1.1719-4.65627,2.14882-5.3927q2.29673,10.068,4.59346,20.13607Z"
            class="cls-86"
          />
          <path
            id="path955"
            d="M166.58245,118.90966c-1.53756-2.08849-2.97876-4.25976-4.66474-6.22077-.59406-.69093-1.78728-.86719-2.70682-1.27854q-.39791-.73222-.796-1.46429c.05033-1.46526.5429-3.09115.07824-4.36936-2.74525-7.55154-5.72914-15.01613-8.58959-22.52645-.48058-1.262-.74979-2.60442-1.11608-3.91,3.63449,4.80087,7.28463,9.58974,10.89523,14.40826,1.846,2.46366,3.62123,4.98025,5.42818,7.47381C167.95494,106.79183,166.15522,112.9423,166.58245,118.90966Z"
            class="cls-87"
          />
          <path
            id="path957"
            d="M195.17276,447.80669q1.49295,1.89333,2.9859,3.7866c8.30382,9.99055,16.43633,20.10317,22.565,31.64228a1.93069,1.93069,0,0,1-.09242,2.093q-9.38019,1.51038-18.76047,3.0211-1.10739-.80436-2.21433-1.61021c-.62288-5.63608-1.1332-11.28665-1.89891-16.90252-.84048-6.16462-1.9594-12.29093-2.85085-18.44929A16.24166,16.24166,0,0,1,195.17276,447.80669Z"
            class="cls-88"
          />
          <path
            id="path959"
            d="M264.16971,283.76048q-.06.4092-.11988.81841c-1.70464,12.03808-4.85224,23.75281-8.07514,35.442-.77715,2.81895.5914,5.73779-.7507,8.45251-.82145,1.7856-.74678,4.37428-3.76077,4.18956-1.85362-1.83361-1.87567-4.26675-1.87952-6.56407-.01619-9.70988-.47994-19.43076.348-29.12256a11.49623,11.49623,0,0,0-.45661-3.13143,2.73654,2.73654,0,0,1,.37782-1.94824c.22025-.34735.44106-.70545.65069-1.06163a35.10187,35.10187,0,0,1,9.22061-7.122c1.355-.6732,2.62839-1.37247,4.11617-.42624Q264.0055,283.52306,264.16971,283.76048Z"
            class="cls-53"
          />
          <path
            id="path961"
            d="M253.47788,327.88768a15.20108,15.20108,0,0,1,.07888-3.2681q4.47159-18.54329,9.0849-37.05223a16.55229,16.55229,0,0,1,1.40827-2.98851q.06835,1.05732.1368,2.11456a60.55274,60.55274,0,0,1-.83563,15.04869q-.42082,1.05258-.84148,2.10518c.0733.75628.1573,1.51163.1907,2.27216-1.09413,6.64008-3.83956,12.73565-6.25172,18.9396C255.90844,326.44821,255.38686,327.91046,253.47788,327.88768Z"
            class="cls-89"
          />
          <path
            id="path963"
            d="M263.31221,281.44718q-.36235-3.4811-.72481-6.9622l.99246-.45483q6.62667,11.62578,13.25324,23.25168c-.38295.10784-1.00711.41989-1.1139.29387-3.87981-4.57976-7.7115-9.20036-11.54968-13.81525l-.05344-.011C263.18566,283.21315,262.48125,282.598,263.31221,281.44718Z"
            class="cls-38"
          />
          <path
            id="path965"
            d="M263.3511,301.74209q.41768-7.52423.83553-15.04858.721,3.39693,1.44185,6.79409Q264.48965,297.61481,263.3511,301.74209Z"
            class="cls-90"
          />
          <path
            id="path967"
            d="M282.71779,392.25778q-.29112.11271-.57612.24c-2.82092,3.32079-6.10833,5.53258-10.75587,4.51953a4.12708,4.12708,0,0,1-.9652-.87668,5.29173,5.29173,0,0,1-1.33021-3.40531q-2.14642-19.11931-4.0318-38.26593a4.21771,4.21771,0,0,1,1.918-3.21208,5.97118,5.97118,0,0,1,4.24529.08588c4.78892,1.77956,9.70146,3.20056,14.47757,5.00943,2.296.86955,4.40908,2.04075,5.34344,4.54944q.06671.827.134,1.65457Q286.9477,377.40781,282.71779,392.25778Z"
            class="cls-9"
          />
          <path
            id="path969"
            d="M291.04292,360.90207c-7.21426-2.75515-14.41287-5.55366-21.67618-8.1729-.51271-.18485-1.50252.95246-2.27052,1.475-2.046.12659-2.379-1.16585-2.31929-2.78849.29117-1.04974,1.30038-1.41314,1.99719-2.075a105.24863,105.24863,0,0,1,9.8498-9.54547c1.23678-1.13425,2.74323-2.29525,4.68423-1.21589q.41988.66537.84011,1.33041c2.61778,5.7108,5.269,11.407,7.82542,17.14536A26.1007,26.1007,0,0,1,291.04292,360.90207Z"
            class="cls-8"
          />
          <path
            id="path971"
            d="M113.31981,175.94482a14.36775,14.36775,0,0,1,2.55171,2.11135q8.80507,11.56216,17.47235,23.2288a11.46986,11.46986,0,0,1,1.04636,2.36113q-2.97-2.28651-5.94-4.57311Z"
            class="cls-43"
          />
          <path
            id="path973"
            d="M276.17334,471.11843c4.17264-.66251,7.99114-.00247,11.18449,2.99237-5.9633,2.84137-11.91662,5.70432-17.90306,8.49629a9.8692,9.8692,0,0,1-2.48812.45167q3.55744-4.80887,7.11562-9.61787A2.25636,2.25636,0,0,1,276.17334,471.11843Z"
            class="cls-46"
          />
          <path
            id="path975"
            d="M276.17334,471.11843q-1.04618,1.16127-2.0918,2.32251c-3.44151,2.495-7.00389,4.84195-10.29936,7.51744-5.97876,4.85425-11.79857,9.904-17.68491,14.87206q-.77606.34967-1.55266.699c-.6162-.572-1.13466-1.3744-1.86186-1.67963-7.08011-2.97175-14.19527-5.86026-21.30028-8.77252q-.01551-.35082-.02754-.70165c.58774-1.59282,2.0132-1.641,3.36107-1.79844,5.64724-.65953,11.28826-1.40093,16.966-.17663a4.36809,4.36809,0,0,0,2.90987-.23882q15.38616-6.39835,30.77234-12.79652Q275.76875,470.74193,276.17334,471.11843Z"
            class="cls-63"
          />
          <path
            id="path977"
            d="M244.59192,483.16175q-11.61831,1.10646-23.23672,2.21344-.36193-.02828-.724-.04665-.37925-.74145-.75831-1.48288c-.01015-2.01632-1.64837-3.46865-1.93414-5.32221-.2844-1.84349-1.95757-4.22367,1.25765-5.3099,6.35027,2.72533,12.67446,5.514,19.066,8.139A56.59909,56.59909,0,0,0,244.59192,483.16175Z"
            class="cls-23"
          />
          <path
            id="path979"
            d="M200.20606,234.18657c2.49653-3.49348,5.99316-6.987,8.807-10.92451-1.07308-2.19948-2.24673-4.605-3.42037-7.01059a.35841.35841,0,0,1,.14421-.59952l2.1533-.06739c7.88975,0,15.7795,0,24.14838,0-.51078,2.42971-1.053,5.00941-1.5953,7.5891,1.03519,1.37148.54857,2.65925-.20818,3.93647-3.71986,2.09274-4.304,6.53642-7.02329,9.39859-1.10227,1.16016-1.8753,2.65251-3.72654,2.77068-5.77589.05543-11.24094-1.48953-16.663-3.23394C201.95475,235.76637,200.34231,235.15572,200.20606,234.18657Z"
            class="cls-7"
          />
          <path
            id="path981"
            d="M205.73693,215.652a3.28509,3.28509,0,0,0-.14421.59955c-.702.45182-1.40415.90368-2.51968,1.6217-.523-1.91056-.96465-3.5241-1.40625-5.13765.22519-1.91943.921-3.92658.5827-5.74106-.84221-4.51623-2.1554-8.9447-3.27918-13.40994q10.54606,6.34174,21.092,12.68648-.07193.62327-.14394,1.24657c-5.3632.62036-10.7265,1.24072-16.83163,1.94687C204.13925,211.92188,204.93809,213.78691,205.73693,215.652Z"
            class="cls-91"
          />
          <path
            id="path983"
            d="M228.8255,226.02086q.80873-1.42375,1.61762-2.84736,4.40982-3.47382,8.81927-6.94828c.07494,1.18042.5267,2.49177.16891,3.5223-5.64559,16.26172-11.39439,32.48755-17.12929,48.71822a3.46167,3.46167,0,0,1-.52222.68953l-.42541-1.14461a2.35714,2.35714,0,0,1-.94525-2.29162,327.04577,327.04577,0,0,1,5.49992-32.274C226.526,230.84467,227.91639,228.52125,228.8255,226.02086Z"
            class="cls-92"
          />
          <path
            id="path985"
            d="M247.50471,218.69619c.0861,4.76431.12518,9.53007.27378,14.29245.10752,3.4462.36035,6.88786.548,10.33161q-3.34977-14.612-6.69936-29.224a5.81977,5.81977,0,0,0,.07677-.66609c1.1182-.47495,2.23621-.9501,4.20009-1.78475C246.47967,214.18118,246.99219,216.43868,247.50471,218.69619Z"
            class="cls-93"
          />
          <path
            id="path987"
            d="M178.6474,270.2886c-.38213-.46664-.76416-.93329-1.07317-1.31071-3.86133,2.58377-7.50086,5.2448-11.382,7.488-1.2764.73767-3.17843.39352-4.7945.54394q8.62665-13.48093,17.25338-26.96163c.31514.48506.93692.99666.89748,1.451-.34214,3.94374-.87982,7.87119-1.19,11.8168a32.05842,32.05842,0,0,0,.2962,4.71116A1.57145,1.57145,0,0,1,178.6474,270.2886Z"
            class="cls-19"
          />
          <path
            id="path989"
            d="M272.36344,428.40632a9.29539,9.29539,0,0,1-2.51575,1.34335c-7.6469,1.35738-15.31182,2.61246-22.97144,3.898a1.60533,1.60533,0,0,1-1.87778.03449c-2.50248-3.90176-.54912-7.88848-.12527-11.81667.11905-1.103.84121-2.17227.83279-3.375a2.91278,2.91278,0,0,1,.53329-1.70345c2.90666-4.64631,7.6598-7.38344,11.55188-11.0075,3.08967-2.87712,6.41057-5.51858,9.607-8.29039,1.19094-1.03276,2.2718-2.49611,4.19651-1.44158l-.01537.22826a4.42225,4.42225,0,0,1,1.75269,3.93688C273.39891,409.623,274.045,419.05563,272.36344,428.40632Z"
            class="cls-94"
          />
          <path
            id="path991"
            d="M245.39121,434.40054q-.95091,23.53455-1.90184,47.06914l-.79829.276q-8.77927-12.07351-17.55864-24.147a5.26226,5.26226,0,0,1,1.039-3.11c5.0261-6.14871,9.72416-12.56817,15.14227-18.392C242.37859,434.95219,243.45314,433.567,245.39121,434.40054Z"
            class="cls-93"
          />
          <path
            id="path993"
            d="M245.39121,434.40054c-5.27234,6.2593-10.51713,12.54219-15.83623,18.76156-1.35318,1.58236-2.94208,2.96329-4.42263,4.43671q-5.61192-3.75969-11.22392-7.5195c2.19612-1.92609,4.524-3.72289,6.561-5.80411,4.40029-4.49588,8.65125-9.13779,12.96334-13.71993,4.79679-2.26168,8.35917.33793,11.90079,3.01954q.77124.0363,1.54259.07272Q246.13374,434.02423,245.39121,434.40054Z"
            class="cls-95"
          />
          <path
            id="path995"
            d="M272.36344,428.40627q-.39188-16.06616-.78383-32.13131,5.28044-1.88831,10.5617-3.77781c-2.52106,9.36821-5.07643,18.7269-7.54121,28.10932-.66076,2.51556-1.045,5.10369-1.5566,7.65757Q272.7042,428.33985,272.36344,428.40627Z"
            class="cls-96"
          />
          <path
            id="path997"
            d="M219.19642,473.21355c.22007,2.26013.48049,4.51733.64465,6.78153.09251,1.27749.02645,2.56646.03194,3.85039q-10.41937-15.0988-20.8229-30.20878a11.47866,11.47866,0,0,1-.89154-2.04331Q208.67759,462.4034,219.19642,473.21355Z"
            class="cls-97"
          />
          <path
            id="path999"
            d="M213.85847,378.91076c-.56788.93686-1.13576,1.87377-1.73412,2.86089-6.95576.68665-13.73619,1.356-21.42289,2.11479,3.44132-11.01806,6.67264-21.36364,9.904-31.70923q-.5246-.23435-1.04911-.46873-4.93991,11.673-9.8798,23.34594l-.802-.1109q-.62234-8.14473-1.24493-16.28982-.38967-3.725-.77944-7.44925l.076.01c2.808-3.70834,6.91266-5.871,10.45784-8.69335a39.12057,39.12057,0,0,0,5.22073-4.73379c3.14823-3.6804,4.3357-8.42865,6.81439-12.4692.84569-1.37847,1.25142-3.40389,3.64135-2.9037,2.55775,3.71882,2.963,8.24182,4.5899,12.31178.92694,2.31917,1.65514,4.73366,2.62866,7.05027-1.40021,10.43687-2.21479,20.92085-3.92831,31.288C216.00719,375.14164,216.28985,377.6533,213.85847,378.91076Z"
            class="cls-15"
          />
          <path
            id="path1001"
            d="M247.56656,417.10517l-.68848.79357c-1.94878,4.65116-5.45892,7.93262-9.45943,10.7872a5.72108,5.72108,0,0,1-4.07728,1.232q-4.47405-3.40131-8.948-6.80294c-.002-11.7-.10194-23.40073.02388-35.09908.10413-9.69324.45423-19.38423.75528-29.07436a17.79939,17.79939,0,0,1,.70029-3.23756c1.64691.15047,1.93186,1.17866,2.2621,2.67549,1.61278,7.30953,3.1981,14.62716,4.94905,21.90687a7.02741,7.02741,0,0,0,2.47531,4.39857c1.519,2.6512,1.72862,5.67646,2.10864,8.58322a25.34935,25.34935,0,0,0,3.24166,9.00919C243.51527,407.0354,246.54345,411.62852,247.56656,417.10517Z"
            class="cls-98"
          />
          <path
            id="path1003"
            d="M234.1586,385.67574c-.12747.30546-.255.611-.62608,1.49957-2.643-10.85964-5.15128-21.16552-7.65962-31.47132-.4772.25158-1.3411.45894-1.37568.761-1.58423,13.86116-3.08986,27.73129-4.61991,41.59867-.4492,4.07147-.9437,8.138-1.41751,12.20673l-1.25371.08946q-1.67358-15.7244-3.34735-31.44892,2.11033-17.254,4.2193-34.50787c.12042-.9863.21614-1.97571.32338-2.96366,1.84456-.5548,1.84785.93924,2.3849,2.00832.59716,1.18894.57685,3.04291,2.60872,2.93333,1.30184-1.47245.48433-3.24684.7368-4.85087.27067-1.71955.24541-3.6895,2.928-3.22891,1.80118,1.63888,2.15631,3.97991,2.50165,6.11153,2.0144,12.43778,4.03382,24.87579,5.91343,37.33538C235.70769,383.29107,235.78162,384.76275,234.1586,385.67574Z"
            class="cls-67"
          />
          <path
            id="path1005"
            d="M233.34137,429.918q6.76816-6.00966,13.53662-12.01923-.77179,7.83851-1.54415,15.67653-5.95122-1.50976-11.90152-3.01936Q233.38442,430.23671,233.34137,429.918Z"
            class="cls-99"
          />
          <path
            id="path1007"
            d="M201.20606,234.18657q9.33681,1.93638,18.67353,3.87272c1.89151,1.03535,1.70355,2.9165,1.778,4.61509a164.019,164.019,0,0,1-1.76184,29.869q-.03267.74311-.06515,1.48624c-.70121.90892.342,2.33609-1.01562,3.34844-5.56095.52052-10.78717-1.25465-16.01641-2.99773a2.307,2.307,0,0,1-1.43324-.98941c-.53741-2.23354.50456-4.11725,1.4068-6.01384a146.95886,146.95886,0,0,1,10.14681-18.49825c-3.04721,5.63231-7.91656,11.89236-13.01056,17.98514-.99393,1.18881-2.05365,2.83075-3.95091,1.10635l-.13122-2.01543a228.81472,228.81472,0,0,1,2.62418-27.68544c.21961-1.51995.08126-3.35349,2.04926-4.04613Q200.85307,234.21007,201.20606,234.18657Z"
            class="cls-6"
          />
          <path
            id="path1009"
            d="M200.49964,234.22328c-1.11783,9.28567-2.20253,18.5756-3.391,27.85222a20.87265,20.87265,0,0,1-1.28226,3.87823q-.39145-6.46415-.78282-12.93059.45129-5.55939.90361-11.11806.94461-7.08507,1.88866-14.17137l.88422-.1088Q199.6099,230.9241,200.49964,234.22328Z"
            class="cls-2"
          />
          <path
            id="path1011"
            d="M212.441,322.64588c-2.33576,4.89139-4.63116,9.803-7.06062,14.64742-.28989.57789-1.31036.78969-1.99216,1.1712-1.51917.24687-2.33869-.664-2.91059-1.85076-5.62738-11.675-12.41825-22.79428-16.78048-35.073a6.58457,6.58457,0,0,1-.55928-3.50188q-2.24513-13.87524-4.49043-27.7504.00357-1.1305.00732-2.2613c5.52929,3.10633,11.03725,6.252,16.60616,9.28561a18.96344,18.96344,0,0,0,3.66469,1.13565c1.61067-.32949,2.18569.77533,2.59353,1.96779.94506,2.76364,2.1737,5.43074,2.8771,8.284.16325.72813-.12536,1.49488.16965,2.20813,3.694,8.934,4.80832,18.61756,8.03515,27.69257C213.04371,319.84577,214.17782,321.37662,212.441,322.64588Z"
            class="cls-38"
          />
          <path
            id="path1013"
            d="M202.57854,289.08451q-1.82663-5.31768-3.65306-10.63567-1.16505-4.09051-2.33018-8.18024c.05966-1.656,1.23852-1.7097,2.34308-1.41941a3.50843,3.50843,0,0,1,2.86118,3.77153l.711.74533a8.38011,8.38011,0,0,1,3.12737,4.94844c5.4495,18.52873,10.73154,37.10573,16.06757,55.66716.44883,1.56122.95622,3.163-.52085,4.51875-2.58429.85656-2.72557-1.39662-3.186-2.76636-3.99731-11.89162-7.74-23.86683-11.62362-35.79577C205.18982,296.298,204.45092,292.48845,202.57854,289.08451Z"
            class="cls-2"
          />
          <path
            id="path1015"
            d="M201.79956,272.62077q-2.602-1.176-5.20417-2.35206-.31966-1.14855-.63852-2.29768c3.34286-3.95668,6.76515-7.84851,10.006-11.88586,3.55772-4.43213,6.94816-8.99833,10.41145-13.50617l.97837.5727Q209.57608,257.88622,201.79956,272.62077Z"
            class="cls-100"
          />
          <path
            id="path1017"
            d="M183.13783,298.03889q10.12523,20.21282,20.25035,40.42561c-.0603.36761.01373.92044-.20049,1.07576-5.40237,3.9168-10.835,7.79175-16.262,11.67411Q185.566,335.3,184.20139,319.38577c-.54711-6.29083-1.16834-12.57544-1.67015-18.86972A8.20437,8.20437,0,0,1,183.13783,298.03889Z"
            class="cls-63"
          />
          <path
            id="path1019"
            d="M146.41418,272.53168q-14.51459-7.50012-29.02853-15.00015c3.79591-.26139,7.589-.56388,11.38745-.76678,1.86277-.09949,3.73533-.014,5.60322-.01259a14.52288,14.52288,0,0,1,2.91407,2.17952c3.05618,3.78348,6.00575,7.65507,8.90482,11.56076C146.5465,270.96576,146.35443,271.84212,146.41418,272.53168Z"
            class="cls-81"
          />
          <path
            id="path1021"
            d="M220.64256,338.45961c-.4771-2.05218-.86472-4.13006-1.44541-6.15255q-8.04274-28.01064-16.1307-56.00841c-.27379-.95234-.37334-1.95472-.55489-2.9332,4.11114.78,8.25449,1.42764,12.3229,2.39164,2.19448.52,3.88759.47209,4.99654-1.72765q.404.75342.80882,1.50657c.5041.51078,1.08644.97361,1.09806,1.78724,1.95189,4.63165,4.57324,8.9373,6.59166,13.53476,3.67439,8.36969,8.23216,16.34184,11.26117,25.00327a2.891,2.891,0,0,1-.44142,2.10034c-1.18481,4.17606-4.2915,7.27377-6.21631,11.03717-.60458,1.182-1.79524,2.13619-1.30541,4.15439,5.603.36949,11.18183-1.14029,16.82486-1.196,1.2139.23228,2.29238,1.00331,3.58947.89648,2.293.22163,3.19535,2.19244,4.4659,3.64276,2.20344,2.51532,3.99951,5.38152,6.44855,7.639,1.428.05836,1.78572-1.94127,3.28119-1.51457,2.06673.8699,1.76751,2.6839,1.719,4.36979-.03285,1.14015-.76059,2.2503-.14522,3.42077l-2.20728.83565c-1.82891,2.22277-3.76095.57831-5.42214-.08836-9.84-3.94922-19.73215-7.76317-29.60912-11.6169a10.03946,10.03946,0,0,0-3.93866-1.08069l-2.28643,11.25606C221.77384,346.40493,219.48859,342.9978,220.64256,338.45961Z"
            class="cls-6"
          />
          <path
            id="path1023"
            d="M219.91272,276.9714q.36345-.71778.7271-1.43546,12.4317-11.84949,24.88316-23.67817a30.89475,30.89475,0,0,1,3.57785-2.55057c2.629,8.23153,3.0699,16.7621,3.3328,25.29716.0959,3.1144.65948,6.17243.74686,9.27852.0744,2.63952-.15821,5.18569-1.76531,7.41575l-.02892-.00942c-1.40945,1.02762-2.771.57074-4.1967-.037-7.73785-3.29829-15.24941-7.08962-22.9438-10.48048C222.38025,279.94955,221.49,278.0842,219.91272,276.9714Z"
            class="cls-101"
          />
          <path
            id="path1025"
            d="M251.41518,291.29863q-1.15695-20.99572-2.31417-41.99143,6.17467,14.25006,12.36042,28.49544c.54345,1.24725,1.23074,2.43193,1.85106,3.64507q.40147,1.1504.80359,2.30181Q257.76559,287.524,251.41518,291.29863Z"
            class="cls-63"
          />
          <path
            id="path1027"
            d="M219.8957,272.54334q-.0081-17.242-.01611-34.48408,4.473-6.01915,8.94591-12.03836-2.58032,14.54881-5.1618,29.09748-1.146,6.44781-2.30914,12.89244Q220.625,270.27691,219.8957,272.54334Z"
            class="cls-72"
          />
          <path
            id="path1029"
            d="M267.81133,350.41146l-2.19145-7.46534c-1.74665-.69726-1.694-2.31419-1.85289-3.76437-1.2247-11.1785-2.51209-22.3553-1.86341-33.638q.30335-.84732.60622-1.69554,7.95148,14.75711,15.90643,29.51427c.94405,1.74928,1.92709,3.47748,2.892,5.2161Q274.5597,344.49575,267.81133,350.41146Z"
            class="cls-77"
          />
          <path
            id="path1031"
            d="M219.91272,276.9714q15.73673,7.15879,31.47354,14.31767l-.07082,1.46066c-1.58094,7.61083-5.75814,14.09118-9.15006,20.90953-.68985,1.38661-1.3357,3.12535-3.54545,2.32971-2.79512-5.53978-5.68961-11.03224-8.361-16.631C226.719,291.93928,223.35331,284.43748,219.91272,276.9714Z"
            class="cls-15"
          />
          <path
            id="path1033"
            d="M261.90367,305.54373c.67723,4.38683,1.58075,8.75306,1.98255,13.165.73442,8.065,1.172,16.157,1.73348,24.23752q.00027,2.74467.00018,5.48955l-1.07061.58508a105.95756,105.95756,0,0,1-12.44762-15.80436.51834.51834,0,0,1-.24048-.56559q.09334-.29827.198-.29837.70976-2.23227,1.41906-4.46469Q257.69055,316.71565,261.90367,305.54373Z"
            class="cls-15"
          />
          <path
            id="path1035"
            d="M252.05928,332.35256l.04255.864q-1.87164.3727-3.74292.74551c-1.79634-3.99551-4.59457-7.3314-7.24766-10.73913a19.3675,19.3675,0,0,1-3.23736-5.73171q.37307-.75111.746-1.50231c3.07695-5.83514,6.12535-11.68557,9.24659-17.49695,1.05532-1.96485,2.29449-3.831,3.44928-5.74225.01739,11.63334.0097,23.26686.08336,34.89982A34.46343,34.46343,0,0,0,252.05928,332.35256Z"
            class="cls-57"
          />
          <path
            id="path1037"
            d="M226.63413,338.46112c.55132-3.12858,2.37493-1.63609,3.89309-1.0394Q248.0719,344.318,265.604,351.24666q.74627,1.47918,1.49226,2.95748,2.24911,20.92263,4.49849,41.84435Q259.581,406.57635,247.567,417.10563a19.67857,19.67857,0,0,1-2.55638-3.019,131.46524,131.46524,0,0,1-6.8691-13.15782c-1.481-3.57466-2.04011-7.53125-3.00448-11.31926-.33335-1.30959-.65307-2.62262-.97865-3.934q-3.61659-21.93456-7.22286-43.87114C226.7552,340.70309,226.731,339.57616,226.63413,338.46112Z"
            class="cls-102"
          />
          <path
            id="path1039"
            d="M220.64256,338.45961q1.85271,5.62871,3.70532,11.25752c-.1034.32983-.20671.65958-.54436,1.73725-1.98695-3.68346-3.69452-6.84912-5.4021-10.01488q-2.98028-9.39669-5.96055-18.79339Q207.51,305.865,202.57873,289.08442a10.90342,10.90342,0,0,1,1.69385,2.43968c5.06773,14.7366,10.06656,29.49685,15.10547,44.24342A26.15726,26.15726,0,0,0,220.64256,338.45961Z"
            class="cls-103"
          />
          <path
            id="path1041"
            d="M237.87389,317.49124c2.08476,2.19926,4.27942,4.30636,6.22472,6.62266,2.1285,2.53421,4.02659,5.26179,6.1647,8.08993-.69928.64572-1.30184,1.20208-1.9044,1.75834-6.84715.53673-13.69429,1.07361-21.77163,1.70693C230.77337,328.92713,234.32367,323.20919,237.87389,317.49124Z"
            class="cls-104"
          />
          <polygon
            id="polygon1043"
            points="197.836 227.734 203.073 217.873 207.89 215.585 209.013 223.262 200.5 234.223 197.836 227.734"
            class="cls-2"
          />
          <polygon
            id="polygon1045"
            points="215.367 212.548 222.075 209.568 233.23 208.381 241.563 210.339 222.116 213.041 215.367 212.548"
            class="cls-7"
          />
          <polygon
            id="polygon1047"
            points="203.073 217.873 199.97 204.729 188.597 219.308 194.948 233.87 195.947 241.905 197.772 229.211 203.073 217.873"
            class="cls-91"
          />
          <polygon
            id="polygon1049"
            points="195.835 240.341 195.044 254.023 191.596 247.184 189.106 235.263 185.655 223.317 188.597 219.308 194.948 233.87 195.835 240.341"
            class="cls-18"
          />
          <polygon
            id="polygon1051"
            points="192.596 246.184 189.106 264.624 189.494 274.03 195.261 277.313 198.925 278.449 195.826 265.954 195.044 253.023 192.596 246.184"
            class="cls-18"
          />
          <polygon
            id="polygon1053"
            points="198.925 278.449 202.579 289.084 212.441 322.646 207.026 333.962 189.494 274.03 198.925 278.449"
            class="cls-10"
          />
          <polygon
            id="polygon1055"
            points="220.062 206.271 221.346 206.238 222.075 209.568 205.576 216.542 203.087 209.464 220.062 206.271"
            class="cls-91"
          />
          <polygon
            id="polygon1057"
            points="222.075 209.568 233.23 208.381 231.775 203.429 221.346 206.238 222.075 209.568"
            class="cls-18"
          />
          <polygon
            id="polygon1059"
            points="231.775 203.429 241.674 202.667 239.541 209.705 233.23 208.381 231.775 203.429"
            class="cls-75"
          />
          <polygon
            id="polygon1061"
            points="245.904 211.645 247.918 220.507 248.201 240.944 248.844 246.294 249.101 249.307 263.312 281.448 258.175 250.036 254.273 240.561 251.354 233.827 245.904 211.645"
            class="cls-54"
          />
        </g>
        <circle
          @click="falert"
          fill="#ff0000"
          r="16"
          cy="493.34225"
          cx="281.6779"
          id="p44"
          class="pa"
        />
        <circle
          class="pa"
          id="p42"
          @click="falert"
          cx="274.52719"
          cy="375.19888"
          r="16"
          fill="#ff0000"
        />
        <circle
          fill="#ff0000"
          r="16"
          @click="falert"
          cy="298.6824"
          cx="250.04189"
          id="p41"
          class="pa"
        />
        <circle
          r="16"
          fill="#ff0000"
          cy="436.41214"
          cx="258.20364"
          @click="falert"
          id="p43"
          class="pa"
        />
        <circle
          @click="falert"
          class="pa"
          id="p45"
          cx="272.48672"
          cy="539.45441"
          r="16"
          fill="#ff0000"
        />
      </svg>
    </div>

    <div class="flex-initial z-30" id="right-arrow">
      <svg
        width="35px"
        height="31px"
        viewBox="0 0 35 31"
        version="1.1"
        class="cursor-pointer arrow-right"
        @click="turnRight"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Website" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            id="Desktop---1.1---Homepage-Callout"
            transform="translate(-1167.000000, -453.000000)"
            fill="#FF0000"
          >
            <g id="Group" transform="translate(1167.000000, 453.000000)">
              <polygon
                id="Triangle"
                transform="translate(11.500000, 15.500000) rotate(-270.000000) translate(-11.500000, -15.500000) "
                points="11.5 4 27 27 -4 27"
              />
              <polygon
                id="Triangle"
                fill-opacity="0.5"
                transform="translate(23.500000, 15.500000) rotate(-270.000000) translate(-23.500000, -15.500000) "
                points="23.5 4 39 27 8 27"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ["left"],
  data() {
    return {
      face: 0,
      ol: 0,
      ot: 0,
      selected: false,
      hand: null,
      point: "",
      center: "left:150px",
    };
  },
  watch: {
    left() {
      this.selected = false;
    },
  },
  computed: {
    trans() {
      return this.left ? "transform: scale(-1,1)" : "transform: scale(1,1)";
    },
    target() {
      return "left:" + this.ol + "px;top:" + this.ot + "px;z-index:100";
    },
  },
  mounted() {
    this.hand = document.getElementById("front-hand-svg");
  },
  created() {
    const handleEscape = (e) => {
      if (e.key === "ArrowLeft") this.turnLeft();
      if (e.key === "ArrowRight") this.turnRight();
    };
    document.addEventListener("keydown", handleEscape);
    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("keydown", handleEscape);
    });
  },

  methods: {
    results() {
      //   this.$parent.$parent.query = ;
      window.router.push({
        name: "Results",
        params: {
        //   pain: this.point,
          from: "painpoint",
          detail: this.point.substring(1),
        },
      });
    },
    falert(e) {
      //   var hand = document.getElementById("hand-front");
      var z = e.target;
      var p = {
        id: z.id,
        x: z.cx.baseVal.value,
        y: z.cy.baseVal.value,
        hw: this.hand.width.baseVal.value,
        hh: this.hand.height.baseVal.value,
        bw: this.hand.viewBox.baseVal.width,
        bh: this.hand.viewBox.baseVal.height,
      };
      p.dh = p.hh / p.bh;
      p.dw = p.hw / p.bw;

      var deltax = window.innerWidth < 1024 ? 25 : 22;
      var deltay = window.innerWidth < 1024 ? 8 : 12;

      p.ot = (p.y - 50) * p.dh - deltay;
      if (this.left) {
        p.ol = p.hw - p.x * p.dw + deltax;
      } else {
        p.ol = p.x * p.dw + deltax;
      }
      //   console.log(p.id);
      this.point = p.id;
      this.ot = p.ot;
      this.ol = p.ol;

      this.selected = p.id;
    },
    turnLeft() {
      this.turn(!this.left);
    },
    turnRight() {
      this.turn(this.left);
    },

    turn(dir) {
      this.selected = false;
      if (dir) {
        this.face = --this.face;
        if (this.face < 0) this.face = 3;
      } else {
        this.face = ++this.face % 4;
      }
      this.$nextTick(() => {
        switch (this.face) {
          case 0:
            this.hand = document.getElementById("front-hand-svg");
            break;
          case 1:
            this.hand = document.getElementById("left-side-svg");
            break;
          case 2:
            this.hand = document.getElementById("back-hand-svg");
            break;
          case 3:
            this.hand = document.getElementById("right-side-svg");
            break;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.pa {
  fill: #fdd;
  fill-opacity: 0.25;
  stroke: none;
  cursor: pointer;
}
.pb {
  fill: red;
  fill-opacity: 0.75;
  stroke: none;
  cursor: pointer;
  filter: url(#f2);
}

.marker,
.pa:hover {
  fill: red;
  fill-opacity: 1;
  filter: url(#f1);
}

.bolt {
  transform: scale(0.2);
}

.ring-container {
  position: relative;
  top: -18px;
  left: -18px;
  z-index: 50;
}

.circle {
  width: 15px;
  height: 15px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 23px;
  left: 23px;
}

.ringring {
  border: 3px solid #fff;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  height: 25px;
  width: 25px;
  position: absolute;
  left: 18px;
  top: 18px;
  -webkit-animation: pulsate 1s ease-out;
  -webkit-animation-iteration-count: infinite;
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
}
@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(2, 2);
    transform: scale(2, 2);
    opacity: 0;
  }
}

@keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(2, 2);
    transform: scale(2, 2);
    opacity: 0;
  }
}

#front-hand {
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #f1f1f1;
  }
  .cls-3 {
    fill: #eaeaea;
  }
  .cls-4 {
    fill: #cecece;
  }
  .cls-5 {
    fill: #cdcdcd;
  }
  .cls-6 {
    fill: #999;
  }
  .cls-7 {
    fill: #c8c8c8;
  }
  .cls-8 {
    fill: #adadad;
  }
  .cls-9 {
    fill: #202020;
  }
  .cls-10 {
    fill: #bebebe;
  }
  .cls-11 {
    fill: #5d5d5d;
  }
  .cls-12 {
    fill: #7d7d7d;
  }
  .cls-13 {
    fill: #212121;
  }
  .cls-14 {
    fill: #e6e6e6;
  }
  .cls-15 {
    fill: #6c6c6c;
  }
  .cls-16 {
    fill: #252525;
  }
  .cls-17 {
    fill: #1d1d1d;
  }
  .cls-18 {
    fill: #b9b9b9;
  }
  .cls-19 {
    fill: #313131;
  }
  .cls-20 {
    fill: #4b4b4b;
  }
  .cls-21 {
    fill: #cacaca;
  }
  .cls-22 {
    fill: #bfbfbf;
  }
  .cls-23 {
    fill: #dadada;
  }
  .cls-24 {
    fill: #464646;
  }
  .cls-25 {
    fill: #c5c5c5;
  }
  .cls-26 {
    fill: #393939;
  }
  .cls-27 {
    fill: #f2f2f2;
  }
  .cls-28 {
    fill: #bdbdbd;
  }
  .cls-29 {
    fill: #e2e2e2;
  }
  .cls-30 {
    fill: #8c8c8c;
  }
  .cls-31 {
    fill: #bbb;
  }
  .cls-32 {
    fill: #4d4d4d;
  }
  .cls-33 {
    fill: #717171;
  }
  .cls-34 {
    fill: #8f8f8f;
  }
  .cls-35 {
    fill: #c4c4c4;
  }
  .cls-36 {
    fill: #282828;
  }
  .cls-37 {
    fill: #a8a8a8;
  }
  .cls-38 {
    fill: #b7b7b7;
  }
  .cls-39 {
    fill: #d8d8d8;
  }
  .cls-40 {
    fill: #bababa;
  }
  .cls-41 {
    fill: #dedede;
  }
  .cls-42 {
    fill: #616161;
  }
  .cls-43 {
    fill: #ababab;
  }
  .cls-44 {
    fill: #a6a6a6;
  }
  .cls-45 {
    fill: #f0f0f0;
  }
  .cls-46 {
    fill: #262626;
  }
  .cls-47 {
    fill: #929292;
  }
  .cls-48 {
    fill: #a2a2a2;
  }
  .cls-49 {
    fill: #eee;
  }
  .cls-50 {
    fill: #e1e1e1;
  }
  .cls-51 {
    fill: #c3c3c3;
  }
  .cls-52 {
    fill: #272727;
  }
  .cls-53 {
    fill: #d7d7d7;
  }
  .cls-54 {
    fill: #9c9c9c;
  }
  .cls-55 {
    fill: #a9a9a9;
  }
  .cls-56 {
    fill: #7a7a7a;
  }
  .cls-57 {
    fill: #a7a7a7;
  }
  .cls-58 {
    fill: #989898;
  }
  .cls-59 {
    fill: #8e8e8e;
  }
  .cls-60 {
    fill: #b6b6b6;
  }
  .cls-61 {
    fill: #888;
  }
  .cls-62 {
    fill: #565656;
  }
  .cls-63 {
    fill: #818181;
  }
  .cls-64 {
    fill: #5f5f5f;
  }
  .cls-65 {
    fill: #d6d6d6;
  }
  .cls-66 {
    fill: #e9e9e9;
  }
  .cls-67 {
    fill: #fefefe;
  }
  .cls-68 {
    fill: #d5d5d5;
  }
  .cls-69 {
    fill: silver;
  }
  .cls-70 {
    fill: #fdfdfd;
  }
  .cls-71 {
    fill: #c9c9c9;
  }
  .cls-72 {
    fill: #a5a5a5;
  }
  .cls-73 {
    fill: #c1c1c1;
  }
  .cls-74 {
    fill: #8d8d8d;
  }
  .cls-75 {
    fill: #efefef;
  }
  .cls-76 {
    fill: #bcbcbc;
  }
  .cls-77 {
    fill: #3b3b3b;
  }
  .cls-78 {
    fill: #aeaeae;
  }
  .cls-79 {
    fill: #8b8b8b;
  }
  .cls-80 {
    fill: #dfdfdf;
  }
  .cls-81 {
    fill: #666;
  }
  .cls-82 {
    fill: #b3b3b3;
  }
  .cls-83 {
    fill: #797979;
  }
  .cls-84 {
    fill: #7e7e7e;
  }
  .cls-85 {
    fill: #909090;
  }
  .cls-86 {
    fill: #505050;
  }
  .cls-87 {
    fill: #515151;
  }
  .cls-88 {
    fill: #d4d4d4;
  }
  .cls-89 {
    fill: #686868;
  }
  .cls-90 {
    fill: #171717;
  }
  .cls-91 {
    fill: #848484;
  }
  .cls-92 {
    fill: #919191;
  }
  .cls-93 {
    fill: #444;
  }
  .cls-94 {
    fill: #585858;
  }
  .cls-95 {
    fill: #ededed;
  }
  .cls-96 {
    fill: #959595;
  }
  .cls-97 {
    fill: #e7e7e7;
  }
  .cls-98 {
    fill: #b4b4b4;
  }
  .cls-99 {
    fill: #ddd;
  }
  .cls-100 {
    fill: #e4e4e4;
  }
  .cls-101 {
    fill: #ececec;
  }
  .cls-102 {
    fill: #d3d3d3;
  }
  .cls-103 {
    fill: #656565;
  }
  .cls-104 {
    fill: #838383;
  }
  .cls-105 {
    fill: #e0e0e0;
  }
  .cls-106 {
    mask: url(#mask);
  }
}
#left-side {
  .cls-1 {
    mask: url(#mask);
  }
  .cls-2 {
    fill: #fff;
  }
  .cls-3 {
    fill: #d9d9d9;
  }
  .cls-4 {
    fill: #d3d3d3;
  }
  .cls-5 {
    fill: #212121;
  }
  .cls-6 {
    fill: #ececec;
  }
  .cls-7 {
    fill: #1f1f1f;
  }
  .cls-8 {
    fill: #e7e7e7;
  }
  .cls-9 {
    fill: #828282;
  }
  .cls-10 {
    fill: #272727;
  }
  .cls-11 {
    fill: #414141;
  }
  .cls-12 {
    fill: #2a2a2a;
  }
  .cls-13 {
    fill: #404040;
  }
  .cls-14 {
    fill: #dbdbdb;
  }
  .cls-15 {
    fill: #a8a8a8;
  }
  .cls-16 {
    fill: #2d2d2d;
  }
  .cls-17 {
    fill: #353535;
  }
  .cls-18 {
    fill: #c4c4c4;
  }
  .cls-19 {
    fill: #adadad;
  }
  .cls-20 {
    fill: #d1d1d1;
  }
  .cls-21 {
    fill: #fefefe;
  }
  .cls-22 {
    fill: #686868;
  }
  .cls-23 {
    fill: #d2d2d2;
  }
  .cls-24 {
    fill: #eaeaea;
  }
  .cls-25 {
    fill: #d5d5d5;
  }
  .cls-26 {
    fill: #eee;
  }
  .cls-27 {
    fill: #5b5b5b;
  }
  .cls-28 {
    fill: #f0f0f0;
  }
  .cls-29 {
    fill: #929292;
  }
  .cls-30 {
    fill: #b4b4b4;
  }
  .cls-31 {
    fill: #e8e8e8;
  }
  .cls-32 {
    fill: #c3c3c3;
  }
  .cls-33 {
    fill: #bbb;
  }
  .cls-34 {
    fill: #737373;
  }
  .cls-35 {
    fill: #757575;
  }
  .cls-36 {
    fill: #454545;
  }
  .cls-37 {
    fill: #d7d7d7;
  }
  .cls-38 {
    fill: #c2c2c2;
  }
  .cls-39 {
    fill: #313131;
  }
  .cls-40 {
    fill: #c8c8c8;
  }
  .cls-41 {
    fill: #6b6b6b;
  }
  .cls-42 {
    fill: #a2a2a2;
  }
  .cls-43 {
    fill: #595959;
  }
  .cls-44 {
    fill: #b6b6b6;
  }
  .cls-45 {
    fill: #6d6d6d;
  }
  .cls-46 {
    fill: #dfdfdf;
  }
  .cls-47 {
    fill: #b3b3b3;
  }
  .cls-48 {
    fill: #b2b2b2;
  }
  .cls-49 {
    fill: #6e6e6e;
  }
  .cls-50 {
    fill: #f2f2f2;
  }
  .cls-51 {
    fill: #e5e5e5;
  }
  .cls-52 {
    fill: #e2e2e2;
  }
  .cls-53 {
    fill: #fcfcfc;
  }
  .cls-54 {
    fill: #a4a4a4;
  }
  .cls-55 {
    fill: #555;
  }
  .cls-56 {
    fill: #6c6c6c;
  }
  .cls-57 {
    fill: #434343;
  }
  .cls-58 {
    fill: #696969;
  }
  .cls-59 {
    fill: #636363;
  }
  .cls-60 {
    fill: #545454;
  }
  .cls-61 {
    fill: #7d7d7d;
  }
  .cls-62 {
    fill: #626262;
  }
  .cls-63 {
    fill: #868686;
  }
  .cls-64 {
    fill: #d4d4d4;
  }
  .cls-65 {
    fill: #b7b7b7;
  }
  .cls-66 {
    fill: #9d9d9d;
  }
  .cls-67 {
    fill: #aaa;
  }
  .cls-68 {
    fill: #f3f3f3;
  }
  .cls-69 {
    fill: #c6c6c6;
  }
  .cls-70 {
    fill: #3e3e3e;
  }
  .cls-71 {
    fill: #fdfdfd;
  }
  .cls-72 {
    fill: #777;
  }
  .cls-73 {
    fill: #787878;
  }
  .cls-74 {
    fill: #878787;
  }
  .cls-75 {
    fill: #727272;
  }
  .cls-76 {
    fill: #fafafa;
  }
  .cls-77 {
    fill: #858585;
  }
  .cls-78 {
    fill: #cecece;
  }
  .cls-79 {
    fill: #cbcbcb;
  }
  .cls-80 {
    fill: #c9c9c9;
  }
  .cls-81 {
    fill: #5f5f5f;
  }
  .cls-82 {
    fill: #818181;
  }
  .cls-83 {
    fill: #9b9b9b;
  }
  .cls-84 {
    fill: #8e8e8e;
  }
  .cls-85 {
    fill: #bfbfbf;
  }
  .cls-86 {
    fill: #848484;
  }
}
#back-hand {
  .cls-1 {
    mask: url(#mask);
  }
  .cls-2 {
    fill: #fff;
  }
  .cls-3 {
    fill: #e1e1e1;
  }
  .cls-4 {
    fill: #cecece;
  }
  .cls-5 {
    fill: #d4d4d4;
  }
  .cls-6 {
    fill: silver;
  }
  .cls-7 {
    fill: #dadada;
  }
  .cls-8 {
    fill: #686868;
  }
  .cls-9 {
    fill: #aeaeae;
  }
  .cls-10 {
    fill: #e8e8e8;
  }
  .cls-11 {
    fill: #cacaca;
  }
  .cls-12 {
    fill: #ddd;
  }
  .cls-13 {
    fill: #ccc;
  }
  .cls-14 {
    fill: #1d1d1d;
  }
  .cls-15 {
    fill: #3b3b3b;
  }
  .cls-16 {
    fill: #545454;
  }
  .cls-17 {
    fill: #9c9c9c;
  }
  .cls-18 {
    fill: #e9e9e9;
  }
  .cls-19 {
    fill: #888;
  }
  .cls-20 {
    fill: #282828;
  }
  .cls-21 {
    fill: #5d5d5d;
  }
  .cls-22 {
    fill: #f3f3f3;
  }
  .cls-23 {
    fill: #adadad;
  }
  .cls-24 {
    fill: #a5a5a5;
  }
  .cls-25 {
    fill: #343434;
  }
  .cls-26 {
    fill: #cbcbcb;
  }
  .cls-27 {
    fill: #3d3d3d;
  }
  .cls-28 {
    fill: #212121;
  }
  .cls-29 {
    fill: #1f1f1f;
  }
  .cls-30 {
    fill: #585858;
  }
  .cls-31 {
    fill: #bbb;
  }
  .cls-32 {
    fill: #b5b5b5;
  }
  .cls-33 {
    fill: #7b7b7b;
  }
  .cls-34 {
    fill: #474747;
  }
  .cls-35 {
    fill: #6e6e6e;
  }
  .cls-36 {
    fill: #8c8c8c;
  }
  .cls-37 {
    fill: #222;
  }
  .cls-38 {
    fill: #373737;
  }
  .cls-39 {
    fill: #a8a8a8;
  }
  .cls-40 {
    fill: #535353;
  }
  .cls-41 {
    fill: #949494;
  }
  .cls-42 {
    fill: #3f3f3f;
  }
  .cls-43 {
    fill: #252525;
  }
  .cls-44 {
    fill: #c3c3c3;
  }
  .cls-45 {
    fill: #9f9f9f;
  }
  .cls-46 {
    fill: #2c2c2c;
  }
  .cls-47 {
    fill: #757575;
  }
  .cls-48 {
    fill: #5f5f5f;
  }
  .cls-49 {
    fill: #9a9a9a;
  }
  .cls-50 {
    fill: #6c6c6c;
  }
  .cls-51 {
    fill: #b9b9b9;
  }
  .cls-52 {
    fill: #acacac;
  }
  .cls-53 {
    fill: #595959;
  }
  .cls-54 {
    fill: #8e8e8e;
  }
  .cls-55 {
    fill: #a1a1a1;
  }
  .cls-56 {
    fill: #d9d9d9;
  }
  .cls-57 {
    fill: #ececec;
  }
  .cls-58 {
    fill: #e3e3e3;
  }
  .cls-59 {
    fill: #f7f7f7;
  }
  .cls-60 {
    fill: #a7a7a7;
  }
  .cls-61 {
    fill: #c9c9c9;
  }
  .cls-62 {
    fill: #fefefe;
  }
  .cls-63 {
    fill: #efefef;
  }
  .cls-64 {
    fill: #afafaf;
  }
  .cls-65 {
    fill: #1e1e1e;
  }
  .cls-66 {
    fill: #676767;
  }
  .cls-67 {
    fill: #262626;
  }
  .cls-68 {
    fill: #f5f5f5;
  }
  .cls-69 {
    fill: #d6d6d6;
  }
  .cls-70 {
    fill: #fdfdfd;
  }
  .cls-71 {
    fill: #d5d5d5;
  }
  .cls-72 {
    fill: #f4f4f4;
  }
  .cls-73 {
    fill: #979797;
  }
  .cls-74 {
    fill: #8b8b8b;
  }
  .cls-75 {
    fill: #dfdfdf;
  }
  .cls-76 {
    fill: #a6a6a6;
  }
  .cls-77 {
    fill: #818181;
  }
  .cls-78 {
    fill: #e5e5e5;
  }
  .cls-79 {
    fill: #d7d7d7;
  }
  .cls-80 {
    fill: #e7e7e7;
  }
  .cls-81 {
    fill: #eaeaea;
  }
  .cls-82 {
    fill: #bdbdbd;
  }
  .cls-83 {
    fill: #969696;
  }
  .cls-84 {
    fill: #747474;
  }
  .cls-85 {
    fill: #525252;
  }
  .cls-86 {
    fill: #989898;
  }
  .cls-87 {
    fill: #e4e4e4;
  }
  .cls-88 {
    fill: #8f8f8f;
  }
  .cls-89 {
    fill: #787878;
  }
  .cls-90 {
    fill: #878787;
  }
  .cls-91 {
    fill: #8a8a8a;
  }
  .cls-92 {
    fill: #d8d8d8;
  }
  .cls-93 {
    fill: #f2f2f2;
  }
  .cls-94 {
    fill: #c7c7c7;
  }
  .cls-95 {
    fill: #c8c8c8;
  }
  .cls-96 {
    fill: #898989;
  }
  .cls-97 {
    fill: #ededed;
  }
  .cls-98 {
    fill: #dbdbdb;
  }
  .cls-99 {
    fill: #c4c4c4;
  }
  .cls-100 {
    fill: #c6c6c6;
  }
  .cls-101 {
    fill: #b8b8b8;
  }
  .cls-102 {
    fill: #858585;
  }
}
#right-side {
  .cls-1 {
    mask: url(#mask);
  }
  .cls-2 {
    fill: #fff;
  }
  .cls-3 {
    fill: #eaeaea;
  }
  .cls-4 {
    fill: #e4e4e4;
  }
  .cls-5 {
    fill: #bfbfbf;
  }
  .cls-6 {
    fill: #dedede;
  }
  .cls-7 {
    fill: #f2f2f2;
  }
  .cls-8 {
    fill: #bebebe;
  }
  .cls-9 {
    fill: #b4b4b4;
  }
  .cls-10 {
    fill: #b6b6b6;
  }
  .cls-11 {
    fill: #b1b1b1;
  }
  .cls-12 {
    fill: #353535;
  }
  .cls-13 {
    fill: #e2e2e2;
  }
  .cls-14 {
    fill: #e0e0e0;
  }
  .cls-15 {
    fill: #b2b2b2;
  }
  .cls-16 {
    fill: #c4c4c4;
  }
  .cls-17 {
    fill: #6f6f6f;
  }
  .cls-18 {
    fill: #8b8b8b;
  }
  .cls-19 {
    fill: #cfcfcf;
  }
  .cls-20 {
    fill: #585858;
  }
  .cls-21 {
    fill: #a3a3a3;
  }
  .cls-22 {
    fill: #999;
  }
  .cls-23 {
    fill: #939393;
  }
  .cls-24 {
    fill: #404040;
  }
  .cls-25 {
    fill: #7a7a7a;
  }
  .cls-26 {
    fill: #efefef;
  }
  .cls-27 {
    fill: #f4f4f4;
  }
  .cls-28 {
    fill: #bbb;
  }
  .cls-29 {
    fill: #aeaeae;
  }
  .cls-30 {
    fill: #333;
  }
  .cls-31 {
    fill: #7c7c7c;
  }
  .cls-32 {
    fill: #c9c9c9;
  }
  .cls-33 {
    fill: #1f1f1f;
  }
  .cls-34 {
    fill: #9e9e9e;
  }
  .cls-35 {
    fill: #232323;
  }
  .cls-36 {
    fill: #9a9a9a;
  }
  .cls-37 {
    fill: #252525;
  }
  .cls-38 {
    fill: #d1d1d1;
  }
  .cls-39 {
    fill: #444;
  }
  .cls-40 {
    fill: #797979;
  }
  .cls-41 {
    fill: #616161;
  }
  .cls-42 {
    fill: #767676;
  }
  .cls-43 {
    fill: #888;
  }
  .cls-44 {
    fill: #ddd;
  }
  .cls-45 {
    fill: #525252;
  }
  .cls-46 {
    fill: #5c5c5c;
  }
  .cls-47 {
    fill: #d4d4d4;
  }
  .cls-48 {
    fill: #757575;
  }
  .cls-49 {
    fill: #0e0e0e;
  }
  .cls-50 {
    fill: #666;
  }
  .cls-51 {
    fill: #626262;
  }
  .cls-52 {
    fill: #7b7b7b;
  }
  .cls-53 {
    fill: #6d6d6d;
  }
  .cls-54 {
    fill: #181818;
  }
  .cls-55 {
    fill: #747474;
  }
  .cls-56 {
    fill: #474747;
  }
  .cls-57 {
    fill: #969696;
  }
  .cls-58 {
    fill: #b7b7b7;
  }
  .cls-59 {
    fill: #dadada;
  }
  .cls-60 {
    fill: #d2d2d2;
  }
  .cls-61 {
    fill: #c3c3c3;
  }
  .cls-62 {
    fill: #b0b0b0;
  }
  .cls-63 {
    fill: #a9a9a9;
  }
  .cls-64 {
    fill: #d6d6d6;
  }
  .cls-65 {
    fill: #686868;
  }
  .cls-66 {
    fill: #8a8a8a;
  }
  .cls-67 {
    fill: #8d8d8d;
  }
  .cls-68 {
    fill: #ababab;
  }
  .cls-69 {
    fill: #b5b5b5;
  }
  .cls-70 {
    fill: #494949;
  }
  .cls-71 {
    fill: #cdcdcd;
  }
  .cls-72 {
    fill: #a2a2a2;
  }
  .cls-73 {
    fill: #898989;
  }
  .cls-74 {
    fill: #eee;
  }
  .cls-75 {
    fill: #5e5e5e;
  }
  .cls-76 {
    fill: #ebebeb;
  }
  .cls-77 {
    fill: #8c8c8c;
  }
  .cls-78 {
    fill: #575757;
  }
  .cls-79 {
    fill: #707070;
  }
  .cls-80 {
    fill: #c1c1c1;
  }
  .cls-81 {
    fill: #fefefe;
  }
  .cls-82 {
    fill: #d9d9d9;
  }
  .cls-83 {
    fill: #6a6a6a;
  }
  .cls-84 {
    fill: gray;
  }
  .cls-85 {
    fill: #d5d5d5;
  }
  .cls-86 {
    fill: #323232;
  }
  .cls-87 {
    fill: #cacaca;
  }
  .cls-88 {
    fill: #aaa;
  }
  .cls-89 {
    fill: #3c3c3c;
  }
  .cls-90 {
    fill: #212121;
  }
  .cls-91 {
    fill: #5f5f5f;
  }
  .cls-92 {
    fill: #6c6c6c;
  }
  .cls-93 {
    fill: #5a5a5a;
  }
  .cls-94 {
    fill: #909090;
  }
  .cls-95 {
    fill: #6e6e6e;
  }
  .cls-96 {
    fill: #858585;
  }
  .cls-97 {
    fill: #818181;
  }
  .cls-98 {
    fill: #b3b3b3;
  }
  .cls-99 {
    fill: #a6a6a6;
  }
  .cls-100 {
    fill: #c7c7c7;
  }
  .cls-101 {
    fill: #d0d0d0;
  }
  .cls-102 {
    fill: #c8c8c8;
  }
  .cls-103 {
    fill: #484848;
  }
  .cls-104 {
    fill: #838383;
  }
}
</style>